import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  DEFAULT_CODIFICATION_FILEDS_CODE_3PL,
  DEFAULT_CODIFICATION_FILEDS_DESC_3PL,
  DEFAULT_CURRENCY_CODE,
  DEFAULT_INVENTORY_UOM,
  DEFAULT_INVENTORY_UOM_3PL,
  DEFAULT_WAREHOUSE,
  DEFAULT_WEIGHT_UOM_3PL,
  DEMO_VALUE,
  DOCUMENT_CHANGED,
  NEW_ENTRY,
} from "../ds/App_Constants";
import {
  BaseBean,
  BaseImageBean,
  NodeData,
  PageListBean,
  RestReportBean,
} from "../ds/client_ds.js";
import {
  ColorSearchCriteria,
  CustomerSearchCriteria,
  EcomShopifyFabricStyleBean,
  EcomShopifySkuLineFabricStyleBean,
  FabricStyleBean,
  FabricStyleBuyingUOMBean,
  FabricStyleColorBean,
  FabricStyleColorMiscellaneousDetailBean,
  FabricStyleColorVendorReferenceBean,
  FabricStyleCompositionBean,
  FabricStyleImageBean,
  FabricStyleInventoryForLotBasedSearchCriteria,
  FabricStyleLogisticPackageInfoBean,
  FabricStyleMiscellaneousDetailBean,
  FabricStyleOtherInfoDetailsRequest,
  FabricStyleSearchCriteria,
  FabricStyleSellingUOMBean,
  FabricStyleSKUBean,
  FabricStyleSKUCostBean,
  FabricStyleSKUCustomerPriceBean,
  FabricStyleSKUPriceBean,
  FabricStyleSKUVendorCostBean,
  FabricStyleVendorReferenceBean,
  RestColorListRequest,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestFabricStyleEntityRequest,
  RestPageListBean,
  RestReadRequest,
  RestVendorListRequest,
  ShopifyBodyDataBean,
  ShopifyBodyLineData,
  SkuBatchInventoryDataBean,
  SKUBatchInventorySearchCriteria,
  VendorSearchCriteria,
  RestUserListRequest,
  UserSearchCriteria,
  FabricStyleCustomerTypePriceBean,
  RestFabricStyleListBeanRequest,
  FabricStyleInventoryForLotBasedDataBean,
  SalesAndPurchaseInquiryCriteriaBean,
  FabricStyleInAndOutStatisticsCriteriaBean,
  FabricStyleSalesAndPurchaseDetailsBean,
  FabricStylePurchaseReceiptHistoryCriteriaBean,
  FabricStyleColorStatisticsInquiryCriteria,
  FabricStyleColorStatisticsReceiptListRequest,
  FabricStyleColorStatisticsPrintRequest,
  FabricStyleDetailInquiryCriteriaBean,
  PurchaseOrderSearchCriteria,
  RestPurchaseOrderListRequest,
  VendorInvoicePurchaseOrderBean,
  PurchaseOrderReceiptSearchCriteria,
  RestPurchaseOrderReceiptListRequest,
  HoldingFabricInventoryDetailBean,
  RestHoldingFabricStyleListRequest,
  HoldingInventoryFabricStyleSearchCriteria,
  AllFabricATSInquiryCriteriaBean,
   FabricStyleDocumentBean,


} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import CustomImage from "../gui_components/CustomImage.js";
import CustomTable from "../gui_components/CustomTable.js";

import {
  AddIcon,
  CameraIcon,
  CancelIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
UploadDocIcon,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DatePickerComponent,
  DatePickerComponent_adv,
  InputCheckbox,
  InputTextbox,
  MessageBoxComponent,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ShortCutMenuPopup,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import noImage from "../images/clicktoAdd.png";
import AllFabricATS from "../Inquiry/ATSInquiry";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { MasterService } from "../services/MasterService.js";
import { ReportService } from "../services/ReportService.js";
import { UserService } from "../services/UserService.js";
import { VendorService } from "../services/VendorService.js";

import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import {
  PopupInvoiceModule,
  PopupPurchaseReceiptModule,
  PopupPurchaseOrderModule,
  PopupVendorModule,
  PopupCustomerModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { PopupSalesPriceInq } from "../Inquiry/InquiryUtil.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { PurchaseOrderReceiptLookupHandler } from "../lookup/PurchaseOrderReceiptLookupHandler.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import {
  AlignStartVertical, // ← Header
  Barcode, // ← Sku
  CircleDollarSign, // ← ItemCost
  LayoutList, // ← Misc Details
  Layers, // ← Compositions
  Scissors, // ← Fabric Details
  BarChart2, // ← ATS Details
  Package, // ← Lot Based Inventory
  PackageSearch, // ← Lot Summary Inventory
  ShoppingBag, // ← CustomerSales & Purchase
  ShoppingCart, // ← Customer Sales
  TrendingUp, // ← Fabric Sales
  FileText, // ← Purchase Details
  Globe, // ← Ecom Details
  Truck, // ← Logistic PackageInfo
  ArrowLeftRight, // ← In / Out Statistics
  PackageOpen, // ← LotBased In / Out
  CopyPlus,
  Warehouse ,
  Combine ,
  Copy,
} from "lucide-react";
class FabricStyleList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricStyleRef = React.createRef();
    this.customerCodeRef = React.createRef();
    this.customerShipToCodeRef = React.createRef();
    this.customerNameRef = React.createRef();
    this.state = {
      fabricStyle_list: [],
      isFabricStyleListFormOpen: true,
      isFabricStyleEntryFormOpen: false,
      isGemsMetalEntryOpened: false,
      isChangesHistoryViewOpened: false,
      response: {},
      fabricStyleData: new FabricStyleBean(),
      fabricStyleSKUData: new FabricStyleSKUBean(),
      eComShopifyData: new EcomShopifyFabricStyleBean(),
      temp_eComShopifyData: new EcomShopifyFabricStyleBean(),
      fabricStyleColorData: new FabricStyleColorBean(),
      pageList: new RestPageListBean(),
      criteria: new FabricStyleSearchCriteria(),
      pageTitle: "",
      currentPageNumber: 0,
      totalCount: 0,
      companyCode: "",
      businessDivisions: [],
      warehouses: [],
      patternTypes: [],
      productTypes: [],
      uoms: [],
      miscReasons: [],
      makeTypes: [],
      compositionTypes: [],
      countUOMs: [],
      weightUOMs: [],
      lengthUOMs: [],
      countries: [],
      productDivisions: [],
      seasons: [],
      colors: [],
      customerTypes: [],
      incoTerms: [],
      patternTypeCategories: [],
      htses: [],
      productStatuses: [],
      miscCostTypes: [],
      styleItemTypes: [],
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      isShowNodes: false,
      nodeList: [],
      isLoading: false,
      selectedNodeKey: "headerView",
      isShowRecalculatePriceButton: true,
      isFabricStylePriceLevelEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      currencies: [],
      configs: [],
      vendor_List: new Array(),
      customer_list: new Array(),
      fabricStyleLookupHandler: null,
      isShowModuleSearchContainer: false,
      customerLookupHandler: null,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      buyingUoms: [],
      isShowMultipleColorPopup: false,
      temp_selectedMultipleColorList: [],
      isShowPopup: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      success_list: [],
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      disabled: false,
      isResetView: true,
      isFocusLookup: true,
      isFocus: false,
      shopifyBodyLineData: new ShopifyBodyLineData(),
      shopifyBodyTopDescriptionData: new ShopifyBodyLineData(),
      shopifyBodyBottomDescriptionData: new ShopifyBodyLineData(),
      shopifyBodyData: new ShopifyBodyDataBean(),
      shopifyBodyTopList: new Array(),
      shopifyBodyBottomList: new Array(),
      shopifyBodyBulletList: new Array(),
      isMaintenanceMode: true,
      isDisabledFields: false,
      isOpenUomPopup: false,
      uomData: new FabricStyleBuyingUOMBean(),
      uomCaption: "",
      isDisableUomFields: false,
      colorData: new FabricStyleColorBean(),
      colorPopupPageListForAutoCompleteList: new Array(),
      showAutoCompleteColorPopupList: true,
      skuBatchInventoryDataBean: new SkuBatchInventoryDataBean(),
      statisticsDataBean: new FabricStyleSalesAndPurchaseDetailsBean(),
      disableCloseOutPrice: true,
      isDisableOnorderQtyFields: true,
      imagePopupCaption: "",
      onHandQtyCaption: "",
      onStatisticsCaption: "",
      imageData: null,
      isOpenImagePopup: false,
      isOpenItemImagePopup: false,
      isOpenColorPopup: false,
      isOpenOnHandDetailPopup: false,
      isOpenStatisticsPopup: false,
      isInandOutStatisticsPopup: false,
      temp_selectedList: [],
      multipleColorList: [],
      selectedMultipleColorList: [],
      uomPopupPageListForAutoCompleteList: new Array(),
      showAutoCompleteUOMPopupList: true,
      patternTypePageListForAutoCompleteList: new Array(),
      typePageListForAutoCompleteList: new Array(),
      makeTypePageListForAutoCompleteList: new Array(),
      usePageListForAutoCompleteList: new Array(),
      divisionPageListForAutoCompleteList: new Array(),
      uomPageListForAutoCompleteList: new Array(),
      widthUomPageListForAutoCompleteList: new Array(),
      currencyCodePageListForAutoCompleteList: new Array(),
      locationPageListForAutoCompleteList: new Array(),
      weightUomPageListForAutoCompleteList: new Array(),
      htsPageListForAutoCompleteList: new Array(),
      seasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSeasonList: true,
      showAutoCompleteHtsList: true,
      showAutoCompleteWeightUomList: true,
      showAutoCompleteCurrencyCodeList: true,
      showAutoCompleteMakeTypeList: true,
      showAutoCompleteTypeList: true,
      showAutoCompletePatternTypeList: true,
      showAutoCompleteList: true,
      showAutoCompletePatternTypeCategoryCodeList: true,
      showAutoCompleteLocationList: true,
      showAutoCompleteDivisionCodeList: true,
      showAutoCompleteUOMList: true,
      showAutoCompleteStyleItemTypeList: true,
      styleItemTypePageListForAutoCompleteList: new Array(),
      showAutoCompleteStatsList: true,
      statsPageListForAutoCompleteList: new Array(),
      isOpenSkuPricePopup: false,
      isLineEditMode: false,
      isShowSkuPopup: false,
      customerSkuPriceData: new FabricStyleSKUCustomerPriceBean(),
      _currentSelectedSkuLine: new FabricStyleSKUBean(),
      customer_shipTo: new Array(),
      isOpenSkuCostPopup: false,
      selectedSkuLine: new FabricStyleSKUBean(),
      selectedVendorRefLine: new FabricStyleVendorReferenceBean(),
      isVendorReferencePopup: false,
      venReferenceData: new FabricStyleVendorReferenceBean(),
      venReferneceCaption: "",
      venColorReferneces: [],
      venRef: [],
      skuCostCaption: "",
      skuCostData: new FabricStyleSKUCostBean(),
      skuVendorCosts: [],
      skuVendorCostData: new FabricStyleSKUVendorCostBean(),
      skuMiscCostData: new FabricStyleColorMiscellaneousDetailBean(),
      fabricStyleCompositionLineData: new FabricStyleCompositionBean(),
      editedMiscCostLineList: [],
      fabricStyleMiscCostLineData: new FabricStyleMiscellaneousDetailBean(),
      isShowTargetWebPopup: false,
      isShowEcomColorPopup: false,
      isShowBodyPopup: false,
      fabricStyleMiscCostLineData: new FabricStyleMiscellaneousDetailBean(),
      targetWebSiteDetail: [],
      moduleForPopup: [],
      selectedCode: "",
      websiteCode: "",
      targetDetail: "",
     moduleForPopup: [],
      selectedCode: "",
      editedMiscCostLineList: [],
      eComSkuData: new EcomShopifySkuLineFabricStyleBean(),
      isLocked: false,
      isLockRequired: false,
      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: true,
      vendorCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorCodeList: true,
      showAutoCompleteReasonList: true,
      reasonPageListForAutoCompleteList: new Array(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      shipToPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipToList: true,
      isShowPopupAlert: false,
      isShowPopupAlertLvl1: false,
      isShowSkuEntryPopup: false,
      isShowTargetSiteEntryPopup: false,
      is3PL: false,
      isStandard: false, //Texco
      fabricLogisticPackageInfosDetails:
        new FabricStyleLogisticPackageInfoBean(),
      isShowAutoCompleteLogisticUomList: false,
      logisticUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLogisticWeightUomList: false,
      logisticWeightUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLogisticCaseUomList: false,
      logisticCaseUomPageListForAutoCompleteList: new Array(),
      sortField: "",
      order: "asc",
      isShowAutoCompleteLogisticPalletUomList: false,
      logisticPalletUomPageListForAutoCompleteList: new Array(),
      ItemImageData: new FabricStyleImageBean(),
      fabricStyleImagesList: new Array(),
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      colorImgUrl: "",
      mainImg: null,
      webImg: null,
      frontImg: null,
      BackImg: null,
      clrImg: null,
      isOpenItemImagePopup: false,
      value: "",
      colorList: [],
      color___List: new Array(),
      clrCodeForDelete: "",
      warningMessage: "",
      isSavedWithWarning: false,
      isShowWarningMsgPopup: false,
      isShowImgAlert: false,
      color_List: new Array(),
      colorLookupHandler: null,

      showAutoCompleteServiceWeightUomList: false,
      serviceWeightUomPageListForAutoCompleteList: new Array(),

      showAutoCompleteServiceDimensionUomList: false,
      serviceDimensionUomPageListForAutoCompleteList: new Array(),

      showAutoCompletePalletDimensionUomList: false,
      palletDimensionUomPageListForAutoCompleteList: new Array(),
      isReseted: false,
      disableStackableQty: true,
      isViewMode: false,
      uomPopupCaption: "",
      isShowAlertLvl3: false,
      isShowUserLookup: false,
      userList: new Array(),

      isShowAutoCompleteUserList: false,
      userPageListForAutoCompleteList: new Array(),

      isShowColorAlert: false,

      isShowCopyFabric: false,
      copyFabricCode: "",
      showAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: new Array(),

      isFabricStyleLotBasedSummaryViewOpen: false,

      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,

      isShowStatReceivedQtyPopup: false,
      isShowStatShippedQtyPopup: false,

      receiptContainerDatas: [],
      shippedContainerDatas: [],

      receiptProjectNumberDatas: [],
      shippedProjectNumberDatas: [],

      statisticsCriteria: new FabricStyleInAndOutStatisticsCriteriaBean(),
      containerDatas: [],
      projectDatas: [],

      isShowLotReceivedQtyPopup: false,
      isShowLotShippedQtyPopup: false,
      lotNumberDatas: new Array(),
      receiptLotDatas: new Array(),
      shippedLotDatas: new Array(),

      statisticsDatailList: [],
      receivedDataList: [],
      shippedDataList: [],

      isShowCustomerModule: false,
      isShowVendorModule: false,
      isShowPurchaseModule: false,
      isShowPurchaseReceiptModule: false,
      isShowInvoiceModule: false,
      isShowInAndOutAlert: false,
      isShowPickTicketModule: false,

      rowSubHeaderData: {},
      isShowInputTextbox: false,

      isShowColorStatisticsPopup: false,
      clrStatisticCriteria: new FabricStyleColorStatisticsInquiryCriteria(),
      salesStatisticsList: [],
      purchaseStatisticsList: [],

      fabricStyleStatus: [],

      moduleOrderStatus: "",

      showAutoCompleteColorStausList: false,
      fabricColorStatusPageListForAutoCompleteList: [],
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,

      isFabricStyleSalesViewOpen: false,

      isFabricStyleHoldingDetailsViewOpen: false,
      isFabricInventoryAndSoAndPoOpen: false,
      // fabricData: new AllFabricATSInquiryCriteriaBean (),
      fabricColorList: [],
       fabricColourPageListForAutoCompleteList: new Array(),
       showAutoCompleteColourList: true,
isMultipleDocFormOpened: false,
      documents: [],
      preview_Docs: [],
      isShowDocLabel: false,

    };
  }
  buyingUomCaption = "Buying UOM";
  sellingUomCaption = "Selling UOM";
  colorCaption = "Color";
  customerTypeCaption = "Customer Type Prices";
  miscCostDetailsCaption = "Misc Cost Details";
  itemCostDetailsCaption = "Item Cost Details";
  onHandQtyCaption = "On Hand Qty On Rolls";
  onStatisticsCaption = "In/Out statistics";
  imagePart = "";
  code = NEW_ENTRY;

  componentDidMount() {
    const { appData } = this.context;
    const { cache } = appData;

    this.cache = cache;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (ConfigManager.isTexcoFabricKey()) {
      this.state.isStandard = true;
      // alert("TRue")
      this.setState({
        isStandard: true,
      });
    }

    ModuleUtils.getSalesOrderStatusList();
    if (this.state.is3PL === true) {
      this.moduleCaption = "Item Maintenance";
    } else {
      this.moduleCaption = "FabricStyle Maintenance";
    }
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...cache };
    let targetWebSiteDetail = [];
    if (!isEmptyArray(this.state.targetWebSiteDetail)) {
      targetWebSiteDetail = this.state.targetWebSiteDetail;
    }
    let targetWebSiteDetailList = [];
    if (!isEmptyArray(attribute_cache.targetWebSiteDetails)) {
      targetWebSiteDetail = attribute_cache.targetWebSiteDetails;
    }
    targetWebSiteDetail.map((targetWebSiteDetail) => {
      targetWebSiteDetailList.push(targetWebSiteDetail);
    });
    this.setState({
      targetWebSiteDetail: targetWebSiteDetailList,
    });
    this.report_url = appData.reportURL;
    this.loadCacheDetails();
    this.initLookupHandlers();
    this.getVendorList();
    this.getCustomerList();
    this.getColors();

    //set readOnly components using view Modes && disable toolbars
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;

    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      this.state.isSpecialViewMode = isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });

    if (
      this.props.fabricStyleCode !== "" &&
      this.props.fabricStyleCode !== undefined
    ) {
      this.code = this.props.fabricStyleCode;
      this.editfabricStyle(this.props.fabricStyleCode);

      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
      this.loadFabricStylePage();
    }
    // this.loadColorList();
  }
  setFocus = () => {
    this.fabricStyleRef.current.focus();
  };
  initLookupHandlers = () => {
    let fabricStyleLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "FabricStyle",
    );
    this.setState({ fabricStyleLookupHandler: fabricStyleLookupHandler });
    let uomsLookupHandler = new GenericAttributeLookupHandler(
      this.state.countUOMs,
      "UOM",
    );
    this.setState({ uomsLookupHandler: uomsLookupHandler });

    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };

  loadCacheDetails = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let warehouses = ModuleUtils.isActiveAttribute(attribute_cache.warehouses);

    let businessDivisions = ModuleUtils.isActiveAttribute(
      attribute_cache.businessDivisions,
    );

    let patternTypes = ModuleUtils.isActiveAttribute(
      attribute_cache.patternTypes,
    );

    let productTypes = ModuleUtils.isActiveAttribute(
      attribute_cache.productTypes,
    );

    let uoms = ModuleUtils.isActiveAttribute(attribute_cache.uoms);

    let currencies = ModuleUtils.isActiveAttribute(attribute_cache.currencies);

    let makeTypes = ModuleUtils.isActiveAttribute(attribute_cache.makeTypes);

    let seasons = ModuleUtils.isActiveAttribute(attribute_cache.seasons);

    let compositionTypes = ModuleUtils.isActiveAttribute(
      attribute_cache.compositionTypes,
    );

    let countries = ModuleUtils.isActiveAttribute(attribute_cache.countries);

    let productDivisions = ModuleUtils.isActiveAttribute(
      attribute_cache.productDivisions,
    );

    let miscReasons = ModuleUtils.isActiveAttribute(
      attribute_cache.miscellaneousChargeReasons,
    );

    let colors = ModuleUtils.isActiveAttribute(attribute_cache.colors);

    let customerTypes = ModuleUtils.isActiveAttribute(
      attribute_cache.customerTypes,
    );

    let incoTerms = ModuleUtils.isActiveAttribute(attribute_cache.incoTerms);

    let patternTypeCategories = ModuleUtils.isActiveAttribute(
      attribute_cache.patternTypeCategories,
    );

    let styleItemTypes = ModuleUtils.isActiveAttribute(
      attribute_cache.styleItemTypes,
    );

    let htses = ModuleUtils.isActiveAttribute(attribute_cache.htses);

    let productStatuses = ModuleUtils.isActiveAttribute(
      attribute_cache.productStatuses,
    );

    let miscCostTypes = ModuleUtils.isActiveAttribute(
      attribute_cache.miscCostTypes,
    );

    let countUOMs = this.state.countUOMs;
    let countUOMs_temp = [];
    if (attribute_cache.uoms != null) {
      attribute_cache.uoms.map((line) => {
        // if (line.uomType == 1) {
        countUOMs_temp.push(line);
        countUOMs = ModuleUtils.isActiveAttribute(countUOMs_temp);
        // }
      });
    }
    let lengthUOMs = this.state.lengthUOMs;
    let lengthUOMs_temp = [];
    if (attribute_cache.uoms != null) {
      attribute_cache.uoms.map((line) => {
        if (line.uomType == 2) {
          lengthUOMs_temp.push(line);
          lengthUOMs = ModuleUtils.isActiveAttribute(lengthUOMs_temp);
        }
      });
    }
    let weightUOMs = this.state.weightUOMs;
    let weightUOMs_temp = [];
    if (attribute_cache.uoms != null) {
      attribute_cache.uoms.map((line) => {
        if (line.uomType == 3) {
          weightUOMs_temp.push(line);
          weightUOMs = ModuleUtils.isActiveAttribute(weightUOMs_temp);
        }
      });
    }

    let statusData = ["Active", "InActive", "Discontinued"];
    let fabricStyleStatus = [];
    statusData.map((type) => {
      let typeBean = new BaseBean();
      typeBean.code = type;
      typeBean.description = "FabricStyleStatus";
      fabricStyleStatus.push(typeBean);
    });

    this.setState({
      warehouses: warehouses,
      productTypes: productTypes,
      uoms: uoms,
      currencies: currencies,
      businessDivisions: businessDivisions,
      patternTypes: patternTypes,
      compositionTypes: compositionTypes,
      makeTypes: makeTypes,
      countUOMs: countUOMs,
      weightUOMs: weightUOMs,
      lengthUOMs: lengthUOMs,
      countries: countries,
      productDivisions: productDivisions,
      miscReasons: miscReasons,
      compositionTypes: compositionTypes,
      seasons: seasons,
      colors: colors,
      customerTypes: customerTypes,
      incoTerms: incoTerms,
      patternTypeCategories: patternTypeCategories,
      htses: htses,
      productStatuses: productStatuses,
      miscCostTypes: miscCostTypes,
      styleItemTypes: styleItemTypes,
      fabricStyleStatus: fabricStyleStatus,
    });
  };
  vendorPageListResponse = (response) => {
    if (
      response.data != null &&
      response.data.vendorPageList != null &&
      response.data.vendorPageList.vendors != null
    ) {
      const vendor_List = response.data.vendorPageList.vendors;
      this.setState({ vendor_List: vendor_List });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
  };
  getVendorList = () => {
    let criteria = new VendorSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = new RestPageListBean();
    let requestInput = new RestVendorListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    VendorService.getVendorPageList(
      requestInput,
      this.vendorPageListResponse,
      this.errorCallBack,
    );
  };
  customerPageListResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerPageList != null &&
      response.data.customerPageList.customers != null
    ) {
      const customer_list = response.data.customerPageList.customers;
      this.setState({ customer_list: customer_list });
    }
  };
  getCustomerList = () => {
    let cust_criteria = new CustomerSearchCriteria();
    cust_criteria.companyCode = this.companyCode;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 50;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.customerPageListResponse,
      this.errorCallBack,
    );

    // CustomerService.getCustomerPageList(
    //   cust_requestInput,
    //   this.customerPageListResponse,
    //   this.errorCallBack
    // );
  };

  // moduleCaption = "FabricStyle Maintenance";
  validateFabricData = (data) => {
    let isValid = false;

    let err_list = [];
    let errorMessage = "";

    if (isEmptyString(data.customerCode)) {
      let errMsg = "Customer Code is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        isShowAlert: true,
        alertMessage: err_list,
        alertType: "danger",
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  save = () => {
    const fabricData = this.state.fabricStyleData;
    if (this.state.is3PL) {
      let isValid = false;
      isValid = this.validateFabricData(fabricData);
      if (isValid) {
        this.savefabricStyle(fabricData);
      }
    } else {
      this.savefabricStyle(fabricData);
    }
  };
  back = () => {
    this.closeEntryForm();
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };

  filterFabricStyles = () => {
    this.loadPage(1);
  };

  onFilterChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    //}
    this.setState({ criteria: criteria });
  };

  resetFilterFabricStyles = () => {
    let criteria = new FabricStyleSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };

  loadFirst = () => {
    this.loadPage(1);
  };

  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };

  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;

    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadFabricStylePage();
  };

  genenateDefaultBuyingAndSellingUoms(uomCode) {
    let fabricStyleData = new FabricStyleBean();
    let buyingUOM = new FabricStyleBuyingUOMBean();
    buyingUOM.companyCode = this.companyCode;
    buyingUOM.fabricStyleCode = NEW_ENTRY;
    buyingUOM.fabricStyleInventoryUOMCode = uomCode;
    buyingUOM.uomCode = uomCode;
    buyingUOM.conversionRate = 1;
    buyingUOM.cost = 0;
    fabricStyleData.buyingUoms.push(buyingUOM);

    let sellingUOM = new FabricStyleSellingUOMBean();
    sellingUOM.companyCode = this.companyCode;
    sellingUOM.fabricStyleCode = NEW_ENTRY;
    sellingUOM.uomCode = uomCode;
    sellingUOM.fabricStyleInventoryUOMCode = uomCode;
    sellingUOM.retailPrice = 0;
    sellingUOM.wholeSalePrice = 0;
    sellingUOM.conversionRate = 1;
    fabricStyleData.sellingUoms.push(sellingUOM);

    return fabricStyleData;
  }
  getDefaultColor = () => {
    const fabricStyleData = this.state.fabricStyleData;
    const colors = new Array();
    // const attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let colors_cache = [];
    if (!isEmptyArray(attribute_cache.colors))
      colors_cache = attribute_cache.colors;

    colors_cache.map((clr) => {
      if (clr.code === ConfigManager.getDefaultItemColorCode()) {
        const colorBean = new FabricStyleColorBean();
        colorBean.companyCode = this.companyCode;
        colorBean.fabricStyleColorCode = clr.code;
        colorBean.fabricStyleColorName = clr.description;
        colors.push(colorBean);
      }
    });
    fabricStyleData.colors = colors;
    this.setState({
      fabricStyleData: fabricStyleData,
      color___List: colors,
    });
    this.generateItemSKUs();
  };
  addNewEntry = () => {
    let fabricStyleData = new FabricStyleBean();
    fabricStyleData.companyCode = this.companyCode;
    fabricStyleData.isFetched = false;
    fabricStyleData.isActive = true;
    if (!this.state.is3PL) {
      fabricStyleData.fabricStatus = "Active";
    }

    fabricStyleData.currencyCode = DEFAULT_CURRENCY_CODE;
    if (this.state.isStandard) {
      fabricStyleData.defaultLocationCode =
        ConfigManager.isDefaultWarehouse() || DEFAULT_WAREHOUSE;
    } else {
      fabricStyleData.defaultLocationCode = DEFAULT_WAREHOUSE;
    }

    if (this.state.is3PL == true) {
      fabricStyleData.inventoryUomCode = DEFAULT_INVENTORY_UOM_3PL;
    } else {
      fabricStyleData.inventoryUomCode = DEFAULT_INVENTORY_UOM;
    }
    if (this.state.is3PL == true) fabricStyleData.widthUomCode = DEMO_VALUE;
    if (this.state.is3PL == true) fabricStyleData.divisionCode = DEMO_VALUE;
    if (this.state.is3PL == true)
      fabricStyleData.weightUomCode = DEFAULT_WEIGHT_UOM_3PL;
    if (this.state.is3PL == true) fabricStyleData.weight = 0;
    if (this.state.is3PL == true) {
      fabricStyleData.productTypeCode = DEFAULT_CODIFICATION_FILEDS_CODE_3PL;
      fabricStyleData.patternTypeCode = DEFAULT_CODIFICATION_FILEDS_CODE_3PL;
      fabricStyleData.makeTypeCode = DEFAULT_CODIFICATION_FILEDS_CODE_3PL;
      fabricStyleData.patternTypeCategoryCode =
        DEFAULT_CODIFICATION_FILEDS_CODE_3PL;
      fabricStyleData.productTypeName = DEFAULT_CODIFICATION_FILEDS_DESC_3PL;
      fabricStyleData.patternTypeName = DEFAULT_CODIFICATION_FILEDS_DESC_3PL;
      fabricStyleData.makeTypeName = DEFAULT_CODIFICATION_FILEDS_DESC_3PL;
      fabricStyleData.patternTypeCategoryName =
        DEFAULT_CODIFICATION_FILEDS_DESC_3PL;
    }
    if (this.state.isStandard) {
      fabricStyleData.patternTypeCode = "NA";
      fabricStyleData.patternTypeName = "NA";
    }
    fabricStyleData.createdDate = new Date().toLocaleDateString("sv-SE");
    fabricStyleData.updatedDate = new Date().toLocaleDateString("sv-SE");
    let fab = this.genenateDefaultBuyingAndSellingUoms(
      fabricStyleData.inventoryUomCode,
    );

    fabricStyleData.buyingUoms = fab.buyingUoms;
    fabricStyleData.sellingUoms = fab.sellingUoms;

    if (isEmptyArray(fabricStyleData.customerTypePrices)) {
      const customer_types = new Array();
      if (!isEmptyArray(this.state.customerTypes)) {
        this.state.customerTypes.map((typ) => {
          const customer_type = new FabricStyleCustomerTypePriceBean();
          customer_type.companyCode = this.companyCode;
          customer_type.customerTypeCode = typ.code;
          customer_type.samplePrice = 0;
          customer_type.price = 0;
          customer_type.uomCode = this.state.is3PL
            ? DEFAULT_INVENTORY_UOM_3PL
            : DEFAULT_INVENTORY_UOM;
          customer_type.currencyCode = DEFAULT_CURRENCY_CODE;
          customer_types.push(customer_type);
        });
      }
      fabricStyleData.customerTypePrices = customer_types;
    }

    let fabricStyleSKUData = new FabricStyleSKUBean();
    fabricStyleSKUData.currencyCode = DEFAULT_CURRENCY_CODE;
    let pageTitle = this.moduleCaption + " - " + NEW_ENTRY;
    let isLocked = false;
    let isLockRequired = false;
    if (!isEmptyString(this.state.moduleKeyCode)) {
      fabricStyleData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        isLocked = false;
        isLockRequired = false;
      }
      isLocked = true;
      isLockRequired = true;
    } else fabricStyleData.code = NEW_ENTRY;

    this.setState({
      fabricStyleSKUData: fabricStyleSKUData,
      fabricStyleData: fabricStyleData,
      pageTitle: pageTitle,
      isShowNodes: false,
      isShowRecalculatePriceButton: false,
      isFocus: true,
      isLocked: isLocked,
      isLockRequired: isLockRequired,
      isReseted: false,
    });
    this.state.fabricStyleData = fabricStyleData;
    if (this.state.is3PL == true) {
      this.getDefaultColor();
      setTimeout(() => {
        // this.generateItemSKUs();
      }, [1000]);
    }
    this.openEntryForm();
  };

  editfabricStyle = (fabricStyleCode) => {

    
    let readrequest = new RestReadRequest();
    readrequest.code = fabricStyleCode;
    readrequest.companyCode = this.companyCode;
    readrequest.isLoadChildren = true;
    let isLockRequired = false;

    if (this.state.isSpecialViewMode) {
      isLockRequired = false;
    } else {
      isLockRequired = NEW_ENTRY === fabricStyleCode ? false : true;
    }

    readrequest.isLockRequired = isLockRequired;

    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      FabricStyleService.initFabricStyleModule(
        readrequest,
        this.readFabricStyleResponse,
        this.readFabricStyleError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
      isReseted: false,
    });
  };
  loadUserLookup = (data) => {
    if (!isEmptyString(data.customerCode)) {
      this.getUserList(data.customerCode);
    }
  };

  readFabricStyleResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.fabricStyleResponse != null) {
      if (response.data.fabricStyleResponse.errors != null) {
        response.data.fabricStyleResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    // if (errMsg != "Fabric[" + this.state.moduleKeyCode + "] Not read!") {
    if (!errMsg.includes("Not read"))
      this.showErrorMessage(response.data.fabricStyleResponse);
    // }
    if (response.data.success == true) {
      this.setState({ isLoading: false, loadingText: "" });
      if (
        response.data.fabricStyleResponse != null &&
        response.data.fabricStyleResponse.fabricStyle != null
      ) {
        let fabricStyleData = new FabricStyleBean();
        fabricStyleData = response.data.fabricStyleResponse.fabricStyle;
        let fabricStyleSKUData = new FabricStyleSKUBean();
        fabricStyleSKUData = fabricStyleData.fabricStyleSkus[0];
        let pageTitle = this.moduleCaption + " - VIEW";
        let moduleKeyCode = fabricStyleData.code;
        let buyingUoms = [];
        let sellingUoms = [];
        let fabricLogisticPackageInfosDetails =
          new FabricStyleLogisticPackageInfoBean();
        if (response.data.fabricStyleResponse.fabricStyle.buyingUoms != null) {
          buyingUoms = response.data.fabricStyleResponse.fabricStyle.buyingUoms;
        }
        if (response.data.fabricStyleResponse.fabricStyle.sellingUoms != null) {
          sellingUoms =
            response.data.fabricStyleResponse.fabricStyle.sellingUoms;
        }
        if (
          response.data.fabricStyleResponse.fabricStyle
            .fabricLogisticPackageInfosDetails != null
        ) {
          fabricLogisticPackageInfosDetails =
            response.data.fabricStyleResponse.fabricStyle
              .fabricLogisticPackageInfosDetails;
        }
        if (
          !isEmptyArray(
            response.data.fabricStyleResponse.fabricStyle.fabricStyleImages,
          )
        ) {
          const itemImagesList =
            response.data.fabricStyleResponse.fabricStyle.fabricStyleImages;
          itemImagesList.map((imgData) => {
            if (this.state.isReseted) return;
            if (imgData.imagePart == "Main") {
              let url = this.getImageURL();
              url = url + imgData.imageName;
              this.setMainUrl(url);
            }
            if (imgData.imagePart == "Web") {
              let url = this.getImageURL();
              url = url + imgData.imageName;
              this.setWebUrl(url);
            }
            if (imgData.imagePart == "Front") {
              let url = this.getImageURL();
              url = url + imgData.imageName;
              this.setFrontUrl(url);
            }
            if (imgData.imagePart == "Back") {
              let url = this.getImageURL();
              url = url + imgData.imageName;
              this.setBackUrl(url);
            }
          });
          this.setState({
            mainImg: null,
            webImg: null,
            frontImg: null,
            BackImg: null,
          });
        } else {
          this.setState({
            mainImageUrl: "",
            webImageUrl: "",
            frontImageUrl: "",
            backImageUrl: "",
            mainImg: null,
            webImg: null,
            frontImg: null,
            BackImg: null,
          });
        }
        if (
          !isEmptyArray(response.data.fabricStyleResponse.fabricStyle.colors)
        ) {
          // const color___List =
          //   response.data.fabricStyleResponse.fabricStyle.colors;

          const color___List =
            response.data.fabricStyleResponse.fabricStyle.colors.filter(
              (clr) => clr.isDeleted != true,
            );
          // setTimeout(() => {
          this.setState({
            clrImg: null,
            color___List: color___List,
          });
          // }, 3000);
        } else {
          this.setState({
            clrImg: null,
            colorImgUrl: "",
            color___List: new Array(),
          });
        }
        this.loadUserLookup(response.data.fabricStyleResponse.fabricStyle);
        this.clearError();
        this.state.fabricStyleData = fabricStyleData;

        this.setState({
          fabricStyleData: fabricStyleData,
          fabricStyleSKUData: fabricStyleSKUData,
          fabricLogisticPackageInfosDetails: fabricLogisticPackageInfosDetails,
          pageTitle: pageTitle,
          isShowNodes: true,
          buyingUoms: buyingUoms,
          sellingUoms: sellingUoms,
          moduleKeyCode: moduleKeyCode,
          isFocusLookup: false,
          isFocus: true,
          isLoading: false,
          loadingText: "",
          isLocked: true,
          selectedNodeKey: "headerView",
        });
        this.getNodeList();
        this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
  };
  readFabricStyleError = (error) => {
    ShowError("Error : ", error);
    this.setState({ isLoading: false });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let nodeList = [];
    let emptyObject = this.getEmptyView();
    let headerNode = new NodeData(
      "headerView",
      "Header",
      emptyObject,
      <AlignStartVertical size={16} />,
    );
    let skuNode = new NodeData(
      "skuView",
      "Sku",
      emptyObject,
      <Barcode size={16} />,
    );
    let itemCostNode = new NodeData(
      "itemCostView",
      "ItemCost",
      emptyObject,
      <CircleDollarSign size={16} />,
    );
    let miscDetailNode = new NodeData(
      "miscDetailView",
      "Misc Details",
      emptyObject,
      <LayoutList size={16} />,
    );
    let compositionNode = new NodeData(
      "compositonView",
      "Compositions",
      emptyObject,
      <Layers size={16} />,
    );
    let fabricDetailsNode = new NodeData(
      "fabricDetailsView",
      "Fabric Details",
      emptyObject,
      <Scissors size={16} />,
    );
    let atsDetailsNode = new NodeData(
      "atsDetailsView",
      "ATS Details",
      emptyObject,
      <BarChart2 size={16} />,
    );
    let inventoryDetailsNode = new NodeData(
      "inventoryDetailsView",
      "Lot Based Inventory Details",
      emptyObject,
      <Package size={16} />,
    );
    let inventorySummaryDetailsNode = new NodeData(
      "inventorySummaryDetailsView",
      "Lot Summary Inventory Details",
      emptyObject,
      <PackageSearch size={16} />,
    );
    let customerSalesAndPurchaseDetailsNode = new NodeData(
      "customerSalesAndPurchaseDetailsView",
      "CustomerSales & Purchase",
      emptyObject,
      <ShoppingBag size={16} />,
    );
    let customerSalesDetailsNode = new NodeData(
      "customerSalesDetailsView",
      "Customer Sales",
      emptyObject,
      <Package size={16} />,
    );

    let fabricSalesDetailsNode = new NodeData(
      "fabricSalesDetailsView",
      "Fabric Sales",
      emptyObject,
      <ShoppingCart size={16} />,
    );

    let purchaseSalesDetailsNode = new NodeData(
      "purchaseSalesDetailsView",
      "Purchase Details",
      emptyObject,
      <FileText size={16} />,
    );
    let ecomDetailsNode = new NodeData(
      "ecomView",
      "Ecom Details",
      emptyObject,
      <Globe size={16} />,
    );
    let logisticDetailsNode = new NodeData(
      "logisticDetailView",
      "Logistic PackageInfo Detail",
      emptyObject,
      <Truck size={16} />,
    );
    let inOutStatisticsDetailsNode = new NodeData(
      "inOutStatisticsDetailView",
      "In / Out Statistics",
      emptyObject,
      <ArrowLeftRight size={16} />,
    );
    let lotBasedInventoryInOutDetailsNode = new NodeData(
      "lotBasedInventoryInOutDetailView",
      "LotBased In / Out Statistics",
      emptyObject,
      <PackageOpen size={16} />,
    );
 let multipleDocumentNode = new NodeData(
      "multipleDocumentView",
      "MultipleDocuments",
      emptyObject,
      <Copy size={16} />,
    );

    let holdingFabricDetails = new NodeData(
      "holdingFabricRolls",
      "Holding Details",
      emptyObject,
       <Warehouse size={16} />,
    );
    
    let fabricInventoryAndSalesAndPurchaseNode = new NodeData(
      "fabricInventoryAndSoAndPoView",
      "FabricInventoryAndSoAndPo Details",
      emptyObject,
     <Combine size={16} />
    );

    nodeList["headerView"] = headerNode;
    if (!this.state.is3PL) {
      nodeList["itemCostView"] = itemCostNode;
    }
    if (fabricStyleData.isFetched) {
      nodeList["skuView"] = skuNode;
      nodeList["compositonView"] = compositionNode;
      nodeList["miscDetailView"] = miscDetailNode;
      // if (this.state.is3PL) {
      nodeList["fabricDetailsView"] = fabricDetailsNode;
      // }
      nodeList["atsDetailsView"] = atsDetailsNode;
      nodeList["inventoryDetailsView"] = inventoryDetailsNode;
      nodeList["inventorySummaryDetailsView"] = inventorySummaryDetailsNode;

      if (!this.state.is3PL) {
        nodeList["ecomView"] = ecomDetailsNode;
        nodeList["customerSalesDetailsView"] = customerSalesDetailsNode;
        nodeList["purchaseSalesDetailsView"] = purchaseSalesDetailsNode;
        nodeList["customerSalesAndPurchaseDetailsView"] =
          customerSalesAndPurchaseDetailsNode;
        nodeList["fabricSalesDetailsView"] = fabricSalesDetailsNode;
      }
      if (this.state.is3PL) {
        nodeList["inOutStatisticsDetailView"] = inOutStatisticsDetailsNode;
      }
      if (this.state.isStandard) {
        nodeList["lotBasedInventoryInOutDetailView"] =
          lotBasedInventoryInOutDetailsNode;

        nodeList["holdingFabricRolls"] = holdingFabricDetails;
  nodeList["multipleDocumentView"] = multipleDocumentNode;
         nodeList["fabricInventoryAndSoAndPoView"] = fabricInventoryAndSalesAndPurchaseNode;
      }
      // if (this.state.isStandard) {
      // nodeList["lotBasedInventoryInOutDetailView"] =
      //   lotBasedInventoryInOutDetailsNode;
      // }
    }
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    // nodeList["fabricSalesDetailsView"] = fabricSalesDetailsNode;
    if (selectedNode == "headerView") {
      this.setFabricStyleHeaderView();
    } else if (selectedNode == "skuView") {
      this.setSkuView();
    } else if (selectedNode == "itemCostView") {
      this.setItemCostView();
    } else if (selectedNode == "compositonView") {
      this.setCompositonView();
    } else if (selectedNode == "fabricDetailsView") {
      this.setFabricDetailsView();
    } else if (selectedNode == "miscDetailView") {
      this.setMiscDetailView();
    } else if (selectedNode == "atsDetailsView") {
      this.setAtsDetailView();
    } else if (selectedNode == "inventoryDetailsView") {
      this.setInventoryDetailView();
    } else if (selectedNode == "inventorySummaryDetailsView") {
      this.setInventorySummaryDetailView();
    } else if (selectedNode == "customerSalesAndPurchaseDetailsView") {
      this.setCustomerSalesAndPurchaseDetailView();
    } else if (selectedNode == "customerSalesDetailsView") {
      this.setCustomerSalesDetailView();
    } else if (selectedNode == "fabricSalesDetailsView") {
      this.setFabricSalesDetailView();
    } else if (selectedNode == "purchaseSalesDetailsView") {
      this.setPurchaseDetailView();
    } else if (selectedNode == "ecomView") {
      this.setEcomDetailsView();
    } else if (selectedNode == "logisticDetailView") {
      this.setLogisticDetailsView();
    } else if (selectedNode == "inOutStatisticsDetailView") {
      this.setInOutStatisticsDetailsView();
    } else if (selectedNode == "lotBasedInventoryInOutDetailView") {
      this.setLotBasedInOutDetailsView();
    } else if (selectedNode == "holdingFabricRolls") {
      this.setHoldingFabricDetailsView();
    }
    else if (selectedNode == "fabricInventoryAndSoAndPoView") {
      this.setFabricInventoryAndSoAndPoView();
    } else if (selectedNode == "multipleDocumentView") {
      this.setMultipleDocumentView();
    }
  };
  setMultipleDocumentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isMultipleDocFormOpened: true,
      isShowBackButton: false,
       isFabricInventoryAndSoAndPoOpen:false,
    });
  };
  setFabricStyleHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: true,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setSkuView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: true,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setMiscDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: true,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setAtsDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: true,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setInventoryDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: true,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setInventorySummaryDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: true,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setItemCostView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleItemCostViewOpen: true,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setCompositonView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleCompositionViewOpen: true,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setFabricDetailsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleDetailsViewOpen: true,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setEcomDetailsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: true,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setLogisticDetailsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setInOutStatisticsDetailsView = () => {
    this.closeAllNodeViews();
    this.statisticExecuteHandler();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: true,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setLotBasedInOutDetailsView = () => {
    this.closeAllNodeViews();
    this.statisticExecuteHandler();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: true,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setCustomerSalesDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: true,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };

  setFabricSalesDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: true,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };

  setCustomerSalesAndPurchaseDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: true,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };
  setPurchaseDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: true,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
        isMultipleDocFormOpened: false,
    });
  };

  setHoldingFabricDetailsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
       isFabricInventoryAndSoAndPoOpen:false,
      isFabricStyleHoldingDetailsViewOpen: true,
       isMultipleDocFormOpened: false,
     
    });
  };
    setFabricInventoryAndSoAndPoView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
       isMultipleDocFormOpened: false,
      isFabricInventoryAndSoAndPoOpen:true
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  unlockWithoutReadResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
      } else {
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockfabricStyle_WithoutRead = (fabricStyleCode) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = fabricStyleCode;
    if (fabricStyleCode != NEW_ENTRY) {
      if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
        FabricStyleService.unLockFabricStyle(
          request,
          this.unlockWithoutReadResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  unlockfabricStyle = (fabricStyleCode) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = fabricStyleCode;
    if (fabricStyleCode != NEW_ENTRY) {
      if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
        FabricStyleService.unLockFabricStyle(
          request,
          this.unlockFabricStyleResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  unlockFabricStyleResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        this.editfabricStyle(this.code);
      } else {
        this.showErrorMessage(response.data);
      }
    }
  };

  // unLockFabricStyle = (isNew) => {
  //   let fabricStyleData = this.state.fabricStyleData;
  //   let data = new RestEntityUnLockRequest();
  //   data.companyCode = this.companyCode;
  //   data.entityCode = fabricStyleData.code;
  //   data.isNew = isNew;
  //   if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
  //     FabricStyleService.unLockFabricStyle(
  //       data,
  //       this.unLockFabricStyleResponse,
  //       this.unLockFabricStyleError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);

  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // unLockFabricStyleResponse = (response) => {
  //   let isLocked = false;
  //   if (response.isSuccess) {
  //   } else {
  //     isLocked = false;
  //   }
  //   this.setState({ isLocked: isLocked });
  // };
  // unLockFabricStyleError = (error) => {
  //   this.setState({ isLoading: false });
  //   ShowError("Error : " + error);
  // };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let fabricStyle_list = this.state.fabricStyle_list;
    if (sortField && !isEmptyArray(fabricStyle_list)) {
      const sorted = [...fabricStyle_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ fabricStyle_list: sorted });
    }
  };
  savefabricStyle = (fabricStyleData) => {
    this.setState({ isLoading: true, loadingText: "Saving .." });
    fabricStyleData.currencyCode = DEFAULT_CURRENCY_CODE;
    let fabricLogisticPackageInfosDetails =
      this.state.fabricLogisticPackageInfosDetails;
    fabricLogisticPackageInfosDetails.companyCode = this.companyCode;
    fabricLogisticPackageInfosDetails.fabricStyleCode = fabricStyleData.code;
    fabricStyleData.fabricLogisticPackageInfosDetails =
      fabricLogisticPackageInfosDetails;
    fabricStyleData.fabricStyleLogisticPackageInfoCode =
      fabricLogisticPackageInfosDetails.code;
    if (fabricStyleData.isFetched) {
      if (SecurityAccessManager.ItemMaintenanceEdit_IsAccessible()) {
        FabricStyleService.updateFabricStyle(
          fabricStyleData,
          this.setFabricStyleResponse,
          this.setFabricStyleError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.ItemMaintenanceCreate_IsAccessible()) {
        FabricStyleService.createFabricStyle(
          fabricStyleData,
          this.setFabricStyleResponse,
          this.setFabricStyleError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  setFabricStyleError = (error) => {
    ShowError("Error : " + error);
  };
  setFabricStyleResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });

    this.handleResponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.fabricStyle)) {
      const fabricStyle = response.data.fabricStyle;
      if (response.data.success == true) {
        this.state.fabricStyleData = fabricStyle;
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          isLoading: false,
          fabricStyleData: fabricStyle,
          isLockRequired: true,
          isLocked: true,
          loadingText: "",
          pageTitle: pageTitle,
        });
        this.uploadItemImagesToServer();
        this.uploadColorImageToServer();
        if (this.state.moduleKeyCode == NEW_ENTRY) {
          this.editfabricStyle(response.data.fabricStyle.code);
        } else {
          this.code = response.data.fabricStyle.code;
          this.unlockfabricStyle(response.data.fabricStyle.code);
        }

        // setTimeout(() => {

        // this.editfabricStyle(response.data.fabricStyle.code);
        // }, 100);
      }
    }
  };
  openEntryForm = () => {
    this.clearError();
    this.getNodeList();
    this.closeAllNodeViews();
    this.setState({
      isFabricStyleListFormOpen: false,
      isFabricStyleEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowModuleSearchContainer: true,
      isShowNodes: true,
      isResetView: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLogisticUomList: false,
      logisticUomPageListForAutoCompleteList: new Array(),
    });
    let moduleOrderStatus = this.state.moduleOrderStatus;
    // let orderStatus = ModuleUtils.getPurchaseOrderStatusCaption(
    //   this.state.purchaseOrderData.orderStatus
    // );
    if (
      this.state.fabricStyleData.fabricStatus !== undefined &&
      this.state.fabricStyleData.fabricStatus !== null
    ) {
      moduleOrderStatus = this.state.fabricStyleData.fabricStatus;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        // isCustomerListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          isDisableNodeFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
  };
  closeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isFabricStyleListFormOpen: true,
      isFabricStyleEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      fabricLogisticPackageInfosDetails:
        new FabricStyleLogisticPackageInfoBean(),
      fabricStyleImagesList: new Array(),
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      colorImgUrl: "",
      mainImg: null,
      webImg: null,
      frontImg: null,
      BackImg: null,
      clrImg: null,
      colorList: new Array(),
      color___List: new Array(),
      isViewMode: false,
      isSpecialViewMode: false,
      isDisabledFields: false,
      isDisableNodeFields: false,
      isShowUserLookup: false,
      receiptContainerDatas: [],
      shippedContainerDatas: [],
      differenceQuantityList: [],

      receiptProjectNumberDatas: [],
      shippedProjectNumberDatas: [],

      statisticsCriteria: new FabricStyleInAndOutStatisticsCriteriaBean(),
      containerDatas: [],
      projectDatas: [],
 documents: [],
      preview_Docs: [],
      isShowDocLabel: false,
    });
  };
  defaultWareHouseCode = null;
  defaultInventoryUomCode = null;
  onChange = (e) => {
    let criteria = this.state.criteria;
    if (e.target.name == "criteriakey") {
      criteria["fabricStyleNameContainingText"] = e.target.value;
      criteria["fabricStyleCodeStartsWith"] = e.target.value;
    }
    this.setState({ criteria: criteria });
  };
  costOnChange = (e) => {
    let fabricStyleData = this.state.fabricStyleData;
    fabricStyleData[e.target.name] = e.target.value;
    this.setState({ fabricStyleData: fabricStyleData });
  };
  loadFabricStylePage = () => {
    let requestInput = new RestCustomerListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.ItemMaintenanceView_IsAccessible()) {
      FabricStyleService.getFabricStylePageList(
        requestInput,
        this.loadFabricStyleResponse,
        this.loadFabricStyleError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFabricStyleResponse = (response) => {
    let fabricStyle_list = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStylePageList) &&
      !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
    ) {
      fabricStyle_list = response.data.fabricStylePageList.fabricStyles;
      this.state.pageList.totalCount =
        response.data.fabricStylePageList.totalCount;
      this.state.pageList.currentPage =
        response.data.fabricStylePageList.currentPage;
    } else {
      fabricStyle_list = new Array();
    }
    this.setState({
      fabricStyle_list: fabricStyle_list,
      isLoading: false,
      loadingText: "",
    });
  };
  loadFabricStyleError = (error) => {
    ShowError("Error : ", error);
  };
  addorUpdateSkuCost = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let selectedSkuLine = this.state.selectedSkuLine;
    selectedSkuLine.companyCode = this.companyCode;
    let skuLines = new Array();
    if (!isEmptyArray(fabricStyleData.fabricStyleSkus))
      skuLines = fabricStyleData.fabricStyleSkus;

    if (!isEmptyArray(skuLines)) {
      skuLines.map((line, i) => {
        if (line.skuNumber == selectedSkuLine.skuNumber) {
          selectedSkuLine.isFetched = line.isFetched;
          skuLines[i] = selectedSkuLine;
        }
      });
    }

    fabricStyleData.fabricStyleSkus = skuLines;
    this.setState({
      fabricStyleData: fabricStyleData,
    });
  };
  // addorUpdateSkuCost = (selectedSkuLine) => {
  //   let _temp_fabricStyleData = this.state.fabricStyleData;
  //   let _temp_fabricStyleSkuData = this.state.fabricStyleData.fabricStyleSkus;
  //   let _temp_selectedVendorCostSkuLine =
  //     selectedSkuLine.skuCostBean.skuVendorCosts;
  //   let dbSkuVendorCosts = new Array();
  //   if (_temp_fabricStyleData != null) {
  //     if (_temp_fabricStyleData.fabricStyleSkus != null) {
  //       const index = _temp_fabricStyleSkuData.findIndex(
  //         (ln) => ln.skuNumber === selectedSkuLine.skuNumber
  //       );
  //       let _dbSkuLine = _temp_fabricStyleSkuData[index];
  //       if (_dbSkuLine != null) {
  //         dbSkuVendorCosts = _dbSkuLine.skuCostBean.skuVendorCosts;
  //         if (dbSkuVendorCosts != null) {
  //           _temp_selectedVendorCostSkuLine.map((_tempskuvendorPrice) => {
  //             const eIndex = dbSkuVendorCosts.findIndex(
  //               (ln) =>
  //                 ln.skuNumber === _tempskuvendorPrice.skuNumber &&
  //                 ln.lineNumber === _tempskuvendorPrice.lineNumber
  //             );
  //             if (eIndex != -1) {
  //               dbSkuVendorCosts[eIndex] = _tempskuvendorPrice;
  //             } else {
  //               dbSkuVendorCosts.push(_tempskuvendorPrice);
  //             }
  //           });
  //         }
  //       }
  //       _dbSkuLine.skuCostBean.skuVendorCosts = dbSkuVendorCosts;
  //       _temp_fabricStyleData.fabricStyleSkus[
  //         index
  //       ].skuCostBean.skuVendorCosts = _dbSkuLine.skuCostBean.skuVendorCosts;
  //     }
  //   }
  //   this.setState({ fabricStyleData: _temp_fabricStyleData });
  // };
  toCustomerSkuPriceLines = (ln, lines, lineNumber) => {
    let customerPriceData = new FabricStyleSKUCustomerPriceBean();
    customerPriceData.companyCode = this.companyCode;
    customerPriceData.skuNumber = ln.skuNumber;
    customerPriceData.fabricStyleCode = ln.fabricStyleCode;
    customerPriceData.fabricStyleColorCode = ln.fabricStyleColorCode;
    customerPriceData.lineNumber = lineNumber;
    customerPriceData.uomCode = ln.uomCode;
    customerPriceData.effectiveDate = lines.effectiveDate;
    customerPriceData.price = lines.price;
    customerPriceData.samplePrice = lines.samplePrice;
    customerPriceData.customerCode = lines.customerCode;
    customerPriceData.customerName = lines.customerName;
    customerPriceData.customerTypeCode = lines.customerTypeCode;
    customerPriceData.customerTypeName = lines.customerTypeName;
    customerPriceData.systemRemarks = lines.systemRemarks;
    customerPriceData.discountPercentage = lines.discountPercentage;
    customerPriceData.updatedBatchCode = lines.updatedBatchCode;
    customerPriceData.updateBatchLineNumber = lines.updateBatchLineNumber;
    customerPriceData.currencyCode = ln.currencyCode;
    customerPriceData.fromDate = lines.fromDate;
    customerPriceData.toDate = lines.toDate;
    customerPriceData.customerShipToCode = lines.customerShipToCode;
    customerPriceData.code = "";
    customerPriceData.description = "";
    // customerPrices.push(customerPriceData);

    return customerPriceData;
  };
  applyToAllSkuPrice = () => {
    const selectedSkuLine = this.state.selectedSkuLine;
    const selectedSkuPriceBean = this.state.selectedSkuLine.skuPriceBean;
    let skuCustomerPrices = selectedSkuPriceBean.skuCustomerPrices;
    let customerPrices = new Array();

    let fabricStyleData = this.state.fabricStyleData;
    let fabricStyleSkuList = this.state.fabricStyleData.fabricStyleSkus;
    // var lineNumber = this.getMaxLineNumberSkuCustomerPriceLines();
    fabricStyleSkuList.map((ln) => {
      let priceBean = ln.skuPriceBean;

      ln.samplePrice = selectedSkuPriceBean.samplePrice;
      priceBean.samplePrice = selectedSkuPriceBean.samplePrice;
      priceBean.defaultPrice = selectedSkuPriceBean.defaultPrice;

      if (ln.skuNumber != selectedSkuLine.skuNumber) {
        if (priceBean.skuCustomerPrices != null) {
          customerPrices = priceBean.skuCustomerPrices;
        }
        // if (
        //   priceBean.skuCustomerPrices == null &&
        //   isEmptyArray(priceBean.skuCustomerPrices)
        //   // priceBean.skuCustomerPrices.length <= 0
        // ) {
        skuCustomerPrices.map((lines) => {
          let lineNumber = lines.lineNumber;
          if (!isEmptyArray(customerPrices) && customerPrices != undefined) {
            customerPrices.map((list) => {
              lineNumber = list.lineNumber++;
            });
          }
          let lineData = this.toCustomerSkuPriceLines(ln, lines, lineNumber);
          customerPrices.push(lineData);
        });
        priceBean.skuCustomerPrices = customerPrices;
      }
    });
    this.setState({ fabricStyleData: fabricStyleData });
    this.closeSkuPricePopup();
  };
  addorUpdateSkuPrice = () => {
    const selectedSkuLine = this.state.selectedSkuLine;
    let _temp_fabricStyleData = this.state.fabricStyleData;
    let _temp_fabricStyleSkuData = this.state.fabricStyleData.fabricStyleSkus;
    if (_temp_fabricStyleData != null) {
      if (_temp_fabricStyleSkuData != null) {
        const index = _temp_fabricStyleSkuData.findIndex(
          (ln) => ln.skuNumber === selectedSkuLine.skuNumber,
        );
        if (!isEmptyArray(selectedSkuLine.skuPriceBean.skuCustomerPrices)) {
          let _temp_selectedCustomerpriceSkuLine = [
            ...selectedSkuLine.skuPriceBean.skuCustomerPrices,
          ];

          let dbSkuCustomerPrices = new Array();
          if (_temp_fabricStyleData.fabricStyleSkus != null) {
            let _dbSkuLine = _temp_fabricStyleSkuData[index];
            if (_dbSkuLine != null) {
              dbSkuCustomerPrices = [
                ..._dbSkuLine.skuPriceBean.skuCustomerPrices,
              ];
              if (dbSkuCustomerPrices != null) {
                _temp_selectedCustomerpriceSkuLine.map(
                  (_tempskuvendorPrice) => {
                    const eIndex = dbSkuCustomerPrices.findIndex(
                      (ln) =>
                        ln.skuNumber === _tempskuvendorPrice.skuNumber &&
                        ln.lineNumber === _tempskuvendorPrice.lineNumber,
                    );
                    if (eIndex != -1) {
                      dbSkuCustomerPrices[eIndex] = _tempskuvendorPrice;
                    } else {
                      dbSkuCustomerPrices.push(_tempskuvendorPrice);
                    }
                  },
                );
              }
            }
            _dbSkuLine.skuPriceBean.skuCustomerPrices = dbSkuCustomerPrices;
            _temp_fabricStyleData.fabricStyleSkus[
              index
            ].skuPriceBean.skuCustomerPrices =
              _dbSkuLine.skuPriceBean.skuCustomerPrices;
          }
        }

        let _dbSkuLine = _temp_fabricStyleSkuData[index];
        if (_dbSkuLine != null) {
          _temp_fabricStyleData.fabricStyleSkus[index].wholesalePrice =
            selectedSkuLine.skuPriceBean.defaultPrice;
          _temp_fabricStyleData.fabricStyleSkus[index].samplePrice =
            selectedSkuLine.skuPriceBean.samplePrice;
        }
      }
      this.setState({ fabricStyleData: _temp_fabricStyleData });
    }
    this.closeSkuPricePopup();
  };
  addorUpdateSkuPrice_ = () => {
    const selectedSkuLine = this.state.selectedSkuLine;
    let fabricStyleData = new FabricStyleBean();
    if (!isEmpty(this.state.fabricStyleData))
      fabricStyleData = this.state.fabricStyleData;
    let fabricStyleSkus = new Array();
    if (!isEmptyArray(this.state.fabricStyleData.fabricStyleSkus))
      fabricStyleSkus = this.state.fabricStyleData.fabricStyleSkus;
    if (fabricStyleData != null) {
      if (fabricStyleSkus != null) {
        // map
      }
    }
    this.setState({ fabricStyleData: fabricStyleData });
    this.closeSkuPricePopup();
  };
  validateVendorReferenceLine = (vendorReferenceData) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";

    if (vendorReferenceData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(vendorReferenceData.vendorCode)) {
        let errMsg = "VendorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(vendorReferenceData.vendorName)) {
        let errMsg = "Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }

    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        isShowPopupAlert: true,
        alertMessage: err_list,
        alertType: "danger",
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  getMaxLineNumberVendorReferenceLines = () => {
    let maxLineNumber = 0;
    let fabricStyleData = this.state.fabricStyleData;
    if (
      !isEmpty(fabricStyleData) &&
      !isEmptyArray(fabricStyleData.vendorReferences)
    ) {
      fabricStyleData.vendorReferences.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  addorUpdateVendorReference = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let venReferenceData = this.state.venReferenceData;
    venReferenceData.companyCode = this.companyCode;
    venReferenceData.code = fabricStyleData.code;
    let vendor_References = new Array();
    if (!isEmptyArray(fabricStyleData.vendorReferences))
      vendor_References = fabricStyleData.vendorReferences;
    let isValid = false;
    isValid = this.validateVendorReferenceLine(venReferenceData);
    if (isValid) {
      var lineNumber = this.getMaxLineNumberVendorReferenceLines();
      let isLineFound = false;
      if (!isEmptyArray(vendor_References)) {
        vendor_References.map((line, i) => {
          if (
            line.vendorCode == venReferenceData.vendorCode &&
            line.lineNumber == venReferenceData.lineNumber
          ) {
            venReferenceData.lineNumber = line.lineNumber;
            venReferenceData.isFetched = line.isFetched;
            const fabClrVendorReferences = new Array();
            if (!isEmptyArray(line.fabricStyleColorVendorReferences)) {
              line.fabricStyleColorVendorReferences.map((fabClrLine) => {
                // fabClrLine.vendorCode = line.vendorCode;
                fabClrLine.isFetched = true;
                fabClrVendorReferences.push({ ...fabClrLine });
              });
            }
            venReferenceData.fabricStyleColorVendorReferences =
              fabClrVendorReferences;
            vendor_References[i] = venReferenceData;
            isLineFound = true;
          }
          //  else if (line.lineNumber == venReferenceData.lineNumber) {
          //   venReferenceData.isFetched = line.isFetched;
          //   vendor_References[i] = venReferenceData;
          //   isLineFound = true;
          // }
        });
      }
      if (!isLineFound) {
        venReferenceData.lineNumber = ++lineNumber;
        vendor_References.push(venReferenceData);
      }
      fabricStyleData.vendorReferences = vendor_References;
      this.setState({
        fabricStyleData: fabricStyleData,
        // isDisablePopupFields: true,
      });
      // this.closeNonMerchandiseLineAlertModalCallBack(false);
    }
  };

  // addorUpdateVendorReference = (selectedVendorRefData) => {
  //   let _temp_fabricStyleData = this.state.fabricStyleData;
  //   if (!isEmptyString(selectedVendorRefData.vendorCode)) {
  //     let _temp_fabricStylevendorRefData =
  //       this.state.fabricStyleData.vendorReferences;

  //     if (
  //       selectedVendorRefData.fabricStyleColorVendorReferences != null &&
  //       selectedVendorRefData.fabricStyleColorVendorReferences.length > 0
  //     ) {
  //       selectedVendorRefData.companyCode = this.companyCode;
  //       let _temp_selectectedVendorClrRefLine =
  //         selectedVendorRefData.fabricStyleColorVendorReferences;
  //       let dbVendorFabricColorRef = new Array();
  //       if (_temp_fabricStyleData != null) {
  //         if (_temp_fabricStylevendorRefData != null) {
  //           const index = _temp_fabricStylevendorRefData.findIndex(
  //             (ln) => ln.vendorCode === selectedVendorRefData.vendorCode
  //           );
  //           let _dbVendorRefLine = _temp_fabricStylevendorRefData[index];
  //           if (_dbVendorRefLine != null) {
  //             dbVendorFabricColorRef =
  //               _dbVendorRefLine.fabricStyleColorVendorReferences;
  //             if (dbVendorFabricColorRef != null) {
  //               _temp_selectectedVendorClrRefLine.map((_tempClrRef) => {
  //                 const eIndex = dbVendorFabricColorRef.findIndex(
  //                   (ln) =>
  //                     ln.vendorCode === _tempClrRef.vendorCode &&
  //                     ln.fabricStyleCode === _tempClrRef.fabricStyleCode &&
  //                     ln.fabricStyleColorCode ===
  //                       _tempClrRef.fabricStyleColorCode
  //                 );
  //                 _tempClrRef.isFetched = true;
  //                 if (eIndex != -1) {
  //                   dbVendorFabricColorRef[eIndex] = _tempClrRef;
  //                 } else {
  //                   dbVendorFabricColorRef.push(_tempClrRef);
  //                 }
  //               });
  //             }
  //             _dbVendorRefLine.fabricStyleColorVendorReferences =
  //               dbVendorFabricColorRef;
  //             _temp_fabricStyleData.vendorReferences[
  //               index
  //             ].fabricStyleColorVendorReferences =
  //               _dbVendorRefLine.fabricStyleColorVendorReferences;
  //           } else {
  //             _temp_fabricStyleData.vendorReferences.push(
  //               selectedVendorRefData
  //             );
  //           }
  //         } else {
  //           _temp_fabricStyleData.vendorReferences = [];
  //           _temp_fabricStyleData.vendorReferences.push(selectedVendorRefData);
  //         }
  //       }
  //     }
  //     this.setState({ fabricStyleData: _temp_fabricStyleData });
  //   } else {
  //     let errMsg = "Vendor Code is Required";
  //     let errList = [];
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowPopupAlert: true,
  //     });
  //   }
  // };
  getModuleListView = () => {
    let fabricData = this.state.fabricStyleData;
    if (fabricData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadFabricStylePage();
    } else {
      if (!this.state.isViewMode)
        this.unlockfabricStyle_WithoutRead(fabricData.code);
      this.closeEntryForm();
      this.loadFabricStylePage();
    }
    this.hideAlertCallBack();
  };
  closeAllNodeViews = () => {
    this.setState({
      isEntryFormOpen: false,
      isListFormOpen: false,
      isFabricStyleSkuViewOpen: false,
      isFabricStyleItemCostViewOpen: false,
      isFabricStyleCompositionViewOpen: false,
      isFabricStyleDetailsViewOpen: false,
      isFabricStyleMiscDetailViewOpen: false,
      isFabricStyleAtsDetailViewOpen: false,
      isFabricStyleLotBasedInvDetailViewOpen: false,
      isfabricStyleEcomDetailsViewOpen: false,
      isFabricStyleLogisticInfoViewOpen: false,
      isFabricStyleLotBasedSummaryViewOpen: false,
      isFabricStyleCustomerSalesViewOpen: false,
      isFabricStylePurchaseViewOpen: false,
      isFabricStyleInOutStatisticsViewOpen: false,
      isFabricStyleLotBasedInventoryInOutViewOpen: false,
      isFabricStyleCustomerSalesAndPurchaseViewOpen: false,
      isFabricStyleSalesViewOpen: false,
      isFabricStyleHoldingDetailsViewOpen: false,
      isFabricInventoryAndSoAndPoOpen: false,
      isMultipleDocFormOpened: false,
    });
    this.clearStatisticNode();
  };

  clearStatisticNode = () => {
    this.setState({
      receiptContainerDatas: [],
      shippedContainerDatas: [],
      differenceQuantityList: [],

      receiptProjectNumberDatas: [],
      shippedProjectNumberDatas: [],

      statisticsCriteria: new FabricStyleInAndOutStatisticsCriteriaBean(),
      containerDatas: [],
      projectDatas: [],
    });
  };  
  resetView = () => {

    let fabricData = this.state.fabricStyleData;
    // if (fabricData.code != NEW_ENTRY) {
    this.state.isReseted = true;
    if (!this.state.isViewMode)
      this.unlockfabricStyle_WithoutRead(fabricData.code);
    // }
    let fabricStyleData = new FabricStyleBean();
    this.setState(
      {
        fabricStyleData: fabricStyleData,
        isResetModule: true,
        moduleKeyCode: NEW_ENTRY,
        disabled: false,
        isFocusLookup: true,
        isFocus: false,
        fabricLogisticPackageInfosDetails:
          new FabricStyleLogisticPackageInfoBean(),
        isShowAutoCompleteLogisticUomList: false,
        logisticUomPageListForAutoCompleteList: new Array(),
        fabricStyleImagesList: new Array(),
        mainImageUrl: "",
        webImageUrl: "",
        frontImageUrl: "",
        backImageUrl: "",
        colorImgUrl: "",
        mainImg: null,
        webImg: null,
        isReseted: true,
        frontImg: null,
        BackImg: null,
        clrImg: null,
        colorList: new Array(),
        color___List: new Array(),
        disableStackableQty: true,
        isShowUserLookup: false,
 documents: [],
        preview_Docs: [],
        isShowDocLabel: false,
      },
      () => {
        this.code = NEW_ENTRY;
        this.state.moduleKeyCode = NEW_ENTRY;
        this.state.isViewMode = false;
        this.hideAlertCallBack();
        this.addNewEntry();
        this.clearStatisticNode();
      },
    );
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
    let fabricData = this.state.fabricStyleData;
    //this.unlockfabricStyle_WithoutRead(fabricData.code);
  };
  selectButtonClick = (e) => {
    this.editfabricStyle(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  onPatternTypeCodeChange = (e) => {
    let productTypeCode = e.target.value;
    this.state.showAutoCompletePatternTypeList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
    if (isEmpty(productTypeCode)) {
      this.state.showAutoCompletePatternTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      let soLine = this.state.fabricStyleData;
      soLine.productTypeCode = "";
      soLine.productTypeName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        patternTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      showAutoCompleteList === true &&
      productTypeCode !== "" &&
      e.target.name == "productTypeCode"
    ) {
      this.readPatternTypeBySearchString(productTypeCode);
      this.readPatternType(productTypeCode);
    }
    // if (e.target.name == "productTypeCode") {
    //   temp_fabricStyledata["productTypeCode"] = e.target.value;
    //   let productType_List = this.state.productTypes;
    //   productType_List.map((pdtType) => {
    //     if (pdtType.code == e.target.value) {
    //       temp_fabricStyledata["productTypeCode"] = pdtType.code;
    //       temp_fabricStyledata["productTypeName"] = pdtType.description;
    //       this.state.showAutoCompletePatternTypeList = false;
    //       let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
    //       this.setState({ showAutoCompleteList: showAutoCompleteList });
    //     }
    //   });
    // }
    temp_fabricStyledata[e.target.name] = e.target.value.toUpperCase();
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readPatternType = (productTypeCode) => {
    let tempData = this.state.fabricStyleData;
    let productTypeBean = null;
    let productTypeData = null;
    this.state.productTypes.map((ln) => {
      if (ln.code === productTypeCode) {
        productTypeBean = ln;
        productTypeData = new BaseBean();
        productTypeData.code = ln.code;
        productTypeData.description = ln.description;
      }
    });
    if (!isEmpty(productTypeBean)) {
      tempData.productTypeCode = productTypeBean.code;
      this.state.showAutoCompletePatternTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      this.setState({
        fabricStyleData: tempData,
        showAutoCompletePatternTypeList: showAutoCompleteList,
      });
    }
  };

  readPatternTypeBySearchString(searchString) {
    let patternTypeData = this.state.productTypes;
    let simpleAutoCompleteList = new Array();
    if (patternTypeData.length > 0 && patternTypeData != null) {
      patternTypeData.map((patternTypeDatas) => {
        let simpleItemBean = {
          code: patternTypeDatas.code,
          description: patternTypeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletePatternTypeLists) =>
        simpleAutoCompletePatternTypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      patternTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  patternTypeEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let productTypeCode = e.target.value;
    temp_fabricStyledata["productTypeCode"] = e.target.value;
    let productType_List = this.state.productTypes;
    let productTypeCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        productTypeCodeBean = pdtType;
      }
    });
    if (!isEmpty(productTypeCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.productTypeCode = productTypeCodeBean.code;
      temp_fabricStyledata.productTypeName = productTypeCodeBean.description;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        patternTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onTypeCodeChange = (e) => {
    let patternTypeCode = e.target.value;
    this.state.showAutoCompleteTypeList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteTypeList;
    if (isEmpty(patternTypeCode)) {
      this.state.showAutoCompleteTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteTypeList;
      let soLine = this.state.fabricStyleData;
      soLine.patternTypeCode = "";
      soLine.patternTypeName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        typePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && patternTypeCode !== "") {
      this.readTypeBySearchString(patternTypeCode);
    }
    if (e.target.name == "patternTypeCode") {
      temp_fabricStyledata["patternTypeCode"] = e.target.value;
      let productType_List = this.state.patternTypes;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["patternTypeCode"] = pdtType.code;
          temp_fabricStyledata["patternTypeName"] = pdtType.description;
          this.state.showAutoCompleteTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readTypeBySearchString(searchString) {
    let patternTypeData = this.state.patternTypes;
    let simpleAutoCompleteList = new Array();
    if (patternTypeData.length > 0 && patternTypeData != null) {
      patternTypeData.map((typeDatas) => {
        let simpleItemBean = {
          code: typeDatas.code,
          description: typeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletetypeLists) =>
        simpleAutoCompletetypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ typePageListForAutoCompleteList: filteredSuggestions });
  }
  typeEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let patternTypeCode = e.target.value;
    temp_fabricStyledata["patternTypeCode"] = e.target.value;
    let productType_List = this.state.patternTypes;
    let patternTypeCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        patternTypeCodeBean = pdtType;
      }
    });
    if (!isEmpty(patternTypeCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.patternTypeCode = patternTypeCodeBean.code;
      temp_fabricStyledata.patternTypeName = patternTypeCodeBean.description;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        typePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onMakeTypeCodeChange = (e) => {
    let makeTypeCode = e.target.value;
    this.state.showAutoCompleteMakeTypeList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
    if (isEmpty(makeTypeCode)) {
      this.state.showAutoCompleteMakeTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
      let soLine = this.state.fabricStyleData;
      soLine.makeTypeCode = "";
      soLine.makeTypeName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        makeTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && makeTypeCode !== "") {
      this.readMakeTypeBySearchString(makeTypeCode);
    }
    if (e.target.name == "makeTypeCode") {
      temp_fabricStyledata["makeTypeCode"] = e.target.value;
      let productType_List = this.state.makeTypes;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["makeTypeCode"] = pdtType.code;
          temp_fabricStyledata["makeTypeName"] = pdtType.description;
          this.state.showAutoCompleteMakeTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readMakeTypeBySearchString(searchString) {
    let makeTypeData = this.state.makeTypes;
    let simpleAutoCompleteList = new Array();
    if (makeTypeData.length > 0 && makeTypeData != null) {
      makeTypeData.map((makeTypeDatas) => {
        let simpleItemBean = {
          code: makeTypeDatas.code,
          description: makeTypeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletetypeLists) =>
        simpleAutoCompletetypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ makeTypePageListForAutoCompleteList: filteredSuggestions });
  }
  makeTypeEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let makeTypeCode = e.target.value;
    temp_fabricStyledata["makeTypeCode"] = e.target.value;
    let productType_List = this.state.makeTypes;
    let makeTypeCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        makeTypeCodeBean = pdtType;
      }
    });
    if (!isEmpty(makeTypeCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.makeTypeCode = makeTypeCodeBean.code;
      temp_fabricStyledata.makeTypeName = makeTypeCodeBean.description;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        makeTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onUseCodeChange = (e) => {
    let patternTypeCategoryCode = e.target.value;
    this.state.showAutoCompletePatternTypeCategoryCodeList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList =
      this.state.showAutoCompletePatternTypeCategoryCodeList;
    if (isEmpty(patternTypeCategoryCode)) {
      this.state.showAutoCompletePatternTypeCategoryCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompletePatternTypeCategoryCodeList;
      let soLine = this.state.fabricStyleData;
      soLine.patternTypeCategoryCode = "";
      soLine.patternTypeCategoryName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        usePageListForAutoCompleteList: suggestion,
      });
    } else if (
      showAutoCompleteList === true &&
      patternTypeCategoryCode !== ""
    ) {
      this.readUseBySearchString(patternTypeCategoryCode);
    }
    if (e.target.name == "patternTypeCategoryCode") {
      temp_fabricStyledata["patternTypeCategoryCode"] = e.target.value;
      let productType_List = this.state.patternTypeCategories;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["patternTypeCategoryCode"] = pdtType.code;
          temp_fabricStyledata["patternTypeCategoryName"] = pdtType.description;
          this.state.showAutoCompletePatternTypeCategoryCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompletePatternTypeCategoryCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readUseBySearchString(searchString) {
    let patternTypeCategoryData = this.state.patternTypeCategories;
    let simpleAutoCompleteList = new Array();
    if (patternTypeCategoryData.length > 0 && patternTypeCategoryData != null) {
      patternTypeCategoryData.map((patternTypeCategoryDatas) => {
        let simpleItemBean = {
          code: patternTypeCategoryDatas.code,
          description: patternTypeCategoryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletePatternTypeCategoryCodeLists) =>
        simpleAutoCompletePatternTypeCategoryCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ usePageListForAutoCompleteList: filteredSuggestions });
  }
  useEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let patternTypeCategoryCode = e.target.value;
    temp_fabricStyledata["patternTypeCategoryCode"] = e.target.value;
    let productType_List = this.state.patternTypeCategories;
    let patternTypeCategoryCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        patternTypeCategoryCodeBean = pdtType;
      }
    });
    if (!isEmpty(patternTypeCategoryCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.patternTypeCategoryCode =
        patternTypeCategoryCodeBean.code;
      temp_fabricStyledata.patternTypeCategoryName =
        patternTypeCategoryCodeBean.description;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        usePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onDivisionCodeChange = (e) => {
    let divisionCode = e.target.value;
    this.state.showAutoCompleteDivisionCodeList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteDivisionCodeList;
    if (isEmpty(divisionCode)) {
      this.state.showAutoCompleteDivisionCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteDivisionCodeList;
      let soLine = this.state.fabricStyleData;
      soLine.divisionCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        divisionPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && divisionCode !== "") {
      this.readDivisionCodeBySearchString(divisionCode);
    }
    if (e.target.name == "divisionCode") {
      temp_fabricStyledata["divisionCode"] = e.target.value;
      let productType_List = this.state.productDivisions;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["divisionCode"] = pdtType.code;
          this.state.showAutoCompleteDivisionCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteDivisionCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readDivisionCodeBySearchString(searchString) {
    let divisionCodeData = this.state.productDivisions;
    let simpleAutoCompleteList = new Array();
    if (divisionCodeData.length > 0 && divisionCodeData != null) {
      divisionCodeData.map((divisionCodeDatas) => {
        let simpleItemBean = {
          code: divisionCodeDatas.code,
          description: divisionCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteDivisionCodeLists) =>
        simpleAutoCompleteDivisionCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ divisionPageListForAutoCompleteList: filteredSuggestions });
  }
  divisionEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let divisionCode = e.target.value;
    temp_fabricStyledata["divisionCode"] = e.target.value;
    let productType_List = this.state.productDivisions;
    let divisionCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        divisionCodeBean = pdtType;
      }
    });
    if (!isEmpty(divisionCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.divisionCode = divisionCodeBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        divisionPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onStyleItemTypeChange = (e) => {
    let styleItemType = e.target.value;
    this.state.showAutoCompleteStyleItemTypeList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteStyleItemTypeList;
    if (isEmpty(styleItemType)) {
      this.state.showAutoCompleteStyleItemTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStyleItemTypeList;
      let soLine = this.state.fabricStyleData;
      soLine.styleItemType = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        styleItemTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && styleItemType !== "") {
      this.readStyleItemTypeBySearchString(styleItemType);
    }
    if (e.target.name == "styleItemType") {
      temp_fabricStyledata["styleItemType"] = e.target.value;
      let productType_List = this.state.styleItemTypes;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["styleItemType"] = pdtType.code;
          temp_fabricStyledata["styleItemTypeName"] = pdtType.description;
          this.state.showAutoCompleteStyleItemTypeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteStyleItemTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readStyleItemTypeBySearchString(searchString) {
    let styleItemTypeData = this.state.styleItemTypes;
    let simpleAutoCompleteList = new Array();
    if (styleItemTypeData.length > 0 && styleItemTypeData != null) {
      styleItemTypeData.map((styleItemTypeDatas) => {
        let simpleItemBean = {
          code: styleItemTypeDatas.code,
          description: styleItemTypeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestyleItemTypeLists) =>
        simpleAutoCompletestyleItemTypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      styleItemTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  styleItemTypeEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let styleItemType = e.target.value;
    temp_fabricStyledata["styleItemType"] = e.target.value;
    let productType_List = this.state.styleItemTypes;
    let styleItemTypeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        styleItemTypeBean = pdtType;
      }
    });
    if (!isEmpty(styleItemTypeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.styleItemType = styleItemTypeBean.code;
      temp_fabricStyledata.styleItemTypeName = styleItemTypeBean.description;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        styleItemTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onStatsChange = (e) => {
    let stats = e.target.value;
    this.state.showAutoCompleteStatsList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteStatsList;
    if (isEmpty(stats)) {
      this.state.showAutoCompleteStatsList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStatsList;
      let soLine = this.state.fabricStyleData;
      soLine.stats = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        statsPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && stats !== "") {
      this.readStatsBySearchString(stats);
    }
    if (e.target.name == "stats") {
      temp_fabricStyledata["stats"] = e.target.value;
      let productType_List = this.state.productStatuses;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["stats"] = pdtType.code;
          this.state.showAutoCompleteStatsList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStatsList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readStatsBySearchString(searchString) {
    let statsData = this.state.productStatuses;
    let simpleAutoCompleteList = new Array();
    if (statsData.length > 0 && statsData != null) {
      statsData.map((statsDatas) => {
        let simpleItemBean = {
          code: statsDatas.code,
          description: statsDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestatsLists) =>
        simpleAutoCompletestatsLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ statsPageListForAutoCompleteList: filteredSuggestions });
  }
  statsEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let stats = e.target.value;
    temp_fabricStyledata["stats"] = e.target.value;
    let productType_List = this.state.productStatuses;
    let statsBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        statsBean = pdtType;
      }
    });
    if (!isEmpty(statsBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.stats = statsBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        statsPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCurrencyCodeChange = (e) => {
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let soLine = this.state.fabricStyleData;
      soLine.currencyCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeBySearchString(currencyCode);
    }
    if (e.target.name == "currencyCode") {
      temp_fabricStyledata["currencyCode"] = e.target.value;
      let productType_List = this.state.currencies;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["currencyCode"] = pdtType.code;
          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readCurrencyCodeBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currencyCodeDatas) => {
        let simpleItemBean = {
          code: currencyCodeDatas.code,
          description: currencyCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      currencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  currencyCodeEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let currencyCode = e.target.value;
    temp_fabricStyledata["currencyCode"] = e.target.value;
    let productType_List = this.state.currencies;
    let currencyCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        currencyCodeBean = pdtType;
      }
    });
    if (!isEmpty(currencyCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.currencyCode = currencyCodeBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };

  onLocationChange = (e) => {
    let defaultLocationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(defaultLocationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let soLine = this.state.fabricStyleData;
      soLine.defaultLocationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && defaultLocationCode !== "") {
      this.readLocationBySearchString(defaultLocationCode);
    }
    if (e.target.name == "defaultLocationCode") {
      temp_fabricStyledata["defaultLocationCode"] = e.target.value;
      let productType_List = this.state.warehouses;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["defaultLocationCode"] = pdtType.code;
          this.state.showAutoCompleteLocationList = false;
          let showAutoCompleteList = this.state.showAutoCompleteLocationList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readLocationBySearchString(searchString) {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((locations) => {
        let simpleItemBean = {
          code: locations.code,
          description: locations.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  }
  locationEnterKeyEventHandler = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let defaultLocationCode = e.target.value;
    temp_fabricStyledata["defaultLocationCode"] = e.target.value;
    let productType_List = this.state.warehouses;
    let locationCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        locationCodeBean = pdtType;
      }
    });
    if (!isEmpty(locationCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.defaultLocationCode = locationCodeBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        locationPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onWeightUomChange = (e) => {
    let weightUomCode = e.target.value;
    this.state.showAutoCompleteWeightUomList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteWeightUomList;
    if (isEmpty(weightUomCode)) {
      this.state.showAutoCompleteWeightUomList = false;
      let showAutoCompleteList = this.state.showAutoCompleteWeightUomList;
      let soLine = this.state.fabricStyleData;
      soLine.weightUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        weightUomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && weightUomCode !== "") {
      this.readweightUomCodeBySearchString(weightUomCode);
    }
    if (e.target.name == "weightUomCode") {
      temp_fabricStyledata["weightUomCode"] = e.target.value;
      let productType_List = this.state.weightUOMs;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["weightUomCode"] = pdtType.code;
          this.state.showAutoCompleteWeightUomList = false;
          let showAutoCompleteList = this.state.showAutoCompleteWeightUomList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readweightUomCodeBySearchString(searchString) {
    let weightUomCodeData = this.state.weightUOMs;
    let simpleAutoCompleteList = new Array();
    if (weightUomCodeData.length > 0 && weightUomCodeData != null) {
      weightUomCodeData.map((weightUomCodes) => {
        let simpleItemBean = {
          code: weightUomCodes.code,
          description: weightUomCodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteweightUomCodeLists) =>
        simpleAutoCompleteweightUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      weightUomPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  weightUomEnterKeyEventHandler = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let weightUomCode = e.target.value;
    temp_fabricStyledata["weightUomCode"] = e.target.value;
    let productType_List = this.state.weightUOMs;
    let weightUomCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        weightUomCodeBean = pdtType;
      }
    });
    if (!isEmpty(weightUomCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.weightUomCode = weightUomCodeBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        weightUomPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onHtsChange = (e) => {
    let hts = e.target.value;
    this.state.showAutoCompleteHtsList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteHtsList;
    if (isEmpty(hts)) {
      this.state.showAutoCompleteHtsList = false;
      let showAutoCompleteList = this.state.showAutoCompleteHtsList;
      let soLine = this.state.fabricStyleData;
      soLine.hts = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        htsPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && hts !== "") {
      this.readHtsBySearchString(hts);
    }
    if (e.target.name == "hts") {
      temp_fabricStyledata["hts"] = e.target.value;
      let productType_List = this.state.htses;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["hts"] = pdtType.code;
          this.state.showAutoCompleteHtsList = false;
          let showAutoCompleteList = this.state.showAutoCompleteHtsList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readHtsBySearchString(searchString) {
    let htsData = this.state.htses;
    let simpleAutoCompleteList = new Array();
    if (htsData.length > 0 && htsData != null) {
      htsData.map((htses) => {
        let simpleItemBean = {
          code: htses.code,
          description: htses.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletehtsLists) =>
        simpleAutoCompletehtsLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ htsPageListForAutoCompleteList: filteredSuggestions });
  }
  htsEnterKeyEventHandler = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let hts = e.target.value;
    temp_fabricStyledata["hts"] = e.target.value;
    let productType_List = this.state.htses;
    let htsBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        htsBean = pdtType;
      }
    });
    if (!isEmpty(htsBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.hts = htsBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        htsPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onSeasonChange = (e) => {
    let seasonCode = e.target.value;
    this.state.showAutoCompleteSeasonList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteSeasonList;
    if (isEmpty(seasonCode)) {
      this.state.showAutoCompleteSeasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSeasonList;
      let soLine = this.state.fabricStyleData;
      soLine.seasonCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        seasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && seasonCode !== "") {
      this.readSeasonCodeBySearchString(seasonCode);
    }
    if (e.target.name == "seasonCode") {
      temp_fabricStyledata["seasonCode"] = e.target.value;
      let productType_List = this.state.seasons;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["seasonCode"] = pdtType.code;
          this.state.showAutoCompleteSeasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteSeasonList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readSeasonCodeBySearchString(searchString) {
    let seasonCodeData = this.state.seasons;
    let simpleAutoCompleteList = new Array();
    if (seasonCodeData.length > 0 && seasonCodeData != null) {
      seasonCodeData.map((seasonCodes) => {
        let simpleItemBean = {
          code: seasonCodes.code,
          description: seasonCodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteseasonCodeLists) =>
        simpleAutoCompleteseasonCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ seasonPageListForAutoCompleteList: filteredSuggestions });
  }
  seasonEnterKeyEventHandler = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let seasonCode = e.target.value;
    temp_fabricStyledata["seasonCode"] = e.target.value;
    let productType_List = this.state.seasons;
    let seasonCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        seasonCodeBean = pdtType;
      }
    });
    if (!isEmpty(seasonCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.seasonCode = seasonCodeBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        seasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteDivisionList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteDivisionCodeList: showAutoCompleteList });
  };
  displayAutoCompleteStatsList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStatsList: showAutoCompleteList });
  };
  displayAutoCompleteStyleItemTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStyleItemTypeList: showAutoCompleteList });
  };
  displayAutoCompleteCurrencyList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCurrencyCodeList: showAutoCompleteList });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  displayAutoCompleteUseList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompletePatternTypeCategoryCodeList: showAutoCompleteList,
    });
  };
  displayAutoCompleteWeightUomList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteWeightUomList: showAutoCompleteList });
  };

  displayAutoCompletePatternTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePatternTypeList: showAutoCompleteList });
  };
  displayAutoCompleteTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteTypeList: showAutoCompleteList });
  };
  displayAutoCompleteMakeTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteMakeTypeList: showAutoCompleteList });
  };
  displayAutoCompleteSeasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSeasonList: showAutoCompleteList });
  };
  displayAutoCompleteHtsList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteHtsList: showAutoCompleteList });
  };
  onWidthUOMCodeChange = (e) => {
    let widthUomCode = e.target.value;
    this.state.showAutoCompleteWidthUOMList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteWidthUOMList;
    if (isEmpty(widthUomCode)) {
      this.state.showAutoCompleteWidthUOMList = false;
      let showAutoCompleteList = this.state.showAutoCompleteWidthUOMList;
      let fabricStyleData = this.state.fabricStyleData;
      fabricStyleData.widthUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: fabricStyleData,
        widthUomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && widthUomCode !== "") {
      this.readWidthUomCodeBySearchString(widthUomCode);
    }
    temp_fabricStyledata[e.target.name] = e.target.value;
    this.setState({ fabricStyleData: temp_fabricStyledata });
    this.readWidthUOM(widthUomCode);
  };
  readWidthUOM = (widthUomCode) => {
    let WidthUomBean = null;
    this.state.lengthUOMs.map((ln) => {
      if (ln.code === widthUomCode) {
        WidthUomBean = ln;
      }
    });
    if (!isEmpty(WidthUomBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.widthUomCode = WidthUomBean.code;
      this.state.showAutoCompleteWidthUOMList = false;
      let showAutoCompleteList = this.state.showAutoCompleteWidthUOMList;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
  };
  readWidthUomCodeBySearchString(searchString) {
    let uomCodeData = this.state.lengthUOMs;
    let simpleAutoCompleteList = new Array();
    if (uomCodeData.length > 0 && uomCodeData != null) {
      uomCodeData.map((uomCodeDatas) => {
        let simpleItemBean = {
          code: uomCodeDatas.code,
          description: uomCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteUomCodeLists) =>
        simpleAutoCompleteUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ widthUomPageListForAutoCompleteList: filteredSuggestions });
  }
  widthUomEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    let widthUomCode = e.target.value;
    temp_fabricStyledata["widthUomCode"] = e.target.value;
    let widthUom_List = this.state.lengthUOMs;
    let widthUomCodeBean = null;
    widthUom_List.map((ln) => {
      if (ln.code == e.target.value) {
        widthUomCodeBean = ln;
      }
    });
    if (!isEmpty(widthUomCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.widthUomCode = widthUomCodeBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        widthUomPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onUOMCodeChange = (e) => {
    let inventoryUomCode = e.target.value;
    this.state.showAutoCompleteUOMList = true;
    let temp_fabricStyledata = this.state.fabricStyleData;
    // const fab = this.genenateDefaultBuyingAndSellingUoms(inventoryUomCode);
    // temp_fabricStyledata.buyingUoms = fab.buyingUoms;
    // temp_fabricStyledata.sellingUoms = fab.sellingUoms;
    let showAutoCompleteList = this.state.showAutoCompleteUOMList;
    if (isEmpty(inventoryUomCode)) {
      this.state.showAutoCompleteUOMList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUOMList;
      let soLine = this.state.fabricStyleData;
      soLine.inventoryUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: soLine,
        uomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && inventoryUomCode !== "") {
      this.readUomCodeBySearchString(inventoryUomCode);
    }
    if (e.target.name == "inventoryUomCode") {
      temp_fabricStyledata["inventoryUomCode"] = e.target.value;
      let productType_List = this.state.countUOMs;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["inventoryUomCode"] = pdtType.code;
          this.state.showAutoCompleteUOMList = false;
          let showAutoCompleteList = this.state.showAutoCompleteUOMList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  readUomCodeBySearchString(searchString) {
    let uomCodeData = this.state.countUOMs;
    let simpleAutoCompleteList = new Array();
    if (uomCodeData.length > 0 && uomCodeData != null) {
      uomCodeData.map((uomCodeDatas) => {
        let simpleItemBean = {
          code: uomCodeDatas.code,
          description: uomCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteUomCodeLists) =>
        simpleAutoCompleteUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ uomPageListForAutoCompleteList: filteredSuggestions });
  }
  uomEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    const fab = this.genenateDefaultBuyingAndSellingUoms(e.target.value);
    temp_fabricStyledata.buyingUoms = fab.buyingUoms;
    temp_fabricStyledata.sellingUoms = fab.sellingUoms;
    temp_fabricStyledata["inventoryUomCode"] = e.target.value;
    let productType_List = this.state.countUOMs;
    let inventoryUomCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        inventoryUomCodeBean = pdtType;
      }
    });
    if (!isEmpty(inventoryUomCodeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleData;
      temp_fabricStyledata.inventoryUomCode = inventoryUomCodeBean.code;
      this.setState({
        fabricStyleData: temp_fabricStyledata,
        uomPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUomList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteUomList: showAutoCompleteList });
  };
  displayAutoCompleteWidthUomList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteUomList: showAutoCompleteList });
  };
  onPopupUomCodeChange = (e) => {
    let uomCode = e.target.value;
    this.state.showAutoCompleteUOMPopupList = true;
    let temp_fabricStyledata = this.state.uomData;
    let showAutoCompleteList = this.state.showAutoCompleteUOMPopupList;
    if (isEmpty(uomCode)) {
      this.state.showAutoCompleteUOMPopupList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUOMPopupList;
      let uomData = this.state.uomData;
      uomData.uomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteUOMPopupList: showAutoCompleteList,
        uomData: uomData,
        uomPopupPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && uomCode !== "") {
      this.readPopupUomCodeBySearchString(uomCode);
    }
    if (e.target.name == "uomCode") {
      temp_fabricStyledata["uomCode"] = e.target.value;
      let uomData_List = this.state.countUOMs;
      uomData_List.map((uom) => {
        if (uom.code == e.target.value) {
          temp_fabricStyledata["uomCode"] = uom.code;
          this.state.showAutoCompleteUOMPopupList = false;
          let showAutoCompleteList = this.state.showAutoCompleteUOMPopupList;
          this.setState({ showAutoCompleteUOMPopupList: showAutoCompleteList });
        }
      });
    }
    this.setState({ uomData: temp_fabricStyledata });
  };
  readPopupUomCodeBySearchString(searchString) {
    let uomCodeData = this.state.countUOMs;
    let simpleAutoCompleteList = new Array();
    if (uomCodeData.length > 0 && uomCodeData != null) {
      uomCodeData.map((uomCodeDatas) => {
        let simpleItemBean = {
          code: uomCodeDatas.code,
          description: uomCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteUomCodeLists) =>
        simpleAutoCompleteUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ uomPopupPageListForAutoCompleteList: filteredSuggestions });
  }
  uomPopupEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.uomData;
    let uomCode = e.target.value;
    temp_fabricStyledata["uomCode"] = e.target.value;
    let uomData_List = this.state.countUOMs;
    let UomCodeBean = null;
    uomData_List.map((uom) => {
      if (uom.code == e.target.value) {
        UomCodeBean = uom;
      }
    });
    if (!isEmpty(UomCodeBean)) {
      let temp_fabricStyledata = this.state.uomData;
      temp_fabricStyledata.uomCode = UomCodeBean.code;
      this.setState({
        uomData: temp_fabricStyledata,
        uomPopupPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUomPopupList = (showAutoCompleteUOMPopupList) => {
    this.setState({
      showAutoCompleteUOMPopupList: showAutoCompleteUOMPopupList,
    });
  };
  onPopupColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteColorPopupList = true;
    let temp_fabricStyledata = this.state.colorData;
    let showAutoCompleteList = this.state.showAutoCompleteColorPopupList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteColorPopupList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColorPopupList;
      let color_Data = this.state.colorData;
      color_Data.fabricStyleColorCode = "";
      color_Data.fabricStyleColorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteColorPopupList: showAutoCompleteList,
        colorData: color_Data,
        colorPopupPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readPopupColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.colors;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;
          this.state.showAutoCompleteColorPopupList = false;
          let showAutoCompleteList = this.state.showAutoCompleteColorPopupList;
          this.setState({
            showAutoCompleteColorPopupList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ colorData: temp_fabricStyledata });
  };
  readPopupColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.colors;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorPopupPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  colorPopupEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.colorData;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.colors;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.colorData;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      temp_fabricStyledata.fabricStyleColorName = colorCodeBean.description;
      this.setState({
        colorData: temp_fabricStyledata,
        colorPopupPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorPopupList = (showAutoCompleteColorPopupList) => {
    this.setState({
      showAutoCompleteColorPopupList: showAutoCompleteColorPopupList,
    });
  };
  addorUpdateBuyingUom = (uomData) => {
    if (this.state.fabricStyleData.buyingUoms != null) {
      let isNew = true;
      let temp_buyingUoms = [];
      temp_buyingUoms = this.state.fabricStyleData.buyingUoms;
      for (var i = 0; i < temp_buyingUoms.length; i++) {
        if (temp_buyingUoms[i].uomCode == uomData.uomCode) {
          if (uomData.conversionRate > 0)
            temp_buyingUoms[i].conversionRate = uomData.conversionRate;
          temp_buyingUoms[i].cost = uomData.cost;
          isNew = false;
        }
      }
      if (isNew) {
        if (uomData.conversionRate == "" || uomData.conversionRate == null)
          uomData.conversionRate = 1;
        temp_buyingUoms.push(uomData);
      }
      let tempFabricStyleData = this.state.fabricStyleData;
      tempFabricStyleData.buyingUoms = temp_buyingUoms;
      this.setState({ fabricStyleData: tempFabricStyleData });
      this.closeUomPopup();
    }
  };
  addorUpdateSellingUom = (uomData) => {
    if (this.state.fabricStyleData.sellingUoms != null) {
      let isNew = true;
      let temp_sellingUoms = this.state.fabricStyleData.sellingUoms;
      for (var i = 0; i < temp_sellingUoms.length; i++) {
        if (temp_sellingUoms[i].uomCode == uomData.uomCode) {
          if (uomData.conversionRate > 0)
            temp_sellingUoms[i].conversionRate = uomData.conversionRate;
          temp_sellingUoms[i].wholeSalePrice = uomData.wholeSalePrice;
          temp_sellingUoms[i].retailPrice = uomData.retailPrice;
          if (this.state.is3PL) {
            temp_sellingUoms[i].weightUomCode = uomData.weightUomCode;
            temp_sellingUoms[i].weight = uomData.weight;
            temp_sellingUoms[i].width = uomData.width;
            temp_sellingUoms[i].height = uomData.height;
            temp_sellingUoms[i].length = uomData.length;
            temp_sellingUoms[i].dimensionUomCode = uomData.dimensionUomCode;
            temp_sellingUoms[i].palletDimensionUomCode =
              uomData.palletDimensionUomCode;
            temp_sellingUoms[i].numberOfItemsPerPallet =
              uomData.numberOfItemsPerPallet;
            temp_sellingUoms[i].palletWidth = uomData.palletWidth;
            temp_sellingUoms[i].palletHeight = uomData.palletHeight;
            temp_sellingUoms[i].palletLength = uomData.palletLength;
            temp_sellingUoms[i].stackableFlag = uomData.stackableFlag;
            temp_sellingUoms[i].stackableQuantity = uomData.stackableQuantity;
          }
          isNew = false;
        }
      }
      if (isNew) {
        if (uomData.conversionRate == "" || uomData.conversionRate == null)
          uomData.conversionRate = 1;
        temp_sellingUoms.push(uomData);
      }
      let tempFabricStyleData = this.state.fabricStyleData;
      tempFabricStyleData.sellingUoms = temp_sellingUoms;
      this.setState({ fabricStyleData: tempFabricStyleData });
      this.closeUomPopup();
    }
  };
  addorUpdateServiceUom = (uomData) => {
    const buyingUomData = new FabricStyleBuyingUOMBean();
    // buyingUomData.cost = uomData.wholeSalePrice;
    buyingUomData.companyCode = uomData.companyCode;
    buyingUomData.fabricStyleCode = uomData.fabricStyleCode;
    buyingUomData.fabricStyleInventoryUOMCode =
      uomData.fabricStyleInventoryUOMCode;
    buyingUomData.uomCode = uomData.uomCode;
    buyingUomData.conversionRate = uomData.conversionRate;

    const sellingUomData = new FabricStyleSellingUOMBean();
    sellingUomData.wholeSalePrice = uomData.wholeSalePrice;
    // sellingUomData.retailPrice = uomData.retailPrice;
    sellingUomData.companyCode = uomData.companyCode;
    sellingUomData.fabricStyleCode = uomData.fabricStyleCode;
    sellingUomData.fabricStyleInventoryUOMCode =
      uomData.fabricStyleInventoryUOMCode;
    sellingUomData.uomCode = uomData.uomCode;
    sellingUomData.conversionRate = uomData.conversionRate;
    sellingUomData.weightUomCode = uomData.weightUomCode;
    sellingUomData.weight = uomData.weight;
    sellingUomData.width = uomData.width;
    sellingUomData.height = uomData.height;
    sellingUomData.length = uomData.length;
    sellingUomData.dimensionUomCode = uomData.dimensionUomCode;
    sellingUomData.palletDimensionUomCode = uomData.palletDimensionUomCode;
    sellingUomData.numberOfItemsPerPallet = uomData.numberOfItemsPerPallet;
    sellingUomData.palletWidth = uomData.palletWidth;
    sellingUomData.palletHeight = uomData.palletHeight;
    sellingUomData.palletLength = uomData.palletLength;
    sellingUomData.stackableFlag = uomData.stackableFlag;
    sellingUomData.stackableQuantity = uomData.stackableQuantity;

    this.addorUpdateBuyingUom(buyingUomData);
    this.addorUpdateSellingUom(sellingUomData);
  };
  addorUpdateUom = (uomData) => {
    this.setState({ isDisableUomFields: false });
    if ((uomData.uomCode != null) & (uomData.uomCode != "")) {
      if (!this.state.is3PL) {
        if (this.state.uomCaption == "Buying UOM")
          this.addorUpdateBuyingUom(uomData);
        else if (this.state.uomCaption == "Selling UOM")
          this.addorUpdateSellingUom(uomData);
      } else {
        this.addorUpdateServiceUom(uomData);
      }
    } else {
      let errMsg = "UOM Code Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertLvl3: true,
      });
    }
  };
  openUomPopup = () => {
    this.setState({ isOpenUomPopup: true });
  };
  closeUomPopup = () => {
    this.setState({ isOpenUomPopup: false, isDisableUomFields: false });
  };
  openNewBuyingUomPopup = () => {
    let uomData = new FabricStyleBuyingUOMBean();
    uomData.companyCode = this.state.fabricStyleData.companyCode;
    uomData.fabricStyleInventoryUOMCode =
      this.state.fabricStyleData.inventoryUomCode;
    uomData.isFetched = false;
    const caption = "Buying UOM";
    this.setState({
      uomCaption: this.buyingUomCaption,
      uomData: uomData,
      uomPopupCaption: caption,
    });
    this.openUomPopup();
    // this.setState({ isOpenUomPopup: true });
  };
  openNewSellingUomPopup = () => {
    let uomData = new FabricStyleSellingUOMBean();
    uomData.companyCode = this.state.fabricStyleData.companyCode;
    uomData.fabricStyleInventoryUOMCode =
      this.state.fabricStyleData.inventoryUomCode;
    uomData.isFetched = false;
    const caption = this.state.is3PL ? "Service UOM" : "Selling UOM";
    if (this.state.isViewMode) {
      this.setState({ disableStackableQty: true });
    } else {
      if (uomData.stackableFlag == true) {
        this.setState({ disableStackableQty: false });
      } else {
        this.setState({ disableStackableQty: true });
      }
    }
    this.setState({
      uomCaption: this.sellingUomCaption,
      uomData: uomData,
      uomPopupCaption: caption,
    });
    // this.openUomPopup();
    this.setState({ isOpenUomPopup: true });
  };
  editBuyingUom = (buyingUom) => {
    let uomData = new FabricStyleBuyingUOMBean();
    uomData = { ...buyingUom };
    this.setState({
      uomCaption: this.buyingUomCaption,
      uomData: uomData,
      isDisableUomFields: true,
    });
    this.openUomPopup();
  };
  editSellingUom = (sellingUom) => {
    let uomData = new FabricStyleBuyingUOMBean();
    uomData = { ...sellingUom };
    if (this.state.isViewMode) {
      this.setState({ disableStackableQty: true });
    } else {
      if (uomData.stackableFlag == true) {
        this.setState({ disableStackableQty: false });
      }
    }
    this.setState({
      uomCaption: this.sellingUomCaption,
      uomData: uomData,
      isDisableUomFields: true,
    });
    this.openUomPopup();
  };
  deleteBuyingUom = (buyingUom) => {
    if (this.state.fabricStyleData.buyingUoms != null) {
      var temp_buyingUoms = this.state.fabricStyleData.buyingUoms;
      var index = temp_buyingUoms.indexOf(buyingUom);
      temp_buyingUoms.map((bu) => {
        if (bu.uomCode === buyingUom.uomCode) {
          bu.isDeleted = true;
        }
      });
      let tempFabricStyleData = this.state.fabricStyleData;
      tempFabricStyleData.buyingUoms = temp_buyingUoms;
      this.setState({
        fabricStyleData: tempFabricStyleData,
        isOpenUomPopup: false,
      });
    }
  };

  deleteSellingUom = (sellingUom) => {
    if (this.state.fabricStyleData.sellingUoms != null) {
      var temp_sellingUoms = [...this.state.fabricStyleData.sellingUoms];
      var index = temp_sellingUoms.indexOf(sellingUom);
      temp_sellingUoms.map((su) => {
        if (su.uomCode === sellingUom.uomCode) {
          su.isDeleted = true;
        }
      });
      let tempFabricStyleData = this.state.fabricStyleData;
      tempFabricStyleData.sellingUoms = temp_sellingUoms;
      this.setState({ fabricStyleData: tempFabricStyleData });
    }
  };

  getFabricStyleImagePath = (imagePart, fabricStyle) => {
    if (imagePart == "Main")
      return this.getFabricStyleMainImagePath(fabricStyle);
    else if (imagePart == "Web")
      return this.getFabricStyleWebImagePath(fabricStyle);
    else if (imagePart == "Front")
      return this.getFabricStyleFrontImagePath(fabricStyle);
    else if (imagePart == "Back")
      return this.getFabricStyleBackImagePath(fabricStyle);
    return null;
  };
  getFabricStyleMainImagePath = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Main" &&
          fabricStyle.fabricStyleImages[i].isDeleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;
      if (mainImage.isDeleted) {
        imageURL = "";
      }

      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getFabricStyleWebImagePath = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let imageData = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Web" &&
          fabricStyle.fabricStyleImages[i].isDeleted == false
        ) {
          imageData = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = imageData.imageName;
      let imageURL = serviceURL + imageName;

      if (imageData.isDeleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getFabricStyleFrontImagePath = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let imageData = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Front" &&
          fabricStyle.fabricStyleImages[i].isDeleted == false
        ) {
          imageData = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = imageData.imageName;
      let imageURL = serviceURL + imageName;
      if (imageData.isDeleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getFabricStyleBackImagePath = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let imageData = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Back" &&
          fabricStyle.fabricStyleImages[i].isDeleted == false
        ) {
          imageData = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = imageData.imageName;
      let imageURL = serviceURL + imageName;

      if (imageData.isDeleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getFabricImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };
  getFabricStyleColorImagePath = (rowData, val) => {
    const colorList = this.state.colorList;
    let imageUrl = "";
    if (rowData.isFetched) {
      imageUrl = this.getImageURL();
      imageUrl = imageUrl + rowData.imageName;
      if (!isEmptyArray(colorList)) {
        colorList.map((clr) => {
          if (clr.code === rowData.fabricStyleColorCode) {
            if (clr.imgData) imageUrl = URL.createObjectURL(clr.imgData);
          }
          // else if (clr.code != rowData.fabricStyleColorCode) {
          // imageUrl = this.getImageURL();
          // imageUrl = imageUrl + rowData.imageName;
          // }
        });
      } else {
        imageUrl = this.getImageURL();
        imageUrl = imageUrl + rowData.imageName;
      }
    } else if (!rowData.isFetched) {
      colorList.map((clr) => {
        if (clr.code === rowData.fabricStyleColorCode) {
          if (clr.imgData) imageUrl = URL.createObjectURL(clr.imgData);
        }
      });
    }

    // let imageUrl = "";
    // // if (rowData.isFetched) {
    // let url = this.getImageURL();
    // imageUrl = url + val;
    // // } else {
    // //   imageUrl = "";
    // // }
    return imageUrl;
  };
  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };
  onColorChange = (e) => {
    let temp_clrdata = this.state.colorData;
    temp_clrdata[e.target.name] = e.target.value;
    if (e.target.name == "fabricStyleColorCode") {
      temp_clrdata["fabricStyleColorCode"] = e.target.value;
      let color_List = this.state.colors;
      color_List.map((clr) => {
        if (clr.code == e.target.value) {
          temp_clrdata["fabricStyleColorName"] = clr.description;
        }
      });
    }
    this.setState({ colorData: temp_clrdata });
  };
  openNewColorPopup = () => {
    let colorData = new FabricStyleColorBean();
    colorData.companyCode = this.state.fabricStyleData.companyCode;
    colorData.isFetched = false;
    this.setState({ colorCaption: this.colorCaption, colorData: colorData });
    this.openColorPopup();
  };
  editColor = (clr) => {
    let colorData = new FabricStyleColorBean();
    const colorList = this.state.colorList;
    colorData = { ...clr };
    let url = "";
    if (colorData.isFetched) {
      if (!isEmptyArray(colorList)) {
        colorList.map((clr) => {
          if (clr.code === colorData.fabricStyleColorCode) {
            if (clr.imgData) url = URL.createObjectURL(clr.imgData);
          } else if (clr.code != colorData.fabricStyleColorCode) {
            url = this.getImageURL();
            url = url + colorData.imageName;
          }
        });
      } else {
        url = this.getImageURL();
        url = url + colorData.imageName;
      }

      // url = this.getImageURL();
      // url = url + colorData.imageName;
    } else if (!colorData.isFetched) {
      colorList.map((clr) => {
        if (clr.code === colorData.fabricStyleColorCode) {
          if (clr.imgData) url = URL.createObjectURL(clr.imgData);
        }
      });
    }
    this.setClrUrl(url);
    this.setState(
      {
        colorCaption: this.colorCaption,
        colorData: colorData,
        // isOpenColorPopup: true,
        // colorImgUrl: url,
      },
      () => {
        this.openColorPopup();
      },
    );
    // setTimeout(() => {
    //   this.openColorPopup();
    // }, 500);
  };
  validateFabricColor = (colorData) => {
    let isValidFabricColorLine = false;
    let err_list = [];
    let errorMessage = "";
    if (colorData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(colorData.fabricStyleColorCode)) {
        let errMsg = "";
        if (!this.state.is3PL) {
          errMsg = "FabricStyle Color Code is Required";
        } else {
          errMsg = "Item Color Code is Required";
        }
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(colorData.fabricStyleColorName)) {
        let errMsg = "";
        if (!this.state.is3PL) {
          errMsg = "FabricStyle Color Name is Required";
        } else {
          errMsg = "Item Color Name is Required";
        }
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidFabricColorLine = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowColorAlert: true,
        //  isShowPopupAlert: false,
      });
    } else {
      isValidFabricColorLine = true;
      this.setState({
        isShowColorAlert: false,
        //isShowPopupAlert: false
      });
    }
    return isValidFabricColorLine;
  };
  addorUpdateColor = (colorData) => {
    this.hideAlertCallBack();
    let tempFabricStyleData = this.state.fabricStyleData;
    let tempFabricStyleColorData = this.state.fabricStyleData.colors;
    let multipleColorList = this.state.multipleColorList;
    let color___List = new Array();
    if (!isEmptyArray(this.state.color___List))
      color___List = this.state.color___List;
    const clrImg = this.state.clrImg;
    let colorList = new Array();
    if (!isEmptyArray(this.state.colorList)) colorList = this.state.colorList;
    let isValidLine = false;
    isValidLine = this.validateFabricColor(colorData);
    colorData.fabricStyleCode = tempFabricStyleData.code;
    if (isValidLine) {
      if (tempFabricStyleData.colors != null) {
        tempFabricStyleColorData.map((colors, i) => {
          multipleColorList.map((color, j) => {
            if (colors.fabricStyleColorCode == color.code) {
              multipleColorList.splice(i, 1);
            }
          });
        });
        const index = tempFabricStyleData.colors.findIndex(
          (ln) => ln.fabricStyleColorCode === colorData.fabricStyleColorCode,
        );
        let _dbColorLine = tempFabricStyleData.colors[index];
        if (_dbColorLine == null) {
          if (clrImg != null) {
            // colorData.imageName = clrImg.name;
            // colorData.imagePath = clrImg.name;
            let imgData = new BaseImageBean();
            imgData.code = colorData.fabricStyleColorCode;
            imgData.imgData = clrImg;

            const i = colorList.findIndex(
              (ln) => ln.code === colorData.fabricStyleColorCode,
            );
            if (i > -1) {
              colorList[i] = imgData;
            } else if (i < 0) {
              colorList.push(imgData);
            }

            // colorList.push(imgData);
            this.setState({
              colorList: colorList,
              clrImg: null,
            });
          }
          tempFabricStyleData.colors.push(colorData);
        } else {
          let fabricStyleColorData = new FabricStyleColorBean();
          fabricStyleColorData = tempFabricStyleData.colors[index];
          fabricStyleColorData.fabricStyleCode = tempFabricStyleData.code;
          fabricStyleColorData.nrfCode = colorData.nrfCode;
          fabricStyleColorData.isActive = colorData.isActive;
          fabricStyleColorData.notesCommunication =
            colorData.notesCommunication;
          fabricStyleColorData.copyrightNumber = colorData.copyrightNumber;
          fabricStyleColorData.status = colorData.status;
          if (clrImg != null) {
            // fabricStyleColorData.imageName = clrImg.name;
            // fabricStyleColorData.imagePath = clrImg.name;
            let imgData = new BaseImageBean();
            imgData.code = colorData.fabricStyleColorCode;
            imgData.imgData = clrImg;
            const i = colorList.findIndex(
              (ln) => ln.code === colorData.fabricStyleColorCode,
            );
            if (i > -1) {
              colorList[i] = imgData;
            } else if (i < 0) {
              colorList.push(imgData);
            }
            this.setState({
              colorList: colorList,
              clrImg: null,
            });
          }
          tempFabricStyleData.colors[index] = fabricStyleColorData;
        }
      } else {
      }
      this.setState({
        fabricStyleData: tempFabricStyleData,
        color___List: tempFabricStyleData.colors,
        multipleColorList: multipleColorList,
      });
      this.closeColorPopup();
      this.generateItemSKUs();
    }
  };
  addorUpdateColor_1 = (colordata) => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let colorList = [];
    if (!isEmptyArray(attribute_cache.colors))
      colorList = attribute_cache.colors;
    let selectedMultipleColorList = this.state.selectedMultipleColorList;
    let multipleColorList = this.state.multipleColorList;
    colorList.map((colors, i) => {
      if (colors.code == colordata.fabricStyleColorCode) {
        selectedMultipleColorList.push(colors);
      }
    });
    multipleColorList.map((colors, i) => {
      if (colors.code == colordata.fabricStyleColorCode) {
        multipleColorList.splice(i, 1);
      }
    });
    this.setState({
      multipleColorList: multipleColorList,
      selectedMultipleColorList: selectedMultipleColorList,
    });
  };
  addOrUpdateMultipleColor = () => {
    let selectedMultipleColorList = this.state.selectedMultipleColorList;
    let temp_selectedMultipleColorList =
      this.state.temp_selectedMultipleColorList;
    let tempArray = [];
    let fabricStyleData = this.state.fabricStyleData;
    tempArray = selectedMultipleColorList.concat(
      temp_selectedMultipleColorList,
    );
    fabricStyleData.colors = tempArray;
    this.setState({
      isShowMultipleColorPopup: false,
      fabricStyleData: fabricStyleData,
      color___List: tempArray,
    });
    this.generateItemSKUs();
  };

  closeAlertMultipleColorModalCallBack = (isShowPopup) => {
    this.setState({
      isShowMultipleColorPopup: isShowPopup,
      isShowColorAlert: isShowPopup,
    });
  };

  unSelectColor = (color) => {
    let temp_selectedMultipleColorList =
      this.state.temp_selectedMultipleColorList;
    let multipleColorList = this.state.multipleColorList;
    const index = temp_selectedMultipleColorList.findIndex(
      (ln) => ln.fabricStyleColorCode === color.fabricStyleColorCode,
    );
    if (index != -1) {
      temp_selectedMultipleColorList.splice(index, 1);
    }
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    let colorsList = [];
    if (!isEmptyArray(attribute_cache.colors))
      colorsList = attribute_cache.colors;
    colorsList.map((colors, i) => {
      if (colors.code == color.fabricStyleColorCode) {
        multipleColorList.push(colors);
      }
    });
    this.setState({
      multipleColorList: multipleColorList,
      temp_selectedMultipleColorList: temp_selectedMultipleColorList,
    });
  };

  selectColor = (color) => {
    let colors = this.state.multipleColorList;
    let colorArray = [];
    colors.map((clr, i) => {
      colorArray.push(clr);
    });
    let colorList = colorArray;
    let temp_selectedMultipleColorList =
      this.state.temp_selectedMultipleColorList;
    let temp_selectedList = this.state.temp_selectedList;
    temp_selectedList.push(color);
    colorList.map((colors, i) => {
      if (colors == color) {
        colorList.splice(i, 1);
      }
    });
    let colorData = new FabricStyleColorBean();
    colorData.companyCode = this.companyCode;
    colorData.fabricStyleColorCode = color.code;
    colorData.fabricStyleColorName = color.description;
    colorData.isActive = true;
    colorData.status = "Active";
    temp_selectedMultipleColorList.push(colorData);

    this.setState({
      temp_selectedList: temp_selectedList,
      temp_selectedMultipleColorList: temp_selectedMultipleColorList,
      multipleColorList: colorList,
    });
  };
  multipleAdd = () => {
    let color = this.state.fabricStyleData.colors;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let multipleColorLists = [];
    if (!isEmptyArray(attribute_cache.colors))
      multipleColorLists = attribute_cache.colors;
    let multipleColorList = [...multipleColorLists];
    let selectedMultipleColorList = [];
    let color_ = [...this.state.fabricStyleData.colors];
    color_.map((color, i) => {
      selectedMultipleColorList.push(color);
    });
    color.map((colors, i) => {
      multipleColorList.map((color, j) => {
        if (colors.fabricStyleColorCode == color.code) {
          multipleColorList.splice(j, 1);
        }
      });
    });
    this.setState({
      isShowMultipleColorPopup: true,
      multipleColorList: multipleColorList,
      temp_selectedMultipleColorList: selectedMultipleColorList,
    });
  };
  generateItemSKUs = () => {
    let _fabricStyleSkus = new Array();
    let temp_fabricStyleData = this.state.fabricStyleData;
    //TODO if required
    if (temp_fabricStyleData.colors != null) {
      temp_fabricStyleData.colors.map((clr) => {
        if (!clr.isFetched) {
          let sku = new FabricStyleSKUBean();
          sku.companyCode = temp_fabricStyleData.companyCode;
          sku.fabricStyleCode = temp_fabricStyleData.code;
          sku.fabricStyleColorCode = clr.fabricStyleColorCode;
          sku.currencyCode = temp_fabricStyleData.currencyCode;
          sku.cost = temp_fabricStyleData.cost;
          sku.retailPrice = temp_fabricStyleData.retailPrice;
          sku.samplePrice = temp_fabricStyleData.samplePrice;
          sku.webRetailPrice = temp_fabricStyleData.webRetailPrice;
          sku.wholesalePrice = temp_fabricStyleData.wholesalePrice;
          sku.closeOutPrice = temp_fabricStyleData.closeOutPrice;
          sku.uomCode = temp_fabricStyleData.inventoryUomCode;
          sku.metalUomCode = temp_fabricStyleData.inventoryUomCode;

          if (clr.fabricStyleColorCode == sku.fabricStyleColorCode) {
            _fabricStyleSkus.push(sku);
          }
          temp_fabricStyleData.fabricStyleSkus = _fabricStyleSkus;
          this.setState({ fabricStyleData: temp_fabricStyleData });
        }
      });
    }
  };
  openColorPopup = () => {
    const colorData = this.state.colorData;
    colorData.createdDate = new Date().toLocaleDateString("sv-SE");
    if (!colorData.isFetched) {
      colorData.isActive = true;
      colorData.status = "Active";
    }

    this.setState({ colorData: colorData, isOpenColorPopup: true });
  };
  closeColorPopup = () => {
    this.setState({
      isOpenColorPopup: false,
      colorImgUrl: "",
      colorData: new FabricStyleColorBean(),
      isShowColorAlert: false,
    });
    this.hideAlertCallBackColor();
  };
  addorUpdateImageData = (tempFabricStyleData) => {
    this.setState({ fabricStyleData: tempFabricStyleData });
    this.closeImagePopup();
  };
  openImagePopup = () => {
    this.setState({ isOpenImagePopup: true });
  };
  openTestImagePopup = (e) => {
    if (e.detail === 1) {
      const imagePart = "Main";
      const fabricStyle = this.state.fabricStyleData;
      let temp_imageData = null;
      // let tempFabricStyleData = { ...this.state.fabricStyleData };
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (fabricStyle.fabricStyleImages[i].imagePart == imagePart)
          temp_imageData = { ...fabricStyle.fabricStyleImages[i] };
      }
      let imagePopupCaption = imagePart + " Image";
      this.imagePart = imagePart;
      this.setState({
        // fabricStyleData: tempFabricStyleData,
        imageData: temp_imageData,
        imagePopupCaption: imagePopupCaption,
      });
      this.setState({ isOpenItemImagePopup: true });
      // this.imageClick(fabricStyleData, "Main")
    }
  };
  closeTestImagePopup = () => {
    this.setState({ isOpenItemImagePopup: false });
  };
  closeImagePopup = () => {
    this.setState({ isOpenImagePopup: false });
  };
  openOnHandDetailPopup = () => {
    this.setState({ isOpenOnHandDetailPopup: true });
  };
  closeOnHandDetailPopup = () => {
    this.setState({ isOpenOnHandDetailPopup: false });
  };
  OpenStatisticsPopup = () => {
    this.setState({ isOpenStatisticsPopup: true });
  };
  closeStatisticsPopup = () => {
    this.setState({ isOpenStatisticsPopup: false });
  };
  OpenInandOutStatisticsPopup = () => {
    this.setState({ isInandOutStatisticsPopup: true });
  };
  closeInandOutStatisticsPopup = () => {
    this.setState({ isInandOutStatisticsPopup: false });
  };
  // getItemImgName = (imagePart) => {
  //   let imgName = "";
  //   let seqNumber = "";
  //   imgName = "IM_" + this.companyCode + "_" + seqNumber;
  //   return imgName;
  // };
  upload___ColorImage = (file, colorCode) => {
    let fabricStyleData = { ...this.state.fabricStyleData };
    if (!isEmptyArray(fabricStyleData.colors)) {
      fabricStyleData.colors.map((clr) => {
        if (clr.fabricStyleColorCode === colorCode) {
          clr.imageName = file.name;
        }
      });
    } else {
      // for new
    }
    this.setState({
      fabricStyleData: fabricStyleData,
    });
  };
  upload____Image = (file, imagePart) => {
    let fabricStyleData = { ...this.state.fabricStyleData };
    let imageData = null;
    for (var i = 0; i < fabricStyleData.fabricStyleImages.length; i++) {
      if (fabricStyleData.fabricStyleImages[i].imagePart == imagePart) {
        imageData = fabricStyleData.fabricStyleImages[i];
        if (imageData.isDeleted == true) imageData.isDeleted = false;
      }
    }
    // fabricStyleData.fabricStyleImages.map((imgData) => {
    //   if (imgData.imagePart == imagePart) {
    //     imageData = imgData;
    //     if (imageData.isDeleted == true) imageData.isDeleted = false;
    //     // imageData.imageOritinalname = file.name;
    //   }
    // });
    // const newState = fabricStyleData.fabricStyleImages.map((obj) => {
    //   if (obj.imagePart === imagePart) {
    //     if (obj.isDeleted == true) obj.isDeleted = false;
    //     return { ...obj, imageOritinalname: file.name };
    //   }
    //   return obj;
    // });
    // fabricStyleData.fabricStyleImages = newState;
    // this.setState({
    //   fabricStyleData: fabricStyleData,
    // });
    if (imageData != null) {
      imageData.imageOritinalname = file.name;
      this.setState({ fabricStyleData: fabricStyleData });
    } else {
      imageData = new FabricStyleImageBean();
      imageData.imagePart = imagePart;
      imageData.imageOritinalname = file.name;
      imageData.imageName = file.name;
      imageData.companyCode = fabricStyleData.companyCode;
      imageData.fabricStyleCode = fabricStyleData.code;
      fabricStyleData.fabricStyleImages.push(imageData);
      this.setState({
        fabricStyleData: fabricStyleData,
      });
    }
    // const newState = fabricStyleData.fabricStyleImages.map(obj => {
    //   if (obj.imagePart === imagePart) {
    //     return {...obj, imageOritinalname: file.name};
    //   }
    //   return obj;
    // });
    // fabricStyleData.fabricStyleImages = newState;
    // this.setState({
    //   fabricStyleData: fabricStyleData,
    // })

    // this.forceUpdate();
  };
  // upload___Image = (file, imagePart) => {
  //   let fabricStyle = this.state.fabricStyleData;
  //   let selectedImage = file;
  //   let imageData = null;
  //   let fabricStyleImagesList = this.state.fabricStyleImagesList;

  //   for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
  //     if (fabricStyle.fabricStyleImages[i].imagePart == imagePart) {
  //       imageData = fabricStyle.fabricStyleImages[i];
  //       if (imageData.isDeleted == true) imageData.isDeleted = false;
  //     }
  //   }
  //   if (imageData != null) {
  //     imageData.imageOritinalname = selectedImage.name;
  //     // this.toServer(selectedImage, imageData.imageName);
  //     this.setState({ fabricStyleData: fabricStyle });
  //   } else {
  //     imageData = new FabricStyleImageBean();
  //     imageData.imagePart = imagePart;
  //     imageData.imageOritinalname = selectedImage.name;
  //     imageData.imageName = selectedImage.name;
  //     // imageData.imageName = this.getItemImgName(imagePart);
  //     imageData.companyCode = fabricStyle.companyCode;
  //     imageData.fabricStyleCode = fabricStyle.code;
  //     fabricStyle.fabricStyleImages.push(imageData);

  //     // this.toServer(selectedImage, imageData.imageOritinalname);

  //     // local array
  //     for (var i = 0; i < fabricStyleImagesList.length; i++) {
  //       if (fabricStyleImagesList[i].imagePart == imagePart) {
  //         imageData = fabricStyleImagesList[i];
  //         if (imageData.isDeleted == true) imageData.isDeleted = false;
  //       }
  //     }
  //     if (imageData != null) {
  //       imageData.imageOritinalname = selectedImage.name;
  //       // this.toServer(selectedImage, imageData.imageName);
  //       this.setState({ fabricStyleImagesList: fabricStyleImagesList });
  //     } else {
  //       imageData = new FabricStyleImageBean();
  //       imageData.imagePart = imagePart;
  //       imageData.imageOritinalname = selectedImage.name;
  //       imageData.imageName = selectedImage.name;
  //       // imageData.imageName = this.getItemImgName(imagePart);
  //       imageData.companyCode = fabricStyle.companyCode;
  //       imageData.fabricStyleCode = fabricStyle.code;
  //       fabricStyleImagesList.push(imageData);
  //     }
  //     this.setState({
  //       fabricStyleData: fabricStyle,
  //     });
  //   }
  //   this.forceUpdate();
  // };
  // upload_____Image = (file, imagePart) => {
  //   let fabricStyle = this.state.fabricStyleData;
  //   let fabricStyleImagesList = this.state.fabricStyleImagesList;
  //   let selectedImage = file;
  //   let imageData = null;
  //   for (var i = 0; i < fabricStyleImagesList.length; i++) {
  //     if (fabricStyleImagesList[i].imagePart == imagePart) {
  //       imageData = fabricStyleImagesList[i];
  //       if (imageData.isDeleted == true) imageData.isDeleted = false;
  //     }
  //   }
  //   if (imageData != null) {
  //     imageData.imageOritinalname = selectedImage.name;
  //     // this.toServer(selectedImage, imageData.imageName);
  //     this.setState({ fabricStyleImagesList: fabricStyleImagesList });
  //   } else {
  //     imageData = new FabricStyleImageBean();
  //     imageData.imagePart = imagePart;
  //     imageData.imageOritinalname = selectedImage.name;
  //     imageData.imageName = selectedImage.name;
  //     // imageData.imageName = this.getItemImgName(imagePart);
  //     imageData.companyCode = fabricStyle.companyCode;
  //     imageData.fabricStyleCode = fabricStyle.code;
  //     fabricStyleImagesList.push(imageData);

  //     // this.toServer(selectedImage, imageData.imageOritinalname);
  //     this.setState({
  //       fabricStyleImagesList: fabricStyleImagesList,
  //     });
  //   }
  //   this.forceUpdate();
  // };
  uploadImage = (file, imagePart) => {
    this.upload____Image(file, imagePart);
  };
  toServer = (file, fileName) => {
    let image = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", image);
    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      FabricStyleService.fabricStyle_Image_Upload(
        formData,
        this.uploadImageServerResponse,
        this.uploadImageServerError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  uploadImageServerResponse = (response) => {
    if (response.data.success) {
      this.closeTestImagePopup(false);
    }
  };
  uploadImageServerError = (error) => {
    ShowError("Error :", error);
  };
  uploadItemImagesToServer = () => {
    const fabricStyleData = { ...this.state.fabricStyleData };
    const mainImg = this.state.mainImg;
    const webImg = this.state.webImg;
    const frontImg = this.state.frontImg;
    const BackImg = this.state.BackImg;
    if (!isEmptyArray(fabricStyleData.fabricStyleImages)) {
      fabricStyleData.fabricStyleImages.map((imgData) => {
        if (imgData.imagePart == "Main" && imgData.isDeleted != true) {
          if (mainImg != null) this.toServer(mainImg, imgData.imageName);
        }
        if (imgData.imagePart == "Web" && imgData.isDeleted != true) {
          if (webImg != null) this.toServer(webImg, imgData.imageName);
        }
        if (imgData.imagePart == "Front" && imgData.isDeleted != true) {
          if (frontImg != null) this.toServer(frontImg, imgData.imageName);
        }
        if (imgData.imagePart == "Back" && imgData.isDeleted != true) {
          if (BackImg != null) this.toServer(BackImg, imgData.imageName);
        }
      });
    }
  };
  uploadColorImageToServer = () => {
    const fabricStyleData = { ...this.state.fabricStyleData };
    if (!isEmptyArray(fabricStyleData.colors)) {
      if (!isEmptyArray(this.state.colorList)) {
        this.state.colorList.map((clr) => {
          fabricStyleData.colors.map((clrData) => {
            if (clrData.fabricStyleColorCode == clr.code) {
              if (clr.imgData != null)
                this.toServer(clr.imgData, clrData.imageName);
            }
          });
        });
      }
      this.setState({
        colorList: new Array(),
      });
    }
  };
  deleteFabricImage = (imagePart) => {
    let fabricStyle = this.state.fabricStyleData;
    // let selectedImage = null;
    for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
      if (fabricStyle.fabricStyleImages[i].imagePart == imagePart) {
        fabricStyle.fabricStyleImages[i].imageOritinalname = null;
        fabricStyle.fabricStyleImages[i].deleted = true;
        fabricStyle.fabricStyleImages[i].isDeleted = true;
        // selectedImage = fabricStyle.fabricStyleImages[i];
      }
    }
    if (imagePart == "Main") {
      this.setMainUrl("");
    } else if (imagePart == "Web") {
      this.setWebUrl("");
    } else if (imagePart == "Front") {
      this.setFrontUrl("");
    } else if (imagePart == "Back") {
      this.setBackUrl("");
    }
    this.setState({ fabricStyleData: fabricStyle });
  };
  setMainUrl = (url) => {
    if (this.state.isReseted) return;
    // setTimeout(() => {
    this.setState({
      mainImageUrl: url,
    });

    // }, );
  };
  setWebUrl = (url) => {
    if (this.state.isReseted) return;
    // setTimeout(() => {
    this.setState({
      webImageUrl: url,
    });
    // }, );
  };
  setFrontUrl = (url) => {
    if (this.state.isReseted) return;
    // setTimeout(() => {
    this.setState({
      frontImageUrl: url,
    });
    // }, );
  };
  setBackUrl = (url) => {
    if (this.state.isReseted) return;
    // setTimeout(() => {
    this.setState({
      backImageUrl: url,
    });
    // }, );
  };
  setMainImg = (data) => {
    if (this.state.isReseted) return;
    this.setState({
      mainImg: data,
    });
  };
  setWebImg = (data) => {
    if (this.state.isReseted) return;
    this.setState({
      webImg: data,
    });
  };
  setFrontImg = (data) => {
    if (this.state.isReseted) return;
    this.setState({
      frontImg: data,
    });
  };
  setBackImg = (data) => {
    if (this.state.isReseted) return;
    this.setState({
      BackImg: data,
    });
  };
  setClrUrl = (url) => {
    // setTimeout(() => {
    this.setState({
      colorImgUrl: url,
    });
    // }, );
  };
  setClrFile = (data) => {
    this.setState({
      clrImg: data,
    });
  };
  showToast = (msg, type, lvl) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowImgAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowImgAlert: true,
      });
    }

    if (lvl == 1) {
      if (this.state.isOpenColorPopup == true) {
        this.setState({
          isShowAlert: false,
          isShowColorAlert: true,
        });
      } else {
        this.setState({
          isShowAlert: true,
          isShowColorAlert: false,
        });
      }
    }
  };
  openItemImage = () => {
    this.setState({
      isOpenItemImagePopup: true,
    });
  };
  closeItemImage = () => {
    this.setState({
      isOpenItemImagePopup: false,
    });
  };

  /***********************Color Statistics ***************************/

  resetClrStatistics = (type) => {
    let criteria = this.state.clrStatisticCriteria;
    criteria.fromDate = "";
    criteria.toDate = "";
    if (type == 1) {
      //sales
      criteria.customerCode = "";
      criteria.customerName = "";

      this.setState({
        salesStatisticsList: [],
        clrStatisticCriteria: criteria,
      });
    } else if (type == 2) {
      //sales
      criteria.vendorCode = "";
      criteria.vendorName = "";

      this.setState({
        purchaseStatisticsList: [],
        clrStatisticCriteria: criteria,
      });
    } else {
      this.setState({
        salesStatisticsList: [],
        purchaseStatisticsList: [],
        clrStatisticCriteria: new FabricStyleColorStatisticsInquiryCriteria(),
      });
    }
  };
  clrStatisticOnChange = (e) => {
    let criteria = this.state.clrStatisticCriteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ clrStatisticCriteria: criteria });
  };
  getOnColorStatistics = (line) => {
    let temp = { ...line };
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.clrStatisticCriteria;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.colorCode = line.fabricStyleColorCode;
    this.setState({
      isShowColorStatisticsPopup: true,
      clrStatisticCriteria: criteria,
    });
  };
  salesClrStatisticsPageResponse = (response) => {
    let salesStatisticsList = [];
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricColorStatisticsDetailsResult)
    ) {
      if (
        !isEmptyArray(
          response.data.fabricColorStatisticsDetailsResult
            .salesStatisticsDetails,
        )
      ) {
        salesStatisticsList =
          response.data.fabricColorStatisticsDetailsResult
            .salesStatisticsDetails;
      }
      // else {
      //   let errMsg = "No Data Found";
      //   let errList = [];
      //   errList.push(errMsg);
      //   this.setState({
      //     alertMessage: errList,
      //     alertType: "danger",
      //     isShowPopupAlertLvl1: true,
      //   });
      // }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      salesStatisticsList: salesStatisticsList,
    });
  };
  salesExecuteHandler = () => {
    let criteria = this.state.clrStatisticCriteria;
    let pageInput = new PageListBean();
    pageInput.currentPage = 1;
    pageInput.pageSize = 100;
    let listRequest = new FabricStyleColorStatisticsReceiptListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    ReportService.getFabricColorSatisticsSalesInquiryDetails(
      listRequest,
      this.salesClrStatisticsPageResponse,
      this.errorCallBack,
    );
  };

  purchaseClrStatisticsPageResponse = (response) => {
    let purchaseStatisticsList = [];
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricColorStatisticsDetailsResult)
    ) {
      if (
        !isEmptyArray(
          response.data.fabricColorStatisticsDetailsResult
            .purchaseStatisticsDetails,
        )
      ) {
        purchaseStatisticsList =
          response.data.fabricColorStatisticsDetailsResult
            .purchaseStatisticsDetails;
      }
      //  else {
      //   let errMsg = "No Data Found";
      //   let errList = [];
      //   errList.push(errMsg);
      //   this.setState({
      //     alertMessage: errList,
      //     alertType: "danger",
      //     isShowPopupAlertLvl1: true,
      //   });
      // }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      purchaseStatisticsList: purchaseStatisticsList,
    });
  };

  purchaseExecuteHandler = () => {
    let criteria = this.state.clrStatisticCriteria;
    let pageInput = new PageListBean();
    pageInput.currentPage = 1;
    pageInput.pageSize = 100;
    let listRequest = new FabricStyleColorStatisticsReceiptListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    ReportService.getFabricColorSatisticsInquiryPurchaseDetails(
      listRequest,
      this.purchaseClrStatisticsPageResponse,
      this.errorCallBack,
    );
  };

  customerClrStatChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.clrStatisticCriteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.clrStatisticCriteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        clrStatisticCriteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ clrStatisticCriteria: tempCriteria });
  };

  customerCodeClrStatEnterKeyHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };

  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.clrStatisticCriteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          clrStatisticCriteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack,
    );
  };

  /********************Vendor AutoComplete */

  vendorClrStatOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.clrStatisticCriteria;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let criteria = this.state.clrStatisticCriteria;
      criteria.vendorCode = "";
      criteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        clrStatisticCriteria: criteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ clrStatisticCriteria: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let criteria = this.state.clrStatisticCriteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        criteria.vendorName = vendorData.description;
        criteria.vendorCode = vendorData.code;
        this.setState({
          clrStatisticCriteria: criteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack,
    );
  };

  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack,
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };

  getOnStatistics = (line) => {
    let temp = { ...line };

    // this.hideAlertCallBack();
    let criteria = new FabricStylePurchaseReceiptHistoryCriteriaBean();
    let statisticsDataBean = this.state.statisticsDataBean;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = temp.fabricStyleCode;
    criteria.fabricStyleColorCode = temp.fabricStyleColorCode;
    statisticsDataBean.companyCode = this.companyCode;
    statisticsDataBean.fabricStyleCode = temp.fabricStyleCode;
    statisticsDataBean.colorCode = temp.fabricStyleColorCode;
    statisticsDataBean.fabricStyleName = this.state.fabricStyleData.description;
    // criteria.fabricStyleName = temp.

    this.setState({
      statisticsDataBean: statisticsDataBean,
      statisticsDatailList: [],
      receivedDataList: [],
      shippedDataList: [],
      // // onStatisticsCaption: this.onStatisticsCaption,
      // statisticsDatailList: statisticsDatailList,
      // isOpenStatisticsPopup: true
    });
    //  criteria.excludeNonWarehouseInventory = true;
    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      ReportService.getFabricStyleInStatistics(
        criteria,
        this.readandSetStatisticsResponse,
        this.readandSetStatisticsError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandSetStatisticsResponse = (response) => {
    let statisticsDatailList = [];
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.infos)) {
        statisticsDatailList = response.data.inquiryResult.infos;
      }

      this.setState({
        // onStatisticsCaption: this.onStatisticsCaption,
        statisticsDatailList: statisticsDatailList,
        isOpenStatisticsPopup: true,
        rowSubHeaderData: [],
        isShowInputTextbox: false,
      });
      //this.setState({ isOpenStatisticsPopup: true });
    } else {
      let errMsg = "No In/Out Statistics";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandSetStatisticsError = (error) => {
    ShowError("Error : " + error);
  };
  getOnHandQty = (line) => {
    this.hideAlertCallBack();
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.state.fabricStyleData.companyCode;
    criteria.fabricStyleCode = this.state.fabricStyleData.code;
    criteria.colorCode = line.fabricStyleColorCode;
    criteria.excludeNonWarehouseInventory = true;
    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      InventoryService.getSKUBatchInventoriesForRollBasedForSalesOrderOnHandQuantity(
        criteria,
        this.readandSetOnHandQuantityResponse,
        this.readandSetOnHandQuantityError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  readandSetOnHandQuantityResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.batchInventoryDataResult) &&
      !isEmpty(response.data.batchInventoryDataResult.batchInventoryDataBean)
    ) {
      let skuBatchInventoryDataBean =
        response.data.batchInventoryDataResult.batchInventoryDataBean;
      this.setState({
        onHandQtyCaption: this.onHandQtyCaption,
        skuBatchInventoryDataBean: skuBatchInventoryDataBean,
      });
      this.setState({ isOpenOnHandDetailPopup: true });
    } else {
      let errMsg = "No OnHandQuantity in Rolls";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandSetOnHandQuantityError = (error) => {
    ShowError("Error : " + error);
  };
  openSalesHistoryDetailsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowItemSalesDetails: true,
        moduleForPopup: (
          <PopupSalesPriceInq
            fabricStyleCode={code.fabricStyleCode}
            colorCode={code.fabricStyleColorCode}
            //  customerCode={customerCode}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  isDisableRemoveUomButton = (buyingUom) => {
    // if (buyingUom != null) {
    //   if (buyingUom.isFetched) return true;
    //   else if (buyingUom.fetched) return true;
    //   else if (this.state.isViewMode) return true;
    //   else return false;
    // }
    if (this.state.isViewMode) return true;
    return true;
  };
  isDisableRemoveColorButton = (color) => {
    if (color != null) {
      if (color.isFetched) return true;
      else if (color.fetched) return true;
      else return false;
    }
    return true;
  };
  deleteColor = (color) => {
    // this.setState({
    //   delClr: clr,
    // });
    let colorList = this.state.colorList;
    if (color.isFetched) {
      let input = new RestFabricStyleEntityRequest();
      input.companyCode = color.companyCode;
      input.entityCode = color.fabricStyleCode;
      input.code = color.fabricStyleColorCode;
      this.setState({
        clrCodeForDelete: color.fabricStyleColorCode,
      });
      FabricStyleService.checkRemovableFabricStyleColor(
        input,
        this.delClrResponse,
        this.delClrError,
      );
    } else {
      let fabricStyleData = this.state.fabricStyleData;
      if (!isEmptyArray(fabricStyleData.colors)) {
        var index = fabricStyleData.colors.indexOf(color);
        if (index > -1) {
          fabricStyleData.colors.splice(index, 1);
        }
        const i = colorList.findIndex(
          (ln) => ln.code === color.fabricStyleColorCode,
        );
        if (i > -1) {
          colorList.colors.splice(i, 1);
        }
        this.setState({
          fabricStyleData: fabricStyleData,
          colorList: colorList,
          color___List: fabricStyleData.colors,
        });
        this.generateItemSKUs();
      }
    }
  };

  delClrResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.isSuccess != null) {
      if (response.data.isSuccess) {
        let warningMessage =
          " Color can be deleted!! Are you sure to remove the color Detail";
        this.setState({ warningMessage: warningMessage });
        this.warningMessageForDeleteColor();
      } else {
      }
    }
    // if (response.data.sucess == null) {
    //   let fabricStyleData = this.state.fabricStyleData;
    //   let fabricData = { ...this.state.fabricStyleData };
    //   let clr = fabricStyleData.colors;
    //   let delClr = this.state.delClr;
    //   if (delClr.isFetched == false) {
    //     var index = clr.indexOf(delClr);
    //     if (index > -1) {
    //       clr.splice(index, 1);
    //     }
    //     this.setState({ fabricStyleData: fabricStyleData });
    //   } else {
    //     let clrArray = [];
    //     if (fabricStyleData.colors != null) {
    //       for (let clrList of fabricStyleData.colors) {
    //         if (delClr.fabricStyleColorCode == clrList.fabricStyleColorCode) {
    //           clrList.isDeleted = true;
    //         }
    //         clrArray.push(clrList);
    //       }
    //       fabricStyleData.colors = clrArray;
    //       this.setState({ fabricStyleData: fabricStyleData });
    //     }
    //   }
    // }
  };
  delClrError = (error) => {
    ShowError("Error : " + error);
  };
  warningMessageForDeleteColor = () => {
    this.setState({ isShowWarningMsgPopup: true });
  };
  onYesButtonClick = () => {
    const clrCode = this.state.clrCodeForDelete;
    let fabricStyleData = this.state.fabricStyleData;
    let colorList = this.state.colorList;
    let color___List = this.state.color___List;
    fabricStyleData.colors.map((clr) => {
      if (clr.fabricStyleColorCode === clrCode) {
        clr.isDeleted = true;
      }
    });
    color___List.map((clr, i) => {
      if (clr.fabricStyleColorCode === clrCode) {
        color___List.splice(i);
      }
    });
    colorList.map((clr, i) => {
      if (clr.code === clrCode) {
        colorList.splice(i);
      }
    });
    this.setState({
      fabricStyleData: fabricStyleData,
      colorList: colorList,
      color___List: color___List,
    });
    this.closeMessageModelCallBack();
  };
  onNoButtonClick = () => {
    this.closeMessageModelCallBack();
  };

  imageClick = (fabricStyle, imagePart) => {
    let temp_imageData = null;
    let tempFabricStyleData = { ...this.state.fabricStyleData };
    for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
      if (fabricStyle.fabricStyleImages[i].imagePart == imagePart)
        temp_imageData = { ...fabricStyle.fabricStyleImages[i] };
    }
    let imagePopupCaption = imagePart + " Image";
    this.imagePart = imagePart;
    this.setState({
      fabricStyleData: tempFabricStyleData,
      imageData: temp_imageData,
      imagePopupCaption: imagePopupCaption,
    });
    this.openImagePopup();
  };

  onEntryFormChange = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleData;
    temp_fabricStyledata[e.target.name] = e.target.value;
    if (e.target.name == "closeOutFlag") {
      temp_fabricStyledata["closeOutFlag"] = e.target.value;
      if (e.target.value == true) {
        this.setState({
          disableCloseOutPrice: false,
        });
      } else {
        this.state.disableCloseOutPrice = true;
      }
    }
    this.setState({ fabricStyleData: temp_fabricStyledata });
  };
  testOnchange = (e) => {
    // setVal(e);
    // set value
    this.cursor = e.target.selectionStart;

    this.inputRef.current.selectionStart = this.state.currentCursor;
    let value = e.target.value;
    this.setState({
      value: value,
    });
    // const [val, setVal] = useState(e.target.value);
    // set onchange
    let fabricStyleData = this.state.fabricStyleData;
    fabricStyleData[e.target.name] = e.target.value;
    this.setState({ fabricStyleData: fabricStyleData });
    // setOnchange(e);
  };
  skuDetailHandleHyperLinkClick = (rowData) => {
    const selectedSkuLine = { ...rowData };
    this.setState({
      selectedSkuLine: selectedSkuLine,
      isShowSkuPopup: true,
    });
  };
  closeSkuPricePopup = () => {
    this.setState({ isShowSkuPopup: false });
  };
  onItemSkuChange = (e) => {
    let temp_selectedSkuLine = this.state.selectedSkuLine;
    let temp_skupricedata = temp_selectedSkuLine.skuPriceBean;
    temp_skupricedata[e.target.name] = e.target.value;
    this.setState({ selectedSkuLine: temp_selectedSkuLine });
  };
  onSkuPriceLineChange = (e) => {
    let temp_customerSkuPriceData = this.state.customerSkuPriceData;
    temp_customerSkuPriceData[e.target.name] = e.target.value;
    this.setState({ customerSkuPriceData: temp_customerSkuPriceData });
  };
  getSkuPriceLineDetails = (customerSkuPriceData) => {
    let customerSkuPriceData_dummy = { ...customerSkuPriceData };
    if (
      customerSkuPriceData_dummy.customerCode == null ||
      customerSkuPriceData_dummy.customerCode.length == 0
    ) {
      this.state.isLineEditMode = true;
      this.setState({
        customerSkuPriceData: customerSkuPriceData_dummy,
      });
    } else {
      this.state.isLineEditMode = false;

      this.setState({
        customerSkuPriceData: customerSkuPriceData_dummy,
      });
    }
  };
  saveCustomerSkuPriceLine = () => {
    // let skuPriceData = this.state.skuPriceData;
    // let customerSkuPriceData = this.state.customerSkuPriceData;
    // if (!isEmptyString(customerSkuPriceData.customerCode)) {
    //   let prp_fabricStyleData = this.state.fabricStyleData;
    //   let temp_selectedSkuLine = { ...this.state.selectedSkuLine };
    //   let temp_selectedCustomerSkuPriceLine = {
    //     ...temp_selectedSkuLine.skuPriceBean,
    //   };

    //   if (temp_selectedCustomerSkuPriceLine == null) {
    //     temp_selectedCustomerSkuPriceLine = skuPriceData;
    //   }
    //   var lineNumber = this.getMaxSkuLineNumber();
    //   let existingLine = this.getCustomerSkuPriceLineByLineNumber(
    //     customerSkuPriceData.lineNumber
    //   );
    //   if (existingLine == null) customerSkuPriceData.lineNumber = ++lineNumber;
    //   let lineBean = new FabricStyleSKUCustomerPriceBean();
    //   lineBean.lineNumber = customerSkuPriceData.lineNumber;
    //   lineBean.skuNumber = temp_selectedSkuLine.skuNumber;
    //   lineBean.companyCode = this.companyCode;
    //   lineBean.fabricStyleCode = prp_fabricStyleData.code;
    //   lineBean.fabricStyleColorCode = temp_selectedSkuLine.fabricStyleColorCode;
    //   lineBean.uomCode = prp_fabricStyleData.inventoryUomCode;
    //   lineBean.effectiveDate = customerSkuPriceData.effectiveDate;
    //   lineBean.fromDate = customerSkuPriceData.fromDate;
    //   lineBean.toDate = customerSkuPriceData.toDate;
    //   lineBean.customerShipToCode = customerSkuPriceData.customerShipToCode;
    //   lineBean.customerCode = customerSkuPriceData.customerCode;
    //   lineBean.customerName = customerSkuPriceData.customerName;
    //   lineBean.customerTypeCode = customerSkuPriceData.customerTypeCode;
    //   lineBean.customerTypeName = customerSkuPriceData.customerTypeName;
    //   lineBean.price = customerSkuPriceData.price;
    //   lineBean.samplePrice = customerSkuPriceData.samplePrice;
    //   lineBean.currencyCode = prp_fabricStyleData.currencyCode;
    //   if (existingLine === null) {
    //     var lineNumber = this.getMaxSkuLineNumber();
    //     lineBean.lineNumber = ++lineNumber;
    //     if (temp_selectedCustomerSkuPriceLine.skuCustomerPrices != null) {
    //       temp_selectedCustomerSkuPriceLine.skuCustomerPrices.push(lineBean);
    //     } else {
    //       let _skuCustomerPrices = new Array();
    //       _skuCustomerPrices.push(lineBean);
    //       temp_selectedCustomerSkuPriceLine.skuCustomerPrices =
    //         _skuCustomerPrices;
    //     }
    //   } else {
    //     let customerSkuPriceData = this.state.customerSkuPriceData;
    //     const index =
    //       temp_selectedCustomerSkuPriceLine.skuCustomerPrices.findIndex(
    //         (ln) => ln.lineNumber === existingLine.lineNumber
    //       );
    //     if (index != -1) {
    //       temp_selectedCustomerSkuPriceLine.skuCustomerPrices.splice(index, 1);
    //       temp_selectedCustomerSkuPriceLine.skuCustomerPrices.push(
    //         customerSkuPriceData
    //       );
    //     }
    //   }
    //   this.reArrangeSkuPriceLineDisplayLineNumbers(
    //     temp_selectedCustomerSkuPriceLine.skuCustomerPrices
    //   );
    //   // temp_selectedSkuLine.skuPriceBean.skuCustomerPrices =
    //   //   temp_selectedCustomerSkuPriceLine.skuCustomerPrices;
    //   this.setState({
    //     // selectedSkuLine: temp_selectedSkuLine,
    //     _currentSelectedSkuLine: temp_selectedSkuLine,
    //   });
    // } else {
    //   let errMsg = "Customer Code is Required";
    //   let errList = [];
    //   errList.push(errMsg);
    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowPopupAlert: true,
    //   });
    // }

    let selectedSkuLine = { ...this.state.selectedSkuLine };
    let customerSkuPriceData = { ...this.state.customerSkuPriceData };
    let fabricStyleData = { ...this.state.fabricStyleData };
    customerSkuPriceData.companyCode = this.companyCode;
    customerSkuPriceData.fabricStyleCode = fabricStyleData.code;
    customerSkuPriceData.fabricStyleColorCode =
      selectedSkuLine.fabricStyleColorCode;

    customerSkuPriceData.skuNumber = selectedSkuLine.skuNumber;
    customerSkuPriceData.uomCode = fabricStyleData.inventoryUomCode;
    customerSkuPriceData.currencyCode = fabricStyleData.currencyCode;

    let custSkuPrices = new Array();
    if (!isEmptyArray(selectedSkuLine.skuPriceBean.skuCustomerPrices))
      custSkuPrices = selectedSkuLine.skuPriceBean.skuCustomerPrices;
    let isValid = false;
    isValid = this.validateSkuCustomerPriceLine(customerSkuPriceData);
    if (isValid) {
      var lineNumber = this.getMaxLineNumberSkuCustomerPriceLines();
      let isLineFound = false;
      if (!isEmptyArray(custSkuPrices)) {
        custSkuPrices.map((line, i) => {
          if (
            line.lineNumber == customerSkuPriceData.lineNumber &&
            line.customerCode == customerSkuPriceData.customerCode
          ) {
            customerSkuPriceData.lineNumber = line.lineNumber;
            customerSkuPriceData.isFetched = line.isFetched;
            custSkuPrices[i] = customerSkuPriceData;
            isLineFound = true;
          }
        });
      }
      if (!isLineFound) {
        customerSkuPriceData.lineNumber = ++lineNumber;
        custSkuPrices.push(customerSkuPriceData);
      }
      selectedSkuLine.skuPriceBean.skuCustomerPrices = custSkuPrices;
      this.setState({
        selectedSkuLine: selectedSkuLine,
      });
      this.clearSkuCustomerPriceLines();
    }
  };
  clearSkuCustomerPriceLines = () => {
    let newLineBean = new FabricStyleSKUCustomerPriceBean();
    newLineBean.customerShipToCode = "";
    this.setState({
      customerSkuPriceData: newLineBean,
    });
  };
  getMaxLineNumberSkuCustomerPriceLines = () => {
    let maxLineNumber = 0;
    let selectedSkuLine = this.state.selectedSkuLine;
    if (
      !isEmpty(selectedSkuLine) &&
      !isEmptyArray(selectedSkuLine.skuPriceBean.skuCustomerPrices)
    ) {
      selectedSkuLine.skuPriceBean.skuCustomerPrices.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };

  validateSkuCustomerPriceLine = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.customerCode)) {
        let errMsg = "Customer is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.effectiveDate)) {
        let errMsg = "Effective Date is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      isValid = true;
      this.setState({
        alertMessage: "",
        isShowPopupAlert: false,
      });
    }
    return isValid;
  };
  getMaxSkuLineNumber() {
    let maxLineNumber = 0;
    let skuPriceLineFormData =
      this.state.selectedSkuLine.skuPriceBean.skuCustomerPrices;
    if (skuPriceLineFormData != null) {
      if (skuPriceLineFormData.length > 0)
        skuPriceLineFormData.map((line) => {
          if (line.lineNumber > maxLineNumber) {
            maxLineNumber = line.lineNumber;
          }
        });
    }
    return maxLineNumber;
  }
  clearSkuLineValues = () => {
    let newLineBean = new FabricStyleSKUCustomerPriceBean();
    newLineBean.customerShipToCode = "";
    this.setState({
      customerSkuPriceData: newLineBean,
    });
  };
  reArrangeSkuPriceLineDisplayLineNumbers = (skuPriceLineList) => {
    let maxLineNumber = 0;
    skuPriceLineList.map((line) => {
      ++maxLineNumber;
      //line.displayLineNumber = maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  getCustomerSkuPriceLineByLineNumber = (lineNumber) => {
    let skuPriceLine = null;
    if (this.state.selectedSkuLine.skuPriceBean === null) return skuPriceLine;
    else if (this.state.selectedSkuLine.skuPriceBean.skuCustomerPrices == null)
      return skuPriceLine;
    else {
      this.state.selectedSkuLine.skuPriceBean.skuCustomerPrices.map((line) => {
        if (line.lineNumber === lineNumber) {
          skuPriceLine = line;
          return skuPriceLine;
        }
      });
    }
    return skuPriceLine;
  };
  deleteFabricSkuCustomerLine = (line) => {
    let fabricStyleSKUData = this.state.fabricStyleSKUData;
    let fabricSkuData = { ...this.state.fabricStyleSKUData };
    let fabricStyleData = this.state.fabricStyleData;
    let sku = fabricStyleSKUData.skuPriceBean.skuCustomerPrices;
    if (line.isFetched == false) {
      var index = sku.indexOf(line);
      if (index > -1) {
        sku.splice(index, 1);
      }
      this.reArrangeSkuPriceLineDisplayLineNumbers(sku);
      this.setState({ fabricStyleSKUData: fabricStyleSKUData });
    } else {
      let skuArray = [];
      if (fabricStyleSKUData.skuPriceBean.skuCustomerPrices != null) {
        for (let skuList of fabricStyleSKUData.skuPriceBean.skuCustomerPrices) {
          if (line.lineNumber === skuList.lineNumber) {
            skuList.isDeleted = true;
          }
          skuArray.push(skuList);
          this.setState({ customerPriceArray: skuArray });
        }
        this.reArrangeSkuPriceLineDisplayLineNumbers(
          fabricStyleSKUData.skuPriceBean.skuCustomerPrices,
        );
        fabricStyleSKUData.skuPriceBean.skuCustomerPrices = skuArray;

        this.setState({ fabricStyleSKUData: fabricStyleSKUData });
        if (!isEmptyArray(fabricStyleSKUData.skuPriceBean.skuCustomerPrices)) {
          fabricStyleData.fabricStyleSkus.map((sku, i) => {
            if (sku.skuNumber == fabricStyleSKUData.skuNumber) {
              sku = fabricStyleSKUData;
            }
          });
        }

        this.setState({
          fabricStyleData: fabricStyleData,
        });
      }
    }
    // this.reArrangeSkuPriceLineDisplayLineNumbers(sku);
  };
  readCustomerCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.customer != null &&
      response.data.customer.shipTos != null
    ) {
      const customerShipTos = response.data.customer.shipTos;
      this.setState({ customer_shipTo: customerShipTos });
    }
    this.loadShipTo();
  };
  readCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    let customerShipTos = this.state.customer_shipTo;
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithBillTosAndShipTos(
      readrestInput,
      this.readCustomerCodeResponse,
      this.errorCallBack,
    );
  };
  onVendorMapVendorCodeChange = (e) => {
    let temp_Vendor_ref_data = this.state.venReferenceData;
    temp_Vendor_ref_data[e.target.name] = e.target.value;

    if (e.target.name == "vendorCode") {
      temp_Vendor_ref_data["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          temp_Vendor_ref_data["vendorName"] = vendor.description;
        }
      });
      if (temp_Vendor_ref_data.fabricStyleColorVendorReferences != null) {
        temp_Vendor_ref_data.fabricStyleColorVendorReferences.map((line) => {
          line.vendorCode = e.target.value;
        });
      }
    }
    this.setState({
      venReferenceData: temp_Vendor_ref_data,
    });
  };
  onItemCostChange = (e) => {
    let temp_Vendor_ref_data = this.state.venReferenceData;
    temp_Vendor_ref_data[e.target.name] = e.target.value;
    this.setState({ venReferenceData: temp_Vendor_ref_data });
  };
  generateVendorColorReferenceInfoList = () => {
    let _fabricStyleData = this.state.fabricStyleData;
    let temp_Vendor_ref_data = this.state.venReferenceData;
    let venColorRefs = new Array();
    let colorList = this.state.fabricStyleData.colors;
    colorList.map((colorLine) => {
      let skuVendorInfo = new FabricStyleColorVendorReferenceBean();
      if (temp_Vendor_ref_data.fabricStyleColorVendorReferences != null) {
        skuVendorInfo.companyCode = _fabricStyleData.companyCode;
        skuVendorInfo.fabricStyleCode = _fabricStyleData.code;
        skuVendorInfo.vendorCode = temp_Vendor_ref_data.vendorCode;
        skuVendorInfo.fabricStyleColorCode = colorLine.fabricStyleColorCode;
        skuVendorInfo.fabricStyleColorName = colorLine.fabricStyleColorName;
        skuVendorInfo.isFetched = false;
        skuVendorInfo.isActive = true;
        venColorRefs.push(skuVendorInfo);
      }
    });

    temp_Vendor_ref_data.fabricStyleColorVendorReferences = venColorRefs;
    this.setState({ venReferenceData: temp_Vendor_ref_data });
  };
  closeVendorReferncePopup = () => {
    this.setState({
      isVendorReferencePopup: false,
    });
  };
  handleVendorReferencePopup = () => {
    let selectedVendorRefLine = null;
    this.setState({
      isVendorReferencePopup: true,
      selectedVendorRefLine: selectedVendorRefLine,
      venReferenceData: new FabricStyleVendorReferenceBean(),
    });
    this.state.isVendorReferencePopup = true;
  };
  openExitingVendorReferencePopup = ({ ...selectedVenRef }) => {
    this.setState({
      selectedVendorRefLine: selectedVenRef,
      venReferenceData: selectedVenRef,
      isVendorReferencePopup: true,
    });
  };
  closeSkuCostPopup = () => {
    this.setState({
      isOpenSkuCostPopup: false,
      selectedSkuLine: new FabricStyleSKUBean(),
    });
  };
  vendorHyperLinkClick = (rowData) => {
    this.openExitingVendorReferencePopup(rowData);
  };
  skuHandleHyperLinkClick = ({ ...rowData }) => {
    this.setState({
      isOpenSkuCostPopup: true,
      selectedSkuLine: { ...rowData },
      skuCostData: rowData.skuCostBean,
    });
  };
  onItemCostVendorCodeChange = (e) => {
    let skuCostData = this.state.selectedSkuLine.skuCostBean;
    skuCostData.cost = this.state.selectedSkuLine.standardCost;
    skuCostData.description = this.state.fabricStyleData.description;
    let tempSkuVendorCostData = this.state.skuVendorCostData;
    tempSkuVendorCostData[e.target.name] = e.target.value;
    if (e.target.name == "vendorCode") {
      tempSkuVendorCostData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          tempSkuVendorCostData["vendorName"] = vendor.description;
        }
      });
      tempSkuVendorCostData["uomCode"] = skuCostData.uomCode;
      tempSkuVendorCostData["currencyCode"] = skuCostData.currencyCode;
      tempSkuVendorCostData["effectiveDate"] = skuCostData.effectiveDate;
    }
    this.setState({
      skuVendorCostData: tempSkuVendorCostData,
    });
  };
  onSkuCostChange = (e) => {
    let selectedSkuLine = this.state.selectedSkuLine;
    // let skuCostData = this.state.selectedSkuLine.skuCostBean;
    selectedSkuLine.skuCostBean[e.target.name] = e.target.value;
    // selectedSkuLine.skuCostBean = skuCostData;
    this.setState({ selectedSkuLine: selectedSkuLine });
    // this.setState({ skuCostData: skuCostData });
  };
  skuCostOnChange = (e) => {
    let selectedSkuLine = this.state.selectedSkuLine;
    let skuCostData = this.state.selectedSkuLine.skuCostBean;
    skuCostData[e.target.name] = e.target.value;
    this.setState({ skuCostData: skuCostData });
    selectedSkuLine.skuCostBean = skuCostData;
    this.setState({ selectedSkuLine: selectedSkuLine });
  };
  setVendorCostLineData = () => {
    const skuVendorCostData = this.state.skuVendorCostData;
    const selectedSkuLine = this.state.selectedSkuLine;
    skuVendorCostData.effectiveDate =
      selectedSkuLine.skuPriceBean.effectiveDate;
    skuVendorCostData.uomCode = selectedSkuLine.uomCode;
    skuVendorCostData.currencyCode = selectedSkuLine.currencyCode;
    this.setState({
      skuVendorCostData,
      skuVendorCostData,
    });
  };
  onLandingCostChange = (e) => {
    let selectedSkuLine = this.state.selectedSkuLine;
    selectedSkuLine[e.target.name] = e.target.value;
    this.setState({ selectedSkuLine: selectedSkuLine });
  };
  onSkuCostLineChange = (e) => {
    let temp_skuVendorCostData = this.state.skuVendorCostData;
    temp_skuVendorCostData[e.target.name] = e.target.value;
    this.setState({ skuVendorCostData: temp_skuVendorCostData });
  };
  getLineDetails = (skuVendorCostData) => {
    if (
      skuVendorCostData.fabricStyleCode == null ||
      skuVendorCostData.fabricStyleCode.length == 0
    ) {
      this.state.isLineEditMode = true;
      let skuVendorCost = new FabricStyleSKUVendorCostBean();
      skuVendorCost = { ...skuVendorCostData };
      this.setState({
        skuVendorCostData: skuVendorCost,
      });
    } else {
      this.state.isLineEditMode = false;
      let skuVendor = new FabricStyleSKUVendorCostBean();
      skuVendor = { ...skuVendorCostData };
      this.setState({
        skuVendorCostData: skuVendor,
      });
    }
  };
  reArrangeSkuCostLineDisplayLineNumbers = (skuCostLineList) => {
    let maxLineNumber = 0;
    skuCostLineList.map((line) => {
      ++maxLineNumber;
      line.displayLineNumber = maxLineNumber;
    });
  };
  getSkuCostLineByLineNumber = (lineNumber) => {
    let skuCostLine = null;
    if (this.state.selectedSkuLine.skuCostBean === null) return skuCostLine;
    else if (this.state.selectedSkuLine.skuCostBean.skuVendorCosts == null)
      return skuCostLine;
    else {
      this.state.selectedSkuLine.skuCostBean.skuVendorCosts.map((line) => {
        if (line.lineNumber === lineNumber) {
          skuCostLine = line;
          return skuCostLine;
        }
      });
    }
    return skuCostLine;
  };
  validateSkuCostLine = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.vendorCode)) {
        let errMsg = "Vendor is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      isValid = true;
      this.setState({
        alertMessage: "",
        isShowPopupAlert: false,
      });
    }
    return isValid;
  };

  getMaxLineNumberSkuCostLines = () => {
    let maxLineNumber = 0;
    let selectedSkuLine = this.state.selectedSkuLine;
    if (
      !isEmpty(selectedSkuLine) &&
      !isEmpty(selectedSkuLine.skuCostBean) &&
      !isEmptyArray(selectedSkuLine.skuCostBean.skuVendorCosts)
    ) {
      selectedSkuLine.skuCostBean.skuVendorCosts.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };

  saveVendorSkuCostLine = () => {
    let selectedSkuLine = this.state.selectedSkuLine;
    let skuVendorCostData = this.state.skuVendorCostData;
    skuVendorCostData.companyCode = this.companyCode;
    let skuVendorCostLines = new Array();
    if (
      !isEmpty(selectedSkuLine.skuCostBean) &&
      !isEmptyArray(selectedSkuLine.skuCostBean.skuVendorCosts)
    )
      skuVendorCostLines = selectedSkuLine.skuCostBean.skuVendorCosts;
    let isValid = false;
    isValid = this.validateSkuCostLine(skuVendorCostData);
    if (isValid) {
      var lineNumber = this.getMaxLineNumberSkuCostLines();
      let isLineFound = false;
      if (!isEmptyArray(skuVendorCostLines)) {
        skuVendorCostLines.map((line, i) => {
          if (
            line.lineNumber == skuVendorCostData.lineNumber &&
            line.vendorCode == skuVendorCostData.vendorCode
          ) {
            skuVendorCostData.lineNumber = line.lineNumber;
            skuVendorCostData.isFetched = line.isFetched;
            skuVendorCostLines[i] = skuVendorCostData;
            isLineFound = true;
          }
        });
      }
      if (!isLineFound) {
        skuVendorCostData.lineNumber = ++lineNumber;
        skuVendorCostLines.push(skuVendorCostData);
      }
      selectedSkuLine.skuCostBean.skuVendorCosts = skuVendorCostLines;
      this.setState({
        selectedSkuLine: selectedSkuLine,
        // isDisablePopupFields: true,
      });
      this.clearLineValues();
    }
  };

  // saveVendorSkuCostLine = () => {
  //   let skuVendorCostData = this.state.skuVendorCostData;
  //   if (!isEmptyString(skuVendorCostData.vendorCode)) {
  //     let prp_fabricStyleData = this.state.fabricStyleData;
  //     let temp_selectedSkuLine = this.state.selectedSkuLine;
  //     let temp_selectedSkuCostLine = this.state.selectedSkuLine.skuCostBean;
  //     let skuCostData = this.state.selectedSkuLine.skuCostBean;
  //     skuCostData.cost = this.state.selectedSkuLine.standardCost;
  //     skuCostData.description = this.state.fabricStyleData.description;
  //     skuVendorCostData.companyCode = this.companyCode;
  //     if (temp_selectedSkuCostLine == null) {
  //       temp_selectedSkuCostLine.skuCostBean = skuCostData;
  //     }
  //     var lineNumber = this.getMaxLineNumber();
  //     let existingLine = this.getSkuCostLineByLineNumber(
  //       skuVendorCostData.lineNumber
  //     );
  //     if (existingLine == null) skuVendorCostData.lineNumber = ++lineNumber;
  //     let lineBean = new FabricStyleSKUVendorCostBean();
  //     lineBean.lineNumber = temp_selectedSkuLine.lastSKUCostLineNumber;
  //     lineBean.skuNumber = temp_selectedSkuLine.skuNumber;
  //     lineBean.companyCode = temp_selectedSkuLine.companyCode;
  //     lineBean.fabricStyleCode = prp_fabricStyleData.code;
  //     lineBean.fabricStyleColorCode = temp_selectedSkuLine.fabricStyleColorCode;
  //     lineBean.uomCode = prp_fabricStyleData.inventoryUomCode;
  //     lineBean.effectiveDate = skuVendorCostData.effectiveDate;
  //     lineBean.vendorCode = skuVendorCostData.vendorCode;
  //     lineBean.vendorName = skuVendorCostData.vendorName;
  //     lineBean.cost = skuVendorCostData.cost;
  //     lineBean.currencyCode = skuVendorCostData.currencyCode;
  //     lineBean.isDefaultCost = skuVendorCostData.isDefaultCost;
  //     if (existingLine === null) {
  //       var lineNumber = this.getMaxLineNumber();
  //       lineBean.lineNumber = ++lineNumber;
  //       if (temp_selectedSkuCostLine.skuVendorCosts != null) {
  //         temp_selectedSkuCostLine.skuVendorCosts.push(lineBean);
  //       } else {
  //         let skuvendorCosts = new Array();
  //         skuvendorCosts.push(lineBean);
  //         temp_selectedSkuCostLine.skuVendorCosts = skuvendorCosts;
  //       }
  //     } else {
  //       const index = temp_selectedSkuCostLine.skuVendorCosts.findIndex(
  //         (ln) => ln.lineNumber === existingLine.lineNumber
  //       );
  //       if (index != -1) {
  //         temp_selectedSkuCostLine.skuVendorCosts.splice(index, 1);
  //         if (lineBean.isFetched) {
  //           lineBean.lineNumber = existingLine.lineNumber;
  //           lineBean.isFetched = true;
  //         }
  //         temp_selectedSkuCostLine.skuVendorCosts.push(lineBean);
  //       }
  //     }
  //     this.reArrangeSkuCostLineDisplayLineNumbers(
  //       temp_selectedSkuCostLine.skuVendorCosts
  //     );

  //     temp_selectedSkuLine.skuCostBean.skuVendorCosts =
  //       temp_selectedSkuCostLine.skuVendorCosts;
  //     this.setState({ selectedSkuLine: temp_selectedSkuLine });
  //     this.clearLineValues();
  //   } else {
  //     let errMsg = "Invalid Vendor";
  //     let errList = [];
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowPopupAlert: true,
  //     });
  //   }
  // };
  getMaxLineNumber() {
    let maxLineNumber = 0;
    let venSkuCostLineFormData =
      this.state.selectedSkuLine.skuCostBean.skuVendorCosts;
    if (venSkuCostLineFormData != null) {
      if (venSkuCostLineFormData.length > 0)
        venSkuCostLineFormData.map((line) => {
          if (line.lineNumber > maxLineNumber) {
            maxLineNumber = line.lineNumber;
          }
        });
    }
    return maxLineNumber;
  }
  clearLineValues = () => {
    let newLineBean = new FabricStyleSKUVendorCostBean();
    this.setState({
      skuVendorCostData: newLineBean,
    });
  };
  deleteVendorSkuCostLine = (line) => {
    let selectedSkuData = this.state.selectedSkuLine;
    let selectedData = { ...this.state.selectedSkuLine };
    let misc = selectedSkuData.skuCostBean.skuVendorCosts;
    let lineData = line;
    if (line.isFetched == false) {
      var index = misc.indexOf(line);
      if (index > -1) {
        misc.splice(index, 1);
      }
      this.reArrangeMiscLineDisplayLineNumbers(
        selectedSkuData.skuCostBean.skuVendorCosts,
      );
      this.setState({ selectedSkuLine: selectedSkuData });
    } else {
      let miscArray = [];
      if (selectedSkuData.skuCostBean.skuVendorCosts != null) {
        for (let miscList of selectedSkuData.skuCostBean.skuVendorCosts) {
          if (line.lineNumber === miscList.lineNumber) {
            miscList.isDeleted = true;
          }
          miscArray.push(miscList);
        }
        selectedSkuData.skuCostBean.skuVendorCosts = miscArray;

        this.setState({ selectedSkuLine: selectedSkuData });
      }
    }
  };
  onMiscVendorCodeChange = (e) => {
    let skuMiscCostData = this.state.skuMiscCostData;
    skuMiscCostData[e.target.name] = e.target.value;
    if (e.target.name == "vendorCode") {
      skuMiscCostData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          skuMiscCostData["vendorName"] = vendor.description;
        }
      });
    }
    this.setState({
      skuMiscCostData: skuMiscCostData,
    });
  };
  onMiscLineChange = (e) => {
    let skuMiscCostData = this.state.skuMiscCostData;
    skuMiscCostData[e.target.name] = e.target.value;
    if (e.target.name == "code") {
      let misc_List = this.state.miscReasons;
      misc_List.map((comp) => {
        if (comp.code == e.target.value) {
          skuMiscCostData["description"] = comp.description;
        }
      });
    }
    this.setState({
      skuMiscCostData: skuMiscCostData,
    });
  };

  reArrangeMiscLineDisplayLineNumbers = (skuCostLineList) => {
    let maxLineNumber = 0;
    skuCostLineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deleteSkuMiscColorLine = (line) => {
    let fabricStyleData = this.state.fabricStyleData;
    let selectedSkuLine = this.state.selectedSkuLine;
    let selectedSkuData = { ...this.state.selectedSkuLine };
    let misc = selectedSkuLine.fabricMiscColorDetails;
    if (line.isFetched == false) {
      var index = misc.indexOf(line);
      if (index > -1) {
        misc.splice(index, 1);
      }
      this.reArrangeMiscLineDisplayLineNumbers(
        selectedSkuLine.fabricMiscColorDetails,
      );
      this.setState({ selectedSkuLine: selectedSkuLine });
    } else {
      let miscArray = [];
      if (selectedSkuLine.fabricMiscColorDetails != null) {
        for (let miscList of selectedSkuLine.fabricMiscColorDetails) {
          if (line.lineNumber === miscList.lineNumber) {
            miscList.isDeleted = true;
          }
          miscArray.push(miscList);
        }
        selectedSkuLine.fabricMiscColorDetails = miscArray;

        this.setState({ selectedSkuLine: selectedSkuLine });
      }
    }
  };
  getMiscColorCostLineDetails = (miscCostLinedata) => {
    if (
      miscCostLinedata.fabricStyleCode == null ||
      miscCostLinedata.fabricStyleCode.length == 0
    ) {
      this.state.isLineEditMode = true;
      this.openExcitingMiscColorCostLineForm(miscCostLinedata);
    } else {
      this.openExcitingMiscColorCostLineForm(miscCostLinedata);
    }
  };

  openExcitingMiscColorCostLineForm = (miscCostLineData) => {
    let fabricStyleData = this.props.fabricStyleData;
    if (this.state.isLineEditMode == true) {
      let newMiscCostLineData = new FabricStyleColorMiscellaneousDetailBean();
      newMiscCostLineData = { ...miscCostLineData };

      this.setState({
        skuMiscCostData: newMiscCostLineData,
      });
      this.setState({ isLineEditMode: false });
    } else {
      let skuMiscCostData = new FabricStyleColorMiscellaneousDetailBean();
      skuMiscCostData = { ...miscCostLineData };
      this.setState({
        skuMiscCostData: skuMiscCostData,
      });
    }
  };
  getMiscColorMaxLineNumber() {
    let maxLineNumber = 0;
    let miscDetail = this.state.selectedSkuLine.fabricMiscColorDetails;
    if (!isEmptyArray(miscDetail) && miscDetail.length > 0)
      miscDetail.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  getMiscColorLineByLineNumber = (lineNumber) => {
    let miscLine = null;
    let miscDetails = this.state.selectedSkuLine.fabricMiscColorDetails;
    if (this.state.selectedSkuLine === null) return miscLine;
    else if (miscDetails === null) return miscLine;
    else {
      miscDetails.map((line) => {
        if (line.lineNumber === lineNumber) {
          miscLine = line;
          return miscLine;
        }
      });
    }
    return miscLine;
  };
  validateMiscColorLine = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.vendorCode)) {
        let errMsg = "Vendor is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.code)) {
        let errMsg = "Reason is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.miscellaneousCost) && data.miscellaneousCost > 0) {
        let errMsg = "MiscCost is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      isValid = true;
      this.setState({
        alertMessage: "",
        isShowPopupAlert: false,
      });
    }
    return isValid;
  };
  getMaxLineNumberMiscColorLines = () => {
    let maxLineNumber = 0;
    let selectedSkuLine = this.state.selectedSkuLine;
    if (
      !isEmpty(selectedSkuLine) &&
      !isEmptyArray(selectedSkuLine.fabricMiscColorDetails)
    ) {
      selectedSkuLine.fabricMiscColorDetails.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  saveSkuColorMiscillaneousLine = () => {
    let selectedSkuLine = this.state.selectedSkuLine;
    let skuMiscCostData = this.state.skuMiscCostData;
    let fabricStyleData = this.state.fabricStyleData;
    skuMiscCostData.companyCode = this.companyCode;
    skuMiscCostData.fabricStyleCode = fabricStyleData.code;
    skuMiscCostData.fabricStyleColorCode = selectedSkuLine.fabricStyleColorCode;
    let miscColorLines = new Array();
    if (!isEmptyArray(selectedSkuLine.fabricMiscColorDetails))
      miscColorLines = selectedSkuLine.fabricMiscColorDetails;
    let isValid = false;
    isValid = this.validateMiscColorLine(skuMiscCostData);
    if (isValid) {
      var lineNumber = this.getMaxLineNumberMiscColorLines();
      let isLineFound = false;
      if (!isEmptyArray(miscColorLines)) {
        miscColorLines.map((line, i) => {
          if (
            // line.lineNumber == skuMiscCostData.lineNumber &&
            line.vendorCode == skuMiscCostData.vendorCode &&
            line.code == skuMiscCostData.code
          ) {
            skuMiscCostData.lineNumber = line.lineNumber;
            skuMiscCostData.isFetched = line.isFetched;
            miscColorLines[i] = skuMiscCostData;
            isLineFound = true;
          }
        });
      }
      if (!isLineFound) {
        skuMiscCostData.lineNumber = ++lineNumber;
        miscColorLines.push(skuMiscCostData);
      }
      selectedSkuLine.fabricMiscColorDetails = miscColorLines;
      this.setState({
        selectedSkuLine: selectedSkuLine,
      });
      this.clearMiscColorLineValues();
    }
  };
  // saveSkuColorMiscillaneousLine = () => {
  //   let compLine = this.state.skuMiscCostData;
  //   if (!isEmptyString(compLine.vendorCode) && !isEmptyString(compLine.code)) {
  //     let fabricStyleData = this.state.fabricStyleData;
  //     let selectedSkuLine = this.state.selectedSkuLine;
  //     compLine.companyCode = fabricStyleData.companyCode;
  //     compLine.fabricStyleCode = fabricStyleData.code;
  //     compLine.fabricStyleColorCode = selectedSkuLine.fabricStyleColorCode;
  //     if (isEmptyArray(selectedSkuLine.fabricMiscColorDetails))
  //       selectedSkuLine.fabricMiscColorDetails = new Array();
  //     let existingLine = this.getMiscColorLineByLineNumber(compLine.lineNumber);
  //     if (existingLine === null) {
  //       var lineNumber = this.getMiscColorMaxLineNumber();
  //       compLine.lineNumber = ++lineNumber;
  //       selectedSkuLine.fabricMiscColorDetails.push(compLine);
  //     } else {
  //       const index = selectedSkuLine.fabricMiscColorDetails.findIndex(
  //         (ln) => ln.code === existingLine.code
  //       );
  //       if (index != -1) {
  //         selectedSkuLine.fabricMiscColorDetails.splice(index, 1);
  //         selectedSkuLine.fabricMiscColorDetails.push(compLine);
  //       }
  //     }
  //     this.setState({
  //       selectedSkuLine: selectedSkuLine,
  //       fabricStyleData: fabricStyleData,
  //     });
  //     this.clearMiscColorLineValues();
  //   } else {
  //     let errMsg = "Vendor & Reason is Required";
  //     let errList = [];
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowPopupAlert: true,
  //     });
  //   }
  // };
  clearMiscColorLineValues = () => {
    let newLineBean = new FabricStyleColorMiscellaneousDetailBean();
    this.setState({
      skuMiscCostData: newLineBean,
    });
  };
  onFabCompChange = (e) => {
    let temp_fabricStyleCompositionLineData =
      this.state.fabricStyleCompositionLineData;
    temp_fabricStyleCompositionLineData[e.target.name] = e.target.value;
    if (e.target.name == "compositionElementCode") {
      let comp_List = this.state.compositionTypes;
      comp_List.map((comp) => {
        if (comp.code == e.target.value) {
          temp_fabricStyleCompositionLineData["compositionElementName"] =
            comp.description;
        }
      });
    }
    this.setState({
      fabricStyleCompositionLineData: temp_fabricStyleCompositionLineData,
    });
  };
  saveCompositionLine = () => {
    let compLine = this.state.fabricStyleCompositionLineData;
    if (!isEmptyString(compLine.compositionElementCode)) {
      let existingLine = this.getCompositionLineByLineNumber(
        compLine.compositionElementCode,
      );
      if (existingLine === null) {
        if (this.state.fabricStyleData.compositions == null) {
          let compositionLines = new Array();
          compositionLines.push(compLine);
          this.state.fabricStyleData.compositions = compositionLines;
        } else this.state.fabricStyleData.compositions.push(compLine);
      } else {
        const index = this.state.fabricStyleData.compositions.findIndex(
          (ln) =>
            ln.compositionElementCode === existingLine.compositionElementCode,
        );
        if (index != -1) {
          this.state.fabricStyleData.compositions.splice(index, 1);
          this.state.fabricStyleData.compositions.push(compLine);
        }
      }
    } else {
      let errMsg = "Element is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteCompositionLine = (line) => {
    let fabricStyleData = this.state.fabricStyleData;
    let comp = fabricStyleData.compositions;
    let lineData = line;
    if (line.isFetched == false) {
      var index = comp.indexOf(line);
      if (index > -1) {
        comp.splice(index, 1);
      }
      this.setState({ fabricStyleData: fabricStyleData });
    } else {
      let compArray = [];
      if (fabricStyleData.compositions != null) {
        for (let compList of fabricStyleData.compositions) {
          if (line.compositionElementCode === compList.compositionElementCode) {
            compList.isDeleted = true;
          }
          compArray.push(compList);
        }
        fabricStyleData.compositions = compArray;
        this.setState({ fabricStyleData: fabricStyleData });
      }
    }
  };
  getCompositionLineByLineNumber = (compositionElementCode) => {
    let compLine = null;
    if (this.state.fabricStyleData.compositions === null) return compLine;
    else {
      this.state.fabricStyleData.compositions.map((line) => {
        if (line.compositionElementCode === compositionElementCode) {
          compLine = line;
          return compLine;
        }
      });
    }
    return compLine;
  };
  openExcitingCompLineForm = (compLineData) => {
    let compData = { ...compLineData };
    if (this.state.isLineEditMode == true) {
      let newCompositionLineData = new FabricStyleCompositionBean();
      newCompositionLineData = compData;
      this.setState({
        fabricStyleCompositionLineData: newCompositionLineData,
      });
      this.setState({ isLineEditMode: false });
    } else {
      this.setState({
        fabricStyleCompositionLineData: compData,
      });
    }
  };
  clearCompositionLineValues = () => {
    let newLineBean = new FabricStyleCompositionBean();
    this.setState({
      fabricStyleCompositionLineData: newLineBean,
    });
  };
  downloadReportResponse = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  generateDetailReport = () => {
    let reportBean = new RestReportBean();
    reportBean.reportType = 2;
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = new FabricStyleSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = 1;
    let requestInput = new FabricStyleOtherInfoDetailsRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.criteria = criteria;
    requestInput.input = reportBean;
    requestInput.pageInput = pageInput;
    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      ReportService.generateFabricStyleOtherInfoDetails(
        requestInput,
        this.downloadReportResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onFabDetailsChange = (e) => {
    let temp_fabricStyleData = this.state.fabricStyleData;
    temp_fabricStyleData[e.target.name] = e.target.value;
    this.setState({ fabricStyleData: temp_fabricStyleData });
  };
  onVendorCodeChange = (e) => {
    let tempFabricStyleMiscCostLineData =
      this.state.fabricStyleMiscCostLineData;
    tempFabricStyleMiscCostLineData[e.target.name] = e.target.value;
    if (e.target.name == "vendorCode") {
      tempFabricStyleMiscCostLineData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          tempFabricStyleMiscCostLineData["vendorName"] = vendor.description;
        }
      });
    }
    this.setState({
      fabricStyleMiscCostLineData: tempFabricStyleMiscCostLineData,
    });
  };
  onMiscCostChange = (e) => {
    let tempFabricStyleMiscCostLineData =
      this.state.fabricStyleMiscCostLineData;
    tempFabricStyleMiscCostLineData[e.target.name] = e.target.value;
    if (e.target.name == "code") {
      let misc_List = this.state.miscReasons;
      misc_List.map((comp) => {
        if (comp.code == e.target.value) {
          tempFabricStyleMiscCostLineData["description"] = comp.description;
        }
      });
    }
    this.setState({
      fabricStyleMiscCostLineData: tempFabricStyleMiscCostLineData,
    });
  };
  getMiscMaxLineNumber() {
    let maxLineNumber = 0;
    let miscDetail = this.state.fabricStyleData.fabricMiscDetails;
    if (!isEmptyArray(miscDetail) && miscDetail.length > 0)
      miscDetail.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  getMiscLineByLineNumber = (lineNumber) => {
    let miscLine = null;
    let miscDetails = this.state.fabricStyleData.fabricMiscDetails;
    if (this.state.fabricStyleData === null) return miscLine;
    else if (miscDetails === null) return miscLine;
    else {
      miscDetails.map((line) => {
        if (line.lineNumber === lineNumber) {
          miscLine = line;
          return miscLine;
        }
      });
    }
    return miscLine;
  };
  saveMiscillaneousLine = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let compLine = this.state.fabricStyleMiscCostLineData;
    if (isEmptyString(compLine.vendorCode)) {
      let errMsg = "Vendor Code is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    } else if (isEmptyString(compLine.code)) {
      let errMsg = "Reason Code is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    } else if (
      !isEmptyString(compLine.vendorCode) &&
      !isEmptyString(compLine.code)
    ) {
      compLine.companyCode = fabricStyleData.companyCode;
      compLine.fabricStyleCode = fabricStyleData.code;

      if (isEmptyArray(fabricStyleData.fabricMiscDetails))
        fabricStyleData.fabricMiscDetails = new Array();
      let existingLine = this.getMiscLineByLineNumber(compLine.lineNumber);
      if (existingLine === null) {
        var lineNumber = this.getMiscMaxLineNumber();
        compLine.lineNumber = ++lineNumber;

        fabricStyleData.fabricMiscDetails.push(compLine);
      } else {
        fabricStyleData.fabricMiscDetails.map((line, i) => {
          if (line.lineNumber == compLine.lineNumber) {
            fabricStyleData.fabricMiscDetails[i] = compLine;
          }
        });
      }
      this.setState({ fabricStyleData: fabricStyleData });
      this.clearMiscLineValues();
    }
  };
  getMiscCostLineDetails = (miscCostLinedata) => {
    if (
      miscCostLinedata.fabricStyleCode == null ||
      miscCostLinedata.fabricStyleCode.length == 0
    ) {
      this.state.isLineEditMode = true;
      this.openExcitingMiscCostLineForm(miscCostLinedata);
    } else {
      this.openExcitingMiscCostLineForm(miscCostLinedata);
    }
  };
  openExcitingMiscCostLineForm = (miscCostLineData) => {
    let fabricStyleData = this.state.fabricStyleData;
    if (this.state.isLineEditMode == true) {
      let newMiscCostLineData = new FabricStyleMiscellaneousDetailBean();
      newMiscCostLineData = { ...miscCostLineData };
      this.setState({
        fabricStyleMiscCostLineData: newMiscCostLineData,
      });
      this.setState({ isLineEditMode: false });
    } else {
      let miscCostLine = new FabricStyleMiscellaneousDetailBean();
      miscCostLine = { ...miscCostLineData };
      this.setState({
        fabricStyleMiscCostLineData: miscCostLine,
      });
    }
  };
  reArrangeMiscDisplayLineNumbers = (miscCostLineList) => {
    let maxLineNumber = 0;
    miscCostLineList.map((line) => {
      if (line.deleted == false || line.isDeleted == false) {
        ++maxLineNumber;
        line.lineNumber = maxLineNumber;
      }
    });
  };
  deleteVendorMiscellaneousLine = (line) => {
    let fabricStyleData = this.state.fabricStyleData;
    let fabricData = { ...this.state.fabricStyleData };
    let misc = fabricStyleData.fabricMiscDetails;
    let lineData = line;
    if (line.isFetched == false) {
      var index = misc.indexOf(line);
      if (index > -1) {
        misc.splice(index, 1);
      }
      this.reArrangeMiscDisplayLineNumbers(fabricStyleData.fabricMiscDetails);
      this.setState({ fabricStyleData: fabricStyleData });
    } else {
      let miscArray = [];
      if (fabricStyleData.fabricMiscDetails != null) {
        for (let miscList of fabricStyleData.fabricMiscDetails) {
          if (line.lineNumber === miscList.lineNumber) {
            miscList.isDeleted = true;
          }
          miscArray.push(miscList);
        }
        fabricStyleData.fabricMiscDetails = miscArray;
        this.setState({ fabricStyleData: fabricStyleData });
      }
    }
  };
  clearMiscLineValues = () => {
    let newLineBean = new FabricStyleMiscellaneousDetailBean();
    this.setState({
      fabricStyleMiscCostLineData: newLineBean,
    });
  };
  applyToAllMiscDetail = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let fabricStyleSku = fabricStyleData.fabricStyleSkus;
    let fabricMiscDetails = fabricStyleData.fabricMiscDetails;
    let fabricSku = fabricStyleData.fabricStyleSkus;
    if (fabricMiscDetails != null) {
      if (fabricSku != null) {
        for (let skuLine of fabricSku) {
          let lineNumber = 1;
          let miscColor = [];
          if (
            skuLine.fabricMiscColorDetails === null ||
            skuLine.fabricMiscColorDetails.length <= 0
          ) {
            for (let misc of fabricMiscDetails) {
              let miscColorList = this.toMiscColorDetails(
                misc,
                lineNumber,
                skuLine,
              );
              miscColor.push(miscColorList);
              ++lineNumber;
            }
            skuLine.fabricMiscColorDetails = miscColor;
          } else {
            // let isLineFound = false;
            // let miscColorList = [];
            // for (let miscDt of fabricMiscDetails) {
            //   for (let miscColorLine of skuLine.fabricMiscColorDetails) {
            //     /if (miscDt.code === miscColorLine.code) {
            //       miscDt.lineNumber = miscColorLine.lineNumber
            //     miscColorLine.miscellaneousCost = miscDt.miscellaneousCost;
            //     isLineFound = true;
            //     // }
            //   }
            //     miscColorList.push(miscDt);
            //   //skuLine.fabricMiscColorDetails.push(miscDt);
            //   ++lineNumber;
            var lineNumbers = this.getMiscAndSkuLineNumber(
              skuLine.fabricMiscColorDetails,
            );
            for (let misc of fabricMiscDetails) {
              let miscColorList = this.toMiscColorDetails(
                misc,
                lineNumbers,
                skuLine,
              );
              miscColorList.lineNumber = ++lineNumbers;
              skuLine.fabricMiscColorDetails.push(miscColorList);
            }
          }
          //skuLine.fabricMiscColorDetails = miscColorList;
        }
      }
    }
    this.setState({ fabricStyleData: fabricStyleData });
  };
  getMiscAndSkuLineNumber(misc) {
    let maxLineNumber = 0;
    if (misc.length > 0)
      misc.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  toMiscColorDetails = (colorLine, lineNumber, skuLine) => {
    let colorCostDetail = new FabricStyleColorMiscellaneousDetailBean();
    colorCostDetail.companyCode = colorLine.companyCode;
    colorCostDetail.fabricStyleCode = colorLine.fabricStyleCode;
    colorCostDetail.code = colorLine.code;
    colorCostDetail.description = colorLine.description;
    colorCostDetail.vendorCode = colorLine.vendorCode;
    colorCostDetail.vendorName = colorLine.vendorName;
    colorCostDetail.miscellaneousCost = colorLine.miscellaneousCost;
    colorCostDetail.lineNumber = lineNumber;
    colorCostDetail.fabricStyleColorCode = skuLine.fabricStyleColorCode;
    colorCostDetail.isFetched = false;
    return colorCostDetail;
  };
  colorButtonClick = (val) => {
    let fabricStyleSKUData = this.state.fabricStyleSKUData;
    this.state.fabricStyleData.fabricStyleSkus.map((list) => {
      if (val === list.skuPriceBean.fabricStyleColorCode) {
        fabricStyleSKUData = list;
      }
    });
    let eComSkuData = new EcomShopifySkuLineFabricStyleBean();
    eComSkuData.companyCode = this.companyCode;
    eComSkuData.code = fabricStyleSKUData.fabricStyleCode;
    eComSkuData.description = fabricStyleSKUData.fabricStyleCode;
    eComSkuData.colorCode = fabricStyleSKUData.fabricStyleColorCode;
    eComSkuData.webSiteCode = this.state.websiteCode;
    eComSkuData.skuNumber = fabricStyleSKUData.skuNumber;
    eComSkuData.variantSKU = fabricStyleSKUData.skuNumber;
    eComSkuData.option1Name = "Color";
    eComSkuData.option1Value = fabricStyleSKUData.fabricStyleColorCode;
    let skuData = new EcomShopifySkuLineFabricStyleBean();
    if (fabricStyleSKUData.shopifySkuLines) {
      fabricStyleSKUData.shopifySkuLines.map((list) => {
        if (val === list.colorCode) {
          skuData = list;
        }
      });
      eComSkuData.variantPrice = skuData.variantPrice;
      eComSkuData.variantGrams = skuData.variantGrams;
      eComSkuData.variantBarcode = skuData.variantBarcode;
      eComSkuData.webSalesFlag = skuData.webSalesFlag;
      eComSkuData.imageAltText = skuData.imageAltText;
    }
    this.setState({
      eComSkuData: eComSkuData,
      isShowEcomColorPopup: true,
    });
  };
  onSkuChange = (e) => {
    let temp_EcomSkuData = this.state.eComSkuData;
    temp_EcomSkuData[e.target.name] = e.target.value;
    this.setState({ eComSkuData: temp_EcomSkuData });
  };
  addorUpdateSkuDetails = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let fabricStyleSKUData = this.state.fabricStyleSKUData;
    let skuData = this.state.eComSkuData;
    let isLineFound = false;
    let shopifyBodyList = fabricStyleData.fabricStyleSkus;
    if (shopifyBodyList != null) {
      shopifyBodyList.map((line, i) => {
        if (line.fabricStyleColorCode == skuData.colorCode) {
          let skus = shopifyBodyList[i].shopifySkuLines;
          if (skus != null) {
            skus.map((sku, i) => {
              skus[i].variantGrams = skuData.variantGrams;
              skus[i].variantPrice = skuData.variantPrice;
              skus[i].variantBarcode = skuData.variantBarcode;
              skus[i].webSalesFlag = skuData.webSalesFlag;
              skus[i].imageAltText = skuData.imageAltText;
            });
            fabricStyleData.fabricStyleSkus.shopifySkuLines = skus;
          } else {
            let tempArray = [];
            tempArray.push(skuData);
            shopifyBodyList.map((line, i) => {
              if (line.fabricStyleColorCode == skuData.colorCode) {
                line.shopifySkuLines = tempArray;
                shopifyBodyList[i] = line;
                fabricStyleData.fabricStyleSkus = shopifyBodyList;
              }
            });
          }
        }
      });
    }
    this.setState({
      fabricStyleSKUData: fabricStyleSKUData,
      fabricStyleData: fabricStyleData,
    });
    this.clearSkuData();
  };
  clearSkuData = () => {
    let skuData = new EcomShopifySkuLineFabricStyleBean();
    this.setState({
      eComSkuData: skuData,
    });
  };
  setDateForCustPriceLine = () => {
    const customerSkuPriceData = this.state.customerSkuPriceData;
    customerSkuPriceData.effectiveDate = new Date().toLocaleDateString("sv-SE");
    this.setState({
      customerSkuPriceData,
      customerSkuPriceData,
    });
  };
  onElementChange = (e) => {
    let compositionElementCode = e.target.value;
    this.state.showAutoCompleteElementList = true;
    let temp_fabricStyledata = this.state.fabricStyleCompositionLineData;
    let showAutoCompleteList = this.state.showAutoCompleteElementList;
    if (isEmpty(compositionElementCode)) {
      this.state.showAutoCompleteElementList = false;
      let showAutoCompleteList = this.state.showAutoCompleteElementList;
      let temp_fabricStyledata = this.state.fabricStyleCompositionLineData;
      temp_fabricStyledata.compositionElementCode = "";
      temp_fabricStyledata.compositionElementName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteElementList: showAutoCompleteList,
        fabricStyleCompositionLineData: temp_fabricStyledata,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && compositionElementCode !== "") {
      this.readCompositionElementCodeBySearchString(compositionElementCode);
    }
    if (e.target.name == "compositionElementCode") {
      temp_fabricStyledata["compositionElementCode"] = e.target.value;
      let element_List = this.state.compositionTypes;
      element_List.map((element) => {
        if (element.compositionElementCode == e.target.value) {
          temp_fabricStyledata["compositionElementCode"] = element.code;
          temp_fabricStyledata["compositionElementName"] = element.description;
          this.state.showAutoCompleteElementList = false;
          let showAutoCompleteList = this.state.showAutoCompleteElementList;
          this.setState({ showAutoCompleteElementList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleCompositionLineData: temp_fabricStyledata });
  };
  readCompositionElementCodeBySearchString(searchString) {
    let compositionElementCode = this.state.compositionTypes;
    let simpleAutoCompleteList = new Array();
    if (compositionElementCode.length > 0 && compositionElementCode != null) {
      compositionElementCode.map((compositionElement) => {
        let simpleItemBean = {
          code: compositionElement.code,
          description: compositionElement.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecompositionElementCodeLists) =>
        simpleAutoCompletecompositionElementCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ elementPageListForAutoCompleteList: filteredSuggestions });
  }
  elementEnterKeyEventHandler = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleCompositionLineData;
    let compositionElementCode = e.target.value;
    temp_fabricStyledata["compositionElementCode"] = e.target.value;
    let element_List = this.state.compositionTypes;
    let elementBean = null;
    element_List.map((compositionElementCode) => {
      if (compositionElementCode.code == e.target.value) {
        elementBean = compositionElementCode;
      }
    });
    if (!isEmpty(elementBean)) {
      let temp_fabricStyledata = this.state.fabricStyleCompositionLineData;
      temp_fabricStyledata.compositionElementCode = elementBean.code;
      temp_fabricStyledata.compositionElementName = elementBean.description;
      this.setState({
        fabricStyleCompositionLineData: temp_fabricStyledata,
        elementPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteElementList = (showAutoCompleteElementList) => {
    this.setState({ showAutoCompleteElementList: showAutoCompleteElementList });
  };
  onVendorCodeMappingChange = (e) => {
    let vendorCode = e.target.value;
    let temp_Vendor_ref_data = this.state.venReferenceData;
    temp_Vendor_ref_data[e.target.name] = e.target.value;
    let showAutoCompleteVendorList = this.state.showAutoCompleteVendorList;
    this.state.showAutoCompleteVendorList = true;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteVendorList = this.state.showAutoCompleteVendorList;
      let venReferenceData = this.state.venReferenceData;
      venReferenceData.vendorCode = "";
      venReferenceData.vendorName = "";
      if (venReferenceData.fabricStyleColorVendorReferences != null) {
        venReferenceData.fabricStyleColorVendorReferences.map((line) => {
          line.vendorCode = "";
        });
      }
      let suggestion = [];
      this.setState({
        showAutoCompleteVendorList: showAutoCompleteVendorList,
        venReferenceData: venReferenceData,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteVendorList === true &&
      vendorCode !== ""
    ) {
      this.state.showAutoCompleteVendorList = true;
      this.readVendorMappingBySearchString(e.target.value);
    }
    // if (e.target.name == "vendorCode") {
    //   temp_Vendor_ref_data["vendorCode"] = e.target.value;
    //   let vendor_List = this.state.vendor_List;
    //   vendor_List.map((vendor) => {
    //     if (vendor.code == e.target.value) {
    //       temp_Vendor_ref_data["vendorCode"] = vendor.code;
    //       temp_Vendor_ref_data["vendorName"] = vendor.description;
    //     }
    //   });
    //   if (temp_Vendor_ref_data.fabricStyleColorVendorReferences != null) {
    //     temp_Vendor_ref_data.fabricStyleColorVendorReferences.map((line) => {
    //       line.vendorCode = e.target.value;
    //     });
    //   }
    // }
    this.setState({
      venReferenceData: temp_Vendor_ref_data,
    });
  };
  readVendorMappingBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeMappingResponse,
      this.errorCallBack,
    );
  }
  readByVendorCodeMappingResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  displayAutoCompleteVendorMappingList = (showAutoCompleteVendorList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteVendorList });
  };
  vendorCodeMappingEnterKeyEventHandler = (e) => {
    let venReferenceData = this.state.venReferenceData;
    venReferenceData[e.target.name] = e.target.value;
    venReferenceData["vendorCode"] = e.target.value;
    let vendor_List = this.state.vendor_List;
    vendor_List.map((vendor) => {
      if (vendor.code == e.target.value) {
        venReferenceData["vendorCode"] = vendor.code;
        venReferenceData["vendorName"] = vendor.description;
      }
    });
    if (venReferenceData.fabricStyleColorVendorReferences != null) {
      venReferenceData.fabricStyleColorVendorReferences.map((line) => {
        line.vendorCode = e.target.value;
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
      venReferenceData: venReferenceData,
    });
  };
  onVendorSkuCostPopupChange = (e) => {
    let vendorCode = e.target.value;
    let temp_Vendor_ref_data = this.state.skuMiscCostData;
    temp_Vendor_ref_data[e.target.name] = e.target.value;
    let showAutoCompleteVendorCodeList =
      this.state.showAutoCompleteVendorCodeList;
    this.state.showAutoCompleteVendorCodeList = true;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorCodeList = false;
      let showAutoCompleteVendorCodeList =
        this.state.showAutoCompleteVendorCodeList;
      let searchCriteria = this.state.skuMiscCostData;
      searchCriteria.vendorCode = "";
      searchCriteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteVendorCodeList: showAutoCompleteVendorCodeList,
        skuMiscCostData: searchCriteria,
        vendorCodePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteVendorCodeList === true &&
      vendorCode !== ""
    ) {
      this.state.showAutoCompleteVendorCodeList = true;
      this.readVendorCodeBySearchString(e.target.value);
    }
    if (e.target.name == "vendorCode") {
      temp_Vendor_ref_data["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          temp_Vendor_ref_data["vendorCode"] = vendor.code;
          temp_Vendor_ref_data["vendorName"] = vendor.description;
        }
      });
      if (temp_Vendor_ref_data.fabricStyleColorVendorReferences != null) {
        temp_Vendor_ref_data.fabricStyleColorVendorReferences.map((line) => {
          line.vendorCode = e.target.value;
        });
      }
    }
    this.setState({
      skuMiscCostData: temp_Vendor_ref_data,
    });
  };
  readVendorCodeBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorResponse,
      this.errorCallBack,
    );
  }
  readByVendorResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorCodePageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  displayAutoCompleteVendorCodeSkuCostPopupList = (
    showAutoCompleteVendorCodeList,
  ) => {
    this.setState({
      showAutoCompleteVendorCodeList: showAutoCompleteVendorCodeList,
    });
  };
  vendorSkuCostPopupEnterKeyEventHandler = (e) => {
    let searchCriteria = this.state.skuMiscCostData;
    searchCriteria[e.target.name] = e.target.value;
    searchCriteria["vendorCode"] = e.target.value;
    let vendor_List = this.state.vendor_List;
    vendor_List.map((vendor) => {
      if (vendor.code == e.target.value) {
        searchCriteria["vendorCode"] = vendor.code;
        searchCriteria["vendorName"] = vendor.description;
      }
    });
    this.setState({ vendorCodePageListForAutoCompleteList: new Array() });
  };
  onReasonCodeChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;
    let temp_fabricStyledata = this.state.skuMiscCostData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;
    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let temp_fabricStyledata = this.state.skuMiscCostData;
      temp_fabricStyledata.code = "";
      temp_fabricStyledata.description = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        skuMiscCostData: temp_fabricStyledata,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonCodeBySearchString(code);
    }
    if (e.target.name == "code") {
      temp_fabricStyledata["code"] = e.target.value;
      let code_List = this.state.miscReasons;
      code_List.map((code) => {
        if (code.code == e.target.value) {
          temp_fabricStyledata["code"] = code.code;
          temp_fabricStyledata["description"] = code.description;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }
    this.setState({ skuMiscCostData: temp_fabricStyledata });
  };
  readReasonCodeBySearchString(searchString) {
    let miscReasons = this.state.miscReasons;
    let simpleAutoCompleteList = new Array();
    if (miscReasons.length > 0 && miscReasons != null) {
      miscReasons.map((miscReason) => {
        let simpleItemBean = {
          code: miscReason.code,
          description: miscReason.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteReasonCodeLists) =>
        simpleAutoCompleteReasonCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.skuMiscCostData;
    let code = e.target.value;
    temp_fabricStyledata["code"] = e.target.value;
    let code_List = this.state.miscReasons;
    let codeBean = null;
    code_List.map((code) => {
      if (code.code == e.target.value) {
        codeBean = code;
      }
    });
    if (!isEmpty(codeBean)) {
      let temp_fabricStyledata = this.state.skuMiscCostData;
      temp_fabricStyledata.code = codeBean.code;
      temp_fabricStyledata.description = codeBean.description;
      this.setState({
        skuMiscCostData: temp_fabricStyledata,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteReasonList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteReasonList });
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack,
    );
  }

  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  displayAutoCompleteSkuCostPopupVendorList = (showAutoCompleteVendorList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteVendorList });
  };
  onVendorCodeSkuCostPopupChange = (e) => {
    let vendorCode = e.target.value;
    let temp_Vendor_ref_data = this.state.skuVendorCostData;
    let skuCostData = this.state.selectedSkuLine.skuCostBean;
    temp_Vendor_ref_data[e.target.name] = e.target.value;
    let showAutoCompleteVendorList = this.state.showAutoCompleteVendorList;
    this.state.showAutoCompleteVendorList = true;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteVendorList = this.state.showAutoCompleteVendorList;
      let searchCriteria = this.state.skuVendorCostData;
      searchCriteria.vendorCode = "";
      searchCriteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteVendorList: showAutoCompleteVendorList,
        skuVendorCostData: searchCriteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteVendorList === true &&
      vendorCode !== ""
    ) {
      this.state.showAutoCompleteVendorList = true;
      this.readVendorBySearchString(e.target.value);
    }
    if (e.target.name == "vendorCode") {
      temp_Vendor_ref_data["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          temp_Vendor_ref_data["vendorCode"] = vendor.code;
          temp_Vendor_ref_data["vendorName"] = vendor.description;
        }
        temp_Vendor_ref_data["uomCode"] = skuCostData.uomCode;
        temp_Vendor_ref_data["currencyCode"] = skuCostData.currencyCode;
        temp_Vendor_ref_data["effectiveDate"] = skuCostData.effectiveDate;
      });
    }
    this.setState({
      skuVendorCostData: temp_Vendor_ref_data,
    });
  };

  vendorCodeSkuCostPopupEnterKeyEventHandler = (e) => {
    let skuCostData = this.state.selectedSkuLine.skuCostBean;
    skuCostData.cost = this.state.selectedSkuLine.standardCost;
    skuCostData.description = this.state.fabricStyleData.description;
    let tempSkuVendorCostData = this.state.skuVendorCostData;
    tempSkuVendorCostData[e.target.name] = e.target.value;
    if (e.target.name == "vendorCode") {
      tempSkuVendorCostData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          tempSkuVendorCostData["vendorCode"] = vendor.code;
          tempSkuVendorCostData["vendorName"] = vendor.description;
        }
      });
      tempSkuVendorCostData["uomCode"] = skuCostData.uomCode;
      tempSkuVendorCostData["currencyCode"] = skuCostData.currencyCode;
      tempSkuVendorCostData["effectiveDate"] = skuCostData.effectiveDate;
    }
    this.setState({
      skuVendorCostData: tempSkuVendorCostData,
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  onReasonMiscCostDetailChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;
    let temp_fabricStyledata = this.state.fabricStyleMiscCostLineData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;
    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let temp_fabricStyledata = this.state.fabricStyleMiscCostLineData;
      temp_fabricStyledata.code = "";
      temp_fabricStyledata.description = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleMiscCostLineData: temp_fabricStyledata,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonCodeBySearchString(code);
    }
    if (e.target.name == "code") {
      temp_fabricStyledata["code"] = e.target.value;
      let code_List = this.state.miscReasons;
      code_List.map((code) => {
        if (code.code == e.target.value) {
          temp_fabricStyledata["code"] = code.code;
          temp_fabricStyledata["description"] = code.description;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }
    this.setState({ fabricStyleMiscCostLineData: temp_fabricStyledata });
  };
  reasonMiscCostDetailEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.fabricStyleMiscCostLineData;
    let code = e.target.value;
    temp_fabricStyledata["code"] = e.target.value;
    let code_List = this.state.miscReasons;
    let codeBean = null;
    code_List.map((code) => {
      if (code.code == e.target.value) {
        codeBean = code;
      }
    });
    if (!isEmpty(codeBean)) {
      let temp_fabricStyledata = this.state.fabricStyleMiscCostLineData;
      temp_fabricStyledata.code = codeBean.code;
      temp_fabricStyledata.description = codeBean.description;
      this.setState({
        fabricStyleMiscCostLineData: temp_fabricStyledata,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonMiscCostDetailList = (
    showAutoCompleteReasonList,
  ) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteReasonList });
  };
  onVendorCodeMiscCostChange = (e) => {
    let vendorCode = e.target.value;
    let tempVendorData = this.state.fabricStyleMiscCostLineData;

    tempVendorData[e.target.name] = e.target.value;
    let showAutoCompleteVendorList = this.state.showAutoCompleteVendorList;
    this.state.showAutoCompleteVendorList = true;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteVendorList = this.state.showAutoCompleteVendorList;
      let searchCriteria = this.state.fabricStyleMiscCostLineData;
      searchCriteria.vendorCode = "";
      searchCriteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteVendorList: showAutoCompleteVendorList,
        fabricStyleMiscCostLineData: searchCriteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteVendorList === true &&
      vendorCode !== ""
    ) {
      this.state.showAutoCompleteVendorList = true;
      this.readVendorBySearchString(e.target.value);
    }
    if (e.target.name == "vendorCode") {
      tempVendorData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          tempVendorData["vendorCode"] = vendor.code;
          tempVendorData["vendorName"] = vendor.description;
        }
      });
    }
    this.setState({
      fabricStyleMiscCostLineData: tempVendorData,
    });
  };
  displayAutoCompleteVendorMiscCostList = (showAutoCompleteVendorList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteVendorList });
  };
  vendorCodeMiscCostEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    let tempVendorData = this.state.fabricStyleMiscCostLineData;
    tempVendorData[e.target.name] = e.target.value;
    if (e.target.name == "vendorCode") {
      tempVendorData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          tempVendorData["vendorCode"] = vendor.code;
          tempVendorData["vendorName"] = vendor.description;
        }
      });
    }
    this.setState({
      fabricStyleMiscCostLineData: tempVendorData,
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCurrencySkuCostList = (
    showAutoCompleteCurrencyCodeList,
  ) => {
    this.setState({
      showAutoCompleteCurrencyCodeList: showAutoCompleteCurrencyCodeList,
    });
  };
  onCurrencyCodeSkuCostChange = (e) => {
    let temp_skuVendorCostData = this.state.skuVendorCostData;
    temp_skuVendorCostData[e.target.name] = e.target.value;
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let temp_skuVendorCostData = this.state.skuVendorCostData;
      temp_skuVendorCostData.currencyCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        skuVendorCostData: temp_skuVendorCostData,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeSkuCostBySearchString(currencyCode);
    }
    if (e.target.name == "currencyCode") {
      temp_skuVendorCostData["currencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((currencyCode) => {
        if (currencyCode.code == e.target.value) {
          temp_skuVendorCostData["currencyCode"] = currencyCode.code;
          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ skuVendorCostData: temp_skuVendorCostData });
  };
  readCurrencyCodeSkuCostBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currencyCodeDatas) => {
        let simpleItemBean = {
          code: currencyCodeDatas.code,
          description: currencyCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      currencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  currencyCodeSkuCostEnterKeyEvent = (e) => {
    let temp_skuVendorCostData = this.state.skuVendorCostData;
    let currencyCode = e.target.value;
    temp_skuVendorCostData["currencyCode"] = e.target.value;
    let currencyCode_List = this.state.currencies;
    let currencyCodeBean = null;
    currencyCode_List.map((currencyCode) => {
      if (currencyCode.code == e.target.value) {
        currencyCodeBean = currencyCode;
      }
    });
    if (!isEmpty(currencyCodeBean)) {
      let temp_skuVendorCostData = this.state.skuVendorCostData;
      temp_skuVendorCostData.currencyCode = currencyCodeBean.code;
      this.setState({
        skuVendorCostData: temp_skuVendorCostData,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onUomSkuCostChange = (e) => {
    let uomCode = e.target.value;
    this.state.showAutoCompleteUOMCodeList = true;
    let temp_fabricStyledata = this.state.skuVendorCostData;
    let showAutoCompleteList = this.state.showAutoCompleteUOMCodeList;
    if (isEmpty(uomCode)) {
      this.state.showAutoCompleteUOMCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUOMCodeList;
      let temp_fabricStyledata = this.state.skuVendorCostData;
      temp_fabricStyledata.uomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteUOMCodeList: showAutoCompleteList,
        skuVendorCostData: temp_fabricStyledata,
        uomCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && uomCode !== "") {
      this.readUomSkuCostBySearchString(uomCode);
    }
    if (e.target.name == "uomCode") {
      temp_fabricStyledata["uomCode"] = e.target.value;
      let uomCode_List = this.state.uoms;
      uomCode_List.map((uomCode) => {
        if (uomCode.code == e.target.value) {
          temp_fabricStyledata["uomCode"] = uomCode.code;
          this.state.showAutoCompleteUOMCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteUOMCodeList;
          this.setState({ showAutoCompleteUOMCodeList: showAutoCompleteList });
        }
      });
    }
    this.setState({ skuVendorCostData: temp_fabricStyledata });
  };
  readUomSkuCostBySearchString(searchString) {
    let uomCodeData = this.state.uoms;
    let simpleAutoCompleteList = new Array();
    if (uomCodeData.length > 0 && uomCodeData != null) {
      uomCodeData.map((uomCodeDatas) => {
        let simpleItemBean = {
          code: uomCodeDatas.code,
          description: uomCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteUomCodeLists) =>
        simpleAutoCompleteUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ uomCodePageListForAutoCompleteList: filteredSuggestions });
  }
  uomCodeSkuCostEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.skuVendorCostData;
    let uomCode = e.target.value;
    temp_fabricStyledata["uomCode"] = e.target.value;
    let uomCode_List = this.state.uoms;
    let UomCodeBean = null;
    uomCode_List.map((UomCode) => {
      if (UomCode.code == e.target.value) {
        UomCodeBean = UomCode;
      }
    });
    if (!isEmpty(UomCodeBean)) {
      let temp_fabricStyledata = this.state.skuVendorCostData;
      temp_fabricStyledata.uomCode = UomCodeBean.code;
      this.setState({
        skuVendorCostData: temp_fabricStyledata,
        uomCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUomCodeSkuCostList = (showAutoCompleteUomCodeList) => {
    this.setState({ showAutoCompleteUomCodeList: showAutoCompleteUomCodeList });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let tempSkuCustomerPriceData = this.state.customerSkuPriceData;
    tempSkuCustomerPriceData[e.target.name] = e.target.value;
    tempSkuCustomerPriceData["customerCode"] = e.target.value;
    let customer_List = this.state.customer_list;
    let customerBean = null;
    customer_List.map((customer) => {
      if (customer.code == e.target.value) {
        customerBean = customer;
      }
    });
    if (!isEmpty(customerBean)) {
      let tempSkuCustomerPriceData = this.state.customerSkuPriceData;
      tempSkuCustomerPriceData.customerCode = customerBean.code;
      tempSkuCustomerPriceData.customerName = customerBean.description;
      this.readCustomerByCustomerCode(customerBean.code);
    }
    this.setState({
      customerSkuPriceData: tempSkuCustomerPriceData,
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteCustomerList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteCustomerList,
    });
  };
  onCustomerChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempSkuCustomerPriceData = this.state.customerSkuPriceData;
    tempSkuCustomerPriceData[e.target.name] = e.target.value;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let tempSkuCustomerPriceData = this.state.customerSkuPriceData;
      tempSkuCustomerPriceData.customerCode = "";
      tempSkuCustomerPriceData.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        customerSkuPriceData: tempSkuCustomerPriceData,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    if (e.target.name == "customerCode") {
      let customer_list = this.state.customer_list;
      customer_list.map((customer) => {
        if (customer.code == e.target.value) {
          tempSkuCustomerPriceData["customerCode"] = customer.code;
          tempSkuCustomerPriceData["customerName"] = customer.description;
          this.state.showAutoCompleteCustomerList = false;
          this.readCustomerByCustomerCode(customer.code);
          let showAutoCompleteCustomerList =
            this.state.showAutoCompleteCustomerList;
          this.setState({
            showAutoCompleteCustomerList: showAutoCompleteCustomerList,
          });
        }
      });
    }
    this.setState({ customerSkuPriceData: tempSkuCustomerPriceData });
  };
  loadShipTo = () => {
    let custShip = this.state.customer_shipTo;
    let customerShipToLookupHandler = new GenericAttributeLookupHandler(
      this.state.customer_shipTo,
      "CustomerShipTo",
    );
    this.setState({ customerShipToLookupHandler: customerShipToLookupHandler });
  };
  displayAutoCompleteShipToList = (showAutoCompleteShipToList) => {
    this.setState({ showAutoCompleteShipToList: showAutoCompleteShipToList });
  };
  onShipToChange = (e) => {
    let customerShipToCode = e.target.value;
    let temp_fabricStyledata = this.state.customerSkuPriceData;
    let showAutoCompleteShipToList = true;
    if (isEmpty(customerShipToCode)) {
      let showAutoCompleteShipToList = false;
      let temp_fabricStyledata = this.state.customerSkuPriceData;
      temp_fabricStyledata.customerShipToCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteShipToList: showAutoCompleteShipToList,
        customerSkuPriceData: temp_fabricStyledata,
        shipToPageListForAutoCompleteList: suggestion,
      });
    } else if (
      showAutoCompleteShipToList === true &&
      customerShipToCode !== ""
    ) {
      this.readShipToBySearchString(customerShipToCode);
    }
    if (e.target.name == "customerShipToCode") {
      temp_fabricStyledata["customerShipToCode"] = e.target.value;
      let customerShipToCode_List = this.state.customer_shipTo;
      customerShipToCode_List.map((customerShipToCode) => {
        if (customerShipToCode.code == e.target.value) {
          temp_fabricStyledata["customerShipToCode"] = customerShipToCode.code;
          let showAutoCompleteShipToList = false;
          this.setState({
            showAutoCompleteShipToList: showAutoCompleteShipToList,
          });
        }
      });
    }
    this.setState({ customerSkuPriceData: temp_fabricStyledata });
  };
  readShipToBySearchString(searchString) {
    let customerShipToCode = this.state.customer_shipTo;
    let simpleAutoCompleteList = new Array();
    if (customerShipToCode.length > 0 && customerShipToCode != null) {
      customerShipToCode.map((customerShipToCodes) => {
        let simpleItemBean = {
          code: customerShipToCodes.code,
          description: customerShipToCodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecustomerShipToCodeLists) =>
        simpleAutoCompletecustomerShipToCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ shipToPageListForAutoCompleteList: filteredSuggestions });
  }
  shipToEnterKeyEventHandler = (e) => {
    let temp_fabricStyledata = this.state.customerSkuPriceData;
    let customerShipToCode = e.target.value;
    temp_fabricStyledata["customerShipToCode"] = e.target.value;
    let customerShipToCode_List = this.state.customer_shipTo;
    let customerShipToCodeBean = null;
    customerShipToCode_List.map((customerShipToCode) => {
      if (customerShipToCode.code == e.target.value) {
        customerShipToCodeBean = customerShipToCode;
      }
    });
    if (!isEmpty(customerShipToCodeBean)) {
      let temp_fabricStyledata = this.state.customerSkuPriceData;
      temp_fabricStyledata.customerShipToCode = customerShipToCodeBean.code;
      this.setState({
        customerSkuPriceData: temp_fabricStyledata,
        shipToPageListForAutoCompleteList: new Array(),
      });
    }
  };
  openSkuEntryPopup = (rowData) => {
    this.setState({
      selectedSkuLine: rowData,
      isShowSkuEntryPopup: true,
    });
  };
  closeSkuEntryPopup = () => {
    this.setState({ isShowSkuEntryPopup: false });
  };
  setTargetSku = (rowData) => {
    let eComSkuData = new EcomShopifySkuLineFabricStyleBean();
    eComSkuData.companyCode = this.companyCode;
    eComSkuData.code = rowData.fabricStyleCode;
    eComSkuData.description = rowData.fabricStyleCode;
    eComSkuData.colorCode = rowData.fabricStyleColorCode;
    eComSkuData.skuNumber = rowData.skuNumber;
    eComSkuData.variantSKU = rowData.skuNumber;
    eComSkuData.option1Name = "Color";
    eComSkuData.option1Value = rowData.fabricStyleColorCode;
    let skuData = new EcomShopifySkuLineFabricStyleBean();
    if (rowData.shopifySkuLines) {
      rowData.shopifySkuLines.map((list) => {
        if (rowData.fabricStyleColorCode === list.colorCode) {
          skuData = list;
        }
      });
      eComSkuData.variantPrice = skuData.variantPrice;
      eComSkuData.variantGrams = skuData.variantGrams;
      eComSkuData.variantBarcode = skuData.variantBarcode;
      eComSkuData.webSalesFlag = skuData.webSalesFlag;
      eComSkuData.imageAltText = skuData.imageAltText;
      eComSkuData.webSiteCode = skuData.webSiteCode;
    }
    this.setState({
      eComSkuData: eComSkuData,
    });
  };
  openTargetEntryPopup = (rowData) => {
    this.setTargetSku(rowData);
    this.setState({
      isShowTargetSiteEntryPopup: true,
    });
  };
  closeTargetEntryPopup = () => {
    this.setState({ isShowTargetSiteEntryPopup: false });
  };
  onSkuEntryChange = (e) => {
    let temp_criteria = this.state.selectedSkuLine;
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ selectedSkuLine: temp_criteria });
  };
  addorUpdateSkuEntry = (line) => {
    this.setState({
      selectedSkuLine: line,
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isOpenUomPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isOpenImagePopup: isShowPopup,
      isOpenColorPopup: isShowPopup,
      isOpenOnHandDetailPopup: isShowPopup,
      isOpenStatisticsPopup: isShowPopup,

      isShowMultipleColorPopup: isShowPopup,
      isShowSkuPopup: isShowPopup,
      isVendorReferencePopup: isShowPopup,
      isOpenSkuCostPopup: isShowPopup,
      isShowTargetWebPopup: isShowPopup,
      isOpenItemImagePopup: isShowPopup,
      isDisableUomFields: false,
      isShowColorStatisticsPopup: isShowPopup,
    });
    this.hideAlertCallBack();
    this.resetClrStatistics();
  };

  closeAlertModalCallBackLvl1 = (isShowPopup) => {
    this.setState({
      isShowAlert: isShowPopup,
      isShowBodyPopup: isShowPopup,
      isShowEcomColorPopup: isShowPopup,
      isShowSkuEntryPopup: isShowPopup,
    });
  };
  closeAlertModalCallBackLvl2 = (isShowPopup) => {
    this.setState({
      isShowAlert: isShowPopup,
      isShowTargetSiteEntryPopup: isShowPopup,
    });
  };
  closeAlertModalCallBackLvl3 = (isShowPopup) => {
    this.setState({
      isShowAlertLvl3: isShowPopup,
      isOpenUomPopup: isShowPopup,
      // isShowAlert: isShowPopup,
      isShowStatReceivedQtyPopup: isShowPopup,
      isShowStatShippedQtyPopup: isShowPopup,
      isShowLotReceivedQtyPopup: isShowPopup,
      isShowLotShippedQtyPopup: isShowPopup,
    });
  };

  /***** uom popup - weightuom lookup */

  onServiceWeightUomChange = (e) => {
    let weightUomCode = e.target.value;
    this.state.showAutoCompleteServiceWeightUomList = true;
    let temp_uomData = this.state.uomData;
    let showAutoCompleteList = this.state.showAutoCompleteServiceWeightUomList;
    if (isEmpty(weightUomCode)) {
      this.state.showAutoCompleteServiceWeightUomList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteServiceWeightUomList;
      let uomData = this.state.uomData;
      uomData.weightUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteServiceWeightUomList: showAutoCompleteList,
        uomData: uomData,
        serviceWeightUomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && weightUomCode !== "") {
      this.readServiceWeightUomCodeBySearchString(weightUomCode);
    }
    if (e.target.name == "weightUomCode") {
      temp_uomData["weightUomCode"] = e.target.value;
      let weightUomList = this.state.weightUOMs;
      weightUomList.map((uom) => {
        if (uom.code == e.target.value) {
          temp_uomData["weightUomCode"] = uom.code;
          this.state.showAutoCompleteServiceWeightUomList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteServiceWeightUomList;
          this.setState({
            showAutoCompleteServiceWeightUomList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ uomData: temp_uomData });
  };
  readServiceWeightUomCodeBySearchString(searchString) {
    let weightUomCodeList = this.state.weightUOMs;
    let simpleAutoCompleteList = new Array();
    if (weightUomCodeList.length > 0 && weightUomCodeList != null) {
      weightUomCodeList.map((weightUomCodes) => {
        let simpleItemBean = {
          code: weightUomCodes.code,
          description: weightUomCodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteweightUomCodeLists) =>
        simpleAutoCompleteweightUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      serviceWeightUomPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  serviceWeightUomEnterKeyEventHandler = (e) => {
    let temp_uomData = this.state.uomData;
    let weightUomCode = e.target.value;
    temp_uomData["weightUomCode"] = e.target.value;
    let weightUomList = this.state.weightUOMs;
    let weightUomCodeBean = null;
    weightUomList.map((uom) => {
      if (uom.code == e.target.value) {
        weightUomCodeBean = uom;
      }
    });
    if (!isEmpty(weightUomCodeBean)) {
      let temp_uomData = this.state.uomData;
      temp_uomData.weightUomCode = weightUomCodeBean.code;
      this.setState({
        uomData: temp_uomData,
        serviceWeightUomPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteServiceWeightUomList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteServiceWeightUomList: showAutoCompleteList,
    });
  };

  /****** dimension[length] uom lookup */

  onServiceDimensionUomChange = (e) => {
    let dimensionUomCode = e.target.value;
    this.state.showAutoCompleteServiceDimensionUomList = true;
    let temp_uomData = this.state.uomData;
    let showAutoCompleteList =
      this.state.showAutoCompleteServiceDimensionUomList;
    if (isEmpty(dimensionUomCode)) {
      this.state.showAutoCompleteServiceDimensionUomList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteServiceDimensionUomList;
      let uomData = this.state.uomData;
      uomData.dimensionUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteServiceDimensionUomList: showAutoCompleteList,
        uomData: uomData,
        serviceDimensionUomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && dimensionUomCode !== "") {
      this.readServiceDimensionUomCodeBySearchString(dimensionUomCode);
    }
    if (e.target.name == "dimensionUomCode") {
      temp_uomData["dimensionUomCode"] = e.target.value;
      let uomList = this.state.lengthUOMs;
      uomList.map((uom) => {
        if (uom.code == e.target.value) {
          temp_uomData["dimensionUomCode"] = uom.code;
          this.state.showAutoCompleteServiceDimensionUomList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteServiceDimensionUomList;
          this.setState({
            showAutoCompleteServiceDimensionUomList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ uomData: temp_uomData });
  };
  readServiceDimensionUomCodeBySearchString(searchString) {
    let dimensionUomCodeList = this.state.lengthUOMs;
    let simpleAutoCompleteList = new Array();
    if (dimensionUomCodeList.length > 0 && dimensionUomCodeList != null) {
      dimensionUomCodeList.map((uomCodes) => {
        let simpleItemBean = {
          code: uomCodes.code,
          description: uomCodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteweightUomCodeLists) =>
        simpleAutoCompleteweightUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      serviceDimensionUomPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  serviceDimensionUomEnterKeyEventHandler = (e) => {
    let temp_uomData = this.state.uomData;
    let dimensionUomCode = e.target.value;
    temp_uomData["dimensionUomCode"] = e.target.value;
    let weightUomList = this.state.lengthUOMs;
    let weightUomCodeBean = null;
    weightUomList.map((uom) => {
      if (uom.code == e.target.value) {
        weightUomCodeBean = uom;
      }
    });
    if (!isEmpty(weightUomCodeBean)) {
      let temp_uomData = this.state.uomData;
      temp_uomData.dimensionUomCode = weightUomCodeBean.code;
      this.setState({
        uomData: temp_uomData,
        serviceDimensionUomPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteServiceDimensionUomList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteServiceDimensionUomList: showAutoCompleteList,
    });
  };

  onPalletDimensionUomChange = (e) => {
    let palletDimensionUomCode = e.target.value;
    this.state.showAutoCompletePalletDimensionUomList = true;
    let temp_uomData = this.state.uomData;
    let showAutoCompleteList =
      this.state.showAutoCompletePalletDimensionUomList;
    if (isEmpty(palletDimensionUomCode)) {
      this.state.showAutoCompletePalletDimensionUomList = false;
      let showAutoCompleteList =
        this.state.showAutoCompletePalletDimensionUomList;
      let uomData = this.state.uomData;
      uomData.palletDimensionUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePalletDimensionUomList: showAutoCompleteList,
        uomData: uomData,
        palletDimensionUomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && palletDimensionUomCode !== "") {
      this.readPalletDimensionUomCodeBySearchString(palletDimensionUomCode);
    }
    if (e.target.name == "palletDimensionUomCode") {
      temp_uomData["palletDimensionUomCode"] = e.target.value;
      let weightUomList = this.state.lengthUOMs;
      weightUomList.map((uom) => {
        if (uom.code == e.target.value) {
          temp_uomData["palletDimensionUomCode"] = uom.code;
          this.state.showAutoCompletePalletDimensionUomList = false;
          let showAutoCompleteList =
            this.state.showAutoCompletePalletDimensionUomList;
          this.setState({
            showAutoCompletePalletDimensionUomList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ uomData: temp_uomData });
  };
  readPalletDimensionUomCodeBySearchString(searchString) {
    let dimensionUomCodeList = this.state.lengthUOMs;
    let simpleAutoCompleteList = new Array();
    if (dimensionUomCodeList.length > 0 && dimensionUomCodeList != null) {
      dimensionUomCodeList.map((uomCodes) => {
        let simpleItemBean = {
          code: uomCodes.code,
          description: uomCodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteweightUomCodeLists) =>
        simpleAutoCompleteweightUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      palletDimensionUomPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  palletDimensionUomEnterKeyEventHandler = (e) => {
    let temp_uomData = this.state.uomData;
    let palletDimensionUomCode = e.target.value;
    temp_uomData["palletDimensionUomCode"] = e.target.value;
    let weightUomList = this.state.lengthUOMs;
    let weightUomCodeBean = null;
    weightUomList.map((uom) => {
      if (uom.code == e.target.value) {
        weightUomCodeBean = uom;
      }
    });
    if (!isEmpty(weightUomCodeBean)) {
      let temp_uomData = this.state.uomData;
      temp_uomData.palletDimensionUomCode = weightUomCodeBean.code;
      this.setState({
        uomData: temp_uomData,
        palletDimensionUomPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompletePalletDimensionUomList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompletePalletDimensionUomList: showAutoCompleteList,
    });
  };
  serviceUomOnChange = (e) => {
    let temp_uomdata = this.state.uomData;
    temp_uomdata[e.target.name] = e.target.value;
    if (e.target.name == "stackableFlag") {
      temp_uomdata["stackableFlag"] = e.target.value;
      if (e.target.value == true) {
        this.state.disableStackableQty = false;
      } else {
        this.state.disableStackableQty = true;
      }
    }
    this.setState({ uomData: temp_uomdata });
  };
  getShippedQuantityLineDetails = (e, val, rowData) => {
    let receivedLineDetails = { ...rowData };
    let criteria = new FabricStylePurchaseReceiptHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = receivedLineDetails.fabricStyleCode;
    criteria.colorCode = receivedLineDetails.fabricStyleColorCode;
    criteria.purchaseOrderReceiptNumber =
      receivedLineDetails.purchaseOrderReceiptNumber;

    //  criteria.excludeNonWarehouseInventory = true;
    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      ReportService.getFabricStyleOutStatistics(
        criteria,
        this.readandShippedQuantityResponse,
        this.readandSetReceivedError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandShippedQuantityResponse = (response) => {
    let shippedDataList = [];
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.infos)) {
        shippedDataList = response.data.inquiryResult.infos;
      }

      this.setState({
        shippedDataList: shippedDataList,
        isInandOutStatisticsPopup: true,
      });
    } else {
      let errMsg = "No ReceivedQuantity in Rolls";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getReceivedLineDetails = (e, val, rowData) => {
    let receivedLineDetails = { ...rowData };

    let rowSubHeaderData = this.state.rowSubHeaderData;
    let criteria = new FabricStylePurchaseReceiptHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = receivedLineDetails.fabricStyleCode;
    criteria.fabricStyleColorCode = receivedLineDetails.fabricStyleColorCode;
    criteria.purchaseOrderReceiptNumber =
      receivedLineDetails.purchaseOrderReceiptNumber;
    rowSubHeaderData.lab_1 = "PO#";
    rowSubHeaderData.lab_2 = "PR#";
    rowSubHeaderData.lab_3 = "Received#";
    rowSubHeaderData.value_1 = receivedLineDetails.purchaseOrderNumber;
    rowSubHeaderData.value_2 = receivedLineDetails.purchaseOrderReceiptNumber;
    rowSubHeaderData.value_3 = receivedLineDetails.receivedQuantity;

    this.setState({
      rowSubHeaderData: rowSubHeaderData,
    });
    // this.state.rowSubHeaderData =  { ...rowData };
    //  criteria.excludeNonWarehouseInventory = true;
    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      ReportService.getFabricStyleOutStatisticsInvoiceDetails(
        criteria,
        this.readandSetReceivedResponse,
        this.readandSetReceivedError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandSetReceivedResponse = (response) => {
    let rowSubHeaderData = this.state.rowSubHeaderData;
    let receivedDataList = [];
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.infos)) {
        receivedDataList = response.data.inquiryResult.infos;
        this.setState({
          isShowInputTextbox: true,
        });
      }
      let receivedDataListLine = [];
      receivedDataListLine = response.data.inquiryResult;

      rowSubHeaderData.lab_4 = "OnHand#";

      rowSubHeaderData.value_4 = receivedDataListLine.totalOnHandQuantity;
      rowSubHeaderData.lab_5 = "TotalShiped#";

      rowSubHeaderData.value_5 = receivedDataListLine.totalShippedQuantity;

      this.setState({
        receivedDataList: receivedDataList,
      });
    } else {
      let errMsg = "No ReceivedQuantity in Rolls";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandSetReceivedError = (error) => {
    ShowError("Error : " + error);
  };

  getHeaderView() {
    return (
      <FabricStyleEntryForm
        {...this.state}
        hideAlertCallBackLvl3={this.hideAlertCallBackLvl3}
        closeAlertModalCallBackLvl3={this.closeAlertModalCallBackLvl3}
        serviceUomOnChange={this.serviceUomOnChange}
        imagePart={this.imagePart}
        fabricStyleRef={this.fabricStyleRef}
        getImages={this.getImages}
        setFocus={this.setFocus}
        closeEntryForm={this.closeEntryForm}
        saveFabricStyle={this.savefabricStyle}
        showErrorMessage={this.showErrorMessage}
        showInfoMessage={this.showInfoMessage}
        onWidthUOMCodeChange={this.onWidthUOMCodeChange}
        readWidthUOM={this.readWidthUOM}
        readWidthUomCodeBySearchString={this.readWidthUomCodeBySearchString}
        widthUomEnterKeyEvent={this.widthUomEnterKeyEvent}
        onUOMCodeChange={this.onUOMCodeChange}
        uomEnterKeyEvent={this.uomEnterKeyEvent}
        readUomCodeBySearchString={this.readUomCodeBySearchString}
        displayAutoCompleteUomList={this.displayAutoCompleteUomList}
        displayAutoCompleteWidthUomList={this.displayAutoCompleteWidthUomList}
        selectColor={this.selectColor}
        unSelectColor={this.unSelectColor}
        addOrUpdateMultipleColor={this.addOrUpdateMultipleColor}
        uomPopupEnterKeyEvent={this.uomPopupEnterKeyEvent}
        onPopupUomCodeChange={this.onPopupUomCodeChange}
        displayAutoCompleteUomPopupList={this.displayAutoCompleteUomPopupList}
        addorUpdateBuyingUom={this.addorUpdateBuyingUom}
        addorUpdateSellingUom={this.addorUpdateSellingUom}
        addorUpdateUom={this.addorUpdateUom}
        closeUomPopup={this.closeUomPopup}
        openUomPopup={this.openUomPopup}
        openNewBuyingUomPopup={this.openNewBuyingUomPopup}
        openNewSellingUomPopup={this.openNewSellingUomPopup}
        editBuyingUom={this.editBuyingUom}
        editSellingUom={this.editSellingUom}
        deleteBuyingUom={this.deleteBuyingUom}
        deleteSellingUom={this.deleteSellingUom}
        closeAlertModalCallBack={this.closeAlertModalCallBack}
        hideAlertCallBack={this.hideAlertCallBack}
        getFabricStyleImagePath={this.getFabricStyleImagePath}
        getFabricStyleColorImagePath={this.getFabricStyleColorImagePath}
        uploadColorImage={this.uploadColorImage}
        onColorChange={this.onColorChange}
        openNewColorPopup={this.openNewColorPopup}
        editColor={this.editColor}
        addorUpdateColor={this.addorUpdateColor}
        openColorPopup={this.openColorPopup}
        closeColorPopup={this.closeColorPopup}
        addorUpdateImageData={this.addorUpdateImageData}
        openImagePopup={this.openImagePopup}
        closeImagePopup={this.closeImagePopup}
        openOnHandDetailPopup={this.openOnHandDetailPopup}
        closeOnHandDetailPopup={this.closeOnHandDetailPopup}
        getOnHandQty={this.getOnHandQty}
        getOnStatistics={this.getOnStatistics}
        getOnColorStatistics={this.getOnColorStatistics}
        isDisableRemoveColorButton={this.isDisableRemoveColorButton}
        deleteColor={this.deleteColor}
        imageClick={this.imageClick}
        isDisableRemoveUomButton={this.isDisableRemoveUomButton}
        onPopupColorCodeChange={this.onPopupColorCodeChange}
        colorPopupEnterKeyEvent={this.colorPopupEnterKeyEvent}
        displayAutoCompleteColorPopupList={
          this.displayAutoCompleteColorPopupList
        }
        onEntryFormChange={this.onEntryFormChange}
        testOnchange={this.testOnchange}
        onPatternTypeCodeChange={this.onPatternTypeCodeChange}
        patternTypeEnterKeyEvent={this.patternTypeEnterKeyEvent}
        onTypeCodeChange={this.onTypeCodeChange}
        typeEnterKeyEvent={this.typeEnterKeyEvent}
        onMakeTypeCodeChange={this.onMakeTypeCodeChange}
        makeTypeEnterKeyEvent={this.makeTypeEnterKeyEvent}
        onUseCodeChange={this.onUseCodeChange}
        useEnterKeyEvent={this.useEnterKeyEvent}
        onDivisionCodeChange={this.onDivisionCodeChange}
        divisionEnterKeyEvent={this.divisionEnterKeyEvent}
        onStyleItemTypeChange={this.onStyleItemTypeChange}
        styleItemTypeEnterKeyEvent={this.styleItemTypeEnterKeyEvent}
        onStatsChange={this.onStatsChange}
        statsEnterKeyEvent={this.statsEnterKeyEvent}
        onCurrencyCodeChange={this.onCurrencyCodeChange}
        currencyCodeEnterKeyEvent={this.currencyCodeEnterKeyEvent}
        onLocationChange={this.onLocationChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        onWeightUomChange={this.onWeightUomChange}
        weightUomEnterKeyEventHandler={this.weightUomEnterKeyEventHandler}
        onHtsChange={this.onHtsChange}
        htsEnterKeyEventHandler={this.htsEnterKeyEventHandler}
        onSeasonChange={this.onSeasonChange}
        seasonEnterKeyEventHandler={this.seasonEnterKeyEventHandler}
        displayAutoCompleteDivisionList={this.displayAutoCompleteDivisionList}
        displayAutoCompleteStatsList={this.displayAutoCompleteStatsList}
        displayAutoCompleteStyleItemTypeList={
          this.displayAutoCompleteStyleItemTypeList
        }
        displayAutoCompleteCurrencyList={this.displayAutoCompleteCurrencyList}
        displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
        displayAutoCompleteUseList={this.displayAutoCompleteUseList}
        displayAutoCompleteWeightUomList={this.displayAutoCompleteWeightUomList}
        displayAutoCompletePatternTypeList={
          this.displayAutoCompletePatternTypeList
        }
        displayAutoCompleteTypeList={this.displayAutoCompleteTypeList}
        displayAutoCompleteMakeTypeList={this.displayAutoCompleteMakeTypeList}
        displayAutoCompleteSeasonList={this.displayAutoCompleteSeasonList}
        displayAutoCompleteHtsList={this.displayAutoCompleteHtsList}
        closeAlertMultipleColorModalCallBack={
          this.closeAlertMultipleColorModalCallBack
        }
        multipleAdd={this.multipleAdd}
        customerOnChange={this.customerOnChange}
        customerEnterKeyEventHandler={this.customerEnterKeyEventHandler}
        displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}
        openTestImagePopup={this.openTestImagePopup}
        uploadImage={this.uploadImage}
        deleteFabricImage={this.deleteFabricImage}
        setMainUrl={this.setMainUrl}
        setWebUrl={this.setWebUrl}
        setFrontUrl={this.setFrontUrl}
        setBackUrl={this.setBackUrl}
        openItemImage={this.openItemImage}
        setMainImg={this.setMainImg}
        setWebImg={this.setWebImg}
        setFrontImg={this.setFrontImg}
        setBackImg={this.setBackImg}
        setClrFile={this.setClrFile}
        showToast={this.showToast}
        onServiceWeightUomChange={this.onServiceWeightUomChange}
        serviceWeightUomEnterKeyEventHandler={
          this.serviceWeightUomEnterKeyEventHandler
        }
        displayAutoCompleteServiceWeightUomList={
          this.displayAutoCompleteServiceWeightUomList
        }
        onServiceDimensionUomChange={this.onServiceDimensionUomChange}
        serviceDimensionUomEnterKeyEventHandler={
          this.serviceDimensionUomEnterKeyEventHandler
        }
        displayAutoCompleteServiceDimensionUomList={
          this.displayAutoCompleteServiceDimensionUomList
        }
        onPalletDimensionUomChange={this.onPalletDimensionUomChange}
        palletDimensionUomEnterKeyEventHandler={
          this.palletDimensionUomEnterKeyEventHandler
        }
        displayAutoCompletePalletDimensionUomList={
          this.displayAutoCompletePalletDimensionUomList
        }
        userOnChange={this.userOnChange}
        displayAutoCompleteUserList={this.displayAutoCompleteUserList}
        userEnterKeyEventHandler={this.userEnterKeyEventHandler}
        setClrUrl={this.setClrUrl}
        uploadClrImage={this.uploadClrImage}
        deleteClrImage={this.deleteClrImage}
        custPriceOnChange={this.custPriceOnChange}
        hideAlertCallBackColor={this.hideAlertCallBackColor}
        getReceivedLineDetails={this.getReceivedLineDetails}
        viewVendorModule={this.viewVendorModule}
        viewPurchaseModule={this.viewPurchaseModule}
        viewPurchaseReceiptModule={this.viewPurchaseReceiptModule}
        viewCustomerModule={this.viewCustomerModule}
        viewInvoiceModule={this.viewInvoiceModule}
        openSalesHistoryDetailsInq={this.openSalesHistoryDetailsInq}
        onFabricStatusChange={this.onFabricStatusChange}
        fabricStatusEnterKeyEventHandler={this.fabricStatusEnterKeyEventHandler}
        displayAutoCompletefabricStatusList={
          this.displayAutoCompletefabricStatusList
        }
        onColorStatusChange={this.onColorStatusChange}
        fabricColorStatusEnterKeyEventHandler={
          this.fabricColorStatusEnterKeyEventHandler
        }
        displayAutoCompletefabricColorStatusList={
          this.displayAutoCompletefabricColorStatusList
        }
      />
    );
  }
  getSkuView() {
    return (
      <FabricStyleSkuDetailsForm
        {...this.state}
        closeAlertModalCallBack={this.closeAlertModalCallBack}
        addorUpdateSkuPrice={this.addorUpdateSkuPrice}
        applyToAllSkuPrice={this.applyToAllSkuPrice}
        saveFabricStyle={this.savefabricStyle}
        skuDetailHandleHyperLinkClick={this.skuDetailHandleHyperLinkClick}
        closeSkuPricePopup={this.closeSkuPricePopup}
        onItemSkuChange={this.onItemSkuChange}
        onSkuPriceLineChange={this.onSkuPriceLineChange}
        getSkuPriceLineDetails={this.getSkuPriceLineDetails}
        saveCustomerSkuPriceLine={this.saveCustomerSkuPriceLine}
        clearSkuLineValues={this.clearSkuLineValues}
        deleteFabricSkuCustomerLine={this.deleteFabricSkuCustomerLine}
        hideAlertCallBack={this.hideAlertCallBack}
        customerCodeEnterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
        displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        onCustomerChange={this.onCustomerChange}
        onShipToChange={this.onShipToChange}
        shipToEnterKeyEventHandler={this.shipToEnterKeyEventHandler}
        displayAutoCompleteShipToList={this.displayAutoCompleteShipToList}
        closeAlertModalCallBackLvl1={this.closeAlertModalCallBackLvl1}
        closeAlertModalCallBackLvl2={this.closeAlertModalCallBackLvl2}
        onSkuEntryChange={this.onSkuEntryChange}
        addorUpdateSkuEntry={this.addorUpdateSkuEntry}
        openSkuEntryPopup={this.openSkuEntryPopup}
        openTargetEntryPopup={this.openTargetEntryPopup}
        onSkuChange={this.onSkuChange}
        addorUpdateSkuDetails={this.addorUpdateSkuDetails}
        setDateForCustPriceLine={this.setDateForCustPriceLine}
      />
    );
  }
  getItemCostView() {
    return (
      <FabricStyleCostDetailsForm
        {...this.state}
        saveFabricStyle={this.savefabricStyle}
        addorUpdateSkuCost={this.addorUpdateSkuCost}
        addorUpdateVendorReference={this.addorUpdateVendorReference}
        onVendorMapVendorCodeChange={this.onVendorMapVendorCodeChange}
        onItemCostChange={this.onItemCostChange}
        closeAlertModalCallBack={this.closeAlertModalCallBack}
        closeVendorReferncePopup={this.closeVendorReferncePopup}
        generateVendorColorReferenceInfoList={
          this.generateVendorColorReferenceInfoList
        }
        handleVendorReferencePopup={this.handleVendorReferencePopup}
        openExitingVendorReferencePopup={this.openExitingVendorReferencePopup}
        closeSkuCostPopup={this.closeSkuCostPopup}
        hideAlertCallBack={this.hideAlertCallBack}
        vendorHyperLinkClick={this.vendorHyperLinkClick}
        skuHandleHyperLinkClick={this.skuHandleHyperLinkClick}
        onItemCostVendorCodeChange={this.onItemCostVendorCodeChange}
        onSkuCostChange={this.onSkuCostChange}
        onSkuCostLineChange={this.onSkuCostLineChange}
        getLineDetails={this.getLineDetails}
        saveVendorSkuCostLine={this.saveVendorSkuCostLine}
        clearLineValues={this.clearLineValues}
        deleteVendorSkuCostLine={this.deleteVendorSkuCostLine}
        onMiscVendorCodeChange={this.onMiscVendorCodeChange}
        onMiscLineChange={this.onMiscLineChange}
        deleteSkuMiscColorLine={this.deleteSkuMiscColorLine}
        getMiscColorCostLineDetails={this.getMiscColorCostLineDetails}
        saveSkuColorMiscillaneousLine={this.saveSkuColorMiscillaneousLine}
        clearMiscColorLineValues={this.clearMiscColorLineValues}
        onVendorCodeMappingChange={this.onVendorCodeMappingChange}
        vendorCodeMappingEnterKeyEventHandler={
          this.vendorCodeMappingEnterKeyEventHandler
        }
        displayAutoCompleteVendorMappingList={
          this.displayAutoCompleteVendorMappingList
        }
        onVendorSkuCostPopupChange={this.onVendorSkuCostPopupChange}
        vendorSkuCostPopupEnterKeyEventHandler={
          this.vendorSkuCostPopupEnterKeyEventHandler
        }
        displayAutoCompleteVendorCodeSkuCostPopupList={
          this.displayAutoCompleteVendorCodeSkuCostPopupList
        }
        onReasonCodeChange={this.onReasonCodeChange}
        reasonEnterKeyEvent={this.reasonEnterKeyEvent}
        displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
        vendorCodeSkuCostPopupEnterKeyEventHandler={
          this.vendorCodeSkuCostPopupEnterKeyEventHandler
        }
        onVendorCodeSkuCostPopupChange={this.onVendorCodeSkuCostPopupChange}
        displayAutoCompleteSkuCostPopupVendorList={
          this.displayAutoCompleteSkuCostPopupVendorList
        }
        onCurrencyCodeSkuCostChange={this.onCurrencyCodeSkuCostChange}
        currencyCodeSkuCostEnterKeyEvent={this.currencyCodeSkuCostEnterKeyEvent}
        displayAutoCompleteCurrencySkuCostList={
          this.displayAutoCompleteCurrencySkuCostList
        }
        onUomSkuCostChange={this.onUomSkuCostChange}
        uomCodeSkuCostEnterKeyEvent={this.uomCodeSkuCostEnterKeyEvent}
        displayAutoCompleteUomCodeSkuCostList={
          this.displayAutoCompleteUomCodeSkuCostList
        }
        costOnChange={this.costOnChange}
        onLandingCostChange={this.onLandingCostChange}
        skuCostOnChange={this.skuCostOnChange}
        setVendorCostLineData={this.setVendorCostLineData}
      />
    );
  }
  getCompositionView() {
    return (
      <FabricStyleCompositionLineForm
        {...this.state}
        saveFabricStyle={this.savefabricStyle}
        clearCompositionLineValues={this.clearCompositionLineValues}
        openExcitingCompLineForm={this.openExcitingCompLineForm}
        saveCompositionLine={this.saveCompositionLine}
        onFabCompChange={this.onFabCompChange}
        onElementChange={this.onElementChange}
        elementEnterKeyEventHandler={this.elementEnterKeyEventHandler}
        displayAutoCompleteElementList={this.displayAutoCompleteElementList}
        hideAlertCallBack={this.hideAlertCallBack}
        deleteCompositionLine={this.deleteCompositionLine}
      />
    );
  }
  getMiscCostView() {
    return (
      <FabricStyleMiscCostDetailsForm
        {...this.state}
        saveFabricStyle={this.savefabricStyle}
        onVendorCodeChange={this.onVendorCodeChange}
        onMiscCostChange={this.onMiscCostChange}
        saveMiscillaneousLine={this.saveMiscillaneousLine}
        getMiscCostLineDetails={this.getMiscCostLineDetails}
        deleteVendorMiscellaneousLine={this.deleteVendorMiscellaneousLine}
        clearMiscLineValues={this.clearMiscLineValues}
        applyToAllMiscDetail={this.applyToAllMiscDetail}
        hideAlertCallBack={this.hideAlertCallBack}
        onReasonMiscCostDetailChange={this.onReasonMiscCostDetailChange}
        reasonMiscCostDetailEnterKeyEvent={
          this.reasonMiscCostDetailEnterKeyEvent
        }
        displayAutoCompleteReasonMiscCostDetailList={
          this.displayAutoCompleteReasonMiscCostDetailList
        }
        onVendorCodeMiscCostChange={this.onVendorCodeMiscCostChange}
        vendorCodeMiscCostEnterKeyEventHandler={
          this.vendorCodeMiscCostEnterKeyEventHandler
        }
        displayAutoCompleteVendorMiscCostList={
          this.displayAutoCompleteVendorMiscCostList
        }
      />
    );
  }
  getAtsView() {
    return (
      <AllFabricATS
        fabricCode={this.state.fabricStyleData.code}
        fabricName={this.state.fabricStyleData.description}
        isDisabledFields={this.state.isDisabledFields}
      />
    );
  }
  getInventoryView() {
    return (
      <FabricStyleInventoryDetailsForm
        {...this.state}
        fabricStyleData={this.state.fabricStyleData}
        saveFabricStyle={this.savefabricStyle}
      />
    );
  }
  getInventorySummaryView() {
    return (
      <FabricStyleInventorySummaryDetailsForm
        {...this.state}
        fabricStyleData={this.state.fabricStyleData}
        saveFabricStyle={this.savefabricStyle}
      />
    );
  }
  getCustomerSalesView() {
    return (
      <FabricStyleCustomerSalesDetailsForm
        {...this.state}
        fabricStyleData={this.state.fabricStyleData}
        saveFabricStyle={this.savefabricStyle}
        viewInvoiceModule={this.viewInvoiceModule}
      />
    );
  }

  getCustomerSalesAndPurchaseView() {
    return (
      <FabricStyleCustomerSalesAndPurchaseDetailsForm
        {...this.state}
        fabricStyleData={this.state.fabricStyleData}
        saveFabricStyle={this.savefabricStyle}
        viewInvoiceModule={this.viewInvoiceModule}
      />
    );
  }

  getFabricSalesView = () => {
    return (
      <FabricStyleSalesDetailsForm
        {...this.state}
        fabricStyleData={this.state.fabricStyleData}
        saveFabricStyle={this.savefabricStyle}
        viewInvoiceModule={this.viewInvoiceModule}
      />
    );
  };
  getPurchaseDetailsView() {
    return (
      <FabricStylePurchaseDetailsForm
        {...this.state}
        fabricStyleData={this.state.fabricStyleData}
        saveFabricStyle={this.savefabricStyle}
        viewInvoiceModule={this.viewInvoiceModule}
      />
    );
  }
  getFabricDetailView() {
    return (
      <FabricStyleDetailsForm
        {...this.state}
        fabricStyleData={this.state.fabricStyleData}
        saveFabricStyle={this.savefabricStyle}
        generateDetailReport={this.generateDetailReport}
        onFabDetailsChange={this.onFabDetailsChange}
        hideAlertCallBack={this.hideAlertCallBack}
      />
    );
  }
  getEcomDetailsView() {
    return (
      <FabricStyleEcomDetailsForm
        {...this.state}
        fabricStyleData={this.state.fabricStyleData}
        miscReasons={this.state.miscReasons}
        vendor_List={this.state.vendor_List}
        saveFabricStyle={this.savefabricStyle}
        eComShopifyData={this.state.eComShopifyData}
        continueButtonClick={this.continueButtonClick}
        onChange={this.onTargetDetailsChange}
        fabricStyleColorData={this.state.fabricStyleColorData}
        fabricStyleSKUData={this.state.fabricStyleSKUData}
        targetContinueButtonClick={this.targetContinueButtonClick}
        onTargetDetailChange={this.onTargetDetailChange}
        targetDetailButtonClick={this.targetDetailButtonClick}
        clearData={this.clearData}
        temp_eComShopifyData={this.state.temp_eComShopifyData}
        deleteLine={this.deleteLine}
        deleteTopLine={this.deleteTopLine}
        deleteBottomLine={this.deleteBottomLine}
        clearLines={this.clearLines}
        clearTopDescriptionLines={this.clearTopDescriptionLines}
        clearBottomDescriptionLines={this.clearBottomDescriptionLines}
        onBodyDataChange={this.onBodyDataChange}
        onBodyBulletinDataChange={this.onBodyBulletinDataChange}
        onBodyTopDataChange={this.onBodyTopDataChange}
        onBodyBottomDataChange={this.onBodyBottomDataChange}
        addBodyTopDescriptionLines={this.addBodyTopDescriptionLines}
        addBodyBottomDescriptionLines={this.addBodyBottomDescriptionLines}
        addBodyBulletinLines={this.addBodyBulletinLines}
        readBulletLines={this.readBulletLines}
        readTopLines={this.readTopLines}
        readBottomLines={this.readBottomLines}
        convertTextToHtml={this.convertTextToHtml}
        shopifyBodyBulletList={this.state.shopifyBodyBulletList}
        shopifyBodyBottomList={this.state.shopifyBodyBottomList}
        shopifyBodyTopList={this.state.shopifyBodyTopList}
        shopifyBodyData={this.state.shopifyBodyData}
        shopifyBodyBottomDescriptionData={
          this.state.shopifyBodyBottomDescriptionData
        }
        shopifyBodyTopDescriptionData={this.state.shopifyBodyTopDescriptionData}
        shopifyBodyLineData={this.state.shopifyBodyLineData}
        bodyClick={this.bodyClick}
        clearBodyList={this.clearBodyList}
        closeAlertModalCallBack={this.closeAlertModalCallBack}
        colorButtonClick={this.colorButtonClick}
        onSkuChange={this.onSkuChange}
        addorUpdateSkuDetails={this.addorUpdateSkuDetails}
        clearSkuData={this.clearSkuData}
        closeAlertModalCallBackLvl1={this.closeAlertModalCallBackLvl1}
        hideAlertCallBack={this.hideAlertCallBack}
      />
    );
  }
  getLogisticDetailsView() {
    return (
      <FabricStyleLogisticDetailsForm
        {...this.state}
        logisticOnChange={this.logisticOnChange}
        uomOnChange={this.uomOnChange}
        logisticUomEnterKeyEvent={this.logisticUomEnterKeyEvent}
        displayLogisticUomAutoCompleteList={
          this.displayLogisticUomAutoCompleteList
        }
        logisticWeightUomOnChange={this.logisticWeightUomOnChange}
        logisticWeightUomEnterKeyEvent={this.logisticWeightUomEnterKeyEvent}
        displayLogisticWeightUomAutoCompleteList={
          this.displayLogisticWeightUomAutoCompleteList
        }
        logisticCaseUomOnChange={this.logisticCaseUomOnChange}
        logisticCaseUomEnterKeyEvent={this.logisticCaseUomEnterKeyEvent}
        displayLogisticCaseUomAutoCompleteList={
          this.displayLogisticCaseUomAutoCompleteList
        }
        logisticPalletUomOnChange={this.logisticPalletUomOnChange}
        logisticPalletUomEnterKeyEvent={this.logisticPalletUomEnterKeyEvent}
        displayLogisticPalletUomAutoCompleteList={
          this.displayLogisticPalletUomAutoCompleteList
        }
        setDefaultValueForLogestic={this.setDefaultValueForLogestic}
      />
    );
  }

  /********************************** In / Out statistics Node*****************************************/

  inOutStatisticsOnChange = (e) => {
    let criteria = this.state.statisticsCriteria;
    criteria[e.target.name] = e.target.value;
    // if ((e.target.name = "mode")) this.resetStatisticsCriteria();
    this.setState({ statisticsCriteria: criteria });
  };

  statisticsResponse = (response) => {
    let containerDatas = new Array();
    let projectDatas = new Array();
    let lotNumberDatas = new Array();
    let statisticsCriteria = this.state.statisticsCriteria;
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (statisticsCriteria.mode == 0) {
        if (!isEmptyArray(response.data.inquiryResult.containerDatas))
          containerDatas = response.data.inquiryResult.containerDatas;
      } else if (statisticsCriteria.mode == 1) {
        if (!isEmptyArray(response.data.inquiryResult.projectNumberDatas))
          projectDatas = response.data.inquiryResult.projectNumberDatas;
      }
      if (this.state.isStandard) {
        if (!isEmptyArray(response.data.inquiryResult.lotNumberDatas))
          lotNumberDatas = response.data.inquiryResult.lotNumberDatas;
      }
    }

    this.setState({
      containerDatas: containerDatas,
      projectDatas: projectDatas,
      lotNumberDatas: lotNumberDatas,
    });
  };
  statisticExecuteHandler = () => {
    let _criteria = this.state.statisticsCriteria;
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = this.state.fabricStyleData.code;
    if (this.state.is3PL) {
      criteria.mode = _criteria.mode;
      criteria.containerNumber = _criteria.containerNumber;
      criteria.projectNumber = _criteria.projectNumber;
    }
    if (this.state.isStandard) {
      criteria.mode = 2;
      criteria.lotNumber = _criteria.lotNumber;
    }

    ReportService.getFabricStyleInAndOutStatisticsDetails(
      criteria,
      this.statisticsResponse,
      this.errorCallBack,
    );
  };
  containerReceivedQuantityResponse = (response) => {
    let receiptContainerDatas = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.receiptContainerDatas))
        receiptContainerDatas =
          response.data.inquiryResult.receiptContainerDatas;
    }
    this.setState({
      receiptContainerDatas: receiptContainerDatas,
    });
  };
  containerReceivedQtyClick = (type, rowData) => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.containerNumber = rowData.containerNumber;
    criteria.fabricStyleCode = this.state.fabricStyleData.code;
    ReportService.getLogisticOrdersReceiptsRollLinesForContainerNumber(
      criteria,
      this.containerReceivedQuantityResponse,
      this.errorCallBack,
    );

    this.setState({ isShowStatReceivedQtyPopup: true });
  };
  containerShippedQuantityResponse = (response) => {
    let shippedContainerDatas = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.pickedContainerDatas))
        shippedContainerDatas =
          response.data.inquiryResult.pickedContainerDatas;
    }
    this.setState({
      shippedContainerDatas: shippedContainerDatas,
    });
  };

  containerShippedQtyClick = (type, rowData) => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.containerNumber = rowData.containerNumber;
    criteria.fabricStyleCode = this.state.fabricStyleData.code;

    // ReportService.getInvoicesRollLinesForContainerNumber(
    ReportService.getPickTicketRollLinesForContainerNumber(
      criteria,
      this.containerShippedQuantityResponse,
      this.errorCallBack,
    );

    this.setState({ isShowStatShippedQtyPopup: true });
  };
  projectReceivedQuantityResponse = (response) => {
    let receiptProjectNumberDatas = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.receiptProjectNumberDatas))
        receiptProjectNumberDatas =
          response.data.inquiryResult.receiptProjectNumberDatas;
    }
    this.setState({
      receiptProjectNumberDatas: receiptProjectNumberDatas,
    });
  };
  projectReceivedQtyClick = (type, rowData) => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.projectNumber = rowData.projectNumber;
    criteria.fabricStyleCode = this.state.fabricStyleData.code;
    ReportService.getLogisticOrderReceiptRollLinesForProjectNumber(
      criteria,
      this.projectReceivedQuantityResponse,
      this.errorCallBack,
    );

    this.setState({ isShowStatReceivedQtyPopup: true });
  };

  projectShippedQuantityResponse = (response) => {
    let shippedProjectNumberDatas = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.pickedProjectNumberDatas))
        shippedProjectNumberDatas =
          response.data.inquiryResult.pickedProjectNumberDatas;
    }
    this.setState({
      shippedProjectNumberDatas: shippedProjectNumberDatas,
    });
  };
  projectShippedQtyClick = (type, rowData) => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.projectNumber = rowData.projectNumber;
    criteria.fabricStyleCode = this.state.fabricStyleData.code;
    // ReportService.getInvoicesRollLinesForProjectNumber(
    ReportService.getPickTicketRollLinesForProjectNumber(
      criteria,
      this.projectShippedQuantityResponse,
      this.errorCallBack,
    );

    this.setState({ isShowStatShippedQtyPopup: true });
  };

  excelButtonClick = (type, rowData) => {};

  receivedQuantityColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name#", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("LR#", "logisticOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll##", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Received", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    return columns;
  };
  shippedQuantityColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name#", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Invoice#", "invoiceNumber", true)
    //     .setStyleDetails("left", "", "", "wt-5", "wt-5")
    // );

    columns.push(
      new ColumnDefinition()
        .setDetails("PickTicket#", "pickTicketNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.handleHyperLinkClick, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll##", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Shipped", "pickedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    return columns;
  };

  receivedExcelButtonClick = (e) => {
    //
  };
  shippedExcelButtonClick = (e) => {
    //
  };

  /* PickTicket */
  handleHyperLinkClick = (e, val, rowData) => {
    if (val !== "" && val !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={val}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  filterStatisticsCriteria = (e, type) => {
    this.statisticExecuteHandler();
  };
  resetStatisticsCriteria = (e, type) => {
    let criteria = this.state.statisticsCriteria;
    criteria.containerNumber = "";
    criteria.projectNumber = "";
    if (this.state.isStandard) {
      criteria.lotNumber = "";
    }
    this.setState({ statisticsCriteria: criteria });

    setTimeout(() => {
      this.statisticExecuteHandler();
    }, 100);
  };

  getInOutStatisticsDetailsView() {
    return (
      <FabricStyleInOutStatisticsForm
        {...this.state}
        inOutStatisticsOnChange={this.inOutStatisticsOnChange}
        containerReceivedQtyClick={this.containerReceivedQtyClick}
        containerShippedQtyClick={this.containerShippedQtyClick}
        excelButtonClick={this.excelButtonClick}
        statisticExecuteHandler={this.statisticExecuteHandler}
        projectReceivedQtyClick={this.projectReceivedQtyClick}
        projectShippedQtyClick={this.projectShippedQtyClick}
        filterStatisticsCriteria={this.filterStatisticsCriteria}
        resetStatisticsCriteria={this.resetStatisticsCriteria}
      />
    );
  }

  /****************Lot Based Inventory In/Out Form ****************************/

  lotReceivedQuantityResponse = (response) => {
    let receiptLotDatas = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.receiptLotDatas))
        receiptLotDatas = response.data.inquiryResult.receiptLotDatas;
    }
    this.setState({
      receiptLotDatas: receiptLotDatas,
    });
  };
  lotReceivedQtyClick = (rowData) => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.lotNumber = rowData.lotNumber;
    criteria.fabricStyleCode = rowData.fabricStyleCode;
    criteria.fabricStyleColorCode = rowData.colorCode;

    ReportService.getPurchaseOrderReceiptRollLinesForLotNumber(
      criteria,
      this.lotReceivedQuantityResponse,
      this.errorCallBack,
    );

    this.setState({ isShowLotReceivedQtyPopup: true });
  };

  lotShippedQuantityResponse = (response) => {
    let shippedLotDatas = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.shippedLotDatas))
        shippedLotDatas = response.data.inquiryResult.shippedLotDatas;
    }
    this.setState({
      shippedLotDatas: shippedLotDatas,
    });
  };

  lotShippedQtyClick = (rowData) => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.lotNumber = rowData.lotNumber;
    criteria.fabricStyleCode = rowData.fabricStyleCode;
    criteria.fabricStyleColorCode = rowData.colorCode;
    // criteria.fabricStyleCode = this.state.fabricStyleData.code;
    ReportService.getInvoiceRollLinesForLotNumber(
      criteria,
      this.lotShippedQuantityResponse,
      this.errorCallBack,
    );

    this.setState({ isShowLotShippedQtyPopup: true });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowPurchaseModule: isOpen,
      isShowVendorModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowPickTicketModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewPRModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  lotReceivedQuantityColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
      // .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name#", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("PR#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.viewPRModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll##", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Received", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    return columns;
  };
  lotShippedQuantityColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
      // .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name#", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.viewInvoiceModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll##", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Shipped", "pickedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    return columns;
  };
  getLotBasedInOutDetailsView() {
    return (
      <FabricStyleLotBasedInventoryInOutForm
        {...this.state}
        inOutStatisticsOnChange={this.inOutStatisticsOnChange}
        lotReceivedQtyClick={this.lotReceivedQtyClick}
        lotShippedQtyClick={this.lotShippedQtyClick}
        // excelButtonClick={this.excelButtonClick}
        statisticExecuteHandler={this.statisticExecuteHandler}
        // projectReceivedQtyClick={this.projectReceivedQtyClick}
        // projectShippedQtyClick={this.projectShippedQtyClick}
        // filterStatisticsCriteria={this.filterStatisticsCriteria}
        resetStatisticsCriteria={this.resetStatisticsCriteria}
      />
    );
  }
uploadMutiDouments = (docs) => {
    let fabricStyleData = this.state.fabricStyleData;
    let documents = new Array();
    let docmentData = null;
    for (const doc of docs) {
      if (!doc.isFetched) {
        docmentData = new FabricStyleDocumentBean();
        docmentData.documentOriginalname = doc.name;
        docmentData.documentName = doc.name;
        docmentData.companyCode = this.companyCode;
        docmentData.fabricStyleCode = fabricStyleData.code;
        docmentData.documentPath = DOCUMENT_CHANGED;
        documents.push(docmentData);
      } else {
        documents.push(doc);
      }
    }
    fabricStyleData.fabricStyleDocuments = documents;
    this.setState({
      fabricStyleData: fabricStyleData,
      documents: docs,
    });
  };
  uploadMutiDoumentsUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Docs: url,
      });
    }, 400);
  };

  deleteMultiDocument = (rowData) => {
    let docs = this.state.fabricStyleData.fabricStyleDocuments;
    if (!isEmptyArray(docs)) {
      for (let j = 0; j < docs.length; j++) {
        if (docs[j].documentName === rowData.documentName) {
          if (docs[j].isFetched == true) {
            docs[j].deleted = true; // Change the value at index 2
            docs[j].isDeleted = true;
          } else {
            docs.splice(j, 1); // Change the value at index 2
            this.state.documents.splice(j, 1);
          }
        }
      }
    }
    this.state.fabricStyleData.fabricStyleDocuments = docs;
  };

  getDocumentMutipleFormView = () => {
    return (
      <MutilpleDocuments
        {...this.state}
        showToast={this.showToast}
        uploadMutiDouments={this.uploadMutiDouments}
        uploadMutiDoumentsUrl={this.uploadMutiDoumentsUrl}
        deleteMultiDocument={this.deleteMultiDocument}
      />
    );
  };
  getHoldingFabricDetailsView() {
    return (
      <HoldingFabricDetailsForm
        {...this.state}
        inOutStatisticsOnChange={this.inOutStatisticsOnChange}
        lotReceivedQtyClick={this.lotReceivedQtyClick}
        lotShippedQtyClick={this.lotShippedQtyClick}
        statisticExecuteHandler={this.statisticExecuteHandler}
        resetStatisticsCriteria={this.resetStatisticsCriteria}
      />
    );
  }

   getFabricInventoryAndSoAndPoView() {
    return (
      <FabricInventoryAndSoAndPoForm
        {...this.state}
        inOutStatisticsOnChange={this.inOutStatisticsOnChange}
        lotReceivedQtyClick={this.lotReceivedQtyClick}
        lotShippedQtyClick={this.lotShippedQtyClick}
        statisticExecuteHandler={this.statisticExecuteHandler}
        resetStatisticsCriteria={this.resetStatisticsCriteria}
        onfabricColorKeyDown={this.onfabricColorKeyDown}
        onfabricColorBlur={this.onfabricColorBlur}
        onFabricColourCodeChange={this.onFabricColourCodeChange}
         viewInvoiceModule={this.viewInvoiceModule}
        // fabricData={this.state.fabricData}
        // fabricColourEnterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
        // displayAutoCompleteColourList={this.displayAutoCompleteColourList}

      />
    );
  }


  onfabricColorBlur = (e) => {
    setTimeout(() => {
      if (this.state.isAllowReadColor == false && e.target.value != "") {
        this.fabricStyleColorSelected(this.state.fabricStyleColorCode);
      }
    }, 100);
  };
  onfabricColorKeyDown = (e) => {
    if (e.keyCode == 113 || e.keyCode == 27) {
      this.setState({
        isAllowReadColor: true,
      });
    }
  };
    onFabricColourCodeChange = (e) => {
      
      
      this.setState({
        fabricStyleColorCode: "",
        isAllowReadColor: false,
      });
      this.state.showAutoCompleteColourList = true;
      let fabricStyleColorCode = e.target.value.toUpperCase();
      let tempFabricData = this.state.fabricData;
      let showAutoCompleteList = this.state.showAutoCompleteColourList;
      if (isEmpty(fabricStyleColorCode)) {
        this.state.showAutoCompleteColourList = false;
        let showAutoCompleteList = this.state.showAutoCompleteColourList;
        let soLine = this.state.fabricData;
        soLine.fabricStyleColorCode = "";
        // soLine.onHandQuantity = 0;
        // soLine.orderQuantity = 0;
        soLine.price = 0;
        let suggestion = [];
        this.setState({
          showAutoCompleteColourList: showAutoCompleteList,
          fabricData: soLine,
          fabricColourPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "fabricStyleColorCode" &&
        showAutoCompleteList === true &&
        fabricStyleColorCode !== ""
      ) {
        this.readFabricColourBySearchString(e.target.value);
      }
      tempFabricData[e.target.name] = e.target.value;
      this.setState({
        fabricData: tempFabricData,
        fabricStyleColorCode: fabricStyleColorCode,
        isAllowReadColor: false,
      });
    };
    readFabricColourBySearchString(searchString) {
    
      
    let fabricColorList = this.state.fabricColorList;
    let simpleAutoCompleteColorList = new Array();
    fabricColorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
   
  }
  clearBodyList = () => {
    this.setState({
      shopifyBodyTopList: new Array(),
      shopifyBodyBottomList: new Array(),
      shopifyBodyBulletList: new Array(),
      shopifyBodyData: new ShopifyBodyDataBean(),
      shopifyBodyLineData: new ShopifyBodyLineData(),
      shopifyBodyTopDescriptionData: new ShopifyBodyLineData(),
      shopifyBodyBottomDescriptionData: new ShopifyBodyLineData(),
    });
  };
  bodyClick = () => {
    this.setState({
      isShowBodyPopup: true,
    });
    let eComShopifyData = this.state.eComShopifyData;
    eComShopifyData.companyCode = this.companyCode;
    if (!isEmptyString(eComShopifyData.jsonBodyDetails)) {
      let test = eComShopifyData.jsonBodyDetails;
      if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
        FabricStyleService.convertStringJsonToObject(
          test,
          this.convertStringJsonToObjectResponse,
          this.convertStringJsonToObjectError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  convertStringJsonToObjectResponse = (response) => {
    let responseData = response.data.dataBean;
    if (responseData.topDescriptionLineDatas == null) {
      responseData.topDescriptionLineDatas = [];
    }
    if (responseData.bulletinLineDatas == null) {
      responseData.bulletinLineDatas = [];
    }
    if (responseData.bottomDescriptionLineDatas == null) {
      responseData.bottomDescriptionLineDatas = [];
    }
    this.setState({
      shopifyBodyData: responseData,
    });
  };
  convertStringJsonToObjectError = (error) => {
    ShowError("Error : " + error);
  };
  convertTextToHtml = () => {
    {
      let bodyText1 = "";
      let bodyText2 = "";
      let lineText = "";
      let headerDescription = "";
      let metaDescription = "";
      let shopifyBody = this.state.shopifyBodyData;
      let shopifyBodytopDescriptionData = [];
      if (!isEmptyArray(this.state.shopifyBodyTopList)) {
        shopifyBodytopDescriptionData = this.state.shopifyBodyTopList;
      } else {
        shopifyBodytopDescriptionData =
          this.state.shopifyBodyData.topDescriptionLineDatas;
      }
      let shopifyBodyListData = [];

      if (!isEmptyArray(this.state.shopifyBodyBulletList)) {
        shopifyBodyListData = this.state.shopifyBodyBulletList;
      } else {
        shopifyBodyListData = this.state.shopifyBodyData.bulletinLineDatas;
      }
      let shopifyBodyBottomData = [];

      if (!isEmptyArray(this.state.shopifyBodyBottomList)) {
        shopifyBodyBottomData = this.state.shopifyBodyBottomList;
      } else {
        shopifyBodyBottomData =
          this.state.shopifyBodyData.bottomDescriptionLineDatas;
      }
      if (shopifyBody != null) {
        if (!isEmptyString(shopifyBody.metaDescription)) {
          metaDescription = "<p>" + shopifyBody.metaDescription + "</p>";
        }
        if (shopifyBodytopDescriptionData != null) {
          let test = "";
          let final = +test;
          shopifyBodytopDescriptionData.map((shopifyBodytopDescriptionData) => {
            test +=
              "<li>" + shopifyBodytopDescriptionData.description + "</li>";
          });
          bodyText1 = "<ul>" + test + "</ul>";
        }
        if (shopifyBodyListData != null) {
          let test = "";
          let final = +test;
          shopifyBodyListData.map((shopifyBodyListData) => {
            test += "<li>" + shopifyBodyListData.description + "</li>";
          });
          lineText = "<ul>" + test + "</ul>";
        }
        if (shopifyBodyBottomData != null) {
          let test = "";
          let final = +test;
          shopifyBodyBottomData.map((shopifyBodyBottomData) => {
            test += "<li>" + shopifyBodyBottomData.description + "</li>";
          });
          bodyText2 = "<ul>" + test + "</ul>";
        }
        if (!isEmptyString(shopifyBody.headerDescription)) {
          headerDescription = "<p>" + shopifyBody.headerDescription + "</p>";
        }
      }
      this.state.temp_eComShopifyData.body =
        metaDescription +
        "\r" +
        bodyText1 +
        "\r" +
        lineText +
        "\r" +
        bodyText2 +
        "\r" +
        headerDescription;
      shopifyBody.bottomDescriptionLineDatas = shopifyBodyBottomData;
      shopifyBody.bulletinLineDatas = shopifyBodyListData;
      shopifyBody.topDescriptionLineDatas = shopifyBodytopDescriptionData;
      this.state.shopifyBodyData = shopifyBody;
      this.setState({
        shopifyBodyData: shopifyBody,
      });
      let test = shopifyBody;
      if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
        FabricStyleService.convertBodyTextTojson(
          test,
          this.convertBodyTextTojsonResponse,
          this.convertBodyTextTojsonError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  convertBodyTextTojsonResponse = (response) => {
    let eComShopifyData = this.state.eComShopifyData;
    eComShopifyData.jsonBodyDetails = response.data.jsonString;
    this.setState({
      eComShopifyData: eComShopifyData,
    });
  };
  convertBodyTextTojsonError = (error) => {
    ShowError("Error : " + error);
  };
  addBodyTopDescriptionLines = () => {
    let shopifyBodyTopList = this.state.shopifyBodyTopList;
    let shopifyBodyData = this.state.shopifyBodyData;
    let bodyTDData = this.state.shopifyBodyTopDescriptionData;
    if (!isEmptyString(bodyTDData.description)) {
      let isLineFound = false;
      let shopifyBodyList = shopifyBodyData.topDescriptionLineDatas;
      shopifyBodyList.map((line, i) => {
        if (line.lineNumber == bodyTDData.lineNumber) {
          shopifyBodyList[i] = bodyTDData;
          isLineFound = true;
        }
        shopifyBodyTopList = shopifyBodyList;
      });
      if (!isLineFound) {
        shopifyBodyTopList.push(bodyTDData);
      }
      shopifyBodyData.topDescriptionLineDatas = shopifyBodyTopList;
      this.reArrangeBodyLineNumbers(shopifyBodyTopList);
      this.setState({
        shopifyBodyTopList: shopifyBodyTopList,
        shopifyBodyData: shopifyBodyData,
      });
      this.clearTopDescriptionLines();
    } else {
      let errMsg = "Description is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlertLvl1: true,
      });
    }
  };

  addBodyBottomDescriptionLines = () => {
    let shopifyBodyBottomList = this.state.shopifyBodyBottomList;
    let shopifyBodyData = this.state.shopifyBodyData;
    let bodyBottomData = this.state.shopifyBodyBottomDescriptionData;
    if (!isEmptyString(bodyBottomData.description)) {
      let isLineFound = false;
      let shopifyBodyList = shopifyBodyData.bottomDescriptionLineDatas;
      shopifyBodyList.map((line, i) => {
        if (line.lineNumber == bodyBottomData.lineNumber) {
          shopifyBodyList[i] = bodyBottomData;
          isLineFound = true;
        }
      });
      if (!isLineFound) shopifyBodyList.push(bodyBottomData);
      shopifyBodyBottomList = shopifyBodyList;
      shopifyBodyData.bottomDescriptionLineDatas = shopifyBodyList;
      this.reArrangeBodyLineNumbers(shopifyBodyBottomList);
      this.setState({
        shopifyBodyBottomList: shopifyBodyBottomList,
        shopifyBodyData: shopifyBodyData,
      });
      this.clearBottomDescriptionLines();
    } else {
      let errMsg = "Description is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlertLvl1: true,
      });
    }
  };
  addBodyBulletinLines = () => {
    let shopifyBodyBulletList = this.state.shopifyBodyBulletList;
    let shopifyBodyData = this.state.shopifyBodyData;
    let bulletinData = this.state.shopifyBodyLineData;
    if (!isEmptyString(bulletinData.description)) {
      let isLineFound = false;
      let shopifyBodyList = shopifyBodyData.bulletinLineDatas;
      shopifyBodyList.map((line, i) => {
        if (line.lineNumber == bulletinData.lineNumber) {
          shopifyBodyList[i] = bulletinData;
          isLineFound = true;
        }
      });
      if (!isLineFound) shopifyBodyList.push(bulletinData);
      shopifyBodyBulletList = shopifyBodyList;
      shopifyBodyData.bulletinLineDatas = shopifyBodyList;
      this.reArrangeBodyLineNumbers(shopifyBodyBulletList);
      this.setState({
        shopifyBodyBulletList: shopifyBodyBulletList,
        shopifyBodyData: shopifyBodyData,
      });
      this.clearLines();
    } else {
      let errMsg = "Description is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlertLvl1: true,
      });
    }
  };
  clearLines = () => {
    let lineData = new ShopifyBodyLineData();
    this.setState({
      shopifyBodyLineData: lineData,
    });
  };
  clearTopDescriptionLines = () => {
    let topDescriptionData = new ShopifyBodyLineData();
    this.setState({
      shopifyBodyTopDescriptionData: topDescriptionData,
    });
  };
  clearBottomDescriptionLines = () => {
    let bottomDescriptionData = new ShopifyBodyLineData();
    this.setState({
      shopifyBodyBottomDescriptionData: bottomDescriptionData,
    });
  };
  getBodyMaxLineNumber() {
    let maxLineNumber = 0;
    let bodyLineFormData = this.state.shopifyBodyData.bulletinLineDatas;
    if (bodyLineFormData.length > 0)
      bodyLineFormData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  getBodyLineByLineNumber = (lineNumber) => {
    let bodyLine = null;
    if (this.state.shopifyBodyLineData === null) return bodyLine;
    else if (this.state.shopifyBodyData.bulletinLineDatas == null)
      return bodyLine;
    else {
      this.state.shopifyBodyData.bulletinLineDatas.map((line) => {
        if (line.lineNumber === lineNumber) {
          bodyLine = line;
          return bodyLine;
        }
      });
    }
    return bodyLine;
  };
  getBodyTopLineByLineNumber = (lineNumber) => {
    let bodyLine = null;
    if (this.state.shopifyBodyTopDescriptionData === null) return bodyLine;
    else if (this.state.shopifyBodyData.topDescriptionLineDatas == null)
      return bodyLine;
    else {
      this.state.shopifyBodyData.topDescriptionLineDatas.map((line) => {
        if (line.lineNumber === lineNumber) {
          bodyLine = line;
          return bodyLine;
        }
      });
    }
    return bodyLine;
  };
  getBodyBottomLineByLineNumber = (lineNumber) => {
    let bodyLine = null;
    if (this.state.shopifyBodyBottomDescriptionData === null) return bodyLine;
    else if (this.state.shopifyBodyData.bottomDescriptionLineDatas == null)
      return bodyLine;
    else {
      this.state.shopifyBodyData.bottomDescriptionLineDatas.map((line) => {
        if (line.lineNumber === lineNumber) {
          bodyLine = line;
          return bodyLine;
        }
      });
    }
    return bodyLine;
  };
  deleteLine = (rowData) => {
    let shopifyBodyData = this.state.shopifyBodyData;
    let existingLine = this.getBodyLineByLineNumber(rowData.lineNumber);
    this.state.shopifyBodyLineData = { ...existingLine };
    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        const index = shopifyBodyData.bulletinLineDatas.findIndex(
          (ln) => ln.lineNumber === existingLine.lineNumber,
        );
        if (index != -1) {
          shopifyBodyData.bulletinLineDatas.splice(index, 1);
        }
        this.reArrangeBodyLineNumbers(shopifyBodyData.bulletinLineDatas);
        this.setState({ shopifyBodyData: shopifyBodyData });
      }
    }
    this.clearLines();
  };
  deleteTopLine = (rowData) => {
    let shopifyBodyData = this.state.shopifyBodyData;
    let existingLine = this.getBodyTopLineByLineNumber(rowData.lineNumber);
    this.state.shopifyBodyTopDescriptionData = { ...existingLine };
    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        const index = shopifyBodyData.topDescriptionLineDatas.findIndex(
          (ln) => ln.lineNumber === existingLine.lineNumber,
        );
        if (index != -1) {
          shopifyBodyData.topDescriptionLineDatas.splice(index, 1);
        }
        this.reArrangeBodyLineNumbers(shopifyBodyData.topDescriptionLineDatas);
        this.setState({ shopifyBodyData: shopifyBodyData });
      }
    }
    this.clearTopDescriptionLines();
  };
  deleteBottomLine = (rowData) => {
    let shopifyBodyData = this.state.shopifyBodyData;
    let existingLine = this.getBodyBottomLineByLineNumber(rowData.lineNumber);
    this.state.shopifyBodyBottomDescriptionData = { ...existingLine };
    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        const index = shopifyBodyData.bottomDescriptionLineDatas.findIndex(
          (ln) => ln.lineNumber === existingLine.lineNumber,
        );
        if (index != -1) {
          shopifyBodyData.bottomDescriptionLineDatas.splice(index, 1);
        }
        this.reArrangeBodyLineNumbers(
          shopifyBodyData.bottomDescriptionLineDatas,
        );
        this.setState({ shopifyBodyData: shopifyBodyData });
      }
    }
    this.clearBottomDescriptionLines();
  };
  onBodyDataChange = (e) => {
    let temp_shopifyBodyData = this.state.shopifyBodyData;
    temp_shopifyBodyData[e.target.name] = e.target.value;
    this.setState({
      shopifyBodyData: temp_shopifyBodyData,
    });
  };
  onBodyBulletinDataChange = (e) => {
    let temp_shopifyBodyData = this.state.shopifyBodyData;
    temp_shopifyBodyData[e.target.name] = e.target.value;
    let temp_shopifyBodyLineData = this.state.shopifyBodyLineData;
    temp_shopifyBodyLineData[e.target.name] = e.target.value;

    this.setState({
      shopifyBodyData: temp_shopifyBodyData,
      shopifyBodyLineData: temp_shopifyBodyLineData,
    });
  };
  onBodyTopDataChange = (e) => {
    let temp_shopifyBodyTopDescriptionData =
      this.state.shopifyBodyTopDescriptionData;
    temp_shopifyBodyTopDescriptionData[e.target.name] = e.target.value;
    this.setState({
      shopifyBodyTopDescriptionData: temp_shopifyBodyTopDescriptionData,
    });
  };
  onBodyBottomDataChange = (e) => {
    let temp_shopifyBodyData = this.state.shopifyBodyData;
    temp_shopifyBodyData[e.target.name] = e.target.value;
    let temp_shopifyBodyBottomDescriptionData =
      this.state.shopifyBodyBottomDescriptionData;
    temp_shopifyBodyBottomDescriptionData[e.target.name] = e.target.value;
    this.setState({
      shopifyBodyData: temp_shopifyBodyData,
      shopifyBodyBottomDescriptionData: temp_shopifyBodyBottomDescriptionData,
    });
  };
  reArrangeBodyLineNumbers = (bodyLineList) => {
    let maxLineNumber = 0;
    bodyLineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  readBulletLines = (rowData) => {
    let lineData = this.state.shopifyBodyLineData;
    lineData.lineNumber = rowData.lineNumber;
    lineData.description = rowData.description;
    this.setState({
      shopifyBodyLineData: lineData,
    });
  };
  readTopLines = (rowData) => {
    let lineData = this.state.shopifyBodyTopDescriptionData;
    lineData.lineNumber = rowData.lineNumber;
    lineData.description = rowData.description;
    this.setState({
      shopifyBodyTopDescriptionData: lineData,
    });
  };
  readBottomLines = (rowData) => {
    let lineData = this.state.shopifyBodyBottomDescriptionData;
    lineData.lineNumber = rowData.lineNumber;
    lineData.description = rowData.description;
    this.setState({
      shopifyBodyBottomDescriptionData: lineData,
    });
  };
  clearData = () => {
    this.setState({
      temp_eComShopifyData: new EcomShopifyFabricStyleBean(),
    });
  };
  targetDetailButtonClick = (element) => {
    let code = element.code;
    let webExportTypCode = element.webExportTypCode;
    if (
      this.state.fabricStyleData.ecomShopifyDetails != null ||
      !isEmptyArray(this.state.fabricStyleData.ecomShopifyDetails)
    ) {
      let shopifyData = new EcomShopifyFabricStyleBean();
      shopifyData.webSiteCode = code;

      let data = this.state.fabricStyleData.ecomShopifyDetails;
      data.map((list) => {
        if (code === list.webSiteCode) {
          shopifyData.handle = list.handle;
          shopifyData.isFetched = true;
          shopifyData.title = list.title;
          shopifyData.body = list.body;
          shopifyData.jsonBodyDetails = list.jsonBodyDetails;
          shopifyData.sEOTitle = list.sEOTitle;
          shopifyData.sEODescription = list.sEODescription;
          shopifyData.customProductTypeTags = list.customProductTypeTags;
          shopifyData.vendor = list.vendor;
          shopifyData.variantTaxable = list.variantTaxable;
          shopifyData.variantTaxCode = list.variantTaxCode;
          shopifyData.standardProductType = list.standardProductType;
          shopifyData.webSalesFlag = list.webSalesFlag;
        } else {
          shopifyData.webSiteCode = code;
        }
      });

      this.setState({
        eComShopifyData: shopifyData,
        temp_eComShopifyData: shopifyData,
      });
    } else {
      let eComShopifyData = this.state.eComShopifyData;
      eComShopifyData = new EcomShopifyFabricStyleBean();
      eComShopifyData.webSiteCode = code;
      this.setState({
        eComShopifyData: eComShopifyData,
        temp_eComShopifyData: eComShopifyData,
      });
    }
    this.setState({
      websiteCode: code,
      targetDetail: webExportTypCode,
      isShowTargetWebPopup: true,
    });
  };
  onTargetDetailChange = (e) => {
    let temp_eComShopifyData = this.state.temp_eComShopifyData;
    temp_eComShopifyData[e.target.name] = e.target.value;
    this.setState({
      temp_eComShopifyData: temp_eComShopifyData,
    });
  };
  targetContinueButtonClick = () => {
    let tempArray = [];
    let temp_eComShopifyData = this.state.temp_eComShopifyData;
    let eComShopifyData = this.state.eComShopifyData;
    eComShopifyData.companyCode = this.companyCode;
    if (isEmptyString(eComShopifyData.handle)) {
      let errMsg = "Handle is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else if (isEmptyString(eComShopifyData.title)) {
      let errMsg = "Title is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else if (isEmptyString(eComShopifyData.body)) {
      let errMsg = "Body is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else if (
      !isEmptyString(eComShopifyData.handle) &&
      !isEmptyString(eComShopifyData.title) &&
      !isEmptyString(eComShopifyData.body)
    ) {
      tempArray.push(this.state.eComShopifyData);
      this.state.fabricStyleData.ecomShopifyDetails = tempArray;
      this.setState({ eComShopifyData: temp_eComShopifyData });
      this.closeAlertModalCallBack(false);
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      isShowPopupAlert: isDisplayed,
      isShowPopupAlertLvl1: isDisplayed,
      isShowImgAlert: isDisplayed,
    });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl3: isDisplayed,
    });
  };
  moduleExit = () => {
    let fabricData = this.state.fabricStyleData;
    if (fabricData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (!this.state.isViewMode)
        this.unlockfabricStyle_WithoutRead(fabricData.code);
      this.props.onModuleExit();
    }
  };
  customerOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.fabricStyleData;
      tempData.customerCode = "";
      tempData.customerName = "";
      tempData.customerUserCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        fabricStyleData: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
      this.customerCleared();
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerCodeBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ fabricStyleData: tempData });
  };
  readCustomerCodeBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    if (this.state.is3PL) {
      CustomerService.getCustomerExcludesMasterCustomer(
        cust_requestInput,
        this.readCustomerBySearchCodeResponse,
        this.errorCallBack,
      );
    } else {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readCustomerBySearchCodeResponse,
        this.errorCallBack,
      );
    }
  }
  readCustomerBySearchCodeResponse = (response) => {
    let simpleAutoCompleteList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.customerPageList) &&
      !isEmptyArray(response.data.customerPageList.customers)
    ) {
      let customerData = response.data.customerPageList.customers;
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerEnterKeyEventHandler = (e) => {
    this.readCustomer(e.target.value);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.getUserList(e.target.value);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerResponse = (response) => {
    let customerData = response.data.customer;
    let fabricStyleData = this.state.fabricStyleData;
    fabricStyleData.customerCode = customerData.code;
    fabricStyleData.customerName = customerData.description;
    this.setState({
      fabricStyleData: fabricStyleData,
    });
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.errorCallBack,
    );
  };
  customerCleared() {
    let tempData = this.state.fabricStyleData;
    tempData.customerName = "";
    tempData.customerUserCode = "";
    this.setState({ customerName: "", isShowUserLookup: false, userList: [] });
  }
  uomOnChange = (e) => {
    let uomCode = e.target.value;
    this.state.isShowAutoCompleteLogisticUomList = true;
    let tempData = this.state.fabricLogisticPackageInfosDetails;
    let showAutoCompleteList = this.state.isShowAutoCompleteLogisticUomList;
    if (isEmpty(uomCode)) {
      this.state.isShowAutoCompleteLogisticUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLogisticUomList;
      let tempData = this.state.fabricLogisticPackageInfosDetails;
      tempData.uomCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        fabricLogisticPackageInfosDetails: tempData,
        logisticUomPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "uomCode" &&
      showAutoCompleteList === true &&
      uomCode !== ""
    ) {
      this.readLogisticUomBySearchString(e.target.value);
      this.readLogisticUom(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ fabricLogisticPackageInfosDetails: tempData });
  };
  logisticUomEnterKeyEvent = (e) => {
    this.readLogisticUom(e.target.value);
    this.state.isShowAutoCompleteLogisticUomList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLogisticUomList;
    this.setState({
      logisticUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLogisticUomAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLogisticUomList: isShowAutoCompleteList,
    });
  };
  readLogisticUomBySearchString = (searchString) => {
    let uomData = this.state.countUOMs;
    let simpleAutoCompleteList = new Array();
    if (uomData.length > 0 && uomData != null) {
      uomData.map((obj) => {
        let uomBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(uomBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      logisticUomPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readLogisticUom = (uomCode) => {
    let tempData = this.state.fabricLogisticPackageInfosDetails;
    let uomBean = null;
    let uomData = null;
    this.state.countUOMs.map((ln) => {
      if (ln.code === uomCode) {
        uomBean = ln;
        uomData = new BaseBean();
        uomData.code = ln.code;
        uomData.description = ln.description;
      }
    });
    if (!isEmpty(uomBean)) {
      tempData.uomCode = uomBean.code;
      this.state.isShowAutoCompleteLogisticUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLogisticUomList;
      this.setState({
        fabricLogisticPackageInfosDetails: tempData,
        isShowAutoCompleteLogisticUomList: showAutoCompleteList,
      });
    }
  };
  logisticWeightUomOnChange = (e) => {
    let weightUomCode = e.target.value;
    this.state.isShowAutoCompleteLogisticWeightUomList = true;
    let tempData = this.state.fabricLogisticPackageInfosDetails;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteLogisticWeightUomList;
    if (isEmpty(weightUomCode)) {
      this.state.isShowAutoCompleteLogisticWeightUomList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteLogisticWeightUomList;
      let tempData = this.state.fabricLogisticPackageInfosDetails;
      tempData.weightUomCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        fabricLogisticPackageInfosDetails: tempData,
        logisticWeightUomPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "weightUomCode" &&
      showAutoCompleteList === true &&
      weightUomCode !== ""
    ) {
      this.readLogisticWeightUomBySearchString(e.target.value);
      this.readLogisticWeightUom(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ fabricLogisticPackageInfosDetails: tempData });
  };
  logisticWeightUomEnterKeyEvent = (e) => {
    this.readLogisticWeightUom(e.target.value);
    this.state.isShowAutoCompleteLogisticWeightUomList = false;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteLogisticWeightUomList;
    this.setState({
      logisticWeightUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLogisticWeightUomAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLogisticWeightUomList: isShowAutoCompleteList,
    });
  };
  readLogisticWeightUomBySearchString = (searchString) => {
    let uomData = this.state.weightUOMs;
    let simpleAutoCompleteList = new Array();
    if (uomData.length > 0 && uomData != null) {
      uomData.map((obj) => {
        let uomBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(uomBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      logisticWeightUomPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readLogisticWeightUom = (weightUomCode) => {
    let tempData = this.state.fabricLogisticPackageInfosDetails;
    let uomBean = null;
    let uomData = null;
    this.state.weightUOMs.map((ln) => {
      if (ln.code === weightUomCode) {
        uomBean = ln;
        uomData = new BaseBean();
        uomData.code = ln.code;
        uomData.description = ln.description;
      }
    });
    if (!isEmpty(uomBean)) {
      tempData.weightUomCode = uomBean.code;
      this.state.isShowAutoCompleteLogisticWeightUomList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteLogisticWeightUomList;
      this.setState({
        fabricLogisticPackageInfosDetails: tempData,
        isShowAutoCompleteLogisticWeightUomList: showAutoCompleteList,
      });
    }
  };

  logisticCaseUomOnChange = (e) => {
    let caseUomCode = e.target.value;
    this.state.isShowAutoCompleteLogisticCaseUomList = true;
    let tempData = this.state.fabricLogisticPackageInfosDetails;
    let showAutoCompleteList = this.state.isShowAutoCompleteLogisticCaseUomList;
    if (isEmpty(caseUomCode)) {
      this.state.isShowAutoCompleteLogisticCaseUomList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteLogisticCaseUomList;
      let tempData = this.state.fabricLogisticPackageInfosDetails;
      tempData.caseUomCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        fabricLogisticPackageInfosDetails: tempData,
        logisticCaseUomPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "caseUomCode" &&
      showAutoCompleteList === true &&
      caseUomCode !== ""
    ) {
      this.readLogisticCaseUomBySearchString(e.target.value);
      this.readLogisticCaseUom(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ fabricLogisticPackageInfosDetails: tempData });
  };
  logisticCaseUomEnterKeyEvent = (e) => {
    this.readLogisticCaseUom(e.target.value);
    this.state.isShowAutoCompleteLogisticCaseUomList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLogisticCaseUomList;
    this.setState({
      logisticCaseUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLogisticCaseUomAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLogisticCaseUomList: isShowAutoCompleteList,
    });
  };
  readLogisticCaseUomBySearchString = (searchString) => {
    let uomData = this.state.lengthUOMs;
    let simpleAutoCompleteList = new Array();
    if (uomData.length > 0 && uomData != null) {
      uomData.map((obj) => {
        let uomBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(uomBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      logisticCaseUomPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readLogisticCaseUom = (caseUomCode) => {
    let tempData = this.state.fabricLogisticPackageInfosDetails;
    let uomBean = null;
    let uomData = null;
    this.state.lengthUOMs.map((ln) => {
      if (ln.code === caseUomCode) {
        uomBean = ln;
        uomData = new BaseBean();
        uomData.code = ln.code;
        uomData.description = ln.description;
      }
    });
    if (!isEmpty(uomBean)) {
      tempData.caseUomCode = uomBean.code;
      this.state.isShowAutoCompleteLogisticCaseUomList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteLogisticCaseUomList;
      this.setState({
        fabricLogisticPackageInfosDetails: tempData,
        isShowAutoCompleteLogisticCaseUomList: showAutoCompleteList,
      });
    }
  };

  logisticPalletUomOnChange = (e) => {
    let palletUomCode = e.target.value;
    this.state.isShowAutoCompleteLogisticPalletUomList = true;
    let tempData = this.state.fabricLogisticPackageInfosDetails;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteLogisticPalletUomList;
    if (isEmpty(palletUomCode)) {
      this.state.isShowAutoCompleteLogisticPalletUomList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteLogisticPalletUomList;
      let tempData = this.state.fabricLogisticPackageInfosDetails;
      tempData.palletUomCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        fabricLogisticPackageInfosDetails: tempData,
        logisticPalletUomPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "palletUomCode" &&
      showAutoCompleteList === true &&
      palletUomCode !== ""
    ) {
      this.readLogisticPalletUomBySearchString(e.target.value);
      this.readLogisticPalletUom(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ fabricLogisticPackageInfosDetails: tempData });
  };
  logisticPalletUomEnterKeyEvent = (e) => {
    this.readLogisticPalletUom(e.target.value);
    this.state.isShowAutoCompleteLogisticPalletUomList = false;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteLogisticPalletUomList;
    this.setState({
      logisticPalletUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLogisticPalletUomAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLogisticPalletUomList: isShowAutoCompleteList,
    });
  };
  readLogisticPalletUomBySearchString = (searchString) => {
    let uomData = this.state.lengthUOMs;
    let simpleAutoCompleteList = new Array();
    if (uomData.length > 0 && uomData != null) {
      uomData.map((obj) => {
        let uomBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(uomBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      logisticPalletUomPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readLogisticPalletUom = (palletUomCode) => {
    let tempData = this.state.fabricLogisticPackageInfosDetails;
    let uomBean = null;
    let uomData = null;
    this.state.lengthUOMs.map((ln) => {
      if (ln.code === palletUomCode) {
        uomBean = ln;
        uomData = new BaseBean();
        uomData.code = ln.code;
        uomData.description = ln.description;
      }
    });
    if (!isEmpty(uomBean)) {
      tempData.palletUomCode = uomBean.code;
      this.state.isShowAutoCompleteLogisticPalletUomList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteLogisticPalletUomList;
      this.setState({
        fabricLogisticPackageInfosDetails: tempData,
        isShowAutoCompleteLogisticPalletUomList: showAutoCompleteList,
      });
    }
  };

  logisticOnChange = (e) => {
    let fabricLogisticPackageInfosDetails =
      this.state.fabricLogisticPackageInfosDetails;
    fabricLogisticPackageInfosDetails[e.target.name] = e.target.value;
    this.setState({
      fabricLogisticPackageInfosDetails: fabricLogisticPackageInfosDetails,
    });
  };
  setDefaultValueForLogestic = () => {
    let fabriStyleData = this.state.fabricStyleData;
    let fabricLogisticPackageInfosDetails =
      this.state.fabricLogisticPackageInfosDetails;
    fabricLogisticPackageInfosDetails.uomCode = fabriStyleData.inventoryUomCode;
    fabricLogisticPackageInfosDetails.weightUomCode =
      fabriStyleData.weightUomCode;
    this.setState({
      fabricLogisticPackageInfosDetails: fabricLogisticPackageInfosDetails,
    });
  };
  getColors = () => {
    const color_criteria = new ColorSearchCriteria();
    color_criteria.companyCode = this.companyCode;
    const color_pageList = new PageListBean();
    const clr_requestInput = new RestColorListRequest();
    clr_requestInput.pageInput = color_pageList;
    clr_requestInput.searchCriteria = color_criteria;
    MasterService.getColorPageList(
      clr_requestInput,
      this.getColorListResponse,
      this.errorCallBack,
    );
  };
  getColorListResponse = (response) => {
    let color_List = [];
    if (
      response.data != null &&
      response.data.colorPageList != null &&
      !isEmptyArray(response.data.colorPageList.colors)
    ) {
      color_List = response.data.colorPageList.colors;
    }
    this.state.color_List = color_List;
    // this.setState({ color_List: color_List });
    let colorLookupHandler = new GenericAttributeLookupHandler(
      color_List,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };
  getColorListError = (error) => {
    ShowError("Error : " + error);
  };

  userOnChange = (e) => {
    let customerUserCode = e.target.value;
    this.state.isShowAutoCompleteUserList = true;
    let fabricStyleData = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.isShowAutoCompleteUserList;
    if (isEmpty(customerUserCode)) {
      this.state.isShowAutoCompleteUserList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteUserList;
      let fabricStyleData = this.state.fabricStyleData;
      fabricStyleData.customerUserCode = "";

      let suggestion = [];
      this.setState({
        isShowAutoCompleteUserList: showAutoCompleteList,
        fabricStyleData: fabricStyleData,
        userPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerUserCode" &&
      showAutoCompleteList === true &&
      customerUserCode !== ""
    ) {
      setTimeout(() => {
        this.readUserCodeBySearchString(e.target.value);
      }, 200);
    }
    fabricStyleData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ fabricStyleData: fabricStyleData });
  };
  readUserCodeBySearchString(searchString) {
    let data = this.state.userList;
    let simpleAutoCompleteList = new Array();
    if (data.length > 0 && data != null) {
      data.map((obj) => {
        let dataBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(dataBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      userPageListForAutoCompleteList: filteredSuggestions,
    });
  }

  userEnterKeyEventHandler = (e) => {
    this.readUser(e.target.value);
    this.state.isShowAutoCompleteUserList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteUserList;
    this.setState({
      userPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteUserList: showAutoCompleteList,
    });
  };
  displayAutoCompleteUserList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteUserList: showAutoCompleteList,
    });
  };

  readUser = (customerUserCode) => {
    let tempData = this.state.fabricStyleData;
    let userBean = new BaseBean();
    this.state.userList.map((ln) => {
      if (ln.code === customerUserCode) {
        userBean = ln;
        // userBean.code = ln.code;
        // userBean.description = ln.description;
      }
    });
    if (!isEmpty(userBean)) {
      tempData.customerUserCode = userBean.code;
      this.state.isShowAutoCompleteUserList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteUserList;
      this.setState({
        fabricStyleData: tempData,
        isShowAutoCompleteUserList: showAutoCompleteList,
      });
    }
  };

  loadUserResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.userPageList) &&
      !isEmptyArray(response.data.userPageList.users)
    ) {
      const userList = new Array();
      response.data.userPageList.users.map((ln) => {
        const userData = new BaseBean();
        userData.code = ln.code;
        userData.description = ln.description;
        userList.push(userData);

        let userLookupHandler = new GenericAttributeLookupHandler(
          userList,
          "User",
        );
        this.setState({ userLookupHandler: userLookupHandler });
      });
      this.setState({
        isLoading: false,
        loadingText: "",
        userList: userList,
        isShowUserLookup: true,
      });
    } else {
      let userLookupHandler = new GenericAttributeLookupHandler(
        new Array(),
        "User",
      );
      this.setState({ userLookupHandler: userLookupHandler });
      this.setState({
        isLoading: false,
        loadingText: "",
        userList: [],
        isShowUserLookup: false,
      });
    }
  };

  getUserList = (code) => {
    this.setState({
      isLoading: true,
      loadingText: "get users",
    });

    const request = new RestUserListRequest();
    const criteria = new UserSearchCriteria();
    criteria.loginType = LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER;
    criteria.entityCode = code;

    const pageInput = new PageListBean();

    request.searchCriteria = criteria;
    request.pageInput = pageInput;
    UserService.getUserPageList(
      request,
      this.loadUserResponse,
      this.errorCallBack,
    );
  };

  uploadClrImage = (file, code) => {
    const fabricStyleData = { ...this.state.fabricStyleData };

    if (!isEmptyArray(fabricStyleData.colors)) {
      fabricStyleData.colors.map((clr) => {
        if (clr.fabricStyleColorCode == code) {
          clr.imageName = file.name;
        }
      });
    }
  };

  deleteClrImage = () => {};

  custPriceOnChange = (e, rowData) => {
    const fabricStyleData = this.state.fabricStyleData;

    fabricStyleData.customerTypePrices.map((ln) => {
      if (ln.customerTypeCode === rowData.customerTypeCode) {
        ln[e.target.name] = e.target.value;
      }
    });
    this.state.fabricStyleData = fabricStyleData;

    this.setState({
      fabricStyleData: fabricStyleData,
    });
  };

  hideAlertCallBackColor = (mslgType, isDisplayed) => {
    this.setState({
      isShowColorAlert: isDisplayed,
    });
  };

  copyFabric = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowCopyFabric: true,
        copyFabricCode: "",
      });
    }
  };
  closeAlertModalCallBackCopyFabric = (isShowPopup) => {
    this.setState({
      // isShowMailInvoicePopup: isShowPopup,
      isShowCopyFabric: isShowPopup,
    });
  };
  copyFabricContinue = (e) => {
    if (e.detail == 1) {
      if (!isEmptyString(this.state.copyFabricCode)) {
        this.setState({
          isLoading: true,
          loadingText: "Copying PO",
        });
        let copyFabricCode = this.state.copyFabricCode;
        let request = new RestReadRequest();
        request.code = copyFabricCode;
        request.companyCode = this.companyCode;
        request.isLoadChildren = true;

        FabricStyleService.readFabricStyle(
          request,
          this.copyFabricContinueResponse,
          this.errorCallBack,
        );
      } else {
        //Else Added
        let errMsg = "Invalid FabricCode";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowCopyPoAlert: true,
        });
      }
    }
  };
  copyFabricContinueResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let fabricStyleData = this.state.fabricStyleData;
    let copyData = response.data.fabricStyle;
    fabricStyleData.code = NEW_ENTRY;
    fabricStyleData.description = copyData.description;
    fabricStyleData.productTypeCode = copyData.productTypeCode;
    fabricStyleData.productTypeName = copyData.productTypeName;
    fabricStyleData.patternTypeCode = copyData.patternTypeCode;
    fabricStyleData.patternTypeName = copyData.patternTypeName;
    fabricStyleData.makeTypeCode = copyData.makeTypeCode;
    fabricStyleData.makeTypeName = copyData.makeTypeName;
    fabricStyleData.divisionCode = copyData.divisionCode;
    fabricStyleData.patternTypeCategoryCode = copyData.patternTypeCategoryCode;
    fabricStyleData.patternTypeCategoryName = copyData.patternTypeCategoryName;
    fabricStyleData.styleItemType = copyData.styleItemType;
    fabricStyleData.styleItemTypeName = copyData.styleItemTypeName;
    fabricStyleData.tariffPercentage = copyData.tariffPercentage;
    fabricStyleData.dutyCharge = copyData.dutyCharge;
    fabricStyleData.stats = copyData.stats;
    fabricStyleData.inventoryUomCode = copyData.inventoryUomCode;
    fabricStyleData.copyrightNumber = copyData.copyrightNumber;
    fabricStyleData.availableFromDate = copyData.availableFromDate;
    fabricStyleData.availableToDate = copyData.availableToDate;
    fabricStyleData.width = copyData.width;
    fabricStyleData.widthUomCode = copyData.widthUomCode;
    fabricStyleData.weight = copyData.weight;
    fabricStyleData.weightUomCode = copyData.weightUomCode;
    fabricStyleData.currencyCode = copyData.currencyCode;
    fabricStyleData.wholesalePrice = copyData.wholesalePrice;
    fabricStyleData.retailPrice = copyData.retailPrice;
    fabricStyleData.webRetailPrice = copyData.webRetailPrice;
    fabricStyleData.closeOutFlag = copyData.closeOutFlag;
    fabricStyleData.closeOutPrice = copyData.closeOutPrice;
    fabricStyleData.samplePrice = copyData.samplePrice;
    fabricStyleData.seasonCode = copyData.seasonCode;
    fabricStyleData.defaultLocationCode = copyData.defaultLocationCode;
    fabricStyleData.hts = copyData.hts;
    fabricStyleData.isActive = copyData.isActive;
    fabricStyleData.salesTaxRequiredFlag = copyData.salesTaxRequiredFlag;
    fabricStyleData.tariffFlag = copyData.tariffFlag;
    fabricStyleData.webSalesFlag = copyData.webSalesFlag;
    fabricStyleData.sampleItemFlag = copyData.sampleItemFlag;
    fabricStyleData.isFetched = false;
    let colors = copyData.colors;
    if (colors != null) {
      for (let color of colors) {
        let colorObj = new FabricStyleColorBean();
        colorObj.fabricStyleCode = NEW_ENTRY;
        colorObj.companyCode = this.companyCode;
        colorObj.fabricStyleColorCode = color.fabricStyleColorCode;
        colorObj.fabricStyleColorName = color.fabricStyleColorName;
        //  colorObj.documentCode = color.documentCode;
        colorObj.isFetched = false;
        colorObj.isDeleted = color.deleted;
        colorObj.imageName = color.imageName;
        colorObj.nrfCode = color.nrfCode;
        fabricStyleData.colors.push(colorObj);
      }
    }
    this.setState({
      fabricStyleData: fabricStyleData,
      copyFabricCode: "",
      color___List: fabricStyleData.colors,
    });
    this.generateItemSKUs();
    this.closeAlertModalCallBackCopyFabric(false);
  };

  fabricCodeOnChange = (e) => {
    let copyFabricCode = this.state.copyFabricCode;
    copyFabricCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;

    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(copyFabricCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.copyFabricCode;
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        copyFabricCode: criteria,
        fabricPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "copyFabricCode" &&
      showAutoCompleteList === true &&
      copyFabricCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    // copyFabricCode[e.target.name] = e.target.value;
    this.setState({ copyFabricCode: copyFabricCode });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.copyFabricCode;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria = fabricStyle.code;

        this.setState({
          copyFabricCode: criteria,
        });
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack,
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack,
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };

  viewVendorModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowVendorModule: true,
        moduleForPopup: (
          <PopupVendorModule
            vendorCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseModule: true,
        moduleForPopup: (
          <PopupPurchaseOrderModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseReceiptModule: true,
        moduleForPopup: (
          <PopupPurchaseReceiptModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  StatisticsOutLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice Date", "invoiceDate", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Inv Num", "invoiceNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustPONum#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Price#", "price", true, true)
        .setStyleDetails("right", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("shippedQty#", "shippedQuantity", true, true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.getShippedQuantityLineDetails, null),
    );

    return columns;
  };
  StatisticsCaptionLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("vendor", "vendorCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewVendorModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "vendorName", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PR#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQty", "receivedQuantity", true, true)
        .setStyleDetails("right", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.getReceivedLineDetails, null),
    );
    return columns;
  };
  StatisticsCaptionLineColumns2 = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewCustomerModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot#", "lotNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RollSku#", "rollSkuNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("uom", "uomCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShippedQty", "shippedQuantity", true, true)
        .setStyleDetails("right", "2", "", "wt-2", "wt-2"),
    );
    return columns;
  };
  closeAlertModalStatesticCallBack = () => {
    this.setState({
      isInandOutStatisticsPopup: false,
    });
  };
  closeModalSalesHistoryCallBack = (isOpen) => {
    this.setState({
      isShowItemSalesDetails: isOpen,
      moduleForPopup: [],
    });
  };
  fabricSalesColorStatisticsExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateFabricSalesColorStatisticsReport(2);
  };
  generateFabricSalesColorStatisticsReport = (reportType) => {
    let criteria = this.state.clrStatisticCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleColorStatisticsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (reportBean.reportType == 1) {
        ReportService.generateFabricColorSatisticsSalesPrintReport(
          listRequest,
          this.generateFabricColorSatisticsSalesPrintPageResponse,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      ReportService.generateFabricColorSatisticsSalesPrintReport(
        listRequest,
        this.generateFabricColorSatisticsSalesPrintPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateFabricColorSatisticsSalesPrintPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  fabricSalesColorStatisticsPDFHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateFabricSalesColorStatisticsReport(1);
  };

  fabricPurchaseColorStatisticsPDFHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateFabricPurchaseColorStatisticsReport(1);
  };

  fabricPurchaseColorStatisticsExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateFabricPurchaseColorStatisticsReport(2);
  };

  generateFabricPurchaseColorStatisticsReport = (reportType) => {
    let criteria = this.state.clrStatisticCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleColorStatisticsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (reportBean.reportType == 1) {
        ReportService.generateFabricColorSatisticsPurchasePrintReport(
          listRequest,
          this.generateFabricColorSatisticsPurchasePrintPageResponse,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      ReportService.generateFabricColorSatisticsPurchasePrintReport(
        listRequest,
        this.generateFabricColorSatisticsPurchasePrintPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateFabricColorSatisticsPurchasePrintPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  onFabricStatusChange = (e) => {
    let fabricStatus = e.target.value;
    this.state.showAutoCompleteFabricStausList = true;
    let tempfabricStyleData = this.state.fabricStyleData;
    let showAutoCompleteList = this.state.showAutoCompleteFabricStausList;
    if (isEmpty(fabricStatus)) {
      this.state.showAutoCompleteFabricStausList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricStausList;
      let tempfabricStyleData = this.state.fabricStyleData;
      tempfabricStyleData.fabricStatus = "";
      tempfabricStyleData.isActive = false;
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        fabricStyleData: tempfabricStyleData,
        fabricStatusPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStatus !== "") {
      this.readFabricStatusSearchString(fabricStatus);
    }
    if (e.target.name == "fabricStatus") {
      tempfabricStyleData[e.target.name] = e.target.value;
      let fabricStatussCityList = this.state.fabricStyleStatus;
      fabricStatussCityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempfabricStyleData["fabricStatus"] = pdtType.code;
          this.state.showAutoCompleteFabricStausList = false;
          let showAutoCompleteList = this.state.showAutoCompleteFabricStausList;
          this.setState({
            showAutoCompleteFabricStausList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      fabricStyleData: tempfabricStyleData,
    });
  };
  readFabricStatusSearchString(searchString) {
    let fabricStatusData = this.state.fabricStyleStatus;
    let simpleAutoCompleteList = new Array();
    if (fabricStatusData.length > 0 && fabricStatusData != null) {
      fabricStatusData.map((bd) => {
        let simpleItemBean = { code: bd.code, description: bd.description };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteOrderLists) =>
        simpleAutoCompleteOrderLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricStatusPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricStatusEnterKeyEventHandler = (e) => {
    let fabricStyleData = this.state.fabricStyleData;
    fabricStyleData["fabricStatus"] = e.target.value;
    let fabricStatuss = this.state.fabricStyleStatus;
    //this.setActiveFalg(e.target.value);
    let fabricStatusBean = null;
    fabricStatuss.map((fb) => {
      if (fb.code == e.target.value) {
        fabricStatusBean = fb;
      }
    });
    if (!isEmpty(fabricStatusBean)) {
      fabricStyleData.fabricStatus = fabricStatusBean.code;

      this.setState(
        {
          fabricStyleData: fabricStyleData,
          fabricStatusPageListForAutoCompleteList: new Array(),
        },
        () => {
          this.setActiveFalg(e.target.value);
        },
      );
    }
  };

  displayAutoCompletefabricStatusList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricStausList: showAutoCompleteList });
  };
  setActiveFalg = (value) => {
    let fabricStyleData = this.state.fabricStyleData;
    if (value == "Active") {
      fabricStyleData.isActive = true;
    } else {
      fabricStyleData.isActive = false;
    }
    this.setState({
      fabricStyleData: fabricStyleData,
    });
  };

  onColorStatusChange = (e) => {
    let status = e.target.value;
    this.state.showAutoCompleteColorStausList = true;
    let tempfabricStyleColorData = this.state.colorData;
    let showAutoCompleteList = this.state.showAutoCompleteColorStausList;
    if (isEmpty(status)) {
      this.state.showAutoCompleteColorStausList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColorStausList;
      let tempfabricStyleColorData = this.state.colorData;
      tempfabricStyleColorData.status = "";
      tempfabricStyleColorData.isActive = false;
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        colorData: tempfabricStyleColorData,
        fabricColorStatusPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && status !== "") {
      this.readFabricColorStatusSearchString(status);
    }
    if (e.target.name == "status") {
      tempfabricStyleColorData[e.target.name] = e.target.value;
      let fabricStatussCityList = this.state.fabricStyleStatus;
      fabricStatussCityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempfabricStyleColorData["status"] = pdtType.code;
          this.state.showAutoCompleteColorStausList = false;
          let showAutoCompleteList = this.state.showAutoCompleteColorStausList;
          this.setState({
            showAutoCompleteColorStausList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      colorData: tempfabricStyleColorData,
    });
  };
  readFabricColorStatusSearchString(searchString) {
    let fabricStatusData = this.state.fabricStyleStatus;
    let simpleAutoCompleteList = new Array();
    if (fabricStatusData.length > 0 && fabricStatusData != null) {
      fabricStatusData.map((bd) => {
        let simpleItemBean = { code: bd.code, description: bd.description };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteOrderLists) =>
        simpleAutoCompleteOrderLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColorStatusPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColorStatusEnterKeyEventHandler = (e) => {
    let fabricStyleColorData = this.state.colorData;
    fabricStyleColorData["status"] = e.target.value;
    let fabricStatuss = this.state.fabricStyleStatus;
    //this.setActiveFalg(e.target.value);
    let fabricStatusBean = null;
    fabricStatuss.map((fb) => {
      if (fb.code == e.target.value) {
        fabricStatusBean = fb;
      }
    });
    if (!isEmpty(fabricStatusBean)) {
      fabricStyleColorData.status = fabricStatusBean.code;

      this.setState(
        {
          colorData: fabricStyleColorData,
          fabricColorStatusPageListForAutoCompleteList: new Array(),
        },
        () => {
          this.setColorActiveFalg(e.target.value);
        },
      );
    }
  };

  displayAutoCompletefabricColorStatusList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteColorStausList: showAutoCompleteList });
  };

  setColorActiveFalg = (value) => {
    let fabricStyleData = this.state.colorData;
    if (value == "Active") {
      fabricStyleData.isActive = true;
    } else {
      fabricStyleData.isActive = false;
    }
    this.setState({
      colorData: fabricStyleData,
    });
  };
  render() {
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let fabricStyleData = this.state.fabricStyleData;
    let is3PL = this.state.is3PL;
    let statisticsDataBean = this.state.statisticsDataBean;
    let isDisabledFields = this.state.isDisabledFields;
    let statisticsDatailList = this.state.statisticsDatailList;
    let receivedDataList = this.state.receivedDataList;
    let shippedDataList = this.state.shippedDataList;

    return (
      <div>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editfabricStyle}
          moduleKeyCode={this.state.moduleKeyCode}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.fabricStyleLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {!this.state.isFabricStyleListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              back={this.back}
              save={this.save}
              clearError={this.clearError}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              pageTitle={this.state.pageTitle}
              isLoading={this.state.isLoading}
              isSpecialViewMode={this.state.isSpecialViewMode}
              extend_toolbar={
                <>
                  {this.state.isStandard &&
                    this.state.fabricStyleData.isFetched == false && (
                      <Button
                        className="header_buttons secondary"
                        size="sm"
                        onClick={(e) => this.copyFabric(e)}
                      >
                        <CopyPlus size={16} />
                        Copy Fabric
                      </Button>
                    )}
                </>
              }
            />
          )}
        {/* {this.state.error_list.length > 0 && (
          <BaseNotification error_list={this.state.error_list} />
        )} */}

        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}

        {/* {
          this.state.isStandard ? (
            this.state.isShowNodes && (
              <BaseNodeBar
                nodeList={this.state.nodeList}
                selectedModuleKey={this.state.selectedNodeKey}
                nodeOnSelect={this.nodeOnSelect}
                moduleOrderStatus={moduleOrderStatus}
              />
            )
          ) : (
            <BaseNodeBar
              nodeList={this.state.nodeList}
              selectedModuleKey={this.state.selectedNodeKey}
              nodeOnSelect={this.nodeOnSelect}
            />
          )
        } */}

        {!this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
            !this.state.isFabricInventoryAndSoAndPoOpen &&
             !this.state.isMultipleDocFormOpened &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
          !this.state.isFabricInventoryAndSoAndPoOpen &&
           !this.state.isMultipleDocFormOpened &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
         !this.state.isFabricInventoryAndSoAndPoOpen &&
          !this.state.isMultipleDocFormOpened &&
          this.getSkuView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
         !this.state.isFabricInventoryAndSoAndPoOpen &&
          !this.state.isMultipleDocFormOpened &&
          this.getItemCostView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
          !this.state.isFabricInventoryAndSoAndPoOpen &&
           !this.state.isMultipleDocFormOpened &&
          this.getCompositionView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
            !this.state.isFabricInventoryAndSoAndPoOpen &&
             !this.state.isMultipleDocFormOpened &&
          this.getFabricDetailView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
           !this.state.isFabricInventoryAndSoAndPoOpen &&
            !this.state.isMultipleDocFormOpened &&
          this.getMiscCostView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
          !this.state.isFabricInventoryAndSoAndPoOpen &&
           !this.state.isMultipleDocFormOpened &&
          this.getAtsView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
              !this.state.isFabricInventoryAndSoAndPoOpen &&
               !this.state.isMultipleDocFormOpened &&
          this.getInventoryView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
           !this.state.isFabricInventoryAndSoAndPoOpen &&
            !this.state.isMultipleDocFormOpened &&
          this.getEcomDetailsView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
              !this.state.isFabricInventoryAndSoAndPoOpen &&
               !this.state.isMultipleDocFormOpened &&
          this.getLogisticDetailsView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
            !this.state.isFabricInventoryAndSoAndPoOpen &&
             !this.state.isMultipleDocFormOpened &&
          this.getInventorySummaryView()}
        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
            !this.state.isFabricInventoryAndSoAndPoOpen &&
             !this.state.isMultipleDocFormOpened &&
          this.getCustomerSalesView()}

        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
            !this.state.isFabricInventoryAndSoAndPoOpen &&
             !this.state.isMultipleDocFormOpened &&
          this.getCustomerSalesAndPurchaseView()}

        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
           !this.state.isFabricInventoryAndSoAndPoOpen &&
            !this.state.isMultipleDocFormOpened &&
          this.getFabricSalesView()}

        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
             !this.state.isFabricInventoryAndSoAndPoOpen &&
              !this.state.isMultipleDocFormOpened &&
          this.getPurchaseDetailsView()}

        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
            !this.state.isFabricInventoryAndSoAndPoOpen &&
             !this.state.isMultipleDocFormOpened &&
          this.getInOutStatisticsDetailsView()}

        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
            !this.state.isFabricInventoryAndSoAndPoOpen &&
             !this.state.isMultipleDocFormOpened &&
          this.getLotBasedInOutDetailsView()}

        {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          this.state.isFabricStyleHoldingDetailsViewOpen &&
            !this.state.isFabricInventoryAndSoAndPoOpen &&
             !this.state.isMultipleDocFormOpened &&
          this.getHoldingFabricDetailsView()}


          {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
          this.state.isFabricInventoryAndSoAndPoOpen &&
           !this.state.isMultipleDocFormOpened &&
          this.getFabricInventoryAndSoAndPoView()}
          
          {this.state.isShowNodes &&
          !this.state.isFabricStyleListFormOpen &&
          !this.state.isChangesHistoryViewOpened &&
          !this.state.isFabricStyleMiscDetailViewOpen &&
          !this.state.isFabricStyleEntryFormOpen &&
          !this.state.isFabricStyleSkuViewOpen &&
          !this.state.isFabricStyleItemCostViewOpen &&
          !this.state.isFabricStyleCompositionViewOpen &&
          !this.state.isFabricStyleDetailsViewOpen &&
          !this.state.isFabricStyleLotBasedInvDetailViewOpen &&
          !this.state.isFabricStyleAtsDetailViewOpen &&
          !this.state.isfabricStyleEcomDetailsViewOpen &&
          !this.state.isFabricStyleLogisticInfoViewOpen &&
          !this.state.isFabricStyleLotBasedSummaryViewOpen &&
          !this.state.isFabricStyleCustomerSalesViewOpen &&
          !this.state.isFabricStylePurchaseViewOpen &&
          !this.state.isFabricStyleInOutStatisticsViewOpen &&
          !this.state.isFabricStyleLotBasedInventoryInOutViewOpen &&
          !this.state.isFabricStyleCustomerSalesAndPurchaseViewOpen &&
          !this.state.isFabricStyleSalesViewOpen &&
          !this.state.isFabricStyleHoldingDetailsViewOpen &&
          this.state.isMultipleDocFormOpened &&
          !this.state.isFabricInventoryAndSoAndPoOpen &&
          this.getDocumentMutipleFormView()}


        {this.state.isFabricStyleListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <FabricStyleListForm
              {...this.state}
              fabricStyle_list={this.state.fabricStyle_list}
              pageList={this.state.pageList}
              criteria={this.state.criteria}
              editfabricStyle={this.editfabricStyle}
              filterFabricStyles={this.filterFabricStyles}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              resetFilterFabricStyles={this.resetFilterFabricStyles}
              onChange={this.onFilterChange}
              saveFabricStyle={this.savefabricStyle}
              handleSortingChange={this.handleSortingChange}
            />
          )}
        <MessageBoxComponent
          isShowPopup={this.state.isShowWarningMsgPopup}
          warningMesage={this.state.warningMessage}
          title="Warning Message"
          onYesButtonClick={this.onYesButtonClick}
          onNoButtonClick={this.onNoButtonClick}
          closeMessageModelCallBack={this.closeMessageModelCallBack}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel6"}
          isModulePopup={false}
          isShowPopup={this.state.isShowCopyFabric}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackCopyFabric}
          title={"Copy Fabric"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.copyFabricContinue(e)}
              >
                Continue
              </Button>
            </div>
          }
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowCopyPoAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="PurchaseOrderPopup">
              <div>
                <Row>
                  <Col sm="">
                    <FormLabel>Fabric</FormLabel>
                  </Col>
                  <Col sm="">
                    <InputTextbox
                      onChange={this.fabricCodeOnChange}
                      //  ref={this.purchaseOrderRef}
                      name="copyFabricCode"
                      placeholder="copyFabricCode"
                      value={this.state.copyFabricCode}
                      lookupRequired={true}
                      lookupHandler={this.state.fabricStyleLookupHandler}
                      enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                      autoCompleteListData={
                        this.state.fabricPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteFabricList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompleteFabricList
                      }
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                {/* <Row>
                  <Button onClick={this.copyPOContinue}>Continue</Button>
                </Row> */}
              </div>
            </div>
          }
        />

        {/**************************** In / Out Statistics **************************/}

        {/*****************************Received Quantity popup **********************/}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowStatReceivedQtyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
          title={"ReceivedQuantity Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.receivedExcelButtonClick(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div>
              {this.state.statisticsCriteria.mode == 0 ? (
                <CustomTable
                  data={this.state.receiptContainerDatas}
                  columns={this.receivedQuantityColumns()}
                  label={"Received Qty List"}
                />
              ) : (
                <CustomTable
                  data={this.state.receiptProjectNumberDatas}
                  columns={this.receivedQuantityColumns()}
                  label={"Received Qty List"}
                />
              )}
            </div>
          }
        />

        {/*****************************Shipped Quantity popup **********************/}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowStatShippedQtyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
          title={"Shipped Quantity Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.shippedExcelButtonClick(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div>
              {this.state.statisticsCriteria.mode == 0 ? (
                <CustomTable
                  data={this.state.shippedContainerDatas}
                  columns={this.shippedQuantityColumns()}
                  label={"Shipped List"}
                />
              ) : (
                <CustomTable
                  data={this.state.shippedProjectNumberDatas}
                  columns={this.shippedQuantityColumns()}
                  label={"Shipped List"}
                />
              )}
            </div>
          }
        />

        {/***************************** LotBased Received Quantity popup **********************/}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowLotReceivedQtyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
          title={"Received Quantity Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.receivedExcelButtonClick(e)}
          //     >
          //       Excel
          //     </Button>
          //   </div>
          // }
          content={
            <div>
              <CustomTable
                data={this.state.receiptLotDatas}
                columns={this.lotReceivedQuantityColumns()}
                label={"Received Qty List"}
              />
            </div>
          }
        />

        {/***************************** LotBased Shipped Quantity popup **********************/}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowLotShippedQtyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
          title={"Shipped Quantity Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.shippedExcelButtonClick(e)}
          //     >
          //       Excel
          //     </Button>
          //   </div>
          // }
          content={
            <div>
              <CustomTable
                data={this.state.shippedLotDatas}
                columns={this.lotShippedQuantityColumns()}
                label={"Shipped List"}
              />
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          isShowPopup={this.state.isShowPickTicketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemSalesDetails}
          closeModalCallBack={this.closeModalSalesHistoryCallBack}
          module={this.state.moduleForPopup}
          lockScroll={false}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isInandOutStatisticsPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalStatesticCallBack}
          title={"FABRIC OUT STATISTICS"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowInAndOutAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>Total ShippedQty:</FormLabel>{" "}
                </Col>

                <Col sm="2">
                  <InputTextbox
                    name="companyCode"
                    value={shippedDataList.reduce(
                      (acc, curr) => acc + (curr.shippedQuantity ?? 0),
                      0,
                    )}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <CustomTable
                columns={this.StatisticsCaptionLineColumns2()}
                data={shippedDataList}
                label={"FABRIC OUT LINE DETAILS"}
              />
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isOpenStatisticsPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"FABRIC IN/OUT STATISTICS"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowInAndOutAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>Company</FormLabel>{" "}
                </Col>

                <Col sm="2">
                  <InputTextbox
                    name="companyCode"
                    value={fabricStyleData.companyCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="1">
                  {is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>

                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    onChange={this.onChange}
                    value={statisticsDataBean.fabricStyleCode}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="description"
                    onChange={this.onChange}
                    value={statisticsDataBean.fabricStyleName}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
                <Col sm="1">
                  <FormLabel>Color</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    onChange={this.onChange}
                    value={statisticsDataBean.colorCode}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <div className="div_inline">
                  <div className="div_40_no_overflow">
                    <div>
                      <CustomTable
                        columns={this.StatisticsCaptionLineColumns()}
                        data={statisticsDatailList}
                        label={"FABRIC IN DETAILS"}
                      />
                    </div>
                  </div>
                  <div className="div_60_no_overflow">
                    <div>
                      <CustomTable
                        columns={this.StatisticsOutLineColumns()}
                        data={receivedDataList}
                        label={"FABRIC OUT DETAILS"}
                        isShowInputTextbox={this.state.isShowInputTextbox}
                        subHeaderData={this.state.rowSubHeaderData}
                      />
                    </div>
                  </div>
                </div>
              </Row>
            </div>
          }
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowColorStatisticsPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"FABRIC COLOR STATISTICS"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <FabricColorStatisticsPopup
                {...this.state}
                clrStatisticOnChange={this.clrStatisticOnChange}
                salesExecuteHandler={this.salesExecuteHandler}
                purchaseExecuteHandler={this.purchaseExecuteHandler}
                viewVendorModule={this.viewVendorModule}
                viewPurchaseModule={this.viewPurchaseModule}
                viewPurchaseReceiptModule={this.viewPurchaseReceiptModule}
                viewCustomerModule={this.viewCustomerModule}
                viewInvoiceModule={this.viewInvoiceModule}
                customerClrStatChange={this.customerClrStatChange}
                customerCodeClrStatEnterKeyHandler={
                  this.customerCodeClrStatEnterKeyHandler
                }
                displayAutoCompleteCustomerList={
                  this.displayAutoCompleteCustomerList
                }
                vendorClrStatOnChange={this.vendorClrStatOnChange}
                vendorCodeEnterKeyEventHandler={
                  this.vendorCodeEnterKeyEventHandler
                }
                displayAutoCompleteVendorList={
                  this.displayAutoCompleteVendorList
                }
                resetClrStatistics={this.resetClrStatistics}
                fabricSalesColorStatisticsExcelHandler={
                  this.fabricSalesColorStatisticsExcelHandler
                }
                fabricSalesColorStatisticsPDFHandler={
                  this.fabricSalesColorStatisticsPDFHandler
                }
                fabricPurchaseColorStatisticsPDFHandler={
                  this.fabricPurchaseColorStatisticsPDFHandler
                }
                fabricPurchaseColorStatisticsExcelHandler={
                  this.fabricPurchaseColorStatisticsExcelHandler
                }
              />
            </div>
          }
        />
      </div>
    );
  }
}
class FabricStyleListForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      fabricStyle_list: this.props.fabricStyle_list,
      editfabricStyle: this.props.editfabricStyle,
    };
  }
  editfabricStyle = (e, fabricStyleCode) => {
    if (e.detail === 1) this.props.editfabricStyle(fabricStyleCode);
  };
  filterFabricStyles = (e) => {
    if (e.detail === 1) this.props.filterFabricStyles();
  };
  resetFilterFabricStyles = (e) => {
    if (e.detail === 1) this.props.resetFilterFabricStyles();
  };
  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };

  onChange = (e) => {
    this.props.onChange(e);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterFabricStyles();
    }
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let fabricStyle_list = new Array();
    if (!isEmptyArray(this.props.fabricStyle_list))
      fabricStyle_list = this.props.fabricStyle_list;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    // totalPages = totalPages.toFixed(0);
    let currentPage = pageList.currentPage.toFixed(0);

    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            {this.props.isStandard ? (
              <div className="">
                <FormLabel className="criteria-labl">Status</FormLabel>
              </div>
            ) : null}
            {this.props.isStandard ? (
              <div className="criteria-val">
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="fabricStatus"
                  value={criteria.fabricStatus}
                >
                  <option value={""}>All</option>
                  <option value={"Active"}>Active</option>
                  <option value={"InActive"}>InActive</option>
                  <option value={"Discontinued"}>Discontinued</option>
                </FormControl>
              </div>
            ) : null}

            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <FormControl
                name="searchName"
                type="text"
                value={criteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
              <span className="px-2"></span>
              <Button onClick={(e) => this.filterFabricStyles(e)}>
                Filter
              </Button>
              <span className="px-2"></span>
              <Button onClick={(e) => this.resetFilterFabricStyles(e)}>
                Reset
              </Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>

            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  {this.props.is3PL ? "Item" : "FabricStyle"}

                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {this.props.is3PL ? (
                  <>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "customerCode")
                      }
                    >
                      Customer
                      {this.props.order === "desc" &&
                      this.props.sortField === "customerCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "customerUserCode")
                      }
                    >
                      User
                      {this.props.order === "desc" &&
                      this.props.sortField === "customerUserCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </>
                ) : null}
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "productTypeCode")
                  }
                >
                  {this.props.is3PL ? "Regulated" : "ProductType"}

                  {this.props.order === "desc" &&
                  this.props.sortField === "productTypeCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {!this.props.is3PL ? (
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "patternTypeCode")
                    }
                  >
                    Type {/* commodity */}
                    {this.props.order === "desc" &&
                    this.props.sortField === "patternTypeCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                ) : null}
                {!this.props.is3PL ? (
                  <th
                    onClick={(e) => this.handleSortingChange(e, "makeTypeCode")}
                  >
                    Content {/* productType */}
                    {this.props.order === "desc" &&
                    this.props.sortField === "makeTypeCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                ) : null}
                <th onClick={(e) => this.handleSortingChange(e, "cost")}>
                  Cost
                  {this.props.order === "desc" &&
                  this.props.sortField === "cost" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {!this.props.is3PL && (
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "wholeSalePrice")
                    }
                  >
                    WholeSale Price
                    {this.props.order === "desc" &&
                    this.props.sortField === "wholeSalePrice" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                )}

                <th onClick={(e) => this.handleSortingChange(e, "retailPrice")}>
                  {this.props.is3PL ? "Price" : "RetailPrice"}
                  {this.props.order === "desc" &&
                  this.props.sortField === "retailPrice" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {!this.props.is3PL && (
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "inventoryUomCode")
                    }
                  >
                    Inventory UOM
                    {this.props.order === "desc" &&
                    this.props.sortField === "inventoryUomCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                )}
                <th onClick={(e) => this.handleSortingChange(e, "weight")}>
                  Weight
                  {this.props.order === "desc" &&
                  this.props.sortField === "weight" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "defaultWareHouseCode")
                  }
                >
                  WareHouse
                  {this.props.order === "desc" &&
                  this.props.sortField === "defaultWareHouseCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>

                <th
                  onClick={(e) => this.handleSortingChange(e, "fabricStatus")}
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "fabricStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Image</th> */}
              </tr>
            </thead>
            <tbody>
              {fabricStyle_list.map((fab, i) => (
                <tr key={i} data-item={fab}>
                  <td>
                    <Button
                      size="sm"
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.editfabricStyle(e, fab.code)}
                    >
                      {fab.code}
                    </Button>
                  </td>
                  <td>{fab.description}</td>
                  {this.props.is3PL ? (
                    <>
                      <td>{fab.customerCode}</td>{" "}
                      <td>{fab.customerUserCode}</td>
                    </>
                  ) : null}
                  <td>{fab.productTypeCode}</td>
                  {!this.props.is3PL ? (
                    <>
                      <td>{fab.patternTypeCode}</td>
                      <td>{fab.makeTypeCode}</td>
                    </>
                  ) : null}
                  <td>{fab.cost}</td>
                  {!this.props.is3PL && <td>{fab.wholeSalePrice}</td>}
                  <td>{fab.retailPrice}</td>
                  {!this.props.is3PL && <td>{fab.inventoryUomCode}</td>}
                  <td>{fab.weight}</td>
                  <td>{fab.defaultWareHouseCode}</td>
                  <td>{fab.fabricStatus}</td>
                  {/* <td class="text-center">
                    <img
                      src={this.getImageURL()}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noImage;
                      }}
                      width={40}
                      height={40}
                      mode="fit"
                    />
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

class FabricStyleEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.patternTypeRef = React.createRef();
    this.productTypeRef = React.createRef();
    this.makeTypeRef = React.createRef();
    this.currencyCodeRef = React.createRef();
    this.seasonCodeRef = React.createRef();
    this.compositionTypeCodeRef = React.createRef();
    this.productDivisionRef = React.createRef();
    this.customerTypeRef = React.createRef();
    this.colorCodeRef = React.createRef();
    this.incoTermRef = React.createRef();
    this.patternTypeCategoryRef = React.createRef();
    this.styleItemTypeRef = React.createRef();
    this.htsRef = React.createRef();
    this.productStatusRef = React.createRef();
    this.countUOMRef = React.createRef();
    this.lengthUOMRef = React.createRef();
    this.weightUomRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.inventoryUomCodeRef = React.createRef();
    this.widthUomRef = React.createRef();
    this.fabricStyleRef = this.props.fabricStyleRef;
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
      fabricStyleSKUData: this.props.fabricStyleSKUData,
      businessDivisions: this.props.businessDivisions,
      patternTypes: this.props.patternTypes,
      productTypes: this.props.productTypes,
      uoms: this.props.uoms,
      currencies: this.props.currencies,
      makeTypes: this.props.makeTypes,
      seasons: this.props.seasons,
      compositionTypes: this.props.compositionTypes,
      countries: this.props.countries,
      productDivisions: this.props.productDivisions,
      colors: this.props.colors,
      customerTypes: this.props.customerTypes,
      incoTerms: this.props.incoTerms,
      patternTypeCategories: this.props.patternTypeCategories,
      styleItemTypes: this.props.styleItemTypes,
      htses: this.props.htses,
      productStatuses: this.props.productStatuses,
      countUOMs: this.props.countUOMs,
      lengthUOMs: this.props.lengthUOMs,
      weightUOMs: this.props.weightUOMs,
      warehouses: this.props.warehouses,
      skuBatchInventories: [],
      isOpenColorPopup: this.props.isOpenColorPopup,
      uomData: this.props.uomData,
      colorData: this.props.colorData,
      uoms: [],
      colorCaption: "",
      imageData: this.props.imageData,
      error_list: this.props.error_list,
      isOpenOnHandDetailPopup: false,
      isOpenStatisticsPopup: false,
      isInandOutStatisticsPopup: false,
      skuBatchInventoryDataBean: this.props.skuBatchInventoryDataBean,
      statisticsDatailList: this.props.statisticsDatailList,
      statisticsDataBean: this.props.statisticsDataBean,
      receivedDataList: this.props.receivedDataList,
      isShowPopup: false,
      alertMessage: this.props.alertMessage,
      alertType: this.props.alertType,
      isShowAlert: this.props.isShowAlert,
      isShowInAndOutAlert: this.props.isShowInAndOutAlert,
      isShowMultipleColorPopup: false,
      isAllowSelectedValues: true,
      colorLookupHandler: null,

      fabricStatusLookupHandler: null,
      fabricStyleStatus: this.props.fabricStyleStatus,
    };
  }
  componentDidMount() {
    let fabricStyleData = this.props.fabricStyleData;
    let uoms = this.props.uoms;
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.setState({
      uoms: uoms,
    });
    this.inventory_data_url = appData.serviceURL + "/InventoryRestService";
    this.initLookupHandlers();
    this.setFocus();
  }
  componentDidUpdate() {
    //
  }
  setFocus = () => {
    if (this.props.isFocus == true) this.props.setFocus();
  };
  initLookupHandlers = () => {
    let patternTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypes,
      !this.props.is3PL ? "Style Type" : "Commodity",
    );
    this.setState({ patternTypeLookupHandler: patternTypeLookupHandler });
    let productTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.productTypes,
      "Style",
    );
    this.setState({ productTypeLookupHandler: productTypeLookupHandler });
    let makeTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.makeTypes,
      "Content",
    );
    this.setState({ makeTypeLookupHandler: makeTypeLookupHandler });
    let uomLookupHandler = new GenericAttributeLookupHandler(
      this.props.countUOMs,
      "UOM",
    );
    this.setState({ uomLookupHandler: uomLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.state.currencies,
      "Currency",
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
    let seasonLookupHandler = new GenericAttributeLookupHandler(
      this.state.seasons,
      "Season",
    );
    this.setState({ seasonLookupHandler: seasonLookupHandler });
    let compositionTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.compositionTypes,
      "CompositionType",
    );
    this.setState({
      compositionTypeLookupHandler: compositionTypeLookupHandler,
    });
    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country",
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
    let productDivisionLookupHandler = new GenericAttributeLookupHandler(
      this.state.productDivisions,
      "Product Division",
    );
    this.setState({
      productDivisionLookupHandler: productDivisionLookupHandler,
    });
    let incoTermLookupHandler = new GenericAttributeLookupHandler(
      this.state.incoTerms,
      "IncoTerm",
    );
    this.setState({ incoTermLookupHandler: incoTermLookupHandler });
    let patternTypeCategoryLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypeCategories,
      "Type Category",
      // !this.props.is3PL ? "Use" : "Type Category"
    );
    this.setState({
      patternTypeCategoryLookupHandler: patternTypeCategoryLookupHandler,
    });
    let styleItemTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.styleItemTypes,
      "StyleItemType",
    );
    this.setState({ styleItemTypeLookupHandler: styleItemTypeLookupHandler });
    let htsLookupHandler = new GenericAttributeLookupHandler(
      this.state.htses,
      "Hts",
    );
    this.setState({ htsLookupHandler: htsLookupHandler });
    let productStatusLookupHandler = new GenericAttributeLookupHandler(
      this.state.productStatuses,
      "ProductStatus",
    );
    this.setState({ productStatusLookupHandler: productStatusLookupHandler });
    let countUOMLookupHandler = new GenericAttributeLookupHandler(
      this.props.countUOMs,
      "CountUOM",
    );
    this.setState({ countUOMLookupHandler: countUOMLookupHandler });
    let lengthUOMLookupHandler = new GenericAttributeLookupHandler(
      this.props.lengthUOMs,
      "LengthUOM",
    );
    this.setState({ lengthUOMLookupHandler: lengthUOMLookupHandler });
    let weightUOMLookupHandler = new GenericAttributeLookupHandler(
      this.props.weightUOMs,
      "weightUOM",
    );
    this.setState({ weightUOMLookupHandler: weightUOMLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
      this.props.is3PL ? true : false,
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    // let colorLookupHandler = new ColorLookupHandler(this.companyCode, "Color");
    // let colorLookupHandler = new GenericAttributeLookupHandler(
    //   this.props.color_List,
    //   "Color"
    // );
    // this.setState({ colorLookupHandler: colorLookupHandler });

    let fabricStatusLookupHandler = new GenericAttributeLookupHandler(
      this.props.fabricStyleStatus,
      "fabricStatus",
    );
    this.setState({ fabricStatusLookupHandler: fabricStatusLookupHandler });
  };
  showErrorMessage = (response) => {
    this.props.showErrorMessage(response);
  };
  showInfoMessage = (response) => {
    this.props.showInfoMessage(response);
  };
  onPatternTypeCodeChange = (e) => {
    this.props.onPatternTypeCodeChange(e);
  };
  patternTypeEnterKeyEvent = (e) => {
    this.props.patternTypeEnterKeyEvent(e);
  };
  onTypeCodeChange = (e) => {
    this.props.onTypeCodeChange(e);
  };
  typeEnterKeyEvent = (e) => {
    this.props.typeEnterKeyEvent(e);
  };
  onMakeTypeCodeChange = (e) => {
    this.props.onMakeTypeCodeChange(e);
  };
  makeTypeEnterKeyEvent = (e) => {
    this.props.makeTypeEnterKeyEvent(e);
  };
  onUseCodeChange = (e) => {
    this.props.onUseCodeChange(e);
  };
  useEnterKeyEvent = (e) => {
    this.props.useEnterKeyEvent(e);
  };
  onDivisionCodeChange = (e) => {
    this.props.onDivisionCodeChange(e);
  };
  divisionEnterKeyEvent = (e) => {
    this.props.divisionEnterKeyEvent(e);
  };
  onStyleItemTypeChange = (e) => {
    this.props.onStyleItemTypeChange(e);
  };
  styleItemTypeEnterKeyEvent = (e) => {
    this.props.styleItemTypeEnterKeyEvent(e);
  };
  onStatsChange = (e) => {
    this.props.onStatsChange(e);
  };
  statsEnterKeyEvent = (e) => {
    this.props.statsEnterKeyEvent(e);
  };
  onCurrencyCodeChange = (e) => {
    this.props.onCurrencyCodeChange(e);
  };
  currencyCodeEnterKeyEvent = (e) => {
    this.props.currencyCodeEnterKeyEvent(e);
  };
  onLocationChange = (e) => {
    this.props.onLocationChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  onWeightUomChange = (e) => {
    this.props.onWeightUomChange(e);
  };
  weightUomEnterKeyEventHandler = (e) => {
    this.props.weightUomEnterKeyEventHandler(e);
  };
  onHtsChange = (e) => {
    this.props.onHtsChange(e);
  };
  htsEnterKeyEventHandler = (e) => {
    this.props.htsEnterKeyEventHandler(e);
  };
  onSeasonChange = (e) => {
    this.props.onSeasonChange(e);
  };
  seasonEnterKeyEventHandler = (e) => {
    this.props.seasonEnterKeyEventHandler(e);
  };
  displayAutoCompleteDivisionList = (list) => {
    this.props.displayAutoCompleteDivisionList(list);
  };
  displayAutoCompleteStatsList = (list) => {
    this.props.displayAutoCompleteStatsList(list);
  };
  displayAutoCompleteStyleItemTypeList = (list) => {
    this.props.displayAutoCompleteStyleItemTypeList(list);
  };
  displayAutoCompleteCurrencyList = (list) => {
    this.props.displayAutoCompleteCurrencyList(list);
  };
  displayAutoCompleteLocationList = (list) => {
    this.props.displayAutoCompleteLocationList(list);
  };
  displayAutoCompleteUseList = (list) => {
    this.props.displayAutoCompleteUseList(list);
  };
  displayAutoCompletePatternTypeList = (list) => {
    this.props.displayAutoCompletePatternTypeList(list);
  };
  displayAutoCompleteWeightUomList = (list) => {
    this.props.displayAutoCompleteWeightUomList(list);
  };
  displayAutoCompleteTypeList = (list) => {
    this.props.displayAutoCompleteTypeList(list);
  };
  displayAutoCompleteMakeTypeList = (list) => {
    this.props.displayAutoCompleteMakeTypeList(list);
  };
  displayAutoCompleteSeasonList = (list) => {
    this.props.displayAutoCompleteSeasonList(list);
  };
  displayAutoCompleteHtsList = (list) => {
    this.props.displayAutoCompleteHtsList(list);
  };
  onWidthUOMCodeChange = (e) => {
    this.props.onWidthUOMCodeChange(e);
  };
  readWidthUOM = (response) => {
    this.props.readWidthUOM(response);
  };
  readWidthUomCodeBySearchString = (response) => {
    this.props.readWidthUomCodeBySearchString(response);
  };
  widthUomEnterKeyEvent = (e) => {
    this.props.widthUomEnterKeyEvent(e);
  };
  displayAutoCompleteWidthUomList = (list) => {
    this.props.displayAutoCompleteWidthUomList(list);
  };
  onUOMCodeChange = (e) => {
    this.props.onUOMCodeChange(e);
  };
  readWidthUOM = (response) => {
    this.props.readWidthUOM(response);
  };
  uomEnterKeyEvent = (e) => {
    this.props.uomEnterKeyEvent(e);
  };
  readUomCodeBySearchString = (response) => {
    this.props.readUomCodeBySearchString(response);
  };
  displayAutoCompleteUomList = (list) => {
    this.props.displayAutoCompleteUomList(list);
  };
  selectColor = (color) => {
    this.props.selectColor(color);
  };
  unSelectColor = (color) => {
    this.props.unSelectColor(color);
  };
  uomPopupEnterKeyEvent = (e) => {
    this.props.uomPopupEnterKeyEvent(e);
  };
  onPopupUomCodeChange = (e) => {
    this.props.onPopupUomCodeChange(e);
  };
  displayAutoCompleteUomPopupList = (showAutoCompleteUOMPopupList) => {
    this.props.displayAutoCompleteUomPopupList(showAutoCompleteUOMPopupList);
  };
  multipleAdd = (e) => {
    if (e.detail <= 1) this.props.multipleAdd();
  };
  addOrUpdateMultipleColor = (e) => {
    if (e.detail === 1) this.props.addOrUpdateMultipleColor();
  };
  closeAlertMultipleColorModalCallBack = (isShowPopup) => {
    this.props.closeAlertMultipleColorModalCallBack(isShowPopup);
  };
  onChange = (e) => {
    this.props.onEntryFormChange(e);
  };
  addorUpdateBuyingUom = (uomData) => {
    this.props.addorUpdateBuyingUom(uomData);
  };
  addorUpdateSellingUom = (uomData) => {
    this.props.addorUpdateSellingUom(uomData);
  };
  addorUpdateUom = (e, uomData) => {
    if (e.detail === 1) this.props.addorUpdateUom(uomData);
  };
  closeUomPopup = () => {
    this.props.closeUomPopup();
  };
  openUomPopup = () => {
    this.props.openUomPopup();
  };
  openNewBuyingUomPopup = (e) => {
    if (e.detail <= 1) this.props.openNewBuyingUomPopup();
  };
  openNewSellingUomPopup = (e) => {
    if (e.detail === 1) this.props.openNewSellingUomPopup();
  };
  editBuyingUom = (e, buyingUom) => {
    if (e.detail === 1) this.props.editBuyingUom(buyingUom);
  };
  editSellingUom = (e, sellingUom) => {
    if (e.detail === 1) this.props.editSellingUom(sellingUom);
  };
  deleteBuyingUom = (e, buyingUom) => {
    if (e.detail === 1) this.props.deleteBuyingUom(buyingUom);
  };
  deleteSellingUom = (e, sellingUom) => {
    if (e.detail === 1) this.props.deleteSellingUom(sellingUom);
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeAlertModalCallBack(isShowPopup);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  getFabricStyleImagePath = (imagePart, fabricStyle) => {
    this.props.getFabricStyleImagePath(imagePart, fabricStyle);
  };
  uploadColorImage = (e) => {
    this.props.uploadColorImage(e);
  };
  editColor = (e, clr) => {
    if (e.detail === 1) this.props.editColor(clr);
  };
  openNewColorPopup = (e) => {
    if (e.detail <= 1) this.props.openNewColorPopup();
  };
  addorUpdateColor = (e, colorData) => {
    if (e.detail === 1) this.props.addorUpdateColor(colorData);
  };
  onColorChange = (e) => {
    this.props.onColorChange(e);
  };
  openColorPopup = () => {
    this.props.openColorPopup();
  };
  closeColorPopup = () => {
    this.props.closeColorPopup();
  };
  onPopupColorCodeChange = (e) => {
    this.props.onPopupColorCodeChange(e);
  };
  colorPopupEnterKeyEvent = (e) => {
    this.props.colorPopupEnterKeyEvent(e);
  };
  displayAutoCompleteColorPopupList = (showAutoCompleteColorPopupList) => {
    this.props.displayAutoCompleteColorPopupList(
      showAutoCompleteColorPopupList,
    );
  };
  addorUpdateImageData = (tempFabricStyleData) => {
    this.props.addorUpdateImageData(tempFabricStyleData);
  };
  openImagePopup = () => {
    this.props.openImagePopup();
  };
  closeImagePopup = () => {
    this.props.closeImagePopup();
  };
  openOnHandDetailPopup = () => {
    this.props.openOnHandDetailPopup();
  };
  closeOnHandDetailPopup = () => {
    this.props.closeOnHandDetailPopup();
  };
  closeStatisticsPopup = () => {
    this.props.closeStatisticsPopup();
  };
  getOnHandQty = (e, line) => {
    if (e.detail === 1) this.props.getOnHandQty(line);
  };

  openSalesHistoryDetailsInq = (e, line) => {
    if (e.detail === 1) this.props.openSalesHistoryDetailsInq(line);
  };
  getOnStatistics = (e, line) => {
    if (e.detail === 1) this.props.getOnStatistics(line);
  };
  getOnColorStatistics = (e, line) => {
    if (e.detail === 1) this.props.getOnColorStatistics(line);
  };
  isDisableRemoveColorButton = (color) => {
    this.props.isDisableRemoveColorButton(color);
  };
  deleteColor = (e, clr) => {
    if (e.detail === 1) this.props.deleteColor(clr);
  };
  closeEntryForm() {
    this.props.closeEntryForm();
  }
  imageClick = (fabricStyle, imagePart) => {
    this.props.imageClick(fabricStyle, imagePart);
  };
  isDisableRemoveUomButton = (buyingUom) => {
    this.props.isDisableRemoveUomButton(buyingUom);
  };
  customerOnChange = (e) => {
    this.props.customerOnChange(e);
  };
  customerEnterKeyEventHandler = (e) => {
    this.props.customerEnterKeyEventHandler(e);
  };
  displayAutoCustomerCompleteList = (list) => {
    this.props.displayAutoCustomerCompleteList(list);
  };
  getReceivedLineDetails = (rowData) => {
    this.props.getReceivedLineDetails(rowData);
  };
  viewVendorModule = (e, code, rowData) => {
    this.props.viewVendorModule(e, code, rowData);
  };
  viewPurchaseModule = (e, code, rowData) => {
    this.props.viewPurchaseModule(e, code, rowData);
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    this.props.viewPurchaseReceiptModule(e, code, rowData);
  };
  viewCustomerModule = (e, code, rowData) => {
    this.props.viewCustomerModule(e, code, rowData);
  };
  viewInvoiceModule = (e, code, rowData) => {
    this.props.viewInvoiceModule(e, code, rowData);
  };
  hideInAndOutAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      isShowPopupAlert: isDisplayed,
      isShowPopupAlertLvl1: isDisplayed,
      isShowImgAlert: isDisplayed,
    });
  };
  testOnchange = (e) => {
    // setVal(e);
    // set value
    this.cursor = e.target.selectionStart;

    this.fabricStyleRef.current.selectionStart = this.cursor;
    let value = e.target.value;
    this.setState({
      value: value,
    });
    // const [val, setVal] = useState(e.target.value);
    // set onchange
    let fabricStyleData = this.props.fabricStyleData;
    fabricStyleData[e.target.name] = e.target.value;
    this.setState({ fabricStyleData: fabricStyleData });
    // setOnchange(e);
  };
  getTypriceColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CustType", "customerTypeCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
      // .setInputDetails(
      //   false,
      //   false,
      //   true,
      //   null,
      //   this.excelDataLineCheck,
      //   null
      // )
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Price#", "price", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setInputDetails(false, true, false, this.props.custPriceOnChange),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SamplePrice#", "samplePrice", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setInputDetails(false, true, false, this.props.custPriceOnChange),
    );

    return columns;
  };

  onFabricStatusChange = (e) => {
    this.props.onFabricStatusChange(e);
  };
  fabricStatusEnterKeyEventHandler = (e) => {
    this.props.fabricStatusEnterKeyEventHandler(e);
  };
  displayAutoCompletefabricStatusList = (list) => {
    this.props.displayAutoCompletefabricStatusList(list);
  };

  onColorStatusChange = (e) => {
    this.props.onColorStatusChange(e);
  };
  fabricColorStatusEnterKeyEventHandler = (e) => {
    this.props.fabricColorStatusEnterKeyEventHandler(e);
  };
  displayAutoCompletefabricColorStatusList = (
    showAutoCompleteColorStausList,
  ) => {
    this.props.displayAutoCompletefabricColorStatusList(
      showAutoCompleteColorStausList,
    );
  };

  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let sellingUoms = this.props.fabricStyleData.sellingUoms;
    let buyingUoms = this.props.fabricStyleData.buyingUoms;
    let colors = [];
    this.props.fabricStyleData.colors.map((clr, i) => {
      if (clr.isDeleted == false) {
        colors.push(clr);
      }
    });
    let uomData = this.props.uomData;
    let isNew = this.props.fabricStyleData.isFetched;
    if (isNew == null) isNew = this.props.fabricStyleData.fetched;
    let colorData = this.props.colorData;
    let colorList = this.props.multipleColorList;
    let selectedMultipleColorList = this.props.selectedMultipleColorList;
    let isDisabledFields = this.props.isDisabledFields;
    let is3PL = this.props.is3PL;

    const textAreaStyle_1 = {
      maxHeight: "9em",
      width: "30em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    const textAreaStyle = {
      maxHeight: "9em",
      width: "30em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    const textAreaStyle_3pl = {
      maxHeight: "9em",
      width: "20em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    let isDisableaddOrUpdate = false;
    if (uomData.uomCode == uomData.fabricStyleInventoryUOMCode) {
      isDisableaddOrUpdate = true;
    } else {
      isDisableaddOrUpdate = false;
    }
    const color___List = this.props.color___List;
    
    
    const customerTypePrices =
      this.props.fabricStyleData.customerTypePrices || [];
    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.props.isOpenUomPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.props.closeAlertModalCallBackLvl3}
          title={this.props.uomPopupCaption}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlertLvl3}
              hideAlertCallBack={this.props.hideAlertCallBackLvl3}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              {isDisableaddOrUpdate && !this.props.is3PL ? null : (
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addorUpdateUom(e, this.props.uomData)}
                  disabled={isDisabledFields}
                >
                  Add/Update
                </Button>
              )}
            </div>
          }
          content={
            <UOMPopup
              is3PL={this.props.is3PL}
              serviceUomOnChange={this.props.serviceUomOnChange}
              disableStackableQty={this.props.disableStackableQty}
              fabricStyleData={this.props.fabricStyleData}
              isDisableUomFields={this.props.isDisableUomFields}
              uomData={this.props.uomData}
              uoms={this.props.uoms}
              uomCaption={this.props.uomCaption}
              isDisabledFields={this.props.isDisabledFields}
              uomPopupPageListForAutoCompleteList={
                this.props.uomPopupPageListForAutoCompleteList
              }
              showAutoCompleteUOMPopupList={
                this.props.showAutoCompleteUOMPopupList
              }
              closeUomPopup={this.closeUomPopup}
              uomPopupEnterKeyEvent={this.uomPopupEnterKeyEvent}
              onPopupUomCodeChange={this.onPopupUomCodeChange}
              displayAutoCompleteUomPopupList={
                this.displayAutoCompleteUomPopupList
              }
              onServiceWeightUomChange={this.props.onServiceWeightUomChange}
              serviceWeightUomEnterKeyEventHandler={
                this.props.serviceWeightUomEnterKeyEventHandler
              }
              displayAutoCompleteServiceWeightUomList={
                this.props.displayAutoCompleteServiceWeightUomList
              }
              showAutoCompleteServiceWeightUomList={
                this.props.showAutoCompleteServiceWeightUomList
              }
              serviceWeightUomPageListForAutoCompleteList={
                this.props.serviceWeightUomPageListForAutoCompleteList
              }
              weightUOMs={this.props.weightUOMs}
              onServiceDimensionUomChange={
                this.props.onServiceDimensionUomChange
              }
              serviceDimensionUomEnterKeyEventHandler={
                this.props.serviceDimensionUomEnterKeyEventHandler
              }
              displayAutoCompleteServiceDimensionUomList={
                this.props.displayAutoCompleteServiceDimensionUomList
              }
              showAutoCompleteServiceDimensionUomList={
                this.props.showAutoCompleteServiceDimensionUomList
              }
              serviceDimensionUomPageListForAutoCompleteList={
                this.props.serviceDimensionUomPageListForAutoCompleteList
              }
              lengthUOMs={this.props.lengthUOMs}
              countUOMs={this.props.countUOMs}
              onPalletDimensionUomChange={this.props.onPalletDimensionUomChange}
              palletDimensionUomEnterKeyEventHandler={
                this.props.palletDimensionUomEnterKeyEventHandler
              }
              displayAutoCompletePalletDimensionUomList={
                this.props.displayAutoCompletePalletDimensionUomList
              }
              showAutoCompletePalletDimensionUomList={
                this.props.showAutoCompletePalletDimensionUomList
              }
              palletDimensionUomPageListForAutoCompleteList={
                this.props.palletDimensionUomPageListForAutoCompleteList
              }
              isDisableaddOrUpdate={isDisableaddOrUpdate}
            />
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.props.isOpenColorPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeColorPopup}
          title={"Color"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowColorAlert}
              hideAlertCallBack={this.props.hideAlertCallBackColor}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addorUpdateColor(e, colorData)}
                disabled={isDisabledFields}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <ColorPopup
              {...this.state}
              is3PL={this.props.is3PL}
              fabricStyleData={this.props.fabricStyleData}
              colorImgUrl={this.props.colorImgUrl}
              colorLookupHandler={this.props.colorLookupHandler}
              colorData={colorData}
              setClrFile={this.props.setClrFile}
              colors={this.props.colors}
              colorCaption={this.props.colorCaption}
              isDisabledFields={this.props.isDisabledFields}
              showAutoCompleteColorPopupList={
                this.props.showAutoCompleteColorPopupList
              }
              colorPopupPageListForAutoCompleteList={
                this.props.colorPopupPageListForAutoCompleteList
              }
              onColorChange={this.onColorChange}
              addorUpdateSellingColor={this.addorUpdateSellingUom}
              uploadColorImage={this.uploadColorImage}
              onPopupColorCodeChange={this.onPopupColorCodeChange}
              displayAutoCompleteColorPopupList={
                this.displayAutoCompleteColorPopupList
              }
              colorPopupEnterKeyEvent={this.colorPopupEnterKeyEvent}
              closeColorPopup={this.closeColorPopup}
              showToast={this.props.showToast}
              setClrUrl={this.props.setClrUrl}
              uploadClrImage={this.props.uploadClrImage}
              deleteClrImage={this.props.deleteClrImage}
              onColorStatusChange={this.onColorStatusChange}
              fabricColorStatusEnterKeyEventHandler={
                this.fabricColorStatusEnterKeyEventHandler
              }
              displayAutoCompletefabricColorStatusList={
                this.displayAutoCompletefabricColorStatusList
              }
              showAutoCompleteColorStausList={
                this.props.showAutoCompleteColorStausList
              }
              fabricColorStatusPageListForAutoCompleteList={
                this.props.fabricColorStatusPageListForAutoCompleteList
              }
            />
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.props.isShowMultipleColorPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertMultipleColorModalCallBack}
          title={"MultipleColors"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowColorAlert}
              hideAlertCallBack={this.hideAlertCallBackColor}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addOrUpdateMultipleColor(e)}
                disabled={isDisabledFields}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <MultiColorPopup
              is3PL={this.props.is3PL}
              fabricStyleData={this.props.fabricStyleData}
              temp_selectedMultipleColorList={
                this.props.temp_selectedMultipleColorList
              }
              multipleColorList={this.props.multipleColorList}
              selectColor={this.selectColor}
              unSelectColor={this.unSelectColor}
            />
          }
        />
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.props.isOpenImagePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={this.props.imagePopupCaption}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                type="submit"
                bssize="large"
                onClick={() => this.addorUpdateImageData(fabricStyleData)}
              >
                Add / Update{" "}
              </Button>
            </div>
          }
          content={
            <ImagePopup
              fabricStyleData={this.props.fabricStyleData}
              imageData={this.props.imageData}
              popupCaption={this.props.imagePopupCaption}
              closeImagePopup={this.closeImagePopup}
              imagePart={this.props.imagePart}
              getFabricStyleImagePath={this.props.getFabricStyleImagePath}
            />
          }
        /> */}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.props.isOpenItemImagePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Item Images"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowImgAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={<div className="floatLeft"></div>}
          content={
            <ImagePopup
              fabricStyleData={this.props.fabricStyleData}
              mainImageUrl={this.props.mainImageUrl}
              webImageUrl={this.props.webImageUrl}
              frontImageUrl={this.props.frontImageUrl}
              backImageUrl={this.props.backImageUrl}
              imagePart={this.props.imagePart}
              uploadImage={this.props.uploadImage}
              deleteFabricImage={this.props.deleteFabricImage}
              getFabricStyleImagePath={this.props.getFabricStyleImagePath}
              setMainUrl={this.props.setMainUrl}
              setWebUrl={this.props.setWebUrl}
              setFrontUrl={this.props.setFrontUrl}
              setBackUrl={this.props.setBackUrl}
              setMainImg={this.props.setMainImg}
              setWebImg={this.props.setWebImg}
              setFrontImg={this.props.setFrontImg}
              setBackImg={this.props.setBackImg}
              fabricStyleImagesList={this.props.fabricStyleImagesList}
              ItemImageData={this.props.ItemImageData}
              showToast={this.props.showToast}
              isDisabledFields={this.props.isDisabledFields}
            />
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.props.isOpenOnHandDetailPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={this.props.onHandQtyCaption}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <OnHandQuantityPopup
              is3PL={this.props.is3PL}
              isDisableOnorderQtyFields={this.props.isDisableOnorderQtyFields}
              fabricStyleData={this.props.fabricStyleData}
              onHandQtyCaption={this.props.onHandQtyCaption}
              batchInventoryDataBean={this.props.skuBatchInventoryDataBean}
              closeOnHandDetailPopup={this.closeOnHandDetailPopup}
              isDisabledFields={this.props.isDisabledFields}
            />
          }
        />
        <form>
          {is3PL ? (
            <div className="header_div col-md-12 col-lg-12">
              <Row>
                <Col sm="1">
                  <FormLabel className="">ShortName</FormLabel>
                </Col>
                <Col sm="5">
                  <InputTextbox
                    ref={this.fabricStyleRef}
                    name="description"
                    type="text"
                    placeholder="Enter ShortName"
                    onChange={this.onChange}
                    value={fabricStyleData.description}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />{" "}
                </Col>
                <Col sm="1">
                  <FormLabel>Customer</FormLabel>
                </Col>

                <Col sm="2">
                  <InputTextbox
                    onChange={this.customerOnChange}
                    name="customerCode"
                    placeholder="Customer"
                    value={fabricStyleData.customerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.customerLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.customerEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.customerPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCustomerCompleteList
                    }
                    showAutoCompleteList={
                      this.props.isShowAutoCompleteCustomerList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>

                <Col sm="3">
                  <InputTextbox
                    name="customerName"
                    type="text"
                    onChange={this.customerOnChange}
                    readOnly={true}
                    value={fabricStyleData.customerName}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Style</FormLabel>{" "}
                </Col>
                <Col sm="1">
                  <InputTextbox
                    onChange={this.onPatternTypeCodeChange}
                    ref={this.productTypeRef}
                    name="productTypeCode"
                    placeholder="Enter Regulated Type"
                    value={fabricStyleData.productTypeCode}
                    lookupRequired={true}
                    lookupHandler={this.state.productTypeLookupHandler}
                    enterKeyEventHandler={this.patternTypeEnterKeyEvent}
                    autoCompleteListData={
                      this.props.patternTypePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompletePatternTypeList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompletePatternTypeList
                    }
                    isMandatory={true}
                    disabled={isDisabledFields}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  <InputTextbox
                    name="productTypeName"
                    type="text"
                    onChange={this.onChange}
                    value={fabricStyleData.productTypeName}
                    readOnly={true}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
                <Col sm="1">
                  <FormLabel>Commodity</FormLabel>
                </Col>
                <Col sm="1">
                  <InputTextbox
                    onChange={this.onTypeCodeChange}
                    ref={this.patternTypeRef}
                    name="patternTypeCode"
                    placeholder="Enter commodity"
                    value={fabricStyleData.patternTypeCode}
                    lookupRequired={true}
                    lookupHandler={this.state.patternTypeLookupHandler}
                    enterKeyEventHandler={this.typeEnterKeyEvent}
                    autoCompleteListData={
                      this.props.typePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteTypeList}
                    showAutoCompleteList={this.props.showAutoCompleteTypeList}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  <InputTextbox
                    name="patternTypeName"
                    type="text"
                    onChange={this.onChange}
                    value={fabricStyleData.patternTypeName}
                    readOnly={true}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
                <Col sm="1">
                  <FormLabel>Content</FormLabel>
                </Col>
                <Col sm="1">
                  <InputTextbox
                    onChange={this.onMakeTypeCodeChange}
                    ref={this.makeTypeRef}
                    name="makeTypeCode"
                    placeholder="Enter ProductType"
                    value={fabricStyleData.makeTypeCode}
                    lookupRequired={true}
                    lookupHandler={this.state.makeTypeLookupHandler}
                    enterKeyEventHandler={this.makeTypeEnterKeyEvent}
                    autoCompleteListData={
                      this.props.makeTypePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteMakeTypeList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteMakeTypeList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  <InputTextbox
                    name="makeTypeName"
                    type="text"
                    onChange={this.onChange}
                    value={fabricStyleData.makeTypeName}
                    readOnly={true}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
                {/* <Col sm="1">
                  <FormLabel>Hierarchy</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onDivisionCodeChange}
                    ref={this.productDivisionRef}
                    name="divisionCode"
                    placeholder="divisionCode"
                    value={fabricStyleData.divisionCode}
                    lookupRequired={true}
                    lookupHandler={this.state.productDivisionLookupHandler}
                    enterKeyEventHandler={this.divisionEnterKeyEvent}
                    autoCompleteListData={
                      this.props.divisionPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteDivisionList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteDivisionCodeList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col> */}
                <Col sm="1">
                  <FormLabel>Type Category</FormLabel>{" "}
                </Col>
                <Col sm="1">
                  <InputTextbox
                    onChange={this.onUseCodeChange}
                    ref={this.patternTypeCategoryRef}
                    name="patternTypeCategoryCode"
                    placeholder="Enter Batch Number"
                    value={fabricStyleData.patternTypeCategoryCode}
                    lookupRequired={true}
                    lookupHandler={this.state.patternTypeCategoryLookupHandler}
                    enterKeyEventHandler={this.useEnterKeyEvent}
                    autoCompleteListData={
                      this.props.usePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteUseList}
                    showAutoCompleteList={
                      this.props.showAutoCompletePatternTypeCategoryCodeList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  <InputTextbox
                    name="patternTypeCategoryName"
                    type="text"
                    onChange={this.onChange}
                    value={fabricStyleData.patternTypeCategoryName}
                    readOnly={true}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>CPM Template</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="cpmTemplateCode"
                    onChange={this.onChange}
                    readOnly={true}
                    value={fabricStyleData.cpmTemplateCode}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>

                {/* <Col sm="1">
                  {" "}
                  <FormLabel>weight</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  {" "}
                  <NumberFormatInputbox
                    name={"weight"}
                    placeholder="Enter weight"
                    value={fabricStyleData.weight}
                    //onBlur={this.onBlur}
                    onChange={this.onChange}
                    className="text-right"
                    decimalScale={2}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>WeightUOM</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onWeightUomChange}
                    ref={this.weightUomRef}
                    name="weightUomCode"
                    placeholder="weightUomCode"
                    value={fabricStyleData.weightUomCode}
                    lookupRequired={true}
                    lookupHandler={this.state.weightUOMLookupHandler}
                    enterKeyEventHandler={this.weightUomEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.weightUomPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteWeightUomList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteWeightUomList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col> */}
                <Col sm="1">
                  {" "}
                  <FormLabel>Inventory UOM</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onUOMCodeChange}
                    ref={this.inventoryUomCodeRef}
                    name="inventoryUomCode"
                    placeholder="inventoryUomCode"
                    value={fabricStyleData.inventoryUomCode}
                    lookupRequired={true}
                    lookupHandler={this.state.countUOMLookupHandler}
                    enterKeyEventHandler={this.uomEnterKeyEvent}
                    autoCompleteListData={
                      this.props.uomPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteUomList}
                    showAutoCompleteList={this.props.showAutoCompleteUOMList}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Customer User</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.props.userOnChange}
                    name="customerUserCode"
                    placeholder="customerUserCode"
                    value={fabricStyleData.customerUserCode}
                    lookupRequired={this.props.isShowUserLookup}
                    lookupHandler={this.props.userLookupHandler}
                    enterKeyEventHandler={this.props.userEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.userPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.props.displayAutoCompleteUserList
                    }
                    showAutoCompleteList={this.props.isShowAutoCompleteUserList}
                    disabled={!this.props.isShowUserLookup}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  <FormLabel>Currency</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onCurrencyCodeChange}
                    ref={this.currencyCodeRef}
                    name="currencyCode"
                    placeholder="currencyCode"
                    value={fabricStyleData.currencyCode}
                    lookupRequired={true}
                    lookupHandler={this.state.currencyLookupHandler}
                    enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
                    autoCompleteListData={
                      this.props.currencyCodePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteCurrencyList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteCurrencyCodeList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
              </Row>
              <Row>
                {/* <Col className="align-items-left" sm="1">
                  <FormLabel>Currency</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onCurrencyCodeChange}
                    ref={this.currencyCodeRef}
                    name="currencyCode"
                    placeholder="currencyCode"
                    value={fabricStyleData.currencyCode}
                    lookupRequired={true}
                    lookupHandler={this.state.currencyLookupHandler}
                    enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
                    autoCompleteListData={
                      this.props.currencyCodePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteCurrencyList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteCurrencyCodeList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col> */}
                {/* <Col sm="1">
                  {" "}
                  <FormLabel>WebRetailPrice</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  {" "}
                  <NumberFormatInputbox
                    name={"webRetailPrice"}
                    placeholder="Enter webRetailPrice"
                    value={fabricStyleData.webRetailPrice}
                    onChange={this.onChange}
                    className="text-right"
                    decimalScale={2}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col> */}
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Location</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onLocationChange}
                    ref={this.warehouseRef}
                    name="defaultLocationCode"
                    placeholder="locationCode"
                    value={fabricStyleData.defaultLocationCode}
                    lookupRequired={true}
                    lookupHandler={this.state.warehouseLookupHandler}
                    enterKeyEventHandler={this.locationEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.locationPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteLocationList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteLocationList
                    }
                    disabled={isDisabledFields}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>HTS</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onHtsChange}
                    ref={this.htsRef}
                    name="hts"
                    placeholder="hts"
                    value={fabricStyleData.hts}
                    lookupRequired={true}
                    lookupHandler={this.state.htsLookupHandler}
                    enterKeyEventHandler={this.htsEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.htsPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteHtsList}
                    showAutoCompleteList={this.props.showAutoCompleteHtsList}
                    disabled={isDisabledFields}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Status</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onStatsChange}
                    ref={this.productStatusRef}
                    name="stats"
                    placeholder="status"
                    value={fabricStyleData.stats}
                    lookupRequired={true}
                    lookupHandler={this.state.productStatusLookupHandler}
                    enterKeyEventHandler={this.statsEnterKeyEvent}
                    autoCompleteListData={
                      this.props.statsPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteStatsList}
                    showAutoCompleteList={this.props.showAutoCompleteStatsList}
                    disabled={isDisabledFields}
                  ></InputTextbox>
                </Col>

                <Col className="align-items-left" sm="1">
                  <FormLabel>C.R.No</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="copyrightNumber"
                    onChange={this.onChange}
                    value={fabricStyleData.copyrightNumber}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
              </Row>
              <Row>
                {/* <Col sm="1">
                  {" "}
                  <FormLabel>Status</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onStatsChange}
                    ref={this.productStatusRef}
                    name="stats"
                    placeholder="status"
                    value={fabricStyleData.stats}
                    lookupRequired={true}
                    lookupHandler={this.state.productStatusLookupHandler}
                    enterKeyEventHandler={this.statsEnterKeyEvent}
                    autoCompleteListData={
                      this.props.statsPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteStatsList}
                    showAutoCompleteList={this.props.showAutoCompleteStatsList}
                    disabled={isDisabledFields}
                  ></InputTextbox>
                </Col>

                <Col className="align-items-left" sm="1">
                  <FormLabel>C.R.No</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="copyrightNumber"
                    onChange={this.onChange}
                    value={fabricStyleData.copyrightNumber}
                    disabled={isDisabledFields}
                  />{" "}
                </Col> */}
                <Col className="align-items-left" sm="1">
                  <FormLabel>AvailableFrom</FormLabel>
                </Col>
                <Col sm="2">
                  <DatePickerComponent
                    name="availableFromDate"
                    value={fabricStyleData.availableFromDate}
                    onChange={this.onChange}
                    disabled={isDisabledFields}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Available UpTo</FormLabel>
                </Col>
                <Col sm="2">
                  <DatePickerComponent
                    name="availableToDate"
                    value={fabricStyleData.availableToDate}
                    onChange={this.onChange}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
              {/* <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Date Of Manufacturing</FormLabel>
                </Col>
                <Col sm="2">
                  <DatePickerComponent
                    name="dateOfManufacturing"
                    value={fabricStyleData.dateOfManufacturing}
                    onChange={this.onChange}
                    disabled={isDisabledFields}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Date Of Expiration</FormLabel>
                </Col>
                <Col sm="2">
                  <DatePickerComponent
                    name="dateOfExpiration"
                    value={fabricStyleData.dateOfExpiration}
                    onChange={this.onChange}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row> */}
              <Row>
                <Col sm="1">
                  <div>
                    <FormLabel>Active</FormLabel>
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <InputCheckbox
                      name="isActive"
                      type="checkbox"
                      checked={fabricStyleData.isActive}
                      onChange={this.onChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <FormLabel>SalesTax</FormLabel>
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <InputCheckbox
                      name="salesTaxRequiredFlag"
                      type="checkbox"
                      checked={fabricStyleData.salesTaxRequiredFlag}
                      onChange={this.onChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col>
                {/* <Col sm="1">
                  <div>
                    <FormLabel>Tariff</FormLabel>
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <InputCheckbox
                      name="tariffFlag"
                      type="checkbox"
                      checked={fabricStyleData.tariffFlag}
                      onChange={this.onChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col> */}
                <Col sm="1">
                  <div>
                    <FormLabel>WebSales</FormLabel>
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <InputCheckbox
                      name="webSalesFlag"
                      type="checkbox"
                      checked={fabricStyleData.webSalesFlag}
                      onChange={this.onChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <FormLabel>SampleItem</FormLabel>
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <InputCheckbox
                      name="sampleItemFlag"
                      type="checkbox"
                      checked={fabricStyleData.sampleItemFlag}
                      onChange={this.onChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <Button
                    className="hyperLinkText"
                    variant="secondry"
                    onClick={(e) => this.props.openTestImagePopup(e)}
                  >
                    {" "}
                    Images{" "}
                  </Button>
                </Col>
                {/* <Col sm="4">
                <div>
                  <img
                    src={`${this.props.getFabricStyleImagePath(
                      "Main",
                      fabricStyleData
                    )}&a=${new Date().getTime()}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImage;
                    }}
                    alt="Click to Add"
                    width={100}
                    height={100}
                    mode="fit"
                    onClick={() => this.imageClick(fabricStyleData, "Main")}
                  />{" "}
                  <img
                    src={`${this.props.getFabricStyleImagePath(
                      "Web",
                      fabricStyleData
                    )}&a=${new Date().getTime()}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImage;
                    }}
                    width={100}
                    height={100}
                    mode="fit"
                    onClick={() => this.imageClick(fabricStyleData, "Web")}
                  />
                  <img
                    src={`${this.props.getFabricStyleImagePath(
                      "Front",
                      fabricStyleData
                    )}&a=${new Date().getTime()}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImage;
                    }}
                    width={100}
                    height={100}
                    mode="fit"
                    onClick={() => this.imageClick(fabricStyleData, "Front")}
                  />
                  <img
                    src={`${this.props.getFabricStyleImagePath(
                      "Back",
                      fabricStyleData
                    )}&a=${new Date().getTime()}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImage;
                    }}
                    width={100}
                    height={100}
                    mode="fit"
                    onClick={() => this.imageClick(fabricStyleData, "Back")}
                  />
                </div>
              </Col> */}
                <Col sm="4">
                  <ItemImages
                    fabricStyleData={this.props.fabricStyleData}
                    mainImageUrl={this.props.mainImageUrl}
                    webImageUrl={this.props.webImageUrl}
                    frontImageUrl={this.props.frontImageUrl}
                    backImageUrl={this.props.backImageUrl}
                    openItemImage={this.props.openItemImage}
                  />
                </Col>
                {/* <Col sm="1"></Col> */}
                <Col sm="1">
                  <FormLabel>Notes</FormLabel>
                </Col>
                <Col sm="2">
                  <textarea
                    style={textAreaStyle_3pl}
                    className="form-control"
                    name="notes"
                    type="text"
                    placeholder="notes"
                    onChange={this.onChange}
                    value={fabricStyleData.notes}
                    disabled={isDisabledFields}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>full Description</FormLabel>
                </Col>
                <Col sm="2">
                  <textarea
                    style={textAreaStyle_1}
                    className="form-control"
                    name="fullDescription"
                    type="text"
                    placeholder="fullDescription"
                    onChange={this.onChange}
                    value={fabricStyleData.fullDescription}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
            </div>
          ) : (
            <>
              {this.props.isStandard ? (
                <div className="header_div col-md-12 col-lg-12">
                  <Row>
                    <Col sm="1">
                      <FormLabel>Description</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        ref={this.fabricStyleRef}
                        name="description"
                        type="text"
                        placeholder="Enter ShortName"
                        onChange={this.onChange}
                        value={fabricStyleData.description}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />{" "}
                    </Col>

                    <Col sm="1">
                      <FormLabel>Product Division</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onDivisionCodeChange}
                        ref={this.productDivisionRef}
                        name="divisionCode"
                        placeholder="divisionCode"
                        value={fabricStyleData.divisionCode}
                        lookupRequired={true}
                        lookupHandler={this.state.productDivisionLookupHandler}
                        enterKeyEventHandler={this.divisionEnterKeyEvent}
                        autoCompleteListData={
                          this.props.divisionPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteDivisionList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteDivisionCodeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>AvailableFrom</FormLabel>
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent
                        name="availableFromDate"
                        value={fabricStyleData.availableFromDate}
                        onChange={this.onChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Available To</FormLabel>
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent
                        name="availableToDate"
                        value={fabricStyleData.availableToDate}
                        onChange={this.onChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Style</FormLabel>{" "}
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        onChange={this.onPatternTypeCodeChange}
                        ref={this.productTypeRef}
                        name="productTypeCode"
                        // placeholder="Enter Pattern Type"
                        value={fabricStyleData.productTypeCode}
                        lookupRequired={true}
                        lookupHandler={this.state.productTypeLookupHandler}
                        enterKeyEventHandler={this.patternTypeEnterKeyEvent}
                        autoCompleteListData={
                          this.props.patternTypePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompletePatternTypeList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompletePatternTypeList
                        }
                        // disabled={false}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="productTypeName"
                        type="text"
                        onChange={this.onChange}
                        value={fabricStyleData.productTypeName}
                        readOnly={true}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>

                    <Col sm="1">
                      <FormLabel>Content</FormLabel>{" "}
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        onChange={this.onMakeTypeCodeChange}
                        ref={this.makeTypeRef}
                        name="makeTypeCode"
                        //  placeholder="Enter ProductType"
                        value={fabricStyleData.makeTypeCode}
                        lookupRequired={true}
                        lookupHandler={this.state.makeTypeLookupHandler}
                        enterKeyEventHandler={this.makeTypeEnterKeyEvent}
                        autoCompleteListData={
                          this.props.makeTypePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteMakeTypeList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteMakeTypeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="makeTypeName"
                        type="text"
                        onChange={this.onChange}
                        value={fabricStyleData.makeTypeName}
                        readOnly={true}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>

                    <Col sm="1">
                      <FormLabel>Type Category</FormLabel>{" "}
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        onChange={this.onUseCodeChange}
                        ref={this.patternTypeCategoryRef}
                        name="patternTypeCategoryCode"
                        placeholder="Enter Use"
                        value={fabricStyleData.patternTypeCategoryCode}
                        lookupRequired={true}
                        lookupHandler={
                          this.state.patternTypeCategoryLookupHandler
                        }
                        enterKeyEventHandler={this.useEnterKeyEvent}
                        autoCompleteListData={
                          this.props.usePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteUseList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompletePatternTypeCategoryCodeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={false}
                      ></InputTextbox>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="patternTypeCategoryName"
                        type="text"
                        onChange={this.onChange}
                        value={fabricStyleData.patternTypeCategoryName}
                        readOnly={true}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Width</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="width"
                        type="text"
                        placeholder="Enter width"
                        onChange={this.onChange}
                        value={fabricStyleData.width}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Width UOM</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onWidthUOMCodeChange}
                        ref={this.widthUomRef}
                        name="widthUomCode"
                        placeholder="widthUomCode"
                        value={fabricStyleData.widthUomCode}
                        lookupRequired={true}
                        lookupHandler={this.state.lengthUOMLookupHandler}
                        enterKeyEventHandler={this.widthUomEnterKeyEvent}
                        autoCompleteListData={
                          this.props.widthUomPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteWidthUomList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteWidthUOMList
                        }
                        disabled={isDisabledFields}
                        isMandatory={false}
                      ></InputTextbox>
                    </Col>

                    <Col sm="1">
                      {" "}
                      <FormLabel>weight</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"weight"}
                        placeholder="Enter weight"
                        value={fabricStyleData.weight}
                        //onBlur={this.onBlur}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                        isMandatory={false}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>WeightUOM</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onWeightUomChange}
                        ref={this.weightUomRef}
                        name="weightUomCode"
                        placeholder="weightUomCode"
                        value={fabricStyleData.weightUomCode}
                        lookupRequired={true}
                        lookupHandler={this.state.weightUOMLookupHandler}
                        enterKeyEventHandler={
                          this.weightUomEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.props.weightUomPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteWeightUomList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteWeightUomList
                        }
                        disabled={isDisabledFields}
                        isMandatory={false}
                      ></InputTextbox>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Currency</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onCurrencyCodeChange}
                        ref={this.currencyCodeRef}
                        name="currencyCode"
                        placeholder="currencyCode"
                        value={fabricStyleData.currencyCode}
                        lookupRequired={true}
                        lookupHandler={this.state.currencyLookupHandler}
                        enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
                        autoCompleteListData={
                          this.props.currencyCodePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteCurrencyList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteCurrencyCodeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>WholeSalePrice</FormLabel>{" "}
                    </Col>

                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"wholesalePrice"}
                        placeholder="Enter WholeSalePrice"
                        value={fabricStyleData.wholesalePrice}
                        //onBlur={this.onBlur}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>

                    <Col sm="1">
                      <div>
                        {" "}
                        <FormLabel>Close Out</FormLabel>
                      </div>
                    </Col>
                    <Col sm="2">
                      <div>
                        <InputCheckbox
                          name="closeOutFlag"
                          type="checkbox"
                          checked={fabricStyleData.closeOutFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>

                    <Col sm="1">
                      {" "}
                      <FormLabel>CloseOutPrice</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"closeOutPrice"}
                        placeholder="Enter closeOutPrice"
                        value={fabricStyleData.closeOutPrice}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={this.props.disableCloseOutPrice}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>SamplePrice</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"samplePrice"}
                        placeholder="Enter samplePrice"
                        value={fabricStyleData.samplePrice}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Season</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onSeasonChange}
                        ref={this.seasonCodeRef}
                        name="seasonCode"
                        placeholder="seasonCode"
                        value={fabricStyleData.seasonCode}
                        lookupRequired={true}
                        lookupHandler={this.state.seasonLookupHandler}
                        enterKeyEventHandler={this.seasonEnterKeyEventHandler}
                        autoCompleteListData={
                          this.props.seasonPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteSeasonList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteSeasonList
                        }
                        disabled={isDisabledFields}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Location</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onLocationChange}
                        ref={this.warehouseRef}
                        name="defaultLocationCode"
                        placeholder="locationCode"
                        value={fabricStyleData.defaultLocationCode}
                        lookupRequired={true}
                        lookupHandler={this.state.warehouseLookupHandler}
                        enterKeyEventHandler={this.locationEnterKeyEventHandler}
                        autoCompleteListData={
                          this.props.locationPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteLocationList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteLocationList
                        }
                        disabled={isDisabledFields}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>HTS</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onHtsChange}
                        ref={this.htsRef}
                        name="hts"
                        placeholder="hts"
                        value={fabricStyleData.hts}
                        lookupRequired={true}
                        lookupHandler={this.state.htsLookupHandler}
                        enterKeyEventHandler={this.htsEnterKeyEventHandler}
                        autoCompleteListData={
                          this.props.htsPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteHtsList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteHtsList
                        }
                        disabled={isDisabledFields}
                      ></InputTextbox>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>UOM</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onUOMCodeChange}
                        ref={this.inventoryUomCodeRef}
                        name="inventoryUomCode"
                        placeholder="inventoryUomCode"
                        value={fabricStyleData.inventoryUomCode}
                        lookupRequired={true}
                        lookupHandler={this.state.countUOMLookupHandler}
                        enterKeyEventHandler={this.uomEnterKeyEvent}
                        autoCompleteListData={
                          this.props.uomPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteUomList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteUOMList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      <div>
                        {/* <FormLabel>Active</FormLabel> */}
                        <FormLabel>FabricStatus</FormLabel>
                      </div>
                    </Col>
                    <Col sm="2">
                      <div>
                        <InputTextbox
                          onChange={this.onFabricStatusChange}
                          name="fabricStatus"
                          placeholder="fabricStatus"
                          value={fabricStyleData.fabricStatus}
                          lookupRequired={true}
                          lookupHandler={this.state.fabricStatusLookupHandler}
                          enterKeyEventHandler={
                            this.fabricStatusEnterKeyEventHandler
                          }
                          autoCompleteListData={
                            this.props.fabricStatusPageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCompletefabricStatusList
                          }
                          showAutoCompleteList={
                            this.props.showAutoCompleteFabricStausList
                          }
                          // disabled={disablePurchaseOrderFormFields}
                          isMandatory={true}
                        />

                        {/* <InputCheckbox
                          name="isActive"
                          type="checkbox"
                          checked={fabricStyleData.isActive}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        /> */}
                      </div>
                    </Col>

                    <Col sm="1">
                      <div>
                        <FormLabel>Tariff</FormLabel>
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <InputCheckbox
                          name="tariffFlag"
                          type="checkbox"
                          checked={fabricStyleData.tariffFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <FormLabel>WebSales</FormLabel>
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <InputCheckbox
                          name="webSalesFlag"
                          type="checkbox"
                          checked={fabricStyleData.webSalesFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <FormLabel>SampleItem</FormLabel>
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <InputCheckbox
                          name="sampleItemFlag"
                          type="checkbox"
                          checked={fabricStyleData.sampleItemFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <Button
                        className="hyperLinkText"
                        variant="secondry"
                        onClick={(e) => this.props.openTestImagePopup(e)}
                      >
                        {" "}
                        Images{" "}
                      </Button>
                    </Col>
                    <Col sm="4">
                      <ItemImages
                        fabricStyleData={this.props.fabricStyleData}
                        mainImageUrl={this.props.mainImageUrl}
                        webImageUrl={this.props.webImageUrl}
                        frontImageUrl={this.props.frontImageUrl}
                        backImageUrl={this.props.backImageUrl}
                        openItemImage={this.props.openItemImage}
                      />
                    </Col>
                    <Col sm="1"></Col>
                    <Col sm="1">
                      <FormLabel>Notes</FormLabel>
                    </Col>
                    <Col sm="2">
                      <textarea
                        style={textAreaStyle}
                        className="form-control"
                        name="notes"
                        type="text"
                        placeholder="notes"
                        onChange={this.onChange}
                        value={fabricStyleData.notes}
                        disabled={isDisabledFields}
                      />
                    </Col>
                  </Row>
                </div>
              ) : (
                <div className="header_div col-md-12 col-lg-12">
                  <Row>
                    <Col sm="1">
                      <FormLabel>ShortName</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        ref={this.fabricStyleRef}
                        name="description"
                        type="text"
                        placeholder="Enter ShortName"
                        onChange={this.onChange}
                        value={fabricStyleData.description}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Style</FormLabel>{" "}
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        onChange={this.onPatternTypeCodeChange}
                        ref={this.productTypeRef}
                        name="productTypeCode"
                        // placeholder="Enter Pattern Type"
                        value={fabricStyleData.productTypeCode}
                        lookupRequired={true}
                        lookupHandler={this.state.productTypeLookupHandler}
                        enterKeyEventHandler={this.patternTypeEnterKeyEvent}
                        autoCompleteListData={
                          this.props.patternTypePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompletePatternTypeList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompletePatternTypeList
                        }
                        // disabled={false}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        name="productTypeName"
                        type="text"
                        onChange={this.onChange}
                        value={fabricStyleData.productTypeName}
                        readOnly={true}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>

                    <Col sm="1">
                      <FormLabel>Style Type </FormLabel>{" "}
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        onChange={this.onTypeCodeChange}
                        ref={this.patternTypeRef}
                        name="patternTypeCode"
                        // placeholder="Enter Type"
                        value={fabricStyleData.patternTypeCode}
                        lookupRequired={true}
                        lookupHandler={this.state.patternTypeLookupHandler}
                        enterKeyEventHandler={this.typeEnterKeyEvent}
                        autoCompleteListData={
                          this.props.typePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteTypeList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteTypeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>

                    <Col sm="1">
                      <InputTextbox
                        name="patternTypeName"
                        type="text"
                        onChange={this.onChange}
                        value={fabricStyleData.patternTypeName}
                        readOnly={true}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>

                    <Col sm="1">
                      <FormLabel>Content</FormLabel>{" "}
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        onChange={this.onMakeTypeCodeChange}
                        ref={this.makeTypeRef}
                        name="makeTypeCode"
                        //  placeholder="Enter ProductType"
                        value={fabricStyleData.makeTypeCode}
                        lookupRequired={true}
                        lookupHandler={this.state.makeTypeLookupHandler}
                        enterKeyEventHandler={this.makeTypeEnterKeyEvent}
                        autoCompleteListData={
                          this.props.makeTypePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteMakeTypeList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteMakeTypeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        name="makeTypeName"
                        type="text"
                        onChange={this.onChange}
                        value={fabricStyleData.makeTypeName}
                        readOnly={true}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>

                    <Col sm="1">
                      <FormLabel>Product Division</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onDivisionCodeChange}
                        ref={this.productDivisionRef}
                        name="divisionCode"
                        placeholder="divisionCode"
                        value={fabricStyleData.divisionCode}
                        lookupRequired={true}
                        lookupHandler={this.state.productDivisionLookupHandler}
                        enterKeyEventHandler={this.divisionEnterKeyEvent}
                        autoCompleteListData={
                          this.props.divisionPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteDivisionList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteDivisionCodeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Type Category</FormLabel>{" "}
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        onChange={this.onUseCodeChange}
                        ref={this.patternTypeCategoryRef}
                        name="patternTypeCategoryCode"
                        placeholder="Enter Use"
                        value={fabricStyleData.patternTypeCategoryCode}
                        lookupRequired={true}
                        lookupHandler={
                          this.state.patternTypeCategoryLookupHandler
                        }
                        enterKeyEventHandler={this.useEnterKeyEvent}
                        autoCompleteListData={
                          this.props.usePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteUseList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompletePatternTypeCategoryCodeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        name="patternTypeCategoryName"
                        type="text"
                        onChange={this.onChange}
                        value={fabricStyleData.patternTypeCategoryName}
                        readOnly={true}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>StyleItemType</FormLabel>{" "}
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        onChange={this.onStyleItemTypeChange}
                        ref={this.styleItemTypeRef}
                        name="styleItemType"
                        placeholder="Enter Style"
                        value={fabricStyleData.styleItemType}
                        lookupRequired={true}
                        lookupHandler={this.state.styleItemTypeLookupHandler}
                        enterKeyEventHandler={this.styleItemTypeEnterKeyEvent}
                        autoCompleteListData={
                          this.props.styleItemTypePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteStyleItemTypeList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteStyleItemTypeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      <InputTextbox
                        name="styleItemTypeName"
                        type="text"
                        onChange={this.onChange}
                        value={fabricStyleData.styleItemTypeName}
                        readOnly={true}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>
                    <Col sm="1">
                      <FormLabel>Tariff</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        name={"tariffPercentage"}
                        placeholder="Enter tariffPercentage"
                        value={fabricStyleData.tariffPercentage}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>DutyCharge</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        name={"dutyCharge"}
                        placeholder="Enter dutyCharge"
                        value={fabricStyleData.dutyCharge}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Status</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onStatsChange}
                        ref={this.productStatusRef}
                        name="stats"
                        placeholder="status"
                        value={fabricStyleData.stats}
                        lookupRequired={true}
                        lookupHandler={this.state.productStatusLookupHandler}
                        enterKeyEventHandler={this.statsEnterKeyEvent}
                        autoCompleteListData={
                          this.props.statsPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteStatsList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteStatsList
                        }
                        disabled={isDisabledFields}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>UOM</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onUOMCodeChange}
                        ref={this.inventoryUomCodeRef}
                        name="inventoryUomCode"
                        placeholder="inventoryUomCode"
                        value={fabricStyleData.inventoryUomCode}
                        lookupRequired={true}
                        lookupHandler={this.state.countUOMLookupHandler}
                        enterKeyEventHandler={this.uomEnterKeyEvent}
                        autoCompleteListData={
                          this.props.uomPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteUomList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteUOMList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>C.R.No</FormLabel>{" "}
                    </Col>

                    <Col sm="2">
                      <InputTextbox
                        name="copyrightNumber"
                        onChange={this.onChange}
                        value={fabricStyleData.copyrightNumber}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>AvailableFrom</FormLabel>
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent
                        name="availableFromDate"
                        value={fabricStyleData.availableFromDate}
                        onChange={this.onChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Available To</FormLabel>
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent
                        name="availableToDate"
                        value={fabricStyleData.availableToDate}
                        onChange={this.onChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Width</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="width"
                        type="text"
                        placeholder="Enter width"
                        onChange={this.onChange}
                        value={fabricStyleData.width}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Width UOM</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onWidthUOMCodeChange}
                        ref={this.widthUomRef}
                        name="widthUomCode"
                        placeholder="widthUomCode"
                        value={fabricStyleData.widthUomCode}
                        lookupRequired={true}
                        lookupHandler={this.state.lengthUOMLookupHandler}
                        enterKeyEventHandler={this.widthUomEnterKeyEvent}
                        autoCompleteListData={
                          this.props.widthUomPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteWidthUomList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteWidthUOMList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>weight</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"weight"}
                        placeholder="Enter weight"
                        value={fabricStyleData.weight}
                        //onBlur={this.onBlur}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>WeightUOM</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onWeightUomChange}
                        ref={this.weightUomRef}
                        name="weightUomCode"
                        placeholder="weightUomCode"
                        value={fabricStyleData.weightUomCode}
                        lookupRequired={true}
                        lookupHandler={this.state.weightUOMLookupHandler}
                        enterKeyEventHandler={
                          this.weightUomEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.props.weightUomPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteWeightUomList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteWeightUomList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>Currency</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onCurrencyCodeChange}
                        ref={this.currencyCodeRef}
                        name="currencyCode"
                        placeholder="currencyCode"
                        value={fabricStyleData.currencyCode}
                        lookupRequired={true}
                        lookupHandler={this.state.currencyLookupHandler}
                        enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
                        autoCompleteListData={
                          this.props.currencyCodePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteCurrencyList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteCurrencyCodeList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>WholeSalePrice</FormLabel>{" "}
                    </Col>

                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"wholesalePrice"}
                        placeholder="Enter WholeSalePrice"
                        value={fabricStyleData.wholesalePrice}
                        //onBlur={this.onBlur}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Retail Price</FormLabel>{" "}
                    </Col>

                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"retailPrice"}
                        placeholder="Enter retailPrice"
                        value={fabricStyleData.retailPrice}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>

                    <Col sm="1">
                      {" "}
                      <FormLabel>WebRetailPrice</FormLabel>{" "}
                    </Col>

                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"webRetailPrice"}
                        placeholder="Enter webRetailPrice"
                        value={fabricStyleData.webRetailPrice}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>

                    <Col sm="1">
                      <div>
                        {" "}
                        <FormLabel>Close Out</FormLabel>
                      </div>
                    </Col>

                    <Col sm="2">
                      <div>
                        <InputCheckbox
                          name="closeOutFlag"
                          type="checkbox"
                          checked={fabricStyleData.closeOutFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>
                    {/* ) : null} */}
                    <Col sm="1">
                      {" "}
                      <FormLabel>CloseOutPrice</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"closeOutPrice"}
                        placeholder="Enter closeOutPrice"
                        value={fabricStyleData.closeOutPrice}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={this.props.disableCloseOutPrice}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>SamplePrice</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      {" "}
                      <NumberFormatInputbox
                        name={"samplePrice"}
                        placeholder="Enter samplePrice"
                        value={fabricStyleData.samplePrice}
                        onChange={this.onChange}
                        className="text-right"
                        decimalScale={2}
                        disabled={isDisabledFields}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Season</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onSeasonChange}
                        ref={this.seasonCodeRef}
                        name="seasonCode"
                        placeholder="seasonCode"
                        value={fabricStyleData.seasonCode}
                        lookupRequired={true}
                        lookupHandler={this.state.seasonLookupHandler}
                        enterKeyEventHandler={this.seasonEnterKeyEventHandler}
                        autoCompleteListData={
                          this.props.seasonPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteSeasonList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteSeasonList
                        }
                        disabled={isDisabledFields}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Location</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onLocationChange}
                        ref={this.warehouseRef}
                        name="defaultLocationCode"
                        placeholder="locationCode"
                        value={fabricStyleData.defaultLocationCode}
                        lookupRequired={true}
                        lookupHandler={this.state.warehouseLookupHandler}
                        enterKeyEventHandler={this.locationEnterKeyEventHandler}
                        autoCompleteListData={
                          this.props.locationPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteLocationList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteLocationList
                        }
                        disabled={isDisabledFields}
                      ></InputTextbox>
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>HTS</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onHtsChange}
                        ref={this.htsRef}
                        name="hts"
                        placeholder="hts"
                        value={fabricStyleData.hts}
                        lookupRequired={true}
                        lookupHandler={this.state.htsLookupHandler}
                        enterKeyEventHandler={this.htsEnterKeyEventHandler}
                        autoCompleteListData={
                          this.props.htsPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteHtsList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteHtsList
                        }
                        disabled={isDisabledFields}
                      ></InputTextbox>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <div>
                        <FormLabel>FabricStatus</FormLabel>
                        {/* {this.props.isStandard ? (

                          <FormLabel>FabricStatus</FormLabel>
                        ) : <FormLabel>Active</FormLabel>} */}
                      </div>
                    </Col>
                    <Col sm="2">
                      <div>
                        <InputTextbox
                          onChange={this.onFabricStatusChange}
                          name="fabricStatus"
                          placeholder="fabricStatus"
                          value={fabricStyleData.fabricStatus}
                          lookupRequired={true}
                          lookupHandler={this.state.fabricStatusLookupHandler}
                          enterKeyEventHandler={
                            this.fabricStatusEnterKeyEventHandler
                          }
                          autoCompleteListData={
                            this.props.fabricStatusPageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCompletefabricStatusList
                          }
                          showAutoCompleteList={
                            this.props.showAutoCompleteFabricStausList
                          }
                          // disabled={disablePurchaseOrderFormFields}
                          isMandatory={true}
                        />

                        {/* <InputCheckbox
                          name="isActive"
                          type="checkbox"
                          checked={fabricStyleData.isActive}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        /> */}
                        {/* {this.props.isStandard ? (


                          <InputTextbox
                            onChange={this.onFabricStatusChange}
                            name="fabricStatus"
                            placeholder="fabricStatus"
                            value={fabricStyleData.fabricStatus}
                            lookupRequired={true}
                            lookupHandler={this.state.fabricStatusLookupHandler}
                            enterKeyEventHandler={this.fabricStatusEnterKeyEventHandler}
                            autoCompleteListData={
                              this.props.fabricStatusPageListForAutoCompleteList
                            }
                            enableAutoCompleteTextBox={true}
                            displayAutoCompleteList={
                              this.displayAutoCompletefabricStatusList
                            }
                            showAutoCompleteList={
                              this.props.showAutoCompleteFabricStausList
                            }
                            // disabled={disablePurchaseOrderFormFields}
                            isMandatory={true}
                          />

                        ) :
                          <InputCheckbox
                            name="isActive"
                            type="checkbox"
                            checked={fabricStyleData.isActive}
                            onChange={this.onChange}
                            disabled={isDisabledFields}
                          />
                        } */}
                      </div>
                    </Col>

                    <Col sm="1">
                      <div>
                        <FormLabel>SalesTax</FormLabel>
                      </div>
                    </Col>

                    <Col sm="1">
                      <div>
                        <InputCheckbox
                          name="salesTaxRequiredFlag"
                          type="checkbox"
                          checked={fabricStyleData.salesTaxRequiredFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>

                    <Col sm="1">
                      <div>
                        <FormLabel>Tariff</FormLabel>
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <InputCheckbox
                          name="tariffFlag"
                          type="checkbox"
                          checked={fabricStyleData.tariffFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <FormLabel>WebSales</FormLabel>
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <InputCheckbox
                          name="webSalesFlag"
                          type="checkbox"
                          checked={fabricStyleData.webSalesFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <FormLabel>SampleItem</FormLabel>
                      </div>
                    </Col>
                    <Col sm="1">
                      <div>
                        <InputCheckbox
                          name="sampleItemFlag"
                          type="checkbox"
                          checked={fabricStyleData.sampleItemFlag}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <Button
                        className="hyperLinkText"
                        variant="secondry"
                        onClick={(e) => this.props.openTestImagePopup(e)}
                      >
                        {" "}
                        Images{" "}
                      </Button>
                    </Col>
                    <Col sm="4">
                      <ItemImages
                        fabricStyleData={this.props.fabricStyleData}
                        mainImageUrl={this.props.mainImageUrl}
                        webImageUrl={this.props.webImageUrl}
                        frontImageUrl={this.props.frontImageUrl}
                        backImageUrl={this.props.backImageUrl}
                        openItemImage={this.props.openItemImage}
                      />
                    </Col>
                    <Col sm="1"></Col>
                    <Col sm="1">
                      <FormLabel>Notes</FormLabel>
                    </Col>
                    <Col sm="2">
                      <textarea
                        style={textAreaStyle}
                        className="form-control"
                        name="notes"
                        type="text"
                        placeholder="notes"
                        onChange={this.onChange}
                        value={fabricStyleData.notes}
                        disabled={isDisabledFields}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}

          <div className="center_div col-md-12 col-lg-12 text-center">
            <Row>
              <div className="div_Column_1">
                {!is3PL ? (
                  <>
                    <div>
                      <FormLabel className="table_title">
                        {" "}
                        Buying UOM{" "}
                      </FormLabel>
                      <Button
                        id="fabric_Add_Button"
                        onClick={(e) => this.openNewBuyingUomPopup(e)}
                        className="enterFocus"
                      >
                        Add
                      </Button>
                    </div>
                    <div className="table_small">
                      <Table id="fabrics_tables">
                        <thead>
                          <tr>
                            <th>UOM</th>
                            <th>InvUOM</th>
                            <th>ConvRate</th>
                            <th>Cost</th>
                            <th> </th>
                          </tr>
                        </thead>
                        <tbody>
                          {buyingUoms.map(
                            (buy, index) =>
                              buy.isDeleted != true && (
                                <tr key={index}>
                                  <td>
                                    <Button
                                      size="sm"
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.editBuyingUom(e, buy)
                                      }
                                    >
                                      {buy.uomCode}
                                    </Button>
                                  </td>
                                  <td>{buy.fabricStyleInventoryUOMCode}</td>
                                  <td className="text-right">
                                    {buy.conversionRate}
                                  </td>
                                  <td className="text-right">{buy.cost}</td>
                                  {buy.uomCode !=
                                    fabricStyleData.inventoryUomCode && (
                                    <td>
                                      <Button
                                        id="fabric_Add_Button"
                                        className="hyperLinkText"
                                        // disabled={this.isDisableRemoveUomButton(
                                        //   buy
                                        // )}
                                        disabled={this.props.isViewMode}
                                        onClick={(e) =>
                                          this.deleteBuyingUom(e, buy)
                                        }
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </td>
                                  )}
                                </tr>
                              ),
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </>
                ) : null}

                <div>
                  {!is3PL ? (
                    <FormLabel className="table_title">Selling UOM </FormLabel>
                  ) : (
                    <FormLabel className="table_title"> Service UOM</FormLabel>
                  )}
                  <Button
                    id="fabric_Add_Button"
                    onClick={(e) => this.openNewSellingUomPopup(e)}
                    // className="enterFocus"
                  >
                    Add
                  </Button>
                </div>
                <div className="table_small">
                  <Table id="fabrics_tables">
                    <thead>
                      <tr>
                        <th>UOM</th>
                        <th>InvUOM</th>
                        <th>ConvRate</th>
                        {is3PL ? <th>Price</th> : <th>WholeSale</th>}
                        {!is3PL && <th>Retail</th>}
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {sellingUoms.map(
                        (sell, index) =>
                          sell.isDeleted != true && (
                            <tr key={index}>
                              <td>
                                <Button
                                  size="sm"
                                  variant="secondry"
                                  className="hyperLinkText"
                                  onClick={(e) => this.editSellingUom(e, sell)}
                                >
                                  {sell.uomCode}
                                </Button>
                              </td>
                              <td>{sell.fabricStyleInventoryUOMCode}</td>
                              <td className="text-right">
                                {sell.conversionRate}
                              </td>
                              <td className="text-right">
                                {sell.wholeSalePrice}
                              </td>
                              {!is3PL && (
                                <td className="text-right">
                                  {sell.retailPrice}
                                </td>
                              )}
                              {sell.uomCode !=
                                fabricStyleData.inventoryUomCode && (
                                <td>
                                  <Button
                                    id="fabric_Add_Button"
                                    className="hyperLinkText"
                                    // disabled={this.isDisableRemoveUomButton(
                                    //   sell
                                    // )}
                                    disabled={this.props.isDisabledFields}
                                    onClick={(e) =>
                                      this.deleteSellingUom(e, sell)
                                    }
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </td>
                              )}
                            </tr>
                          ),
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
              <div className="div_Column_2">
                <CustomTable
                  label={"Customer Type Price"}
                  columns={this.getTypriceColumns()}
                  data={customerTypePrices}
                />
                {/* <div>Customer Type Price</div>
                <div>
                  <Table id="fabrics_tables">
                    <thead>
                      <th>CustType</th>
                      <th>Price</th>
                      <th>SamplePrice</th>
                    </thead>
                    {!isEmptyArray(
                      this.props.fabricStyleData.customerTypePrices
                    ) ? (
                      <tbody>
                        {this.props.fabricStyleData.customerTypePrices.map(
                          (list, i) => (
                            <tr key={i}>
                              <td>{list.customerTypeCode} </td>
                              <td className="text-right">{list.price} </td>
                              <td className="text-right">
                                {list.samplePrice}{" "}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    ) : (
                      <tbody>
                        {this.props.customerTypes.map((list, i) => (
                          <tr key={i}>
                            <td>{list.code} </td>
                            <td className="text-right">0</td>
                            <td className="text-right">0</td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </Table>
                </div> */}
              </div>
              <div className="div_Column_3">
                <div>
                  <FormLabel className="table_title"> Color </FormLabel>{" "}
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.openNewColorPopup(e)}
                  >
                    Add
                  </Button>
                  <Button
                    id="fabric_Add_Button"
                    onClick={(e) => this.multipleAdd(e)}
                    className="enterFocus"
                  >
                    MultiAdd
                  </Button>
                </div>
                <div>
                  <Table id="fabrics_tables_v1">
                    <thead>
                      <tr>
                        <th>Color</th>
                        <th>Name</th>
                        {/* <th>Active</th> */}
                        <th></th>
                        {/* <th>OnHandQty</th>
                        <th>Color stat</th>
                        <th>In/Out stat</th>
                        <th>SalesHistory</th> */}
                        <th>Img</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {color___List.map((clr, index) => (
                        <tr
                          key={index}
                          className={
                            clr.isActive === false
                              ? "inactive-cell"
                              : "active-cell"
                          }
                        >
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) => this.editColor(e, clr)}
                            >
                              {clr.fabricStyleColorCode}
                            </Button>
                          </td>
                          <td>{clr.fabricStyleColorName}</td>
                          {/* <td className="text-center">
                            <input type="checkbox" checked={clr.isActive} readOnly />
                          </td> */}
                          <td>
                            <ShortCutMenuPopup
                              value={clr}
                              menuItems={
                                <ul>
                                  <li
                                    className="shortcut-menu-item"
                                    onClick={(e) => this.getOnHandQty(e, clr)}
                                  >
                                    OnHandQty
                                  </li>

                                  <li
                                    className="shortcut-menu-item"
                                    onClick={(e) =>
                                      this.getOnColorStatistics(e, clr)
                                    }
                                  >
                                    Sales/purchase
                                  </li>

                                  <li
                                    className="shortcut-menu-item"
                                    onClick={(e) =>
                                      this.getOnStatistics(
                                        e,
                                        clr,
                                        //row.customerCode
                                      )
                                    }
                                  >
                                    In/Out stat
                                  </li>

                                  <li
                                    className="shortcut-menu-item"
                                    // onClick={this.lnkFabricCurrentInvModule}
                                    onClick={(e) =>
                                      this.openSalesHistoryDetailsInq(e, clr)
                                    }
                                  >
                                    {" "}
                                    SalesHistory{" "}
                                  </li>
                                </ul>
                              }
                            />
                          </td>
                          {/* <td className="text-center">
                            <Button
                              className="header_buttons"
                              onClick={(e) => this.getOnHandQty(e, clr)}
                            >
                              OnHandQty
                            </Button>
                          </td>
                          <td className="text-center">
                            <Button
                              className="header_buttons"
                              onClick={(e) => this.getOnColorStatistics(e, clr)}
                            >
                              Sales/purchase
                            </Button>
                          </td>
                          <td className="text-center">
                            <Button
                              className="header_buttons"
                              onClick={(e) => this.getOnStatistics(e, clr)}
                            >
                              In/Out stat
                            </Button>
                          </td>
                          <td className="text-center">
                            <Button
                              className="header_buttons"
                              onClick={(e) =>
                                this.openSalesHistoryDetailsInq(e, clr)
                              }
                            >
                              SalesHistory
                            </Button>
                          </td> */}
                          {/* <td className="text-center">
                            <img
                              src={this.props.getFabricStyleColorImagePath(
                                clr,
                                clr.imageName
                              )}
                              // src={image_1}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = noImage;
                              }}
                              width={40}
                              height={40}
                              mode="fit"
                            />
                          </td> */}
                          <td className="text-center">
                            <ClrImg
                              imgSrc={this.props.getFabricStyleColorImagePath(
                                clr,
                                clr.imageName,
                              )}
                            />
                            {/* <ErrorBoundary>
                              <Suspense fallback={<span>Loading...</span>}>
                                <ImgDiv
                                  imgSrc={this.props.getFabricStyleColorImagePath(
                                    clr,
                                    clr.imageName
                                  )}
                                />
                              </Suspense>
                            </ErrorBoundary> */}
                          </td>
                          <td>
                            <Button
                              id="fabric_Add_Button"
                              onClick={(e) => this.deleteColor(e, clr)}
                              disabled={this.props.isViewMode}
                            >
                              <DeleteIcon />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Row>
          </div>
        </form>
      </div>
    );
  }
}

class FabricColorStatisticsPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    //

    this.state = {
      // customerLookupHandler: null,
      // vendorLookupHandler: null,
    };
  }
  componentDidMount() {
    //
    // const { appData } = this.context;
    // this.companyCode = appData.companyCode;
    // this.initLookupHandlers();
    this.props.salesExecuteHandler();
    this.props.purchaseExecuteHandler();
  }

  // initLookupHandlers = () => {
  //   let customerLookupHandler = new CustomerLookupHandler(
  //     this.companyCode,
  //     "Customer"
  //   );
  //   this.setState({ customerLookupHandler: customerLookupHandler });

  //   let vendorLookupHandler = new VendorLookupHandler(
  //     this.companyCode,
  //     "Vendor"
  //   );
  //   this.setState({ vendorLookupHandler: vendorLookupHandler });
  // };

  onChange = (e) => {
    this.props.clrStatisticOnChange(e);
  };

  viewVendorModule = (e, code, rowData) => {
    this.props.viewVendorModule(e, code, rowData);
  };
  viewPurchaseModule = (e, code, rowData) => {
    this.props.viewPurchaseModule(e, code, rowData);
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    this.props.viewPurchaseReceiptModule(e, code, rowData);
  };
  viewCustomerModule = (e, code, rowData) => {
    this.props.viewCustomerModule(e, code, rowData);
  };
  viewInvoiceModule = (e, code, rowData) => {
    this.props.viewInvoiceModule(e, code, rowData);
  };

  salesStatisticsColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "", "")
        .setClickDetails(true, false, this.viewInvoiceModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate#", "invoiceDate", true, false, true)
        .setStyleDetails("left", "", "", "", ""),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "", "")
        .setClickDetails(true, false, this.viewCustomerModule, null),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "", "", "", ""),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustPO", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "", ""),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "quantity", true, true)
        .setStyleDetails("right", "", "", "", ""),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "", ""),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "amount", true, true)
        .setStyleDetails("right", "", "", "", ""),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "", ""),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Year", "year", true)
        .setStyleDetails("left", "", "", "", ""),
    );

    return _columns;
  };

  purchaseStatisticsColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "", "")
        .setClickDetails(true, false, this.viewPurchaseModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("PODate#", "orderDate", true, false, true)
        .setStyleDetails("left", "", "", "", ""),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "", "")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("ReceiptDate#", "receiptDate", true, false, true)
        .setStyleDetails("left", "", "", "", ""),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Vendor#", "vendorCode", true)
        .setStyleDetails("left", "", "", "", "")
        .setClickDetails(true, false, this.viewVendorModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "vendorName", true)
        .setStyleDetails("left", "", "", "", ""),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "", ""),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Cost", "cost", true, true)
        .setStyleDetails("right", "", "", "", ""),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "totalAmount", true, true)
        .setStyleDetails("right", "", "", "", ""),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "", ""),
    );

    return _columns;
  };

  render() {
    let fabricStyleData = this.props.fabricStyleData;
    const is3PL = this.props.is3PL;
    const criteria = this.props.clrStatisticCriteria;
    let salesStatisticsList = [];
    let purchaseStatisticsList = [];
    if (!isEmptyArray(this.props.salesStatisticsList))
      salesStatisticsList = this.props.salesStatisticsList;
    if (!isEmptyArray(this.props.purchaseStatisticsList))
      purchaseStatisticsList = this.props.purchaseStatisticsList;

    return (
      <div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              <FormLabel>Company</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="companyCode"
                value={fabricStyleData.companyCode}
                disabled={true}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>FabricStyle</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                onChange={this.onChange}
                value={criteria.fabricStyleCode}
                disabled={true}
                isMandatory={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>Color</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleColorCode"
                onChange={this.onChange}
                value={criteria.colorCode}
                disabled={true}
                isMandatory={true}
              />{" "}
            </Col>
          </Row>
        </div>
        <div className="header_div">
          <Row>
            <div className="div_inline">
              <div className="div_60_no_overflow">
                <div className="text-center pb-2 label_head">
                  <h6>Sales</h6>
                </div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Customer</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="customerCode"
                      onChange={this.props.customerClrStatChange}
                      value={criteria.customerCode}
                      lookupRequired={true}
                      lookupHandler={this.props.customerLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.props.customerCodeClrStatEnterKeyHandler
                      }
                      autoCompleteListData={
                        this.props.customerPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteCustomerList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteCustomerList
                      }
                      // disabled={isDisableFields}
                      isMandatory={true}
                    />{" "}
                  </Col>
                  <Col sm="5">
                    <InputTextbox
                      name="customerName"
                      onChange={this.onChange}
                      value={criteria.customerName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>

                <Row>
                  <Col sm="2">
                    <FormLabel>FromDate</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent_adv
                      name="fromDate"
                      onChange={this.onChange}
                      value={criteria.fromDate}
                      // disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>ToDate</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent_adv
                      name="toDate"
                      onChange={this.onChange}
                      value={criteria.toDate}
                      // disabled={true}
                    />
                  </Col>

                  <Col sm="2">
                    <Button onClick={() => this.props.salesExecuteHandler()}>
                      Execute
                    </Button>
                  </Col>

                  <Col sm="2">
                    <Button onClick={() => this.props.resetClrStatistics(1)}>
                      Reset
                    </Button>
                  </Col>
                </Row>
              </div>
              <div className="div_60_no_overflow">
                <div className="text-center pb-2 label_head">
                  <h6>Purchase</h6>
                </div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Vendor</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="vendorCode"
                      onChange={this.props.vendorClrStatOnChange}
                      value={criteria.vendorCode}
                      lookupRequired={true}
                      lookupHandler={this.props.vendorLookupHandler}
                      enterKeyEventHandler={
                        this.props.vendorCodeEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.vendorPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteVendorList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteVendorList
                      }
                      // disabled={props.isDisableFields}
                      isMandatory={true}
                    />{" "}
                  </Col>
                  <Col sm="5">
                    <InputTextbox
                      name="vendorName"
                      onChange={this.onChange}
                      value={criteria.vendorName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>

                <Row>
                  <Col sm="2">
                    <FormLabel>FromDate</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent_adv
                      name="fromDate"
                      onChange={this.onChange}
                      value={criteria.fromDate}
                      // disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>ToDate</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent_adv
                      name="toDate"
                      onChange={this.onChange}
                      value={criteria.toDate}
                      // disabled={true}
                    />
                  </Col>
                  <Col sm="2">
                    <Button onClick={() => this.props.purchaseExecuteHandler()}>
                      Execute
                    </Button>
                  </Col>

                  <Col sm="2">
                    <Button onClick={() => this.props.resetClrStatistics(2)}>
                      Reset
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </Row>
        </div>

        <div className="div_inline">
          <div className="div_60_no_overflow">
            {/* {!isEmptyArray(salesStatisticsList) ? ( */}
            <div className="div_Custom_1">
              <CustomTable
                // cstmStyle="custom_style"
                columns={this.salesStatisticsColumns()}
                data={salesStatisticsList}
                label={"Color Statistics - Sales"}
                isShowLabelButton={true}
                labelButtonRenderPDF={"PDF"}
                labelButtonRender={"Excel"}
                labelButtonClickHandler={(e) =>
                  this.props.fabricSalesColorStatisticsExcelHandler(e)
                }
                labelPDFButtonClickHandler={(e) =>
                  this.props.fabricSalesColorStatisticsPDFHandler(e)
                }
              />
            </div>
            {/* ) : null} */}
          </div>

          <div className="div_60_no_overflow">
            {/* {!isEmptyArray(purchaseStatisticsList) ? ( */}
            <div className="div_Custom_1">
              <CustomTable
                columns={this.purchaseStatisticsColumns()}
                data={purchaseStatisticsList}
                label={"Color Statistics - Purchase"}
                isShowLabelButton={true}
                labelButtonRenderPDF={"PDF"}
                labelButtonRender={"Excel"}
                labelButtonClickHandler={(e) =>
                  this.props.fabricPurchaseColorStatisticsExcelHandler(e)
                }
                labelPDFButtonClickHandler={(e) =>
                  this.props.fabricPurchaseColorStatisticsPDFHandler(e)
                }
              />
            </div>
            {/* ) : null} */}
          </div>
        </div>
      </div>
    );
  }
}
export function ClrImg(props) {
  const [url, setUrl] = useState(props.imgSrc);
  useEffect(() => {
    // setTimeout(() => {
    setUrl(props.imgSrc);
    // }, 2000);
  });
  return (
    <>
      {/* <img
        src={url}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={40}
        height={40}
        mode="fit"
      /> */}
      <CustomImage src={url} width={40} height={40} mode={"fit"} />
    </>
  );
}
class FabricStyleCompositionLineForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.compositionCodeRef = React.createRef();
    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      compositionTypes: this.props.compositionTypes,
      fabricStyleCompositionLineData: this.props.fabricStyleCompositionLineData,
    };
  }
  componentDidMount() {
    this.initLookupHandlers();
    this.setFocus();
  }

  componentDidUpdate() {
    //
  }

  initLookupHandlers = () => {
    let compositionTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.compositionTypes,
      "Composition Type",
    );
    this.setState({
      compositionTypeLookupHandler: compositionTypeLookupHandler,
    });
  };
  setFocus = () => {
    if (
      this.compositionCodeRef.current != null &&
      this.compositionCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.compositionCodeRef.current.focus();
      }, 100);
    }
  };
  clearCompositionLineValues = (e) => {
    if (e.detail <= 1) {
      if (this.compositionCodeRef.current != null) {
        this.compositionCodeRef.current.clear();
      }
      this.props.clearCompositionLineValues();
    }
  };
  openExcitingCompLineForm = (e, compLineData) => {
    if (e.detail === 1) this.props.openExcitingCompLineForm(compLineData);
  };
  saveCompositionLine = (e) => {
    if (e.detail <= 1) {
      this.props.saveCompositionLine();
      this.clearCompositionLineValues(e);
    }
  };
  onFabCompChange = (e) => {
    this.props.onFabCompChange(e);
  };
  onElementChange = (e) => {
    this.props.onElementChange(e);
  };
  elementEnterKeyEventHandler = (e) => {
    this.props.elementEnterKeyEventHandler(e);
  };
  displayAutoCompleteElementList = (showAutoCompleteElementList) => {
    this.props.displayAutoCompleteElementList(showAutoCompleteElementList);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  deleteCompositionLine = (e, line) => {
    if (e.detail <= 1) this.props.deleteCompositionLine(line);
  };
  render() {
    let currentCompLineData = this.props.fabricStyleCompositionLineData;
    let fabricStyleData = this.props.fabricStyleData;
    let compositionTypes = this.state.compositionTypes;
    let _compositionLines = [];
    if (fabricStyleData.compositions != null) {
      fabricStyleData.compositions.map((line) => {
        _compositionLines.push(line);
      });
    }
    return (
      <div className="header_div col-md-12 col-lg-12 ">
        <div className="header_div">
          <div className="div_Custom_3">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Element</th>
                  <th>Element Name</th>
                  <th>Compositions %</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {_compositionLines.map(
                  (invoiceLine, index) =>
                    invoiceLine.isDeleted != true && (
                      <tr key={index} data-item={invoiceLine}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.openExcitingCompLineForm(e, invoiceLine)
                            }
                          >
                            {invoiceLine.compositionElementCode}
                          </Button>
                        </td>

                        <td>{invoiceLine.compositionElementName}</td>
                        <td>{invoiceLine.compostionPercentageValue}</td>

                        <td>
                          <Button
                            id="fabric_Add_Button"
                            className="enterFocus"
                            size="sm1"
                            bssize="large"
                            onClick={(e) =>
                              this.deleteCompositionLine(e, invoiceLine)
                            }
                            disabled={this.props.isDisabledFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ),
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <br />
        <div className="">
          <Row>
            <FormLabel className=""> Composition Line Detail</FormLabel>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              {" "}
              {this.props.is3PL ? (
                <FormLabel>CompositionType</FormLabel>
              ) : (
                <FormLabel>Element</FormLabel>
              )}
              {/* <FormLabel>Element</FormLabel>{" "} */}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="compositionElementCode"
                placeholder="Enter compositionElementCode"
                ref={this.compositionCodeRef}
                onChange={this.onElementChange}
                value={currentCompLineData.compositionElementCode}
                lookupHandler={this.state.compositionTypeLookupHandler}
                lookupRequired={true}
                valuePropery="code"
                descriptionProperty="description"
                enterKeyEventHandler={this.elementEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.elementPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteElementList}
                showAutoCompleteList={this.props.showAutoCompleteElementList}
                isMandatory={true}
                disabled={this.props.isDisabledFields}
              />{" "}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="compositionElementName"
                disabled={true}
                onChange={this.onFabCompChange}
                value={currentCompLineData.compositionElementName}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Composition%</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="compostionPercentageValue"
                value={currentCompLineData.compostionPercentageValue}
                onChange={this.onFabCompChange}
                className="text-right"
                decimalScale={2}
                isMandatory={true}
                disabled={this.props.isDisabledFields}
              />
            </Col>
          </Row>{" "}
          <div className="button-flex">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.saveCompositionLine(e)}
              disabled={this.props.isDisabledFields}
            >
              Add / Update
            </Button>
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.clearCompositionLineValues(e)}
              disabled={this.props.isDisabledFields}
            >
              Clear
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
class FabricStyleDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
    };
  }
  generateDetailReport = (e) => {
    if (e.detail <= 1) this.props.generateDetailReport();
  };
  onFabDetailsChange = (e) => {
    this.props.onFabDetailsChange(e);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  render() {
    let fabricStyleData = this.state.fabricStyleData;
    const textAreaStyle = {
      maxHeight: "120px",
      minHeight: "14em",
      width: "25em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div className="header_div col-md-12 col-lg-12 ">
        <div className="div_Custom_2">
          <Row>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>FabricStyle#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                onChange={this.onFabDetailsChange}
                value={fabricStyleData.code}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.generateDetailReport(e)}
              >
                Report{" "}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Width</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="width"
                value={fabricStyleData.width}
                onChange={this.onFabDetailsChange}
                readOnly={false}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Content</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricContent"
                value={fabricStyleData.fabricContent}
                onChange={this.onFabDetailsChange}
                readOnly={false}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Repeat</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricRepeat"
                value={fabricStyleData.fabricRepeat}
                onChange={this.onFabDetailsChange}
                readOnly={false}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Abrasion</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricAbrasion"
                value={fabricStyleData.fabricAbrasion}
                onChange={this.onFabDetailsChange}
                readOnly={false}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>{" "}
          <Row>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Direction</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricDirection"
                value={fabricStyleData.fabricDirection}
                onChange={this.onFabDetailsChange}
                readOnly={false}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>COO#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricCountryOfOrigin"
                value={fabricStyleData.fabricCountryOfOrigin}
                onChange={this.onFabDetailsChange}
                readOnly={false}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Cleaning#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricCleaningCode"
                value={fabricStyleData.fabricCleaningCode}
                onChange={this.onFabDetailsChange}
                readOnly={false}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Style Type</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleType"
                value={fabricStyleData.fabricStyleType}
                onChange={this.onFabDetailsChange}
                readOnly={false}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>{" "}
          <div>
            <Row>
              <Col sm="4">
                <FormLabel className="label_head">Yarn Details</FormLabel>{" "}
              </Col>
              <Col sm="4">
                <FormLabel className="label_head">
                  BackingAndFinishingDetails
                </FormLabel>{" "}
              </Col>
              <Col sm="4">
                <FormLabel className="label_head">
                  StandardTesting
                </FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="4">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="yarnDetails"
                  type="text"
                  placeholder="YarnDetail"
                  onChange={this.onFabDetailsChange}
                  value={fabricStyleData.yarnDetails}
                  disabled={isDisabledFields}
                />
              </Col>
              <Col sm="4">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="backingAndFinishingDetails"
                  type="text"
                  placeholder="FinishingDetail"
                  onChange={this.onFabDetailsChange}
                  value={fabricStyleData.backingAndFinishingDetails}
                  disabled={isDisabledFields}
                />
              </Col>
              <Col sm="4">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="standardTestingDetails"
                  type="text"
                  placeholder="TestingDetail"
                  onChange={this.onFabDetailsChange}
                  value={fabricStyleData.standardTestingDetails}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
            {/* {this.props.is3PL ? ( */}
            <Row>
              <Col sm="4">
                <FormLabel className="label_head">
                  Shringing Details
                </FormLabel>{" "}
              </Col>

              <Col sm="4">
                <FormLabel className="label_head">
                  Cleaning Instruction
                </FormLabel>{" "}
              </Col>
            </Row>
            {/* ) : null}
            {this.props.is3PL ? ( */}
            <Row>
              <Col sm="4">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="shrinkingDetails"
                  type="text"
                  placeholder="ShrinkingDetails"
                  onChange={this.onFabDetailsChange}
                  value={fabricStyleData.shrinkingDetails}
                  disabled={isDisabledFields}
                />
              </Col>

              <Col sm="4">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="cleaningInstruction"
                  type="text"
                  placeholder="CleaningInstruction"
                  onChange={this.onFabDetailsChange}
                  value={fabricStyleData.cleaningInstruction}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>

            {/* ) : null} */}
          </div>
        </div>
      </div>
    );
  }
}
class FabricStyleSkuDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      isLineEditMode: this.props.isLineEditMode,
      isOpenSkuPricePopup: this.props.isOpenSkuPricePopup,
      customer_list: this.props.customer_list,
      isShowSkuPopup: this.props.isShowSkuPopup,
    };
  }
  componentDidMount() {}
  componentDidUpdate() {
    //
  }
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  skuDetailHandleHyperLinkClick = (e, selectedSkuLine) => {
    if (e.detail === 1)
      this.props.skuDetailHandleHyperLinkClick(selectedSkuLine);
  };
  closeSkuPricePopup = () => {
    this.props.closeSkuPricePopup();
  };
  addorUpdateSkuPrice = (e) => {
    let selectedSkuLine = this.props.selectedSkuLine;
    if (e.detail === 1) this.props.addorUpdateSkuPrice(selectedSkuLine);
  };
  applyToAllSkuPrice = (e) => {
    let selectedSkuLine = this.props.selectedSkuLine;
    if (e.detail === 1) this.props.applyToAllSkuPrice(selectedSkuLine);
  };
  onItemSkuChange = (e) => {
    this.props.onItemSkuChange(e);
  };
  onSkuPriceLineChange = (e) => {
    this.props.onSkuPriceLineChange(e);
  };
  saveCustomerSkuPriceLine = () => {
    this.props.saveCustomerSkuPriceLine();
    this.clearSkuLineValues();
  };
  getSkuPriceLineDetails = (customerSkuPriceData) => {
    this.props.getSkuPriceLineDetails(customerSkuPriceData);
  };
  clearSkuLineValues = () => {
    this.props.clearSkuLineValues();
  };
  deleteFabricSkuCustomerLine = (line) => {
    this.props.deleteFabricSkuCustomerLine(line);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };

  displayAutoCompleteCustomerList = (showAutoCompleteCustomerList) => {
    this.props.displayAutoCompleteCustomerList(showAutoCompleteCustomerList);
  };
  onShipToChange = (e) => {
    this.props.onShipToChange(e);
  };
  shipToEnterKeyEventHandler = (e) => {
    this.props.shipToEnterKeyEventHandler(e);
  };
  displayAutoCompleteShipToList = (showAutoCompleteShipToList) => {
    this.props.displayAutoCompleteShipToList(showAutoCompleteShipToList);
  };
  onCustomerChange = (e) => {
    this.props.onCustomerChange(e);
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeAlertModalCallBack(isShowPopup);
    this.clearSkuLineValues();
  };
  addorUpdateSkuEntry = (e, line) => {
    if (e.detail === 1) {
      this.props.addorUpdateSkuEntry(line);
      this.closeAlertModalCallBackLvl1(false);
    }
  };
  openSkuEntryPopup = (e, selectedSkuLine) => {
    if (e.detail === 1) this.props.openSkuEntryPopup(selectedSkuLine);
  };
  closeSkuEntryPopup = () => {
    this.props.closeSkuEntryPopup();
  };
  onSkuEntryChange = (e) => {
    this.props.onSkuEntryChange(e);
  };
  onSkuChange = (e) => {
    this.props.onSkuChange(e);
  };
  openTargetEntryPopup = (selectedSkuLine) => {
    this.props.openTargetEntryPopup(selectedSkuLine);
  };

  closeAlertModalCallBackLvl1 = (isShowPopup) => {
    this.props.closeAlertModalCallBackLvl1(isShowPopup);
  };
  closeAlertModalCallBackLvl2 = (isShowPopup) => {
    this.props.closeAlertModalCallBackLvl2(isShowPopup);
  };
  addOrUpdateTargetSku = () => {
    this.props.addorUpdateSkuDetails();
    this.closeAlertModalCallBackLvl2(false);
  };
  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let _skuLines = new Array();
    if (!isEmptyArray(fabricStyleData.fabricStyleSkus))
      _skuLines = fabricStyleData.fabricStyleSkus;
    let is3PL = this.props.is3PL;
    return (
      <div>
        <div className="center_div col-md-12 col-lg-12 text-center">
          <div className="div_default">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Color</th>
                  <th>SKU Number</th>
                  <th>InventoryUOM</th>
                  <th>SamplePrice</th>
                  {!is3PL ? <th>Price</th> : <th>UPC Number</th>}
                  <th>StandartCost</th>
                  <th>LandingCost</th>
                </tr>
              </thead>
              <tbody>
                {_skuLines.map((sku, index) => (
                  <tr key={index}>
                    <td>{sku.fabricStyleColorCode}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.openSkuEntryPopup(e, sku)}
                      >
                        {sku.skuNumber}
                      </Button>
                    </td>
                    <td className="text-right">{sku.uomCode}</td>
                    <td className="text-right">
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.skuDetailHandleHyperLinkClick(e, sku)
                        }
                      >
                        {sku.samplePrice}
                      </Button>
                    </td>
                    {!is3PL ? (
                      <td className="text-right">
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.skuDetailHandleHyperLinkClick(e, sku)
                          }
                        >
                          {sku.wholesalePrice}
                        </Button>
                      </td>
                    ) : (
                      <td className="text-right">{sku.upcCode}</td>
                    )}
                    <td className="text-right">{sku.standardCost}</td>
                    <td className="text-right">{sku.landingCost}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.props.isShowSkuPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"SKU LINE DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.addorUpdateSkuPrice(e)}
                disabled={this.props.isDisabledFields}
              >
                Add/Update
              </Button>
              {/* <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.applyToAllSkuPrice(e)}
                disabled={this.props.isDisabledFields}
              >
                apply to all
              </Button> */}
            </div>
          }
          content={
            <SkuPricePopup
              {...this.state}
              is3PL={this.props.is3PL}
              fabricStyleData={this.props.fabricStyleData}
              isOpenSkuPricePopup={this.props.isOpenSkuPricePopup}
              selectedSkuLine={this.props.selectedSkuLine}
              customer_list={this.props.customer_list}
              isDisabledFields={this.props.isDisabledFields}
              customerSkuPriceData={this.props.customerSkuPriceData}
              _currentSelectedSkuLine={this.props._currentSelectedSkuLine}
              customer_shipTo={this.props.customer_shipTo}
              isShowSkuPopup={this.props.isShowSkuPopup}
              closeSkuPricePopup={this.closeSkuPricePopup}
              onItemSkuChange={this.onItemSkuChange}
              onSkuPriceLineChange={this.onSkuPriceLineChange}
              getSkuPriceLineDetails={this.getSkuPriceLineDetails}
              saveCustomerSkuPriceLine={this.saveCustomerSkuPriceLine}
              clearSkuLineValues={this.clearSkuLineValues}
              deleteFabricSkuCustomerLine={this.deleteFabricSkuCustomerLine}
              customerCodeEnterKeyEventHandler={
                this.customerCodeEnterKeyEventHandler
              }
              displayAutoCompleteCustomerList={
                this.displayAutoCompleteCustomerList
              }
              onCustomerChange={this.onCustomerChange}
              customerPageListForAutoCompleteList={
                this.props.customerPageListForAutoCompleteList
              }
              showAutoCompleteCustomerList={
                this.props.showAutoCompleteCustomerList
              }
              onShipToChange={this.onShipToChange}
              shipToEnterKeyEventHandler={this.shipToEnterKeyEventHandler}
              displayAutoCompleteShipToList={this.displayAutoCompleteShipToList}
              shipToPageListForAutoCompleteList={
                this.props.shipToPageListForAutoCompleteList
              }
              showAutoCompleteShipToList={this.props.showAutoCompleteShipToList}
              customerShipToLookupHandler={
                this.props.customerShipToLookupHandler
              }
              setDateForCustPriceLine={this.props.setDateForCustPriceLine}
            />
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.props.isShowSkuEntryPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"SKU DETAIL ENTRY"}
          closeOnDocumentClick={false}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) =>
                  this.addorUpdateSkuEntry(e, this.props.selectedSkuLine)
                }
                disabled={this.props.isDisabledFields}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <SkuEntryPopup
              {...this.state}
              isStandard={this.props.isStandard}
              is3PL={this.props.is3PL}
              fabricStyleData={this.props.fabricStyleData}
              selectedSkuLine={this.props.selectedSkuLine}
              targetWebSiteDetail={this.props.targetWebSiteDetail}
              isShowTargetSiteEntryPopup={this.props.isShowTargetSiteEntryPopup}
              eComSkuData={this.props.eComSkuData}
              openTargetEntryPopup={this.openTargetEntryPopup}
              closeTargetEntryPopup={this.closeTargetEntryPopup}
              closeAlertModalCallBackLvl2={this.closeAlertModalCallBackLvl2}
              onSkuEntryChange={this.onSkuEntryChange}
              onSkuChange={this.onSkuChange}
              addOrUpdateTargetSku={this.addOrUpdateTargetSku}
              isDisabledFields={this.props.isDisabledFields}
            />
          }
        />
      </div>
    );
  }
}
class SkuPricePopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.customerShipToCodeRef = React.createRef();
    this.customerNameRef = React.createRef();
    this.state = {
      isOpenSkuPricePopup: this.props.isOpenSkuPricePopup,
      fabricStyleData: this.props.fabricStyleData,
      skuPriceData: this.props.fabricStyleData.skuPriceBean,
      customerSkuPriceData: this.props.customerSkuPriceData,
      _currentSelectedSkuLine: this.props._currentSelectedSkuLine,
      customer_shipTo: this.props.customer_shipTo,
      customer_list: this.props.customer_list,
      isShowSkuPopup: this.props.isShowSkuPopup,
      customerShipToLookupHandler: this.props.customerShipToLookupHandler,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setFocus();
    this.props.setDateForCustPriceLine();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  setFocus = () => {
    if (
      this.customerCodeRef.current != null &&
      this.customerCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.customerCodeRef.current.focus();
      }, 100);
    }
  };
  onItemSkuChange = (e) => {
    this.props.onItemSkuChange(e);
  };
  onSkuPriceLineChange = (e) => {
    this.props.onSkuPriceLineChange(e);
  };
  saveCustomerSkuPriceLine = (e) => {
    if (e.detail <= 1) {
      this.props.saveCustomerSkuPriceLine();
      // this.clearSkuLineValues(e);
    }
  };
  getSkuPriceLineDetails = (e, customerSkuPriceData) => {
    if (e.detail <= 1) {
      if (this.customerShipToCodeRef.current != null) {
        this.customerShipToCodeRef.current.clear();
      }
      this.props.getSkuPriceLineDetails(customerSkuPriceData);
    }
  };
  deleteFabricSkuCustomerLine = (e, line) => {
    if (e.detail <= 1) this.props.deleteFabricSkuCustomerLine(line);
  };
  clearSkuLineValues = (e) => {
    if (e.detail <= 1) {
      if (this.customerCodeRef.current != null) {
        this.customerCodeRef.current.clear();
      }
      if (this.customerShipToCodeRef.current != null) {
        this.customerShipToCodeRef.current.clear();
      }
      if (this.customerNameRef.current != null) {
        this.customerNameRef.current.clear();
      }
      this.props.clearSkuLineValues();
    }
  };
  closeSkuPricePopup = () => {
    this.props.closeSkuPricePopup();
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteCustomerList = (showAutoCompleteCustomerList) => {
    this.props.displayAutoCompleteCustomerList(showAutoCompleteCustomerList);
  };
  onCustomerChange = (e) => {
    this.props.onCustomerChange(e);
  };
  onShipToChange = (e) => {
    this.props.onShipToChange(e);
  };
  shipToEnterKeyEventHandler = (e) => {
    this.props.shipToEnterKeyEventHandler(e);
  };
  displayAutoCompleteShipToList = (showAutoCompleteShipToList) => {
    this.props.displayAutoCompleteShipToList(showAutoCompleteShipToList);
  };
  render() {
    let skuCustomerPrices = [];

    let isOpenSkuPricePopup = this.props.isOpenSkuPricePopup;
    let selectedSkuLine = this.props.selectedSkuLine;
    let skuPriceData = new FabricStyleSKUPriceBean();
    if (selectedSkuLine.skuPriceBean != null) {
      skuPriceData = selectedSkuLine.skuPriceBean;
      if (!isEmptyArray(skuPriceData.skuCustomerPrices)) {
        skuPriceData.skuCustomerPrices.map((line) => {
          skuCustomerPrices.push(line);
        });
      }
    }
    let customerSkuPriceData = this.props.customerSkuPriceData;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div className="center_div">
        <div>
          <Row>
            <Col sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                onChange={this.onItemSkuChange}
                value={skuPriceData.fabricStyleCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="description"
                onChange={this.onItemSkuChange}
                value={skuPriceData.fabricStyleCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>UOM</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="uomCode"
                onChange={this.onItemSkuChange}
                value={skuPriceData.uomCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Color</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleColorCode"
                onChange={this.onItemSkuChange}
                value={skuPriceData.fabricStyleColorCode}
                disabled={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Sku</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="skuNumber"
                onChange={this.onItemSkuChange}
                value={skuPriceData.skuNumber}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Currency</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="currencyCode"
                onChange={this.onItemSkuChange}
                value={skuPriceData.currencyCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Price</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="defaultPrice"
                // type="defaultPrice"
                placeholder="Enter defaultPrice"
                onChange={this.onItemSkuChange}
                value={skuPriceData.defaultPrice}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Sample Price</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="samplePrice"
                // type="samplePrice"
                placeholder="Enter samplePrice"
                onChange={this.onItemSkuChange}
                value={skuPriceData.samplePrice}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
          </Row>{" "}
        </div>
        <div className="div_Custom">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Ln#</th>
                <th>Cust#</th>
                <th>Name</th>
                <th>Date</th>
                <th>Price</th>
                <th>Delete Line</th>
              </tr>
            </thead>
            <tbody>
              {skuCustomerPrices.map(
                (line, i) =>
                  line.isDeleted != true && (
                    <tr key={i} data-item={line}>
                      <td>
                        <Button
                          id="fabric_Add_Button"
                          className="enterFocus"
                          size="sm1"
                          bssize="large"
                          onClick={(e) => this.getSkuPriceLineDetails(e, line)}
                        >
                          {line.lineNumber}
                        </Button>
                      </td>
                      <td>{line.customerCode}</td>
                      <td>{line.customerName}</td>
                      <td>{line.effectiveDate}</td>
                      <td>{line.price}</td>

                      <td>
                        <Button
                          id="fabric_Add_Button"
                          className="enterFocus"
                          size="sm1"
                          bssize="large"
                          onClick={(e) =>
                            this.deleteFabricSkuCustomerLine(e, line)
                          }
                          disabled={isDisabledFields}
                        >
                          <DeleteIcon />
                        </Button>
                      </td>
                    </tr>
                  ),
              )}
            </tbody>
          </Table>
        </div>

        <div>
          <Row>
            <FormLabel>LineDetails</FormLabel>{" "}
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Cust#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="customerCode"
                placeholder="Enter customerCode"
                ref={this.customerCodeRef}
                onChange={this.onCustomerChange}
                value={customerSkuPriceData.customerCode}
                lookupRequired={true}
                lookupHandler={this.state.customerLookupHandler}
                enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.customerPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCustomerList}
                showAutoCompleteList={this.props.showAutoCompleteCustomerList}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                name="customerName"
                ref={this.customerNameRef}
                onChange={this.onCustomerChange}
                value={customerSkuPriceData.customerName}
                disabled={true}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>ShipTo#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="customerShipToCode"
                placeholder="Enter customerShipToCode"
                ref={this.customerShipToCodeRef}
                onChange={this.onShipToChange}
                value={customerSkuPriceData.customerShipToCode}
                lookupRequired={true}
                lookupHandler={this.props.customerShipToLookupHandler}
                enterKeyEventHandler={this.shipToEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.shipToPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteShipToList}
                showAutoCompleteList={this.props.showAutoCompleteShipToList}
                valuePropery="code"
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Price</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"price"}
                value={customerSkuPriceData.price}
                onChange={this.onSkuPriceLineChange}
                className="text-right"
                decimalScale={2}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
          </Row>{" "}
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Sample Price</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"samplePrice"}
                value={customerSkuPriceData.samplePrice}
                onChange={this.onSkuPriceLineChange}
                className="text-right"
                decimalScale={2}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>From Date</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                onChange={this.onSkuPriceLineChange}
                name="fromDate"
                value={customerSkuPriceData.fromDate}
                disabled={isDisabledFields}
              ></DatePickerComponent>
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>To Date</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                onChange={this.onSkuPriceLineChange}
                name="toDate"
                value={customerSkuPriceData.toDate}
                disabled={isDisabledFields}
              ></DatePickerComponent>
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Date</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                onChange={this.onSkuPriceLineChange}
                name="effectiveDate"
                isMandatory={true}
                value={customerSkuPriceData.effectiveDate}
                disabled={isDisabledFields}
              ></DatePickerComponent>
            </Col>
          </Row>
        </div>
        <div className="button-flex">
          <Button
            id="fabric_Add_Button"
            className="enterFocus"
            size="sm1"
            bssize="large"
            onClick={(e) => this.saveCustomerSkuPriceLine(e)}
            disabled={isDisabledFields}
          >
            Add Line{" "}
          </Button>
          <Button
            id="fabric_Add_Button"
            className="enterFocus"
            size="sm1"
            bssize="large"
            onClick={(e) => this.clearSkuLineValues(e)}
            disabled={isDisabledFields}
          >
            Clear Line{" "}
          </Button>
        </div>
      </div>
    );
  }
}
class SkuEntryPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.oldSkuCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.setFocus();
  }
  setFocus = () => {
    if (
      this.oldSkuCodeRef.current != null &&
      this.oldSkuCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.oldSkuCodeRef.current.focus();
      }, 100);
    }
  };
  openTargetEntryPopup = (e, selectedSkuLine) => {
    if (e.detail <= 1) this.props.openTargetEntryPopup(selectedSkuLine);
  };
  closeTargetEntryPopup = () => {
    this.props.closeTargetEntryPopup();
  };
  closeAlertModalCallBackLvl2 = (isShowPopup) => {
    this.props.closeAlertModalCallBackLvl2(isShowPopup);
  };
  onSkuEntryChange = (e) => {
    this.props.onSkuEntryChange(e);
  };
  onSkuChange = (e) => {
    this.props.onSkuChange(e);
  };

  addOrUpdateTargetSku = (e) => {
    if (e.detail == 1) this.props.addOrUpdateTargetSku();
  };
  render() {
    let selectedSkuLine = this.props.selectedSkuLine;
    let targetWebSiteDetail = this.props.targetWebSiteDetail;
    let fabricStyleData = this.props.fabricStyleData;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div className="center_div ">
        <div>
          <Row>
            <Col sm="2">
              {is3PL ? (
                <FormLabel>Item#</FormLabel>
              ) : (
                <FormLabel>FabricStyle#</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                onChange={this.onSkuEntryChange}
                value={selectedSkuLine.fabricStyleCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="2">
              <FormLabel>Name</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="description"
                onChange={this.onSkuEntryChange}
                value={fabricStyleData.description}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="2">
              <FormLabel>UOM</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="uomCode"
                onChange={this.onSkuEntryChange}
                value={selectedSkuLine.uomCode}
                disabled={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>Color</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleColorCode"
                onChange={this.onSkuEntryChange}
                value={selectedSkuLine.fabricStyleColorCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="2">
              <FormLabel>SKU</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="skuNumber"
                onChange={this.onSkuEntryChange}
                value={selectedSkuLine.skuNumber}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="2">
              <FormLabel>Price</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="wholesalePrice"
                onChange={this.onSkuEntryChange}
                value={selectedSkuLine.wholesalePrice}
                disabled={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>Currency</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="currencyCode"
                onChange={this.onSkuEntryChange}
                value={selectedSkuLine.currencyCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="2">
              <FormLabel>Old SKU</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.oldSkuCodeRef}
                name="oldSystemSkuNumber"
                onChange={this.onSkuEntryChange}
                value={selectedSkuLine.oldSystemSkuNumber}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="2">
              <FormLabel>UPC</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="upcCode"
                onChange={this.onSkuEntryChange}
                value={selectedSkuLine.upcCode}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
        </div>
        {!this.props.isStandard ? (
          <div>
            <Row>
              <Col sm="2">
                <FormLabel>EcomDetails</FormLabel>
              </Col>
            </Row>
            {/* <hr class="row_border"></hr> */}
            <div className="button-flex">
              {targetWebSiteDetail.map(
                (element) =>
                  element.webExportTypCode === "SHOPIFY" && (
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      bssize="large"
                      onClick={(e) =>
                        this.openTargetEntryPopup(e, selectedSkuLine)
                      }
                      disabled={isDisabledFields}
                    >
                      {element.code + "(" + element.webExportTypCode + ")"}
                    </Button>
                  ),
              )}
            </div>
          </div>
        ) : null}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.props.isShowTargetSiteEntryPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl2}
          title={"TARGET DETAIL ENTRY"}
          closeOnDocumentClick={false}
          lockScroll={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.addOrUpdateTargetSku(e)}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <TargetSiteEntryPopup
              {...this.state}
              is3PL={this.props.is3PL}
              fabricStyleData={this.props.fabricStyleData}
              eComSkuData={this.props.eComSkuData}
              onSkuChange={this.onSkuChange}
            />
          }
        />
      </div>
    );
  }
}
class TargetSiteEntryPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onSkuChange = (e) => {
    this.props.onSkuChange(e);
  };
  setFocus = () => {
    if (
      this.customerCodeRef.current != null &&
      this.customerCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.customerCodeRef.current.focus();
      }, 100);
    }
  };
  render() {
    let eComSkuData = this.props.eComSkuData;
    const textAreaStyle = {
      maxHeight: "9em",
      width: "40em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    const is3PL = this.props.is3PL;
    return (
      <div className="center_div col-md-12 col-lg-12 text-center">
        <div>
          <div>
            <Row>
              <Col sm="1">
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle</FormLabel>
                )}
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="code"
                  onChange={this.onSkuChange}
                  value={eComSkuData.code}
                  disabled={true}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Desc</FormLabel>{" "}
              </Col>
              <Col sm="4">
                <InputTextbox
                  name="description"
                  onChange={this.onSkuChange}
                  value={eComSkuData.description}
                  disabled={true}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Color</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="colorCode"
                  onChange={this.onSkuChange}
                  value={eComSkuData.colorCode}
                  disabled={true}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Website</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="webSiteCode"
                  onChange={this.onSkuChange}
                  value={eComSkuData.webSiteCode}
                  disabled={true}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Sku</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="skuNumber"
                  onChange={this.onSkuChange}
                  value={eComSkuData.skuNumber}
                  disabled={true}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Variant Sku</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="variantSKU"
                  onChange={this.onSkuChange}
                  value={eComSkuData.variantSKU}
                  disabled={true}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>option1Name</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="option1Name"
                  onChange={this.onSkuChange}
                  value={eComSkuData.option1Name}
                  disabled={true}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Option1Value</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="option1Value"
                  onChange={this.onSkuChange}
                  value={eComSkuData.option1Value}
                  disabled={true}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Variant Price</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {/* <InputTextbox
                  name="variantPrice"
                  onChange={this.onSkuChange}
                  value={eComSkuData.variantPrice}
                />{" "} */}
                <NumberFormatInputbox
                  name="variantPrice"
                  onChange={this.onSkuChange}
                  value={eComSkuData.variantPrice}
                  decimalScale={2}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Variant Grams</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="variantGrams"
                  onChange={this.onSkuChange}
                  value={eComSkuData.variantGrams}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Variant Bar Code</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="variantBarcode"
                  onChange={this.onSkuChange}
                  value={eComSkuData.variantBarcode}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Web Sales</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputCheckbox
                  name="webSalesFlag"
                  type="checkbox"
                  checked={eComSkuData.webSalesFlag}
                  onChange={this.onSkuChange}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Image Alt Text</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="imageAltText"
                  type="text"
                  onChange={this.onSkuChange}
                  value={eComSkuData.imageAltText}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}
class FabricStyleVendorMappingPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.vendorCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
      isVendorMappingPopup: this.props.isVendorReferencePopup,
      selectedVendorRefLine: this.props.selectedVendorRefLine,
      venReferenceData: this.props.venReferenceData,
      vendor_List: this.props.vendor_List,
      colorList: this.props.colorList,
      venReferneceCaption: this.props.venReferneceCaption,
      venColorReferneces: this.props.venColorReferneces,
      venRef: this.props.venRef,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (!this.props.venReferenceData.isFetched) {
      this.generateVendorColorReferenceInfoList();
    }
    this.initLookupHandlers();
    this.setFocus();
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  setFocus = () => {
    if (
      this.vendorCodeRef.current != null &&
      this.vendorCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.vendorCodeRef.current.focus();
      }, 100);
    }
  };
  onVendorMapVendorCodeChange = (e) => {
    this.props.onVendorMapVendorCodeChange(e);
  };
  addorUpdateVendorReference = (venRefData) => {
    this.props.addorUpdateVendorReference(this.props.venReferenceData);
    if (this.vendorCodeRef.current != null) this.vendorCodeRef.current.clear();
  };
  onItemCostChange = (e) => {
    this.props.onItemCostChange(e);
  };
  closeVendorReferncePopup = () => {
    this.props.closeVendorReferncePopup();
  };
  generateVendorColorReferenceInfoList = () => {
    this.props.generateVendorColorReferenceInfoList();
  };
  onVendorCodeMappingChange = (e) => {
    this.props.onVendorCodeMappingChange(e);
  };
  displayAutoCompleteVendorMappingList = (showAutoCompleteVendorList) => {
    this.props.displayAutoCompleteVendorMappingList(showAutoCompleteVendorList);
  };
  vendorCodeMappingEnterKeyEventHandler = (e) => {
    this.props.vendorCodeMappingEnterKeyEventHandler(e);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  render() {
    let isVendorMappingPopup = this.props.isVendorMappingPopup;
    let vendorReferenceData = this.props.venReferenceData;
    let venReferneceCaption = this.props.venReferneceCaption;
    let selectedVendorRefLine = this.props.selectedVendorRefLine;
    let fabricStyleData = this.props.fabricStyleData;
    let isDisbleAddorUpdateButton = false;
    let vendorList = this.props.vendor_List;
    let isDisabledFields = this.props.isDisabledFields;
    if (selectedVendorRefLine != null) {
      if (
        selectedVendorRefLine.vendorCode != null ||
        selectedVendorRefLine.vendorCode.length > 0
      ) {
        vendorReferenceData = this.props.selectedVendorRefLine;
      }
    }
    let venColorReferneces = [];
    if (vendorReferenceData.fabricStyleColorVendorReferences != null) {
      vendorReferenceData.fabricStyleColorVendorReferences.map((line) => {
        venColorReferneces.push(line);
      });
    }
    const is3PL = this.props.is3PL;
    return (
      <div class="center_div col-md-12 col-lg-12 text-center">
        <Row>
          <Col sm="1">
            {is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              onChange={this.onItemCostChange}
              value={fabricStyleData.code}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="description"
              onChange={this.onItemCostChange}
              value={fabricStyleData.description}
              disabled={true}
            />{" "}
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>Ven#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.vendorCodeRef}
              name="vendorCode"
              placeholder="Select vendorCode"
              onChange={this.onVendorCodeMappingChange}
              value={vendorReferenceData.vendorCode}
              lookupRequired={true}
              lookupHandler={this.state.vendorLookupHandler}
              enterKeyEventHandler={this.vendorCodeMappingEnterKeyEventHandler}
              autoCompleteListData={
                this.props.vendorPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.displayAutoCompleteVendorMappingList
              }
              showAutoCompleteList={this.props.showAutoCompleteVendorList}
              disabled={isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="vendorName"
              onChange={this.onItemCostChange}
              value={vendorReferenceData.vendorName}
              disabled={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>Vendor Style#</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="vendorStyleReferenceCode"
              placeholder="Enter vendorStyleReferenceCode"
              onChange={this.onItemCostChange}
              value={vendorReferenceData.vendorStyleReferenceCode}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>Style Desc</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="vendorStyleReferenceName"
              placeholder="Enter vendorStyleReferenceName"
              onChange={this.onItemCostChange}
              value={vendorReferenceData.vendorStyleReferenceName}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="2">
            <div>
              {" "}
              <FormLabel>Primary Vendor</FormLabel>
            </div>
          </Col>
          <Col sm="1">
            <div>
              <InputCheckbox
                name="isPrimaryVendorFlag"
                type="checkbox"
                checked={vendorReferenceData.isPrimaryVendorFlag}
                onChange={this.onItemCostChange}
                disabled={isDisabledFields}
              />
            </div>
          </Col>
        </Row>
        <div className="div_Custom_1">
          <Table id="fabrics_tables">
            <thead>
              <tr>
                {is3PL ? <th>Item#</th> : <th>Fabric#</th>}
                <th>Vendor#</th>
                <th>Color</th>
                <th>Name</th>
                <th>VenColor</th>
                <th>Name</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {venColorReferneces.map((line, i) => (
                <tr key={i} data-item={line}>
                  <td>{line.fabricStyleCode}</td>
                  <td>{line.vendorCode}</td>
                  <td>{line.fabricStyleColorCode}</td>
                  <td>{line.fabricStyleColorName}</td>
                  <td>{line.vendorStyleColorReferenceCode}</td>
                  <td>{line.vendorStyleColorReferenceName}</td>
                  <td>{line.isActive.toString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}
class FabricStyleCostDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      vendor_List: this.props.vendor_List,
      currencies: this.props.currencies,
      uoms: this.props.uoms,
      isOpenSkuCostPopup: this.props.isOpenSkuCostPopup,
      selectedSkuLine: this.props.selectedSkuLine,
      selectedVendorRefLine: this.props.selectedVendorRefLine,
      isVendorReferencePopup: this.props.isVendorReferencePopup,
      venReferenceData: this.props.venReferenceData,
    };
  }
  componentDidUpdate() {
    //
  }
  vendorHyperLinkClick = (e, rowData) => {
    if (e.detail == 1) this.props.vendorHyperLinkClick(rowData);
  };
  skuHandleHyperLinkClick = (e, rowData) => {
    if (e.detail == 1) this.props.skuHandleHyperLinkClick(rowData);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  addorUpdateSkuCost = (e, selectedSkuLine) => {
    if (e.detail == 1) {
      this.props.addorUpdateSkuCost(selectedSkuLine);
      this.closeSkuCostPopup();
    }
  };
  closeSkuCostPopup = () => {
    this.props.closeSkuCostPopup();
  };
  openExitingVendorReferencePopup = (selectedVenRef) => {
    this.props.openExitingVendorReferencePopup(selectedVenRef);
  };
  handleVendorReferencePopup = (e) => {
    if (e.detail <= 1) this.props.handleVendorReferencePopup();
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.clearLineValues();
    this.clearMiscColorLineValues();
    this.props.closeAlertModalCallBack(isShowPopup);
  };
  onItemCostChange = (e) => {
    this.props.onItemCostChange(e);
  };
  closeVendorReferncePopup = () => {
    this.props.closeVendorReferncePopup();
  };
  addorUpdateVendorReference = (e, venRefData) => {
    venRefData.fabricStyleCode = this.props.fabricStyleData.code;
    if (e.detail == 1) {
      this.props.addorUpdateVendorReference(venRefData);
      if (!isEmptyString(venRefData.vendorCode))
        this.closeVendorReferncePopup();
    }
  };
  generateVendorColorReferenceInfoList = () => {
    this.props.generateVendorColorReferenceInfoList();
  };
  onVendorMapVendorCodeChange = (e) => {
    this.props.onVendorMapVendorCodeChange(e);
  };
  onItemCostVendorCodeChange = (e) => {
    this.props.onItemCostVendorCodeChange(e);
  };
  onSkuCostChange = (e) => {
    this.props.onSkuCostChange(e);
  };
  onSkuCostLineChange = (e) => {
    this.props.onSkuCostLineChange(e);
  };
  getLineDetails = (skuVendorCostData) => {
    this.props.getLineDetails(skuVendorCostData);
  };
  saveVendorSkuCostLine = () => {
    this.props.saveVendorSkuCostLine();
  };
  clearLineValues = () => {
    this.props.clearLineValues();
  };
  deleteVendorSkuCostLine = (line) => {
    this.props.deleteVendorSkuCostLine(line);
  };
  onMiscVendorCodeChange = (e) => {
    this.props.onMiscVendorCodeChange(e);
  };
  onMiscLineChange = (e) => {
    this.props.onMiscLineChange(e);
  };
  deleteSkuMiscColorLine = (line) => {
    this.props.deleteSkuMiscColorLine(line);
  };
  getMiscColorCostLineDetails = (miscCostLinedata) => {
    this.props.getMiscColorCostLineDetails(miscCostLinedata);
  };
  saveSkuColorMiscillaneousLine = () => {
    this.props.saveSkuColorMiscillaneousLine();
  };
  clearMiscColorLineValues = () => {
    this.props.clearMiscColorLineValues();
  };
  onVendorCodeMappingChange = (e) => {
    this.props.onVendorCodeMappingChange(e);
  };
  vendorCodeMappingEnterKeyEventHandler = (e) => {
    this.props.vendorCodeMappingEnterKeyEventHandler(e);
  };
  displayAutoCompleteVendorMappingList = (showAutoCompleteVendorList) => {
    this.props.displayAutoCompleteVendorMappingList(showAutoCompleteVendorList);
  };
  onVendorSkuCostPopupChange = (e) => {
    this.props.onVendorSkuCostPopupChange(e);
  };
  displayAutoCompleteVendorCodeSkuCostPopupList = (
    showAutoCompleteVendorCodeList,
  ) => {
    this.props.displayAutoCompleteVendorCodeSkuCostPopupList(
      showAutoCompleteVendorCodeList,
    );
  };
  vendorSkuCostPopupEnterKeyEventHandler = (e) => {
    this.props.vendorSkuCostPopupEnterKeyEventHandler(e);
  };
  onReasonCodeChange = (e) => {
    this.props.onReasonCodeChange(e);
  };
  reasonEnterKeyEvent = (e) => {
    this.props.reasonEnterKeyEvent(e);
  };
  displayAutoCompleteReasonList = (showAutoCompleteReasonList) => {
    this.props.displayAutoCompleteReasonList(showAutoCompleteReasonList);
  };
  onVendorCodeSkuCostPopupChange = (e) => {
    this.props.onVendorCodeSkuCostPopupChange(e);
  };
  displayAutoCompleteSkuCostPopupVendorList = (showAutoCompleteVendorList) => {
    this.props.displayAutoCompleteSkuCostPopupVendorList(
      showAutoCompleteVendorList,
    );
  };
  vendorCodeSkuCostPopupEnterKeyEventHandler = (e) => {
    this.props.vendorCodeSkuCostPopupEnterKeyEventHandler(e);
  };
  displayAutoCompleteCurrencySkuCostList = (
    showAutoCompleteCurrencyCodeList,
  ) => {
    this.props.displayAutoCompleteCurrencySkuCostList(
      showAutoCompleteCurrencyCodeList,
    );
  };
  onCurrencyCodeSkuCostChange = (e) => {
    this.props.onCurrencyCodeSkuCostChange(e);
  };
  currencyCodeSkuCostEnterKeyEvent = (e) => {
    this.props.currencyCodeSkuCostEnterKeyEvent(e);
  };
  onUomSkuCostChange = (e) => {
    this.props.onUomSkuCostChange(e);
  };
  uomCodeSkuCostEnterKeyEvent = (e) => {
    this.props.uomCodeSkuCostEnterKeyEvent(e);
  };
  displayAutoCompleteUomCodeSkuCostList = (showAutoCompleteUomCodeList) => {
    this.props.displayAutoCompleteUomCodeSkuCostList(
      showAutoCompleteUomCodeList,
    );
  };
  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let _skuLines = [];
    if (fabricStyleData.isFetched == true) {
      _skuLines = fabricStyleData.fabricStyleSkus;
    }
    let _vendorReferencesLines = [];
    if (fabricStyleData.vendorReferences != null) {
      fabricStyleData.vendorReferences.map((vendorRef) => {
        _vendorReferencesLines.push(vendorRef);
      });
    }
    const is3PL = this.props.is3PL;
    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.props.isOpenSkuCostPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"SKU COST DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) =>
                  this.addorUpdateSkuCost(e, this.props.selectedSkuLine)
                }
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <SkuCostPopup
              isDisabledFields={this.props.isDisabledFields}
              is3PL={this.props.is3PL}
              miscReasons={this.props.miscReasons}
              fabricStyleData={this.props.fabricStyleData}
              isOpenSkuCostPopup={this.props.isOpenSkuCostPopup}
              selectedSkuLine={this.props.selectedSkuLine}
              vendor_List={this.props.vendor_List}
              currencies={this.props.currencies}
              uoms={this.props.uoms}
              venReferenceData={this.props.venReferenceData}
              venReferneceCaption={this.props.venReferneceCaption}
              venColorReferneces={this.props.venColorReferneces}
              venRef={this.props.venRef}
              skuCostData={this.props.skuCostData}
              onItemCostVendorCodeChange={this.onItemCostVendorCodeChange}
              skuCostCaption={this.props.skuCostCaption}
              skuVendorCosts={this.props.skuVendorCosts}
              skuVendorCostData={this.props.skuVendorCostData}
              skuMiscCostData={this.props.skuMiscCostData}
              addorUpdateSkuCost={this.addorUpdateSkuCost}
              closeSkuCostPopup={this.closeSkuCostPopup}
              onSkuCostLineChange={this.onSkuCostLineChange}
              clearLineValues={this.clearLineValues}
              saveVendorSkuCostLine={this.saveVendorSkuCostLine}
              getLineDetails={this.getLineDetails}
              onSkuCostChange={this.onSkuCostChange}
              deleteVendorSkuCostLine={this.deleteVendorSkuCostLine}
              onMiscVendorCodeChange={this.onMiscVendorCodeChange}
              onMiscLineChange={this.onMiscLineChange}
              deleteSkuMiscColorLine={this.deleteSkuMiscColorLine}
              getMiscColorCostLineDetails={this.getMiscColorCostLineDetails}
              saveSkuColorMiscillaneousLine={this.saveSkuColorMiscillaneousLine}
              clearMiscColorLineValues={this.clearMiscColorLineValues}
              hideAlertCallBack={this.hideAlertCallBack}
              onVendorSkuCostPopupChange={this.onVendorSkuCostPopupChange}
              vendorSkuCostPopupEnterKeyEventHandler={
                this.vendorSkuCostPopupEnterKeyEventHandler
              }
              displayAutoCompleteVendorCodeSkuCostPopupList={
                this.displayAutoCompleteVendorCodeSkuCostPopupList
              }
              showAutoCompleteVendorCodeList={
                this.props.showAutoCompleteVendorCodeList
              }
              vendorCodePageListForAutoCompleteList={
                this.props.vendorCodePageListForAutoCompleteList
              }
              onReasonCodeChange={this.onReasonCodeChange}
              reasonEnterKeyEvent={this.reasonEnterKeyEvent}
              displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
              showAutoCompleteReasonList={this.props.showAutoCompleteReasonList}
              reasonPageListForAutoCompleteList={
                this.props.reasonPageListForAutoCompleteList
              }
              vendorCodeSkuCostPopupEnterKeyEventHandler={
                this.vendorCodeSkuCostPopupEnterKeyEventHandler
              }
              onVendorCodeSkuCostPopupChange={
                this.onVendorCodeSkuCostPopupChange
              }
              displayAutoCompleteSkuCostPopupVendorList={
                this.displayAutoCompleteSkuCostPopupVendorList
              }
              vendorPageListForAutoCompleteList={
                this.props.vendorPageListForAutoCompleteList
              }
              showAutoCompleteVendorList={this.props.showAutoCompleteVendorList}
              onCurrencyCodeSkuCostChange={this.onCurrencyCodeSkuCostChange}
              currencyCodeSkuCostEnterKeyEvent={
                this.currencyCodeSkuCostEnterKeyEvent
              }
              displayAutoCompleteCurrencySkuCostList={
                this.displayAutoCompleteCurrencySkuCostList
              }
              currencyCodePageListForAutoCompleteList={
                this.props.currencyCodePageListForAutoCompleteList
              }
              showAutoCompleteCurrencyCodeList={
                this.props.showAutoCompleteCurrencyCodeList
              }
              onUomSkuCostChange={this.onUomSkuCostChange}
              uomCodeSkuCostEnterKeyEvent={this.uomCodeSkuCostEnterKeyEvent}
              displayAutoCompleteUomCodeSkuCostList={
                this.displayAutoCompleteUomCodeSkuCostList
              }
              showAutoCompleteUomCodeList={
                this.props.showAutoCompleteUomCodeList
              }
              uomCodePageListForAutoCompleteList={
                this.props.uomCodePageListForAutoCompleteList
              }
              onLandingCostChange={this.props.onLandingCostChange}
              skuCostOnChange={this.props.skuCostOnChange}
              // isDisabledFields={this.props.isDisabledFields}
              setVendorCostLineData={this.props.setVendorCostLineData}
              // skuCostData={this.props.skuCostData}
            />
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.props.isVendorReferencePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"VENDOR ITEM MAPPING ENTRY"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) =>
                  this.addorUpdateVendorReference(
                    e,
                    this.props.venReferenceData,
                  )
                }
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <FabricStyleVendorMappingPopup
              is3PL={this.props.is3PL}
              fabricStyleData={this.props.fabricStyleData}
              isVendorReferencePopup={this.props.isVendorReferencePopup}
              selectedVendorRefLine={this.props.selectedVendorRefLine}
              vendor_List={this.props.vendor_List}
              venReferenceData={this.props.venReferenceData}
              isDisabledFields={this.props.isDisabledFields}
              venReferneceCaption={this.props.venReferneceCaption}
              venColorReferneces={this.props.venColorReferneces}
              venRef={this.props.venRef}
              colorList={this.props.colorList}
              addorUpdateVendorReference={this.addorUpdateVendorReference}
              closeVendorReferncePopup={this.closeVendorReferncePopup}
              onItemCostChange={this.onItemCostChange}
              onVendorMapVendorCodeChange={this.onVendorMapVendorCodeChange}
              generateVendorColorReferenceInfoList={
                this.generateVendorColorReferenceInfoList
              }
              onVendorCodeMappingChange={this.onVendorCodeMappingChange}
              vendorCodeMappingEnterKeyEventHandler={
                this.vendorCodeMappingEnterKeyEventHandler
              }
              displayAutoCompleteVendorMappingList={
                this.displayAutoCompleteVendorMappingList
              }
              showAutoCompleteVendorList={this.props.showAutoCompleteVendorList}
              vendorPageListForAutoCompleteList={
                this.props.vendorPageListForAutoCompleteList
              }
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
        />
        <div class="center_div col-md-12 col-lg-12 text-center">
          <div className="div_default">
            <Row>
              <Col sm="1">
                {is3PL ? (
                  <FormLabel>Item code</FormLabel>
                ) : (
                  <FormLabel>FabricStyle code</FormLabel>
                )}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="code"
                  type="text"
                  value={fabricStyleData.code}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Current Cost</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  name="cost"
                  decimalScale={2}
                  value={fabricStyleData.cost}
                  onChange={this.props.costOnChange}
                />
              </Col>
            </Row>
            <div class="div_Equal">
              <FormLabel className="table_title">
                {" "}
                SKU(Store Keeping Unit){" "}
              </FormLabel>
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th>Color</th>
                    <th>SKU</th>
                    <th>UOM</th>
                    <th>Cost</th>
                    <th>LandingCost</th>
                    <th>RmbCost</th>
                  </tr>
                </thead>
                <tbody>
                  {_skuLines.map((sku, index) => (
                    <tr key={index}>
                      <td className="text-right">{sku.fabricStyleColorCode}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.skuHandleHyperLinkClick(e, sku)}
                        >
                          {sku.skuNumber}
                        </Button>
                      </td>
                      <td className="text-right">{sku.uomCode}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.skuHandleHyperLinkClick(e, sku)}
                        >
                          {sku.cost}
                        </Button>
                      </td>
                      <td className="text-right">{sku.landingCost}</td>
                      <td className="text-right">{sku.rmbCost}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div class="div_Equal">
              <Row>
                <Col sm="4">
                  <FormLabel className="table_title">
                    {" "}
                    Vendor -FabricStyle Mapping{" "}
                  </FormLabel>
                </Col>
                <Col sm="1">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    size="sm1"
                    bssize="large"
                    onClick={(e) => this.handleVendorReferencePopup(e)}
                  >
                    Add
                  </Button>
                </Col>
              </Row>
              <div></div>
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>Name</th>
                    <th>VendorStyleCode</th>
                    <th>VendorStyleDesc</th>
                  </tr>
                </thead>
                <tbody>
                  {_vendorReferencesLines.map((ln, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.vendorHyperLinkClick(e, ln)}
                        >
                          {ln.vendorCode}
                        </Button>
                      </td>
                      <td className="text-right">{ln.vendorName}</td>
                      <td className="text-right">
                        {ln.vendorStyleReferenceCode}
                      </td>
                      <td className="text-right">
                        {ln.vendorStyleReferenceName}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class SkuCostPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.vendorCodeRef = React.createRef();
    this.vendorCodeRef_ = React.createRef();
    this.vendorNameRef = React.createRef();
    this.currencyCodeRef = React.createRef();
    this.uomCodeRef = React.createRef();
    this.miscReasonCodeRef = React.createRef();
    this.state = {
      isOpenSkuCostPopup: this.props.isOpenSkuCostPopup,
      fabricStyleData: this.props.fabricStyleData,
      skuCostData: this.props.selectedSkuLine.skuCostBean,
      skuCostCaption: this.props.skuCostCaption,
      skuVendorCosts: this.props.skuVendorCosts,
      skuVendorCostData: this.props.skuVendorCostData,
      skuMiscCostData: this.props.skuMiscCostData,
      selectedSkuLine: this.props.selectedSkuLine,
      vendor_List: this.props.vendor_List,
      currencies: this.props.currencies,
      uoms: this.props.uoms,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let prp_fabricStyleData = this.props.fabricStyleData;
    let isOpenSkuCostPopup = this.props.isOpenSkuCostPopup;
    let selectedSkuLine = this.props.selectedSkuLine;
    let skuCostData = this.state.skuCostData;
    if (skuCostData != null) {
      skuCostData.cost = selectedSkuLine.standardCost;
      skuCostData.description = prp_fabricStyleData.description;
    }
    let skuCostCaption = this.props.uomCaption;

    this.setState({
      isOpenSkuCostPopup: isOpenSkuCostPopup,
      skuCostCaption: skuCostCaption,
      selectedSkuLine: selectedSkuLine,
    });
    this.initLookupHandlers();
    this.setFocus();
    this.props.setVendorCostLineData();
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });

    let uomLookupHandler = new GenericAttributeLookupHandler(
      this.props.uoms,
      "UOM",
    );
    this.setState({ uomLookupHandler: uomLookupHandler });

    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.props.currencies,
      "UOM",
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });

    let miscLookupHandler = new GenericAttributeLookupHandler(
      this.props.miscReasons,
      "Reason",
    );
    this.setState({ miscLookupHandler: miscLookupHandler });
  };
  setFocus = () => {
    if (
      this.vendorCodeRef.current != null &&
      this.vendorCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.vendorCodeRef.current.focus();
      }, 100);
    }
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  closeSkuCostPopup = () => {
    this.props.closeSkuCostPopup();
  };
  onItemCostVendorCodeChange = (e) => {
    this.props.onItemCostVendorCodeChange(e);
  };
  onSkuCostChange = (e) => {
    this.props.onSkuCostChange(e);
  };
  onLandingCostChange = (e) => {
    this.props.onLandingCostChange(e);
  };
  onSkuCostLineChange = (e) => {
    this.props.onSkuCostLineChange(e);
  };
  getLineDetails = (e, skuVendorCostData) => {
    if (e.detail == 1) this.props.getLineDetails(skuVendorCostData);
  };
  saveVendorSkuCostLine = (e) => {
    if (e.detail <= 1) this.props.saveVendorSkuCostLine();
  };

  clearLineValues = (e) => {
    if (e.detail <= 1) {
      if (this.vendorCodeRef.current != null) {
        this.vendorCodeRef.current.clear();
      }
      if (this.vendorCodeRef_.current != null) {
        this.vendorCodeRef_.current.clear();
      }
      if (this.currencyCodeRef.current != null) {
        this.currencyCodeRef.current.clear();
      }
      if (this.uomCodeRef.current != null) {
        this.uomCodeRef.current.clear();
      }
      if (this.vendorNameRef.current != null) {
        this.vendorNameRef.current.clear();
      }
      this.props.clearLineValues();
    }
  };
  deleteVendorSkuCostLine = (e, line) => {
    if (e.detail <= 1) this.props.deleteVendorSkuCostLine(line);
  };
  onMiscVendorCodeChange = (e) => {
    this.props.onMiscVendorCodeChange(e);
  };
  onMiscLineChange = (e) => {
    this.props.onMiscLineChange(e);
  };
  deleteSkuMiscColorLine = (e, line) => {
    if (e.detail <= 1) this.props.deleteSkuMiscColorLine(line);
  };
  getMiscColorCostLineDetails = (e, miscCostLinedata) => {
    if (e.detail == 1) this.props.getMiscColorCostLineDetails(miscCostLinedata);
  };

  saveSkuColorMiscillaneousLine = (e) => {
    if (e.detail <= 1) this.props.saveSkuColorMiscillaneousLine();
  };
  clearMiscColorLineValues = (e) => {
    if (e.detail <= 1) {
      if (this.miscReasonCodeRef.current != null) {
        this.miscReasonCodeRef.current.clear();
      }

      if (this.vendorCodeRef_.current != null) {
        this.vendorCodeRef_.current.clear();
      }
      this.props.clearMiscColorLineValues();
    }
  };
  onVendorSkuCostPopupChange = (e) => {
    this.props.onVendorSkuCostPopupChange(e);
  };

  displayAutoCompleteVendorCodeSkuCostPopupList = (
    showAutoCompleteVendorCodeList,
  ) => {
    this.props.displayAutoCompleteVendorCodeSkuCostPopupList(
      showAutoCompleteVendorCodeList,
    );
  };
  vendorSkuCostPopupEnterKeyEventHandler = (e) => {
    this.props.vendorSkuCostPopupEnterKeyEventHandler(e);
  };
  onReasonCodeChange = (e) => {
    this.props.onReasonCodeChange(e);
  };

  reasonEnterKeyEvent = (e) => {
    this.props.reasonEnterKeyEvent(e);
  };
  displayAutoCompleteReasonList = (showAutoCompleteReasonList) => {
    this.props.displayAutoCompleteReasonList(showAutoCompleteReasonList);
  };

  onVendorCodeSkuCostPopupChange = (e) => {
    this.props.onVendorCodeSkuCostPopupChange(e);
  };
  displayAutoCompleteSkuCostPopupVendorList = (showAutoCompleteVendorList) => {
    this.props.displayAutoCompleteSkuCostPopupVendorList(
      showAutoCompleteVendorList,
    );
  };
  vendorCodeSkuCostPopupEnterKeyEventHandler = (e) => {
    this.props.vendorCodeSkuCostPopupEnterKeyEventHandler(e);
  };
  displayAutoCompleteCurrencySkuCostList = (
    showAutoCompleteCurrencyCodeList,
  ) => {
    this.props.displayAutoCompleteCurrencySkuCostList(
      showAutoCompleteCurrencyCodeList,
    );
  };
  onCurrencyCodeSkuCostChange = (e) => {
    this.props.onCurrencyCodeSkuCostChange(e);
  };

  currencyCodeSkuCostEnterKeyEvent = (e) => {
    this.props.currencyCodeSkuCostEnterKeyEvent(e);
  };
  onUomSkuCostChange = (e) => {
    this.props.onUomSkuCostChange(e);
  };

  uomCodeSkuCostEnterKeyEvent = (e) => {
    this.props.uomCodeSkuCostEnterKeyEvent(e);
  };
  displayAutoCompleteUomCodeSkuCostList = (showAutoCompleteUomCodeList) => {
    this.props.displayAutoCompleteUomCodeSkuCostList(
      showAutoCompleteUomCodeList,
    );
  };
  render() {
    let isOpenSkuCostPopup = this.props.isOpenSkuCostPopup;
    let skuCostCaption = this.props.skuCostCaption;
    let fabricStyleData = this.props.fabricStyleData;
    let skuCost_Data = this.props.skuCostData;
    let skuCostData = this.props.selectedSkuLine.skuCostBean;
    if (skuCostData == null) {
      skuCostData = new FabricStyleSKUCostBean();
    }
    let skuVendorCostData = this.props.skuVendorCostData;
    let isDisbleAddorUpdateButton = false;
    //let miscLines = skuCostData.fabricMiscColorDetails;
    let skuMiscCostData = this.props.skuMiscCostData;
    let selectedSkuLine = this.props.selectedSkuLine;
    let vendor_List = this.props.vendor_List;
    let currencies = this.props.currencies;
    let uoms = this.props.uoms;
    let miscReasons = [];
    let skuVendorCosts = [];
    if (selectedSkuLine.skuCostBean != null) {
      if (selectedSkuLine.skuCostBean.skuVendorCosts != null) {
        selectedSkuLine.skuCostBean.skuVendorCosts.map((line) => {
          skuVendorCosts.push(line);
        });
      }
    }
    let miscLines = [];
    if (selectedSkuLine.fabricMiscColorDetails != null) {
      selectedSkuLine.fabricMiscColorDetails.map((line) => {
        miscLines.push(line);
      });
    }
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <div className="sales_line_pop">
          <Row>
            <Col sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                onChange={this.onSkuCostChange}
                value={selectedSkuLine.fabricStyleCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="description"
                onChange={this.onSkuCostChange}
                value={skuCostData.description}
                disabled={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>UOM</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="uomCode"
                onChange={this.onSkuCostChange}
                value={selectedSkuLine.uomCode}
                disabled={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>Color</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="fabricStyleColorCode"
                onChange={this.onSkuCostChange}
                value={selectedSkuLine.fabricStyleColorCode}
                disabled={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>SkuNumber</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="skuNumber"
                onChange={this.onSkuCostChange}
                value={selectedSkuLine.skuNumber}
                disabled={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>Currency</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="currencyCode"
                onChange={this.onSkuCostChange}
                value={selectedSkuLine.currencyCode}
                disabled={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>Current Cost</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="cost"
                placeholder="Enter cost"
                onChange={this.onLandingCostChange}
                value={selectedSkuLine.cost}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>landed Cost</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="landingCost"
                placeholder="cost"
                onChange={this.onLandingCostChange}
                value={selectedSkuLine.landingCost}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Date</FormLabel>
            </Col>

            <Col sm="2">
              <DatePickerComponent
                name="effectiveDate"
                value={selectedSkuLine.skuPriceBean.effectiveDate}
                onChange={this.onLandingCostChange}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>{" "}
          <br />
          <div className="sales_grid_columns">
            <div>
              <div className="div_Custom">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th>Ln#</th>
                      <th>Vendor#</th>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Cost</th>
                      <th>Currency#</th>
                      <th>P.O</th>
                      <th>PurchaseCost</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {skuVendorCosts.map(
                      (line, i) =>
                        line.isDeleted != true && (
                          <tr key={i} data-item={line}>
                            <td>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) => this.getLineDetails(e, line)}
                              >
                                {line.lineNumber}
                              </Button>
                            </td>
                            <td>{line.vendorCode}</td>
                            <td>{line.vendorName}</td>
                            <td>{line.effectiveDate}</td>
                            <td>{line.cost}</td>
                            <td>{line.currencyCode}</td>
                            <td>{line.purchaseOrderNumber}</td>
                            <td>{line.cost}</td>
                            <td>
                              <Button
                                id="fabric_Add_Button"
                                className="enterFocus"
                                size="sm1"
                                bssize="large"
                                onClick={(e) =>
                                  this.deleteVendorSkuCostLine(e, line)
                                }
                                disabled={this.props.isDisabledFields}
                              >
                                <DeleteIcon />
                              </Button>
                            </td>
                          </tr>
                        ),
                    )}
                  </tbody>
                </Table>
              </div>
              <Row>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Ven#</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    ref={this.vendorCodeRef}
                    name="vendorCode"
                    //type="vendorCode"
                    placeholder="Select vendorCode"
                    onChange={this.onVendorCodeSkuCostPopupChange}
                    value={skuVendorCostData.vendorCode}
                    lookupRequired={true}
                    lookupHandler={this.state.vendorLookupHandler}
                    enterKeyEventHandler={
                      this.vendorCodeSkuCostPopupEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.props.vendorPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteSkuCostPopupVendorList
                    }
                    showAutoCompleteList={this.props.showAutoCompleteVendorList}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>

                <Col sm="6">
                  <InputTextbox
                    name="vendorName"
                    ref={this.vendorNameRef}
                    onChange={this.onSkuCostLineChange}
                    value={skuVendorCostData.vendorName}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>{" "}
              <Row>
                <Col className="align-items-left" sm="2">
                  <FormLabel>VenCost</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    name={"cost"}
                    value={skuVendorCostData.cost}
                    onChange={this.onSkuCostLineChange}
                    className="text-right"
                    decimalScale={2}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>

                <Col sm="2">
                  <FormLabel>Currency</FormLabel>{" "}
                </Col>

                <Col sm="4">
                  <InputTextbox
                    name="currencyCode"
                    onChange={this.onCurrencyCodeSkuCostChange}
                    ref={this.currencyCodeRef}
                    value={skuVendorCostData.currencyCode}
                    lookupRequired={true}
                    lookupHandler={this.state.currencyLookupHandler}
                    enterKeyEventHandler={this.currencyCodeSkuCostEnterKeyEvent}
                    autoCompleteListData={
                      this.props.currencyCodePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteCurrencySkuCostList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteCurrencyCodeList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>UOM</FormLabel>{" "}
                </Col>

                <Col sm="4">
                  <InputTextbox
                    name="uomCode"
                    onChange={this.onUomSkuCostChange}
                    ref={this.uomCodeRef}
                    value={skuVendorCostData.uomCode}
                    lookupRequired={true}
                    lookupHandler={this.state.uomLookupHandler}
                    enterKeyEventHandler={this.uomCodeSkuCostEnterKeyEvent}
                    autoCompleteListData={
                      this.props.uomCodePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteUomCodeSkuCostList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteUomCodeList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Date</FormLabel>
                </Col>
                <Col sm="4">
                  <DatePickerComponent
                    onChange={this.onSkuCostLineChange}
                    name="effectiveDate"
                    value={skuVendorCostData.effectiveDate}
                  ></DatePickerComponent>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <div>
                    {" "}
                    <FormLabel>IsDefault</FormLabel>
                  </div>
                </Col>
                <Col sm="2">
                  <div>
                    <InputCheckbox
                      name="isDefaultCost"
                      type="checkbox"
                      checked={skuVendorCostData.isDefaultCost}
                      onChange={this.onSkuCostLineChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col>
              </Row>
              <div className="button-flex">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.saveVendorSkuCostLine(e)}
                >
                  Add / Update{" "}
                </Button>
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.clearLineValues(e)}
                >
                  Clear{" "}
                </Button>
              </div>
            </div>
            <div>
              <div className="div_Custom">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th>Ln#</th>
                      <th>Reason#</th>
                      <th>Name</th>
                      <th>Vendor#</th>
                      <th>Name</th>
                      <th>MiscCost</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {miscLines.map(
                      (line, i) =>
                        line.isDeleted != true && (
                          <tr key={i} data-item={line}>
                            <td>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.getMiscColorCostLineDetails(e, line)
                                }
                              >
                                {line.lineNumber}
                              </Button>
                            </td>
                            <td>{line.code}</td>
                            <td>{line.description}</td>
                            <td>{line.vendorCode}</td>
                            <td>{line.vendorName}</td>
                            <td>{line.miscellaneousCost}</td>
                            <td>
                              <Button
                                id="fabric_Add_Button"
                                className="enterFocus"
                                size="sm1"
                                bssize="large"
                                onClick={(e) =>
                                  this.deleteSkuMiscColorLine(e, line)
                                }
                                disabled={this.props.isDisabledFields}
                              >
                                <DeleteIcon />
                              </Button>
                            </td>
                          </tr>
                        ),
                    )}
                  </tbody>
                </Table>
              </div>
              <div>
                <Row>
                  <Col className="align-items-left" sm="2">
                    {" "}
                    <FormLabel>Ln#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="lineNumber"
                      value={skuMiscCostData.lineNumber}
                      onChange={this.onMiscLineChange}
                      disabled={true}
                    />
                  </Col>
                  <Col className="align-items-left" sm="2">
                    {" "}
                    <FormLabel>MiscCost</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="miscellaneousCost"
                      value={skuMiscCostData.miscellaneousCost}
                      onChange={this.onMiscLineChange}
                      className="text-right"
                      decimalScale={2}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left" sm="2">
                    {" "}
                    <FormLabel>Reason#</FormLabel>{" "}
                  </Col>

                  <Col sm="4">
                    <InputTextbox
                      name="code"
                      placeholder="Enter Reason"
                      onChange={this.onReasonCodeChange}
                      value={skuMiscCostData.code}
                      ref={this.miscReasonCodeRef}
                      lookupHandler={this.state.miscLookupHandler}
                      lookupRequired={true}
                      enterKeyEventHandler={this.reasonEnterKeyEvent}
                      autoCompleteListData={
                        this.props.reasonPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteReasonList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteReasonList
                      }
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>

                  <Col sm="6">
                    <InputTextbox
                      name="description"
                      onChange={this.onMiscLineChange}
                      value={skuMiscCostData.description}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>{" "}
                <Row>
                  <Col className="align-items-left" sm="2">
                    <FormLabel>Ven#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      ref={this.vendorCode_Ref}
                      name="vendorCode"
                      placeholder="Select Vendor"
                      onChange={this.onVendorSkuCostPopupChange}
                      value={skuMiscCostData.vendorCode}
                      lookupHandler={this.state.vendorLookupHandler}
                      lookupRequired={true}
                      enterKeyEventHandler={
                        this.vendorSkuCostPopupEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.vendorCodePageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteVendorCodeSkuCostPopupList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteVendorCodeList
                      }
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      name="vendorName"
                      placeholder="Enter vendorName"
                      onChange={this.onSkuCostChange}
                      value={skuMiscCostData.vendorName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>{" "}
                <div className="button-flex">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    size="sm1"
                    bssize="large"
                    onClick={(e) => this.saveSkuColorMiscillaneousLine(e)}
                  >
                    Add / Update
                  </Button>

                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    size="sm1"
                    bssize="large"
                    onClick={(e) => this.clearMiscColorLineValues(e)}
                  >
                    Clear
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class FabricStyleMiscCostDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.miscReasonCodeRef = React.createRef();
    this.vendorCodeRef = React.createRef();
    this.vendorNameRef = React.createRef();
    this.miscReasonNameRef = React.createRef();

    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      miscReasons: this.props.miscReasons,
      vendor_List: this.props.vendor_List,
      editedMiscCostLineList: this.props.editedMiscCostLineList,
      fabricStyleMiscCostLineData: this.props.fabricStyleMiscCostLineData,
    };
  }

  componentDidMount() {
    this.initLookupHandlers();
    this.setFocus();
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });

    let reasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.miscReasons,
      "Reason",
    );
    this.setState({ reasonLookupHandler: reasonLookupHandler });
  };
  setFocus = () => {
    if (
      this.miscReasonCodeRef.current != null &&
      this.miscReasonCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.miscReasonCodeRef.current.focus();
      }, 100);
    }
  };

  componentDidUpdate() {
    //
  }

  onVendorCodeChange = (e) => {
    this.props.onVendorCodeChange(e);
  };
  onMiscCostChange = (e) => {
    this.props.onMiscCostChange(e);
  };
  saveMiscillaneousLine = (e) => {
    if (e.detail <= 1) this.props.saveMiscillaneousLine();
  };
  getMiscCostLineDetails = (e, miscCostLinedata) => {
    if (e.detail <= 1) this.props.getMiscCostLineDetails(miscCostLinedata);
  };

  deleteVendorMiscellaneousLine = (e, miscCostLinedata) => {
    if (e.detail <= 1)
      this.props.deleteVendorMiscellaneousLine(miscCostLinedata);
  };
  clearMiscLineValues = (e) => {
    if (e.detail <= 1) {
      if (this.miscReasonCodeRef.current != null) {
        this.miscReasonCodeRef.current.clear();
      }

      if (this.miscReasonNameRef.current != null) {
        this.miscReasonNameRef.current.clear();
      }

      if (this.vendorCodeRef.current != null) {
        this.vendorCodeRef.current.clear();
      }

      if (this.vendorNameRef.current != null) {
        this.vendorNameRef.current.clear();
      }

      this.props.clearMiscLineValues();
    }
  };
  applyToAllMiscDetail = (e) => {
    if (e.detail <= 1) this.props.applyToAllMiscDetail();
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  onVendorCodeMiscCostChange = (e) => {
    this.props.onVendorCodeMiscCostChange(e);
  };
  vendorCodeMiscCostEnterKeyEventHandler = (e) => {
    this.props.vendorCodeMiscCostEnterKeyEventHandler(e);
  };
  displayAutoCompleteVendorMiscCostList = (showAutoCompleteVendorList) => {
    this.props.displayAutoCompleteVendorMiscCostList(
      showAutoCompleteVendorList,
    );
  };
  onReasonMiscCostDetailChange = (e) => {
    this.props.onReasonMiscCostDetailChange(e);
  };
  reasonMiscCostDetailEnterKeyEvent = (e) => {
    this.props.reasonMiscCostDetailEnterKeyEvent(e);
  };
  displayAutoCompleteReasonMiscCostDetailList = (
    showAutoCompleteReasonList,
  ) => {
    this.props.displayAutoCompleteReasonMiscCostDetailList(
      showAutoCompleteReasonList,
    );
  };

  render() {
    let isDisabledFields = this.props.isDisabledFields;
    let fabricStyleMiscCostLineData = this.props.fabricStyleMiscCostLineData;
    let fabricStyleData = this.props.fabricStyleData;
    let miscLines = [];
    if (fabricStyleData.fabricMiscDetails != null) {
      miscLines = fabricStyleData.fabricMiscDetails;
    }
    let miscReasons = this.props.miscReasons;
    let vendorList = this.props.vendor_List;
    const is3PL = this.props.is3PL;

    return (
      <div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox value={fabricStyleData.code} disabled={true} />
            </Col>
            <Col sm="2">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.applyToAllMiscDetail(e)}
                disabled={this.props.isDisabledFields}
              >
                Apply To All
              </Button>
            </Col>
          </Row>
          <Row>
            {" "}
            <Col sm="2">
              <FormLabel className="table_title">
                {" "}
                Miscellaneous Cost Details
              </FormLabel>
            </Col>
          </Row>
          <div className="div_Custom_3">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th>Ln#</th>
                  <th>Reason#</th>
                  <th>Desc</th>
                  <th>vendor</th>
                  <th>Name</th>
                  <th>MiscCost</th>
                  <th>Delete Line</th>
                </tr>
              </thead>
              <tbody>
                {miscLines.map(
                  (mLine, i) =>
                    mLine.isDeleted != true && (
                      <tr key={i} data-item={mLine}>
                        <td>
                          <Button
                            id="fabric_Add_Button"
                            className="enterFocus"
                            size="sm1"
                            bssize="large"
                            onClick={(e) =>
                              this.getMiscCostLineDetails(e, mLine)
                            }
                          >
                            {mLine.lineNumber}
                          </Button>
                        </td>
                        <td>{mLine.code}</td>
                        <td>{mLine.description}</td>
                        <td>{mLine.vendorCode}</td>
                        <td>{mLine.vendorName}</td>
                        <td>{mLine.miscellaneousCost}</td>
                        <td>
                          <Button
                            id="fabric_Add_Button"
                            className="enterFocus"
                            size="sm1"
                            bssize="large"
                            onClick={(e) =>
                              this.deleteVendorMiscellaneousLine(e, mLine)
                            }
                            disabled={this.props.isDisabledFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ),
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="header_div">
          <Row>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Ln#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lineNumber"
                readOnly={true}
                onChange={this.onMiscCostChange}
                value={fabricStyleMiscCostLineData.lineNumber}
                disabled={isDisabledFields}
              />{" "}
            </Col>{" "}
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Reason#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                placeholder="Select Reason"
                ref={this.miscReasonCodeRef}
                onChange={this.onReasonMiscCostDetailChange}
                value={fabricStyleMiscCostLineData.code}
                lookupRequired={true}
                lookupHandler={this.state.reasonLookupHandler}
                enterKeyEventHandler={this.reasonMiscCostDetailEnterKeyEvent}
                autoCompleteListData={
                  this.props.reasonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteReasonMiscCostDetailList
                }
                showAutoCompleteList={this.props.showAutoCompleteReasonList}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="description"
                onChange={this.onMiscCostChange}
                value={fabricStyleMiscCostLineData.description}
                ref={this.miscReasonNameRef}
                disabled={true}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Misc Cost</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="miscellaneousCost"
                value={fabricStyleMiscCostLineData.miscellaneousCost}
                onChange={this.onMiscCostChange}
                className="text-right"
                decimalScale={2}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>{" "}
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Vendor#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="vendorCode"
                // type="vendorCode"
                placeholder="Select vendorCode"
                ref={this.vendorCodeRef}
                onChange={this.onVendorCodeMiscCostChange}
                value={fabricStyleMiscCostLineData.vendorCode}
                lookupRequired={true}
                lookupHandler={this.state.vendorLookupHandler}
                enterKeyEventHandler={
                  this.vendorCodeMiscCostEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.vendorPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteVendorMiscCostList
                }
                showAutoCompleteList={this.props.showAutoCompleteVendorList}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="vendorName"
                ref={this.vendorNameRef}
                onChange={this.onMiscCostChange}
                value={fabricStyleMiscCostLineData.vendorName}
                disabled={true}
              />{" "}
            </Col>
          </Row>{" "}
          <div className="button-flex">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.saveMiscillaneousLine(e)}
              disabled={isDisabledFields}
            >
              Add / Update
            </Button>

            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.clearMiscLineValues(e)}
              disabled={isDisabledFields}
            >
              Clear
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

class FabricStyleInventoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      inventoryDataList: [],
      skuInventoryList: [],
      criteria: new FabricStyleInventoryForLotBasedSearchCriteria(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      showAutoCompleteColorPopupList: true,
      colorPopupPageListForAutoCompleteList: new Array(),
      fabricStyleColorList: [],
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage();
    this.loadColors();
    this.setFocus();
  }

  componentDidUpdate() {
    //
  }
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    if (this.props.is3PL) {
      criteria.logisticCustomerCode = fabricStyleData.customerCode;
    }
    this.loadFabricInventoryLotInquiryList(criteria);
  };
  loadFabricInventoryLotInquiryList = (criteria) => {
    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: this.props.is3PL ? "read Item" : "read Fabric",
      });
      InventoryService.getFabricStyleInventoryForLotBased(
        criteria,
        this.loadFabricInventoryLotPageResponse,
        this.loadFabricInventoryLotPageError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFabricInventoryLotPageResponse = (response) => {
    let inquiryList = response.data.result;
    if (inquiryList != null) {
      let skuInventoryList = [];
      if (response.data.result.skuInventoryDataDetails != null) {
        skuInventoryList = response.data.result.skuInventoryDataDetails;
        this.setState({
          skuInventoryList: skuInventoryList,
          inventoryDataList: [],
        });
      }
    }
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
    this.setFocus();
  };
  loadFabricInventoryLotPageError = (error) => {
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
    ShowError("loadFabricInventoryLotPageError :" + error);
    this.setFocus();
  };
  onHandQuantityClick = (e, val, rowData) => {
    if (e.detail == 1) {
      let inventoryDataList = [];
      if (rowData.inventoryDataDetails != null) {
        inventoryDataList = rowData.inventoryDataDetails;
        this.setState({ inventoryDataList: inventoryDataList });
      }
    }
  };
  fetchInventory = (e) => {
    let tempCriteria = this.state.criteria;
    let criteria = new FabricStyleInventoryForLotBasedSearchCriteria();
    criteria.colorCode = tempCriteria.colorCode;
    criteria.lotNumber = tempCriteria.lotNumber;
    if (e.detail <= 1) this.loadFabricInventoryLotInquiryList(criteria);
  };
  loadColors = () => {
    let fabricStyleColorList = this.props.fabricStyleData.colors;
    let simpleAutoCompleteList = new Array();
    fabricStyleColorList.map((colorCodeDatas) => {
      let simpleItemBean = {
        code: colorCodeDatas.fabricStyleColorCode,
        description: colorCodeDatas.fabricStyleColorName,
      };
      simpleAutoCompleteList.push(simpleItemBean);
    });
    this.setState({ fabricStyleColorList: simpleAutoCompleteList });
    this.state.fabricStyleColorList = simpleAutoCompleteList;
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.fabricStyleColorList,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };
  setFocus = () => {
    if (
      this.colorCodeRef.current != null &&
      this.colorCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.colorCodeRef.current.focus();
      }, 100);
    }
  };

  onLotBasedColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteColorPopupList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteColorPopupList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteColorPopupList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColorPopupList;
      let color_Data = this.state.criteria;
      color_Data.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteColorPopupList: showAutoCompleteList,
        criteria: color_Data,
        colorPopupPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "colorCode") {
      temp_fabricStyledata["colorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["colorCode"] = color_Data.code;

          this.state.showAutoCompleteColorPopupList = false;
          let showAutoCompleteList = this.state.showAutoCompleteColorPopupList;
          this.setState({
            showAutoCompleteColorPopupList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorPopupPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  colorLotBasedEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["colorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.colorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorPopupPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorLotBasedList = (showAutoCompleteColorPopupList) => {
    this.setState({
      showAutoCompleteColorPopupList: showAutoCompleteColorPopupList,
    });
  };

  skuInventoryLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "lotNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalOnHandQty", "totalOnHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.onHandQuantityClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No Of Pallets", "numberOfPallets", true, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    if (this.props.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("Total Area", "totalArea", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
    }
    return columns;
  };
  inventoryLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory# " : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    if (this.props.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("UPC", "upcNumber", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
    }
    columns.push(
      new ColumnDefinition()
        .setDetails("Batch", "batchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("WH", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQuantity", "onHandQuantity", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    return columns;
  };
  render() {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div class="center_div col-md-12 col-lg-12 text-center">
        <div className="div_default">
          <div>
            <Row>
              {" "}
              <Col className="align-items-left" sm="1">
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle</FormLabel>
                )}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="code"
                  readOnly={true}
                  value={fabricStyleData.code}
                  disabled={isDisabledFields}
                />{" "}
              </Col>{" "}
              <Col sm="3">
                <InputTextbox
                  name="description"
                  readOnly={true}
                  value={fabricStyleData.description}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                {" "}
                <FormLabel>Color</FormLabel>{" "}
              </Col>
              <Col sm="2  ">
                <InputTextbox
                  ref={this.colorCodeRef}
                  name="colorCode"
                  onChange={this.onLotBasedColorCodeChange}
                  value={criteria.colorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.colorLookupHandler}
                  enterKeyEventHandler={this.colorLotBasedEnterKeyEvent}
                  autoCompleteListData={
                    this.state.colorPopupPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteColorLotBasedList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompleteColorPopupList
                  }
                  disabled={isDisabledFields}
                  isMandatory={true}
                />{" "}
              </Col>{" "}
              <Col className="align-items-left" sm="1">
                {" "}
                <FormLabel>Lot</FormLabel>{" "}
              </Col>
              <Col sm="1">
                <InputTextbox
                  name="lotNumber"
                  onChange={this.onChange}
                  value={criteria.lotNumber}
                  disabled={isDisabledFields}
                  isMandatory={true}
                />{" "}
              </Col>{" "}
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.fetchInventory(e)}
                  disabled={isDisabledFields}
                >
                  {" "}
                  Fetch{" "}
                </Button>
              </Col>{" "}
            </Row>
          </div>
          <div>
            {/* <div className="div_inline"></div> */}
            <div className="div_inline">
              <div className="div_Equal_no_height">
                <div className="mt-3">
                  <CustomTable
                    data={this.state.skuInventoryList}
                    columns={this.skuInventoryLineColumns()}
                  />
                </div>
              </div>
              <div className="div_Equal_no_height">
                <div className="mt-3">
                  <CustomTable
                    data={this.state.inventoryDataList}
                    columns={this.inventoryLineColumns()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
      </div>
    );
  }
}
class FabricStyleInventorySummaryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      inventoryDataList: [],
      skuInventoryList: [],
      criteria: new FabricStyleInventoryForLotBasedSearchCriteria(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      showAutoCompleteSummaryColorPopupList: true,
      colorSummaryForAutoCompleteList: new Array(),
      fabricStyleColorList: [],
      // filterSearchCriteria: new FabricStyleInventoryForLotBasedDataBean(),
      isSearchCriteria: true,
      isResetCriteria: false,
      disabledFilter: false,
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      totalOnhandQty: 0,
      isDisableFilterFields: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage();
    this.loadColors();
    this.setFocus();
  }

  componentDidUpdate() {
    //
  }
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  // onFilterChange = (e) => {
  //   let criteria = this.state.filterSearchCriteria;
  //   criteria[e.target.name] = e.target.value;
  //   this.setState({ filterSearchCriteria: criteria });
  // };
  loadPage = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.isSummary = true;
    if (this.props.is3PL) {
      criteria.logisticCustomerCode = fabricStyleData.customerCode;
    }
    this.loadFabricInventoryLotInquiryList(criteria);
  };
  loadFabricInventoryLotInquiryList = (criteria) => {
    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: this.props.is3PL
          ? "read Item Lot Inventory(Summary)"
          : "read Fabric Lot Inventory (Summary)",
      });
      InventoryService.getFabricStyleInventoryForLotBased(
        criteria,
        this.loadFabricInventoryLotPageResponse,
        this.loadFabricInventoryLotPageError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFabricInventoryLotPageResponse = (response) => {
    let inquiryList = response.data.result;
    if (inquiryList != null) {
      let skuInventoryList = [];
      let totalOnhandQty = 0;
      if (response.data.result.skuInventoryDataDetails != null) {
        skuInventoryList = response.data.result.skuInventoryDataDetails;
        totalOnhandQty = skuInventoryList.reduce((acc, curr) => {
          return acc + curr.totalOnHandQuantity || 0;
        }, 0);
        this.setState({
          skuInventoryList: skuInventoryList,
          inventoryDataList: [],
          totalOnhandQty: totalOnhandQty,
        });
      }
      this.disable();
    }
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
    this.setFocus();
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  loadFabricInventoryLotPageError = (error) => {
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
    ShowError("loadFabricInventoryLotPageError :" + error);
    this.setFocus();
  };
  onHandQuantityClick = (e, val, rowData) => {
    if (e.detail == 1) {
      let inventoryDataList = [];
      if (rowData.inventoryDataDetails != null) {
        inventoryDataList = rowData.inventoryDataDetails;
        this.setState({ inventoryDataList: inventoryDataList });
      }
    }
  };
  fetchInventory = (e) => {
    let tempCriteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = new FabricStyleInventoryForLotBasedSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.colorCode = tempCriteria.colorCode;
    criteria.lotNumber = tempCriteria.lotNumber;
    criteria.purchaseOrderNumber = tempCriteria.purchaseOrderNumber;
    criteria.purchaseOrderReceiptNumber =
      tempCriteria.purchaseOrderReceiptNumber;
    criteria.isSummary = true;
    if (e.detail <= 1) this.loadFabricInventoryLotInquiryList(criteria);
  };
  loadColors = () => {
    let fabricStyleColorList = this.props.fabricStyleData.colors;
    let simpleAutoCompleteList = new Array();
    fabricStyleColorList.map((colorCodeDatas) => {
      let simpleItemBean = {
        code: colorCodeDatas.fabricStyleColorCode,
        description: colorCodeDatas.fabricStyleColorName,
      };
      simpleAutoCompleteList.push(simpleItemBean);
    });
    this.setState({ fabricStyleColorList: simpleAutoCompleteList });
    this.state.fabricStyleColorList = simpleAutoCompleteList;
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.fabricStyleColorList,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };
  setFocus = () => {
    if (
      this.colorCodeRef.current != null &&
      this.colorCodeRef.current != undefined
    ) {
      setTimeout(() => {
        this.colorCodeRef.current.focus();
      }, 100);
    }
  };

  onLotBasedSummaryColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteSummaryColorPopupList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSummaryColorPopupList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteSummaryColorPopupList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteSummaryColorPopupList;
      let color_Data = this.state.criteria;
      color_Data.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSummaryColorPopupList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "colorCode") {
      temp_fabricStyledata["colorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["colorCode"] = color_Data.code;

          this.state.showAutoCompleteSummaryColorPopupList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteSummaryColorPopupList;
          this.setState({
            showAutoCompleteSummaryColorPopupList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorLotSummaryEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["colorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.colorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorLotSummaryList = (showAutoCompleteColorPopupList) => {
    this.setState({
      showAutoCompleteSummaryColorPopupList: showAutoCompleteColorPopupList,
    });
  };

  skuInventoryLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "lotNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalOnHandQty", "totalOnHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
      //  .setClickDetails(true, false, this.onHandQuantityClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    if (this.props.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("No Of Pallets", "numberOfPallets", true, true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
    }
    if (!this.props.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("No.Of.Rolls", "numberOfRolls", true, true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
    }
    if (this.props.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("Total Area", "totalArea", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
    }
    columns.push(
      new ColumnDefinition()
        .setDetails(this.props.is3PL ? "LO" : "PO", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "LR" : "PR",
          "purchaseOrderReceiptNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    return columns;
  };
  inventoryLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory# " : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    if (this.props.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("UPC", "upcNumber", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
    }
    columns.push(
      new ColumnDefinition()
        .setDetails("Batch", "batchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("WH", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQuantity", "onHandQuantity", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    return columns;
  };

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  resetLotLines = (e) => {
    if (e.detail == 1) {
      //let tempCriteria = this.state.criteria;
      let fabricStyleData = this.state.fabricStyleData;
      let criteria = new FabricStyleInventoryForLotBasedSearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricStyleData.code;
      criteria.isSummary = true;
      criteria.purchaseOrderNumber = "";
      criteria.purchaseOrderReceiptNumber = "";
      this.setState({ criteria: criteria, isDisableFilterFields: false });
      this.loadFabricInventoryLotInquiryList(criteria);
    }
  };

  render() {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let filterSearchCriteria = this.state.filterSearchCriteria;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    let totalOnhandQty = this.state.totalOnhandQty;
    let isDisableFilterFields = this.props.isDisableFilterFields;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <div>
          <div>
            <Row>
              {" "}
              <Col className="align-items-left" sm="1">
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle</FormLabel>
                )}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="code"
                  readOnly={true}
                  value={fabricStyleData.code}
                  disabled={isDisabledFields}
                />{" "}
              </Col>{" "}
              <Col sm="3">
                <InputTextbox
                  name="description"
                  readOnly={true}
                  value={fabricStyleData.description}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                {" "}
                <FormLabel>Color</FormLabel>{" "}
              </Col>
              <Col sm="2  ">
                <InputTextbox
                  ref={this.colorCodeRef}
                  name="colorCode"
                  onChange={this.onLotBasedSummaryColorCodeChange}
                  value={criteria.colorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.colorLookupHandler}
                  enterKeyEventHandler={this.colorLotSummaryEnterKeyEvent}
                  autoCompleteListData={
                    this.state.colorSummaryForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteColorLotSummaryList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompleteSummaryColorPopupList
                  }
                  disabled={isDisableFilterFields}
                  isMandatory={true}
                />{" "}
              </Col>{" "}
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                {" "}
                <FormLabel>Lot</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="lotNumber"
                  onChange={this.onChange}
                  value={criteria.lotNumber}
                  disabled={isDisableFilterFields}
                  isMandatory={true}
                />{" "}
              </Col>{" "}
              <Col className="align-items-left" sm="1">
                {" "}
                {is3PL ? <FormLabel>LO</FormLabel> : <FormLabel>PO</FormLabel>}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="purchaseOrderNumber"
                  onChange={this.onChange}
                  value={criteria.purchaseOrderNumber}
                  disabled={isDisableFilterFields}
                  isMandatory={true}
                />{" "}
              </Col>{" "}
              <Col className="align-items-left" sm="1">
                {" "}
                {is3PL ? <FormLabel>LR</FormLabel> : <FormLabel>PR</FormLabel>}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="purchaseOrderReceiptNumber"
                  onChange={this.onChange}
                  value={criteria.purchaseOrderReceiptNumber}
                  disabled={isDisableFilterFields}
                  isMandatory={true}
                />{" "}
              </Col>{" "}
              {/* <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.fetchInventory(e)}
                  disabled={isDisabledFields}
                >
                  {" "}
                  Fetch{" "}
                </Button>
              </Col>{" "} */}
              {/* {this.state.isSearchCriteria && (
                <Button
                  className=""
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.fetchInventory(e)}
                // disabled={this.state.isSearchCriteria}
                >
                  Filter
                </Button>
              )}

              {this.state.isResetCriteria && (
                <Button
                  className=""
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.resetPtLines(e)}
                //disabled={this.state.isResetCriteria}
                >
                  Reset
                </Button>
              )} */}
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.fetchInventory(e)}
                  disabled={isDisabledFields}
                >
                  {" "}
                  Fetch{" "}
                </Button>
              </Col>{" "}
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.resetLotLines(e)}
                  // disabled={this.state.isResetCriteria}
                >
                  {" "}
                  Reset{" "}
                </Button>
              </Col>{" "}
            </Row>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Total OnHandQty</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  value={totalOnhandQty}
                  className="summary_input text-right"
                  decimalScale={2}
                  name={"totalOnhandQty"}
                  disabled={true}
                />
              </Col>
              {/* <Col sm="6">
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Total OnHandQty</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                 value={totalOnhandQty}
                  className="summary_input text-right"
                  decimalScale={2}
                  name={"totalOnhandQty"}
                  disabled={true}
                />
              </Col> */}
            </Row>
          </div>
          <div>
            {/* <div className="div_inline"></div> */}
            {/* <div className="div_inline"> */}
            {/* <div className="div_Equal_no_height"> */}
            <div className="mt-3">
              <CustomTable
                data={this.state.skuInventoryList}
                columns={this.skuInventoryLineColumns()}
              />
            </div>
            {/* </div>
              <div className="div_Equal_no_height"> */}
            {/* <div className="mt-3">
                  <CustomTable
                    data={this.state.inventoryDataList}
                    columns={this.inventoryLineColumns()}
                  />
                </div> */}
            {/* </div> */}
            {/* </div> */}
          </div>
        </div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
      </div>
    );
  }
}
class FabricStyleCustomerSalesDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
      criteria: new SalesAndPurchaseInquiryCriteriaBean(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: null,
      customerLookupHandler: null,
      fabricStyleColorList: [],
      showAutoCompleteCustomerSalesColorList: false,
      colorSummaryForAutoCompleteList: new Array(),
      inquiryDataList: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      moduleForPopup: [],
      isShowInvoiceModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadColors();
    this.loadPage();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let colors = [];
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode",
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    // let colorLookupHandler = new GenericAttributeLookupHandler(
    //   this.state.colors,
    //   "fabricStyleColorCode"
    // );
    // this.setState({ colorLookupHandler: colorLookupHandler });
    // let vendorLookupHandler = new VendorLookupHandler(
    //   this.companyCode,
    //   "Vendor"
    // );
    // this.setState({ vendorLookupHandler: vendorLookupHandler });
  };

  loadColors = () => {
    let fabricStyleColorList = this.props.fabricStyleData.colors;
    let simpleAutoCompleteList = new Array();
    fabricStyleColorList.map((colorCodeDatas) => {
      let simpleItemBean = {
        code: colorCodeDatas.fabricStyleColorCode,
        description: colorCodeDatas.fabricStyleColorName,
      };
      simpleAutoCompleteList.push(simpleItemBean);
    });
    this.setState({ fabricStyleColorList: simpleAutoCompleteList });
    this.state.fabricStyleColorList = simpleAutoCompleteList;
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.fabricStyleColorList,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;

      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack,
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };

  //
  onCustomerSalesColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteCustomerSalesColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompleteCustomerSalesColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteCustomerSalesColorList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerSalesColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;

          this.state.showAutoCompleteCustomerSalesColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerSalesColorList;
          this.setState({
            showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorCustomerSalesEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorCustomerSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
    });
  };
  loadPage = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    criteria.resultType = 0;
    // criteria.isSummary = true;
    // if (this.props.is3PL) {
    //   criteria.logisticCustomerCode = fabricStyleData.customerCode;
    // }
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  };
  fetchCustomerSales = () => {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    criteria.resultType = 0;
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
  };
  loadSalesAndPurchaseDetailsInquiryList = (criteria) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    ReportService.inquireSalesAndPurchaseDetails(
      criteria,
      this.loadSalesAndPurchasePageResponse,
      this.errorCallBack,
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadSalesAndPurchasePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,
      });
      //  this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  inquiryInvoiceColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),

      //.setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyle", "fabricStyleCode", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyleName", "fabricStyleName", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "quantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "extension", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };
  resetCustomerSales = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = new SalesAndPurchaseInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.resultType = 0;
    criteria.fabricStyleColorCode = "";
    criteria.customerCode = "";
    this.setState({ criteria: criteria, isDisableFilterFields: false });
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      // isShowFabricStyleModule: isOpen,
      // isShowInventoryAdjustmentModule: isOpen,
      // isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      // isShowPickticketModule: isOpen,
      // isShowInventoryTransferModule: isOpen,
      // isShowLogisticReceiptModule: isOpen,
      // isShowPurchaseModule:isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code, rowData) => {
    this.props.viewInvoiceModule(e, code, rowData);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  onCustomerSalesColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteCustomerSalesColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompleteCustomerSalesColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteCustomerSalesColorList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerSalesColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;

          this.state.showAutoCompleteCustomerSalesColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerSalesColorList;
          this.setState({
            showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorCustomerSalesEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorCustomerSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
    });
  };
  render() {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    const inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <div>
          <Row className="d-flex justify-content-left">
            <Col className="align-items-left" sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                value={fabricStyleData.code}
                disabled={isDisabledFields}
              />{" "}
            </Col>{" "}
            <Col sm="2">
              <InputTextbox
                name="description"
                readOnly={true}
                value={fabricStyleData.description}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Color</FormLabel>{" "}
            </Col>
            <Col sm="2  ">
              <InputTextbox
                ref={this.colorCodeRef}
                name="fabricStyleColorCode"
                onChange={this.onCustomerSalesColorCodeChange}
                value={criteria.fabricStyleColorCode}
                lookupRequired={true}
                lookupHandler={this.state.colorLookupHandler}
                enterKeyEventHandler={this.colorCustomerSalesEnterKeyEvent}
                autoCompleteListData={
                  this.state.colorSummaryForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteColorCustomerSalesList
                }
                showAutoCompleteList={
                  this.state.showAutoCompleteCustomerSalesColorList
                }
                //  disabled={isDisableFilterFields}
                isMandatory={true}
              />{" "}
            </Col>{" "}
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Customer</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCustomerCodeChange}
                // disabled={props.isDisableFields}
                name="customerCode"
                placeholder="Customer"
                value={criteria.customerCode}
                lookupRequired={true}
                lookupHandler={this.state.customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.state.customerPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteList}
                showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.fetchCustomerSales(e)}
                //  disabled={isDisabledFields}
              >
                {" "}
                Fetch{" "}
              </Button>
            </Col>{" "}
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.resetCustomerSales(e)}
                // disabled={this.state.isResetCriteria}
              >
                {" "}
                Reset{" "}
              </Button>
            </Col>{" "}
          </Row>
          <div>
            {this.state.isInquiryDatasFound && (
              <div className="mt-3">
                <CustomTable
                  data={inquiryDataList}
                  columns={this.inquiryInvoiceColumns()}
                  // isEnableSpan={true}
                  label={"Inquiry Data List"}
                />
              </div>
            )}

            {/* {this.state.isInquiryDatasFound && this.state.resultType == 1 && (

            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryPurchaseColumns()}
                // isEnableSpan={true}
                label={"Inquiry Data List"}
              />
            </div>
          )} */}
          </div>
        </div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class FabricStyleSalesDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
      criteria: new FabricStyleDetailInquiryCriteriaBean(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: null,
      customerLookupHandler: null,
      fabricStyleColorList: [],
      showAutoCompleteCustomerSalesColorList: false,
      colorSummaryForAutoCompleteList: new Array(),
      inquiryDataList: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      moduleForPopup: [],
      isShowInvoiceModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      isShowPickTicketModule: false,
      isShowSalesOrderMaintenanceModule: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadColors();
    this.loadPage();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let colors = [];
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode",
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    // let colorLookupHandler = new GenericAttributeLookupHandler(
    //   this.state.colors,
    //   "fabricStyleColorCode"
    // );
    // this.setState({ colorLookupHandler: colorLookupHandler });
    // let vendorLookupHandler = new VendorLookupHandler(
    //   this.companyCode,
    //   "Vendor"
    // );
    // this.setState({ vendorLookupHandler: vendorLookupHandler });
  };

  loadColors = () => {
    let fabricStyleColorList = this.props.fabricStyleData.colors;
    let simpleAutoCompleteList = new Array();
    fabricStyleColorList.map((colorCodeDatas) => {
      let simpleItemBean = {
        code: colorCodeDatas.fabricStyleColorCode,
        description: colorCodeDatas.fabricStyleColorName,
      };
      simpleAutoCompleteList.push(simpleItemBean);
    });
    this.setState({ fabricStyleColorList: simpleAutoCompleteList });
    this.state.fabricStyleColorList = simpleAutoCompleteList;
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.fabricStyleColorList,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;

      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack,
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };

  //
  onCustomerSalesColorCodeChange = (e) => {
    let colorCode = e.target.value;
    this.state.showAutoCompleteCustomerSalesColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompleteCustomerSalesColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteCustomerSalesColorList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerSalesColorList;
      let color_Data = this.state.criteria;
      color_Data.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && colorCode !== "") {
      this.readLotBasedColorCodeBySearchString(colorCode);
    }
    if (e.target.name == "colorCode") {
      temp_fabricStyledata["colorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["colorCode"] = color_Data.code;

          this.state.showAutoCompleteCustomerSalesColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerSalesColorList;
          this.setState({
            showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorCustomerSalesEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let colorCode = e.target.value;
    temp_fabricStyledata["colorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.colorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorCustomerSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
    });
  };
  loadPage = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    //criteria.fabricStyleName = fabricStyleData.description;
    // criteria.resultType = 0;
    // criteria.isSummary = true;
    // if (this.props.is3PL) {
    //   criteria.logisticCustomerCode = fabricStyleData.customerCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    // }
    this.loadfabricSalesInquiryList(criteria);
  };
  fetchFabricSales = () => {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    // criteria.fabricStyleName = fabricStyleData.description;
    // criteria.resultType = 0;

    this.loadfabricSalesInquiryList(criteria);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
  };
  loadfabricSalesInquiryList = (criteria) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    ReportService.inquireFabricStyleSalesInquiryDetails(
      criteria,
      this.loadfabricSalesPageResponse,
      this.errorCallBack,
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadfabricSalesPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,
      });
      //  this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  inquiryInvoiceColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)

        .setStyleDetails("left", "5", "", "wt-4", "wt-4"),

      //.setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyle", "fabricStyleCode", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyleName", "fabricStyleName", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SO#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewsalesOrderModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate", "orderDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("CustPo", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("PT#", "pickTicketNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.handleHyperLinkClick, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null),
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("InvoiceDate", "invoiceDate", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStatusDetails(true, this.getCaption)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenQty", "openQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("QTY", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };

  getCaption = (status) => {
    return ModuleUtils.getSalesOrderStatusCaption(status);
  };

  resetfabricSales = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = new FabricStyleDetailInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    // criteria.resultType = 0;
    // criteria.fabricStyleColorCode = "";
    // criteria.customerCode = "";
    this.setState({ criteria: criteria, isDisableFilterFields: false });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadfabricSalesInquiryList(criteria);
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  handleHyperLinkClick = (e, val, rowData) => {
    if (val !== "" && val !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={val}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewsalesOrderModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderMaintenanceModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowPickTicketModule: isOpen,
      isShowSalesOrderMaintenanceModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code, rowData) => {
    this.props.viewInvoiceModule(e, code, rowData);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  // onCustomerSalesColorCodeChange = (e) => {
  //   let fabricStyleColorCode = e.target.value;
  //   this.state.showAutoCompleteCustomerSalesColorList = true;
  //   let temp_fabricStyledata = this.state.criteria;
  //   let showAutoCompleteList =
  //     this.state.showAutoCompleteCustomerSalesColorList;
  //   if (isEmpty(fabricStyleColorCode)) {
  //     this.state.showAutoCompleteCustomerSalesColorList = false;
  //     let showAutoCompleteList =
  //       this.state.showAutoCompleteCustomerSalesColorList;
  //     let color_Data = this.state.criteria;
  //     color_Data.fabricStyleColorCode = "";
  //     let suggestion = [];
  //     this.setState({
  //       showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
  //       criteria: color_Data,
  //       colorSummaryForAutoCompleteList: suggestion,
  //     });
  //   } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
  //     this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
  //   }
  //   if (e.target.name == "fabricStyleColorCode") {
  //     temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
  //     let color_Data_List = this.state.fabricStyleColorList;
  //     color_Data_List.map((color_Data) => {
  //       if (color_Data.code == e.target.value) {
  //         temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;

  //         this.state.showAutoCompleteCustomerSalesColorList = false;
  //         let showAutoCompleteList =
  //           this.state.showAutoCompleteCustomerSalesColorList;
  //         this.setState({
  //           showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
  //         });
  //       }
  //     });
  //   }
  //   this.setState({ criteria: temp_fabricStyledata });
  // };
  // readLotBasedColorCodeBySearchString(searchString) {
  //   let colorCodeData = this.state.fabricStyleColorList;
  //   let simpleAutoCompleteList = new Array();
  //   if (colorCodeData.length > 0 && colorCodeData != null) {
  //     colorCodeData.map((colorCodeDatas) => {
  //       let simpleItemBean = {
  //         code: colorCodeDatas.code,
  //         description: colorCodeDatas.description,
  //       };
  //       simpleAutoCompleteList.push(simpleItemBean);
  //     });
  //   }
  //   let userInput = searchString;
  //   let filteredSuggestions = new Array();
  //   filteredSuggestions = simpleAutoCompleteList.filter(
  //     (simpleAutoCompleteColorCodeLists) =>
  //       simpleAutoCompleteColorCodeLists.code
  //         .toLowerCase()
  //         .indexOf(userInput.toLowerCase()) > -1
  //   );
  //   this.setState({
  //     colorSummaryForAutoCompleteList: filteredSuggestions,
  //   });
  // }
  // colorCustomerSalesEnterKeyEvent = (e) => {
  //   let temp_fabricStyledata = this.state.criteria;
  //   let fabricStyleColorCode = e.target.value;
  //   temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
  //   let color_Data_List = this.state.fabricStyleColorList;
  //   let colorCodeBean = null;
  //   color_Data_List.map((color_Data) => {
  //     if (color_Data.code == e.target.value) {
  //       colorCodeBean = color_Data;
  //     }
  //   });
  //   if (!isEmpty(colorCodeBean)) {
  //     let temp_fabricStyledata = this.state.criteria;
  //     temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
  //     this.setState({
  //       criteria: temp_fabricStyledata,
  //       colorSummaryForAutoCompleteList: new Array(),
  //     });
  //   }
  // };
  // displayAutoCompleteColorCustomerSalesList = (
  //   showAutoCompleteColorPopupList
  // ) => {
  //   this.setState({
  //     showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
  //   });
  // };
  render() {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    const inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <div class="center_div col-md-12 col-lg-12 text-center">
          <Row className="d-flex justify-content-left">
            {/* <Col className="align-items-left" sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                value={fabricStyleData.code}
                disabled={isDisabledFields}
              />{" "}
            </Col>{" "}
            <Col sm="2">
              <InputTextbox
                name="description"
                readOnly={true}
                value={fabricStyleData.description}
                disabled={isDisabledFields}
              />{" "}
            </Col> */}
            <Col sm="1">
              <FormLabel>Customer</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCustomerCodeChange}
                // disabled={props.isDisableFields}
                name="customerCode"
                placeholder="Customer"
                value={criteria.customerCode}
                lookupRequired={true}
                lookupHandler={this.state.customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.state.customerPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteList}
                showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                isMandatory={true}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Color</FormLabel>{" "}
            </Col>
            <Col sm="2  ">
              <InputTextbox
                ref={this.colorCodeRef}
                name="colorCode"
                onChange={this.onCustomerSalesColorCodeChange}
                value={criteria.colorCode}
                lookupRequired={true}
                lookupHandler={this.state.colorLookupHandler}
                enterKeyEventHandler={this.colorCustomerSalesEnterKeyEvent}
                autoCompleteListData={
                  this.state.colorSummaryForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteColorCustomerSalesList
                }
                showAutoCompleteList={
                  this.state.showAutoCompleteCustomerSalesColorList
                }
                //  disabled={isDisableFilterFields}
                isMandatory={true}
              />{" "}
            </Col>{" "}
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.fetchFabricSales(e)}
                //  disabled={isDisabledFields}
              >
                {" "}
                Fetch{" "}
              </Button>
            </Col>{" "}
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.resetfabricSales(e)}
                // disabled={this.state.isResetCriteria}
              >
                {" "}
                Reset{" "}
              </Button>
            </Col>{" "}
          </Row>
          {/* <Row>
           
         
          </Row> */}
          <div>
            {this.state.isInquiryDatasFound && (
              <div className="mt-3">
                <CustomTable
                  data={inquiryDataList}
                  columns={this.inquiryInvoiceColumns()}
                  // isEnableSpan={true}
                  label={"Sales Data List"}
                  enableVritualizer={true}
                />
              </div>
            )}

            {/* {this.state.isInquiryDatasFound && this.state.resultType == 1 && (

            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryPurchaseColumns()}
                // isEnableSpan={true}
                label={"Inquiry Data List"}
              />
            </div>
          )} */}
          </div>
        </div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          isShowPopup={this.state.isShowPickTicketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesOrderMaintenanceModule}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

class FabricStyleCustomerSalesAndPurchaseDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
      criteria: new SalesAndPurchaseInquiryCriteriaBean(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: null,
      customerLookupHandler: null,
      fabricStyleColorList: [],
      showAutoCompleteCustomerSalesColorList: false,
      colorSummaryForAutoCompleteList: new Array(),
      inquiryDataList: [],
      inquiryDataListVendor: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      moduleForPopup: [],
      isShowInvoiceModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: null,
      vendorLookupHandler: null,
      isShowPurchaseReceiptModule: false,
      isShowPickTicketModule: false,
      isShowPurchaseModule: false,
      isShowSalesOrderMaintenanceModule: false,

      showAutoCompletPurchaseColorList: null,
      purchaseColorSummaryForAutoCompleteList: new Array(),
      purchaseColorCode: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadColors();
    this.loadPage();
    this.loadPageVendor();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let colors = [];
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode",
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    // let colorLookupHandler = new GenericAttributeLookupHandler(
    //   this.state.colors,
    //   "fabricStyleColorCode"
    // );
    // this.setState({ colorLookupHandler: colorLookupHandler });
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };

  loadColors = () => {
    let fabricStyleColorList = this.props.fabricStyleData.colors;
    let simpleAutoCompleteList = new Array();
    fabricStyleColorList.map((colorCodeDatas) => {
      let simpleItemBean = {
        code: colorCodeDatas.fabricStyleColorCode,
        description: colorCodeDatas.fabricStyleColorName,
      };
      simpleAutoCompleteList.push(simpleItemBean);
    });
    this.setState({ fabricStyleColorList: simpleAutoCompleteList });
    this.state.fabricStyleColorList = simpleAutoCompleteList;
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.fabricStyleColorList,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;

      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack,
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };

  //
  onCustomerSalesColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteCustomerSalesColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompleteCustomerSalesColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteCustomerSalesColorList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerSalesColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;

          this.state.showAutoCompleteCustomerSalesColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerSalesColorList;
          this.setState({
            showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorCustomerSalesEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorCustomerSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
    });
  };
  loadPage = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    criteria.resultType = 0;
    // criteria.isSummary = true;
    // if (this.props.is3PL) {
    //   criteria.logisticCustomerCode = fabricStyleData.customerCode;
    // }
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  };
  loadPageVendor = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    criteria.resultType = 1;
    // criteria.isSummary = true;
    // if (this.props.is3PL) {
    //   criteria.logisticCustomerCode = fabricStyleData.customerCode;
    // }

    this.loadSalesAndPurchaseDetailsInquiryListVendor(criteria);
  };
  fetchCustomerSales = () => {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    criteria.resultType = 0;
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
  };

  fetchVendorSales = () => {
    let criteria = { ...this.state.criteria };
    let fabricStyleData = this.state.fabricStyleData;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    criteria.fabricStyleColorCode = this.state.purchaseColorCode;
    criteria.resultType = 1;
    this.loadSalesAndPurchaseDetailsInquiryListVendor(criteria);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
  };

  loadSalesAndPurchaseDetailsInquiryListVendor = (criteria) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    ReportService.inquireSalesAndPurchaseDetailsForFabricStyle(
      criteria,
      this.loadSalesAndPurchasePageResponseVendor,
      this.errorCallBack,
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };

  loadSalesAndPurchasePageResponseVendor = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasVendorFound: true,
        isShowVendorResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataListVendor: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        //inquiryDataListVendor: inquiryDataList,
      });
      //  this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadSalesAndPurchaseDetailsInquiryList = (criteria) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    ReportService.inquireSalesAndPurchaseDetailsForFabricStyle(
      criteria,
      this.loadSalesAndPurchasePageResponse,
      this.errorCallBack,
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadSalesAndPurchasePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos.reverse();
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,
      });
      //  this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  inquiryInvoiceColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)

        .setStyleDetails("left", "5", "", "wt-4", "wt-4"),

      //.setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyle", "fabricStyleCode", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyleName", "fabricStyleName", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SO#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewsalesOrderModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PT", "pickTicketNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.handleHyperLinkClick, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "quantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "extension", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };

  inquiryPurchaseColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)

        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),

      // .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "3", "", "wt-2", "wt-2"),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyle", "fabricStyleCode", true)
    //     .setStyleDetails("left", "3", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyleName", "fabricStyleName", true)
    //     .setStyleDetails("left", "3", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PoDate", "purchaseOrderDate", true, false.true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseModule, null),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PRDate", "purchaseOrderReceiptNumber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("PR", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceiptDate", "receiptDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ordQuantity", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "extension", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("RecdQuantity", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };
  handleHyperLinkClick = (e, val, rowData) => {
    if (val !== "" && val !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={val}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewsalesOrderModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderMaintenanceModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  resetVendorSales = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = new SalesAndPurchaseInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.resultType = 1;
    criteria.fabricStyleColorCode = "";
    criteria.vendorCode = "";
    criteria.customerCode = this.state.criteria.customerCode;
    this.setState({
      criteria: criteria,
      isDisableFilterFields: false,
      purchaseColorCode: "",
    });
    this.loadSalesAndPurchaseDetailsInquiryListVendor(criteria);
  };
  resetCustomerSales = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = new SalesAndPurchaseInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.resultType = 0;
    criteria.fabricStyleColorCode = "";
    criteria.customerCode = "";
    criteria.vendorCode = this.state.criteria.vendorCode;
    this.setState({ criteria: criteria, isDisableFilterFields: false });
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseReceiptModule: isOpen,
      isShowPurchaseModule: isOpen,
      // isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowPickTicketModule: isOpen,
      isShowSalesOrderMaintenanceModule: isOpen,
      // isShowInventoryTransferModule: isOpen,
      // isShowLogisticReceiptModule: isOpen,
      // isShowPurchaseModule:isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code, rowData) => {
    this.props.viewInvoiceModule(e, code, rowData);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  onCustomerSalesColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteCustomerSalesColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompleteCustomerSalesColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteCustomerSalesColorList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerSalesColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;

          this.state.showAutoCompleteCustomerSalesColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerSalesColorList;
          this.setState({
            showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorCustomerSalesEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorCustomerSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
    });
  };

  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let criteria = this.state.criteria;
      criteria.vendorCode = "";
      criteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        criteria.vendorName = vendorData.description;
        criteria.vendorCode = vendorData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack,
    );
  };

  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack,
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };

  onPurchaseSalesColorCodeChange = (e) => {
    let purchaseColorCode = e.target.value;
    this.state.showAutoCompletPurchaseColorList = true;
    let temp_purchaseColorCode = this.state.purchaseColorCode;
    let showAutoCompleteList = this.state.showAutoCompletPurchaseColorList;
    if (isEmpty(purchaseColorCode)) {
      this.state.showAutoCompletPurchaseColorList = false;
      let showAutoCompleteList = this.state.showAutoCompletPurchaseColorList;
      let color_Data = this.state.purchaseColorCode;
      color_Data = "";
      let suggestion = [];
      this.setState({
        showAutoCompletPurchaseColorList: showAutoCompleteList,
        purchaseColorCode: color_Data,
        purchaseColorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && purchaseColorCode !== "") {
      this.readPurchaseColorCodeBySearchString(purchaseColorCode);
    }
    if (e.target.name == "purchaseColorCode") {
      temp_purchaseColorCode = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_purchaseColorCode = color_Data.code;

          this.state.showAutoCompletPurchaseColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompletPurchaseColorList;
          this.setState({
            showAutoCompletPurchaseColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ purchaseColorCode: temp_purchaseColorCode });
  };
  readPurchaseColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      purchaseColorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorPurchaseSalesEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.purchaseColorCode;
    let purchaseColorCode = e.target.value;
    purchaseColorCode = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.purchaseColorCode;
      temp_fabricStyledata = colorCodeBean.code;
      this.setState({
        purchaseColorCode: temp_fabricStyledata,
        purchaseColorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorPurchaseSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompletPurchaseColorList: showAutoCompleteColorPopupList,
    });
  };

  render() {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    const inquiryDataList = this.state.inquiryDataList;
    const inquiryDataListVendor = this.state.inquiryDataListVendor;

    return (
      // <div>
      //   <AlertToolBox
      //     alertMsgList={this.state.alertMessage}
      //     alertErrorType={this.state.alertType}
      //     isShowAlert={this.state.isShowAlert}
      //     hideAlertCallBack={this.hideAlertCallBack}
      //   />

      <div class="center_div col-md-12 col-lg-12 text-center">
        <div>
          <div>
            <Row>
              <Col sm={6}>
                <Row>
                  <Col sm="1">
                    <FormLabel>Customer</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      onChange={this.onCustomerCodeChange}
                      // disabled={props.isDisableFields}
                      name="customerCode"
                      placeholder="Customer"
                      value={criteria.customerCode}
                      lookupRequired={true}
                      lookupHandler={this.state.customerLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.customerCodeEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.state.customerPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={this.displayAutoCompleteList}
                      showAutoCompleteList={
                        this.state.showAutoCompleteCustomerList
                      }
                      isMandatory={true}
                    />
                  </Col>
                  <Col className="align-items-left" sm="1">
                    {" "}
                    <FormLabel>Color</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      ref={this.colorCodeRef}
                      name="fabricStyleColorCode"
                      onChange={this.onCustomerSalesColorCodeChange}
                      value={criteria.fabricStyleColorCode}
                      lookupRequired={true}
                      lookupHandler={this.state.colorLookupHandler}
                      enterKeyEventHandler={
                        this.colorCustomerSalesEnterKeyEvent
                      }
                      autoCompleteListData={
                        this.state.colorSummaryForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteColorCustomerSalesList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompleteCustomerSalesColorList
                      }
                      //  disabled={isDisableFilterFields}
                      isMandatory={true}
                    />{" "}
                  </Col>{" "}
                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      bssize="large"
                      onClick={(e) => this.fetchCustomerSales(e)}
                      //  disabled={isDisabledFields}
                    >
                      {" "}
                      Fetch{" "}
                    </Button>
                  </Col>{" "}
                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      bssize="large"
                      onClick={(e) => this.resetCustomerSales(e)}
                      // disabled={this.state.isResetCriteria}
                    >
                      {" "}
                      Reset{" "}
                    </Button>
                  </Col>{" "}
                  <Col sm="1"></Col>
                </Row>
              </Col>

              <Col sm={6}>
                <Row>
                  <Col sm="1">
                    <FormLabel>Vendor</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      // ref={vendorCodeRef}
                      name="vendorCode"
                      placeholder="vendor"
                      onChange={this.vendorCodeOnChange}
                      value={criteria.vendorCode}
                      lookupRequired={true}
                      lookupHandler={this.state.vendorLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                      autoCompleteListData={
                        this.state.vendorPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteVendorList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompleteVendorList
                      }
                      // disabled={props.isDisableFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col className="align-items-left" sm="1">
                    {" "}
                    <FormLabel>Color</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      ref={this.colorCodeRef}
                      name="purchaseColorCode"
                      onChange={this.onPurchaseSalesColorCodeChange}
                      value={this.state.purchaseColorCode}
                      lookupRequired={true}
                      lookupHandler={this.state.colorLookupHandler}
                      enterKeyEventHandler={
                        this.colorPurchaseSalesEnterKeyEvent
                      }
                      autoCompleteListData={
                        this.state.purchaseColorSummaryForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteColorPurchaseSalesList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompletPurchaseColorList
                      }
                      //  disabled={isDisableFilterFields}
                      isMandatory={true}
                    />{" "}
                  </Col>{" "}
                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      bssize="large"
                      onClick={(e) => this.fetchVendorSales(e)}
                      //  disabled={isDisabledFields}
                    >
                      {" "}
                      Fetch{" "}
                    </Button>
                  </Col>{" "}
                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      bssize="large"
                      onClick={(e) => this.resetVendorSales(e)}
                      // disabled={this.state.isResetCriteria}
                    >
                      {" "}
                      Reset{" "}
                    </Button>
                  </Col>{" "}
                </Row>
              </Col>
            </Row>
            {/* <Row>
              {" "}
              <Col className="align-items-left" sm="1">
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle</FormLabel>
                )}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="code"
                  readOnly={true}
                  value={fabricStyleData.code}
                  disabled={isDisabledFields}
                />{" "}
              </Col>{" "}
              <Col sm="3">
                <InputTextbox
                  name="description"
                  readOnly={true}
                  value={fabricStyleData.description}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                {" "}
                <FormLabel>Color</FormLabel>{" "}
              </Col>
              <Col sm="2  ">
                <InputTextbox
                  ref={this.colorCodeRef}
                  name="fabricStyleColorCode"
                  onChange={this.onCustomerSalesColorCodeChange}
                  value={criteria.fabricStyleColorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.colorLookupHandler}
                  enterKeyEventHandler={this.colorCustomerSalesEnterKeyEvent}
                  autoCompleteListData={
                    this.state.colorSummaryForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteColorCustomerSalesList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompleteCustomerSalesColorList
                  }
                  //  disabled={isDisableFilterFields}
                  isMandatory={true}
                />{" "}
              </Col>{" "}

            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Customer</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onCustomerCodeChange}
                  // disabled={props.isDisableFields}
                  name="customerCode"
                  placeholder="Customer"
                  value={criteria.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteList}
                  showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.fetchCustomerSales(e)}
                //  disabled={isDisabledFields}
                >
                  {" "}
                  Fetch{" "}
                </Button>
              </Col>{" "}
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.resetCustomerSales(e)}
                // disabled={this.state.isResetCriteria}
                >
                  {" "}
                  Reset{" "}
                </Button>
              </Col>{" "}
              <Col sm="1"></Col>


              <Col sm="1">
                <FormLabel>Vendor</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  // ref={vendorCodeRef}
                  name="vendorCode"
                  placeholder="vendor"
                  onChange={this.vendorCodeOnChange}
                  value={criteria.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteVendorList}
                  showAutoCompleteList={this.state.showAutoCompleteVendorList}
                  // disabled={props.isDisableFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.fetchVendorSales(e)}
                //  disabled={isDisabledFields}
                >
                  {" "}
                  Fetch{" "}
                </Button>
              </Col>{" "}
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm1"
                  bssize="large"
                  onClick={(e) => this.resetVendorSales(e)}
                // disabled={this.state.isResetCriteria}
                >
                  {" "}
                  Reset{" "}
                </Button>
              </Col>{" "}
            </Row> */}
          </div>
          <div>
            {/* <div className="div_inline"></div> */}
            <div className="div_inline">
              {this.state.isInquiryDatasFound && (
                <div className="div_Equal_no_height">
                  <div className="mt-3">
                    <CustomTable
                      data={inquiryDataList}
                      columns={this.inquiryInvoiceColumns()}
                      // isEnableSpan={true}
                      label={"Customer Sales Data List"}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              )}
              {this.state.isInquiryDatasVendorFound && (
                <div className="div_Equal_no_height">
                  <div className="mt-3">
                    <CustomTable
                      data={inquiryDataListVendor}
                      columns={this.inquiryPurchaseColumns()}
                      // isEnableSpan={true}
                      label={"Purchase Data List"}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

     
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          isShowPopup={this.state.isShowPickTicketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesOrderMaintenanceModule}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

class FabricStylePurchaseDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
      criteria: new SalesAndPurchaseInquiryCriteriaBean(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: null,
      customerLookupHandler: null,
      fabricStyleColorList: [],
      showAutoCompleteCustomerSalesColorList: false,
      colorSummaryForAutoCompleteList: new Array(),
      inquiryDataList: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      moduleForPopup: [],
      isShowInvoiceModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: null,
      vendorLookupHandler: null,
      colorLookupHandler: null,
      isShowPurchaseReceiptModule: false,
      isShowPurchaseModule: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadColors();
    this.loadPage();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let colors = [];
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode",
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    // let colorLookupHandler = new GenericAttributeLookupHandler(
    //   this.state.colors,
    //   "fabricStyleColorCode"
    // );
    // this.setState({ colorLookupHandler: colorLookupHandler });
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };

  loadColors = () => {
    let fabricStyleColorList = this.props.fabricStyleData.colors;
    let simpleAutoCompleteList = new Array();
    fabricStyleColorList.map((colorCodeDatas) => {
      let simpleItemBean = {
        code: colorCodeDatas.fabricStyleColorCode,
        description: colorCodeDatas.fabricStyleColorName,
      };
      simpleAutoCompleteList.push(simpleItemBean);
    });
    this.setState({ fabricStyleColorList: simpleAutoCompleteList });
    this.state.fabricStyleColorList = simpleAutoCompleteList;
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.fabricStyleColorList,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };

  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let criteria = this.state.criteria;
      criteria.vendorCode = "";
      criteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        criteria.vendorName = vendorData.description;
        criteria.vendorCode = vendorData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack,
    );
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack,
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };
  loadPage = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    criteria.resultType = 1;
    // criteria.isSummary = true;
    // if (this.props.is3PL) {
    //   criteria.logisticCustomerCode = fabricStyleData.customerCode;
    // }
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  };
  fetchCustomerSales = () => {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    criteria.resultType = 1;
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
  };
  loadSalesAndPurchaseDetailsInquiryList = (criteria) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    ReportService.inquireSalesAndPurchaseDetails(
      criteria,
      this.loadSalesAndPurchasePageResponse,
      this.errorCallBack,
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadSalesAndPurchasePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,
      });
      //  this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  inquiryPurchaseColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)

        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),

      // .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "3", "", "wt-2", "wt-2"),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyle", "fabricStyleCode", true)
    //     .setStyleDetails("left", "3", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyleName", "fabricStyleName", true)
    //     .setStyleDetails("left", "3", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "3", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PoDate", "purchaseOrderDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseModule, null),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PRDate", "purchaseOrderReceiptNumber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("PR", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceiptDate", "receiptDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ordQuantity", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "extension", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("RecdQuantity", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };
  resetCustomerSales = () => {
    let fabricStyleData = this.state.fabricStyleData;
    let criteria = new SalesAndPurchaseInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.resultType = 1;
    criteria.fabricStyleColorCode = "";
    criteria.vendorCode = "";
    this.setState({ criteria: criteria, isDisableFilterFields: false });
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      // isShowFabricStyleModule: isOpen,
      // isShowInventoryAdjustmentModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      //  // isShowPickticketModule: isOpen,
      // isShowInventoryTransferModule: isOpen,
      // isShowLogisticReceiptModule: isOpen,
      isShowPurchaseModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code, rowData) => {
    this.props.viewInvoiceModule(e, code, rowData);
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  //
  onCustomerSalesColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteCustomerSalesColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompleteCustomerSalesColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteCustomerSalesColorList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerSalesColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;

          this.state.showAutoCompleteCustomerSalesColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerSalesColorList;
          this.setState({
            showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorCustomerSalesEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorCustomerSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
    });
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  render() {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    const inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <div>
          <Row className="d-flex justify-content-left">
            <Col className="align-items-left" sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                value={fabricStyleData.code}
                disabled={isDisabledFields}
              />{" "}
            </Col>{" "}
            <Col sm="2">
              <InputTextbox
                name="description"
                readOnly={true}
                value={fabricStyleData.description}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Color</FormLabel>{" "}
            </Col>
            <Col sm="2  ">
              <InputTextbox
                ref={this.colorCodeRef}
                name="fabricStyleColorCode"
                onChange={this.onCustomerSalesColorCodeChange}
                value={criteria.fabricStyleColorCode}
                lookupRequired={true}
                lookupHandler={this.state.colorLookupHandler}
                enterKeyEventHandler={this.colorCustomerSalesEnterKeyEvent}
                autoCompleteListData={
                  this.state.colorSummaryForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteColorCustomerSalesList
                }
                showAutoCompleteList={
                  this.state.showAutoCompleteCustomerSalesColorList
                }
                //  disabled={isDisableFilterFields}
                isMandatory={true}
              />{" "}
            </Col>{" "}
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Vendor</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                // ref={vendorCodeRef}
                name="vendorCode"
                placeholder="vendor"
                onChange={this.vendorCodeOnChange}
                value={criteria.vendorCode}
                lookupRequired={true}
                lookupHandler={this.state.vendorLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.state.vendorPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteVendorList}
                showAutoCompleteList={this.state.showAutoCompleteVendorList}
                // disabled={props.isDisableFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.fetchCustomerSales(e)}
                //  disabled={isDisabledFields}
              >
                {" "}
                Fetch{" "}
              </Button>
            </Col>{" "}
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.resetCustomerSales(e)}
                // disabled={this.state.isResetCriteria}
              >
                {" "}
                Reset{" "}
              </Button>
            </Col>{" "}
          </Row>
          <div>
            {this.state.isInquiryDatasFound && (
              <div className="mt-3">
                <CustomTable
                  data={inquiryDataList}
                  columns={this.inquiryPurchaseColumns()}
                  // isEnableSpan={true}
                  label={"Inquiry Data List"}
                />
              </div>
            )}

            {/* {this.state.isInquiryDatasFound && this.state.resultType == 1 && (

            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryPurchaseColumns()}
                // isEnableSpan={true}
                label={"Inquiry Data List"}
              />
            </div>
          )} */}
          </div>
        </div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class UOMPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      uomData: new FabricStyleBuyingUOMBean(),
      // uomCaption: "",
      // uoms: [],
      uomsLookupHandler: null,
    };
    this.uomsRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    // let uomData = this.props.uomData;
    // let uomCaption = this.props.uomCaption;
    // this.setState({
    //   uomData: uomData,
    //   uomCaption: uomCaption,
    // });

    this.initLookupHandlers();
    // this.setFocus();
  }
  initLookupHandlers = () => {
    let uomsLookupHandler = new GenericAttributeLookupHandler(
      this.props.countUOMs,
      "UOM",
    );
    this.setState({ uomsLookupHandler: uomsLookupHandler });
    let serviceWeightUOMLookupHandler = new GenericAttributeLookupHandler(
      this.props.weightUOMs,
      "WEIGHT UOM",
    );
    this.setState({
      serviceWeightUOMLookupHandler: serviceWeightUOMLookupHandler,
    });
    let dimensionUOMLookupHandler = new GenericAttributeLookupHandler(
      this.props.lengthUOMs,
      "LENGTH UOM",
    );
    this.setState({
      dimensionUOMLookupHandler: dimensionUOMLookupHandler,
    });
    let palletDimensionUOMLookupHandler = new GenericAttributeLookupHandler(
      this.props.lengthUOMs,
      "PALLET LENGTH UOM",
    );
    this.setState({
      palletDimensionUOMLookupHandler: palletDimensionUOMLookupHandler,
    });
  };
  setFocus = () => {
    if (this.uomsRef.current != null && this.uomsRef.current != undefined) {
      setTimeout(() => {
        this.uomsRef.current.focus();
      }, 100);
    }
  };
  onChange = (e) => {
    this.props.serviceUomOnChange(e);
    // let temp_uomdata = this.props.uomData;
    // temp_uomdata[e.target.name] = e.target.value;
    // if (e.target.name == "stackableFlag") {
    //   temp_uomdata["stackableFlag"] = e.target.value;
    //   if (e.target.value == true) {
    //     this.props.disableStackableQty = false;
    //   } else {
    //     this.props.disableStackableQty = true;
    //   }
    // }
    // this.setState({ uomData: temp_uomdata });
  };
  closeUomPopup = () => {
    this.props.closeUomPopup();
  };
  onPopupUomCodeChange = (e) => {
    this.props.onPopupUomCodeChange(e);
  };
  uomPopupEnterKeyEvent = (e) => {
    this.props.uomPopupEnterKeyEvent(e);
  };
  displayAutoCompleteUomPopupList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteUomPopupList(showAutoCompleteList);
  };

  render() {
    let uomData = this.props.uomData;
    let fabricStyle = this.props.fabricStyleData;
    uomData.companyCode = fabricStyle.companyCode;
    uomData.fabricStyleCode = fabricStyle.code;
    let uoms = this.props.uoms;
    let isDisabledFields = this.props.isDisabledFields;
    const isDisableaddOrUpdate = this.props.isDisableaddOrUpdate;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <Row>
          <Col sm="2">
            <FormLabel>CompanyCode</FormLabel>{" "}
          </Col>
          <Col sm="4">
            <InputTextbox
              name="companyCode"
              onChange={this.onChange}
              value={uomData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="2">
            {is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="4">
            <InputTextbox
              name="fabricStyleCode"
              onChange={this.onChange}
              value={uomData.fabricStyleCode}
              disabled={true}
            />{" "}
          </Col>
        </Row>
        {this.props.uomCaption == "Buying UOM" ? (
          <Row>
            {" "}
            <Col sm="4">
              <FormLabel className="label-head">
                Buying UOM Details
              </FormLabel>{" "}
            </Col>
          </Row>
        ) : (
          <Row>
            {" "}
            <Col sm="4">
              {is3PL ? (
                <FormLabel className="label-head">
                  Service UOM Details
                </FormLabel>
              ) : (
                <FormLabel className="label-head">
                  Selling UOM Details
                </FormLabel>
              )}
            </Col>
          </Row>
        )}
        <Row>
          <Col sm="2">
            <FormLabel>UOMCode</FormLabel>
          </Col>

          <Col sm="4">
            <InputTextbox
              onChange={this.onPopupUomCodeChange}
              ref={this.uomsRef}
              name="uomCode"
              placeholder="uomCode"
              value={uomData.uomCode}
              lookupRequired={true}
              lookupHandler={this.state.uomsLookupHandler}
              enterKeyEventHandler={this.uomPopupEnterKeyEvent}
              autoCompleteListData={
                this.props.uomPopupPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteUomPopupList}
              showAutoCompleteList={this.props.showAutoCompleteUOMPopupList}
              // disabled={this.props.isDisableUomFields}
              isMandatory={true}
              disabled={this.props.isDisabledFields || isDisableaddOrUpdate}
            ></InputTextbox>
          </Col>
          <Col sm="2">
            <FormLabel>Inventory UOM</FormLabel>{" "}
          </Col>

          <Col sm="4">
            <InputTextbox
              name="fabricStyleInventoryUOMCode"
              onChange={this.onChange}
              value={uomData.fabricStyleInventoryUOMCode}
              disabled={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Conv Rate</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              name="conversionRate"
              onChange={this.onChange}
              value={uomData.conversionRate}
              disabled={this.props.isDisabledFields || isDisableaddOrUpdate}
              isMandatory={true}
              decimalScale={2}
            />
          </Col>
          {/* {is3PL ? (
            <>
              <Col sm="2">
                <FormLabel>Price</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  name="wholeSalePrice"
                  onChange={this.onChange}
                  value={uomData.wholeSalePrice}
                  disabled={isDisabledFields}
                  isMandatory={true}
                  decimalScale={2}
                />
              </Col>{" "}
            </>
          ) : null} */}
        </Row>
        {this.props.uomCaption == "Buying UOM" ? (
          <Row>
            <Col sm="2">
              <FormLabel>Cost</FormLabel>
            </Col>

            <Col sm="4">
              <NumberFormatInputbox
                name="cost"
                onChange={this.onChange}
                value={uomData.cost}
                disabled={isDisabledFields}
                isMandatory={true}
                decimalScale={2}
              />{" "}
            </Col>
          </Row>
        ) : (
          <Row>
            {/* {is3PL ? (
              <>
                <Col sm="2">
                  <FormLabel>Is Stackable</FormLabel>
                </Col>
                <Col sm="4">
                  <InputCheckbox
                    disabled={isDisabledFields}
                    name="stackableFlag"
                    onChange={this.onChange}
                    checked={uomData.stackableFlag}
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>StackableQty</FormLabel>
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    disabled={this.props.disableStackableQty}
                    name="stackableQuantity"
                    onChange={this.onChange}
                    value={uomData.stackableQuantity}
                    decimalScale={2}
                  />
                </Col>
              </>
            ) : (
              <> */}
            <Col sm="2">
              <FormLabel>WholeSale Price</FormLabel>
            </Col>
            <Col sm="4">
              <NumberFormatInputbox
                name="wholeSalePrice"
                onChange={this.onChange}
                value={uomData.wholeSalePrice}
                disabled={isDisabledFields}
                isMandatory={true}
                decimalScale={2}
              />
            </Col>
            <Col sm="2">
              <FormLabel>RetailPrice</FormLabel>
            </Col>
            <Col sm="4">
              <NumberFormatInputbox
                name="retailPrice"
                onChange={this.onChange}
                value={uomData.retailPrice}
                disabled={isDisabledFields}
                isMandatory={true}
                decimalScale={2}
              />
            </Col>
            {/* </>
            )} */}
          </Row>
        )}
        {is3PL ? (
          <>
            <Row>
              <Col sm="2">
                <FormLabel>Weight Details</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Weight UOM</FormLabel>
              </Col>
              <Col sm="4">
                <InputTextbox
                  onChange={this.props.onServiceWeightUomChange}
                  name="weightUomCode"
                  placeholder="weightUOMCode"
                  value={uomData.weightUomCode}
                  lookupRequired={true}
                  lookupHandler={this.state.serviceWeightUOMLookupHandler}
                  enterKeyEventHandler={
                    this.props.serviceWeightUomEnterKeyEventHandler
                  }
                  autoCompleteListData={
                    this.props.serviceWeightUomPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.props.displayAutoCompleteServiceWeightUomList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteServiceWeightUomList
                  }
                  disabled={isDisabledFields}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="2">
                <FormLabel>Weight</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={isDisabledFields}
                  name="weight"
                  onChange={this.onChange}
                  value={uomData.weight}
                  decimalScale={2}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Dimension Details</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Dimension UOM</FormLabel>
              </Col>
              <Col sm="4">
                {/* <InputTextbox
                  disabled={true}
                  name="dimensionUomCode"
                  onChange={this.onChange}
                  value={uomData.dimensionUomCode}
                /> */}
                <InputTextbox
                  onChange={this.props.onServiceDimensionUomChange}
                  name="dimensionUomCode"
                  placeholder="dimensionUOMCode"
                  value={uomData.dimensionUomCode}
                  lookupRequired={true}
                  lookupHandler={this.state.dimensionUOMLookupHandler}
                  enterKeyEventHandler={
                    this.props.serviceDimensionUomEnterKeyEventHandler
                  }
                  autoCompleteListData={
                    this.props.serviceDimensionUomPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.props.displayAutoCompleteServiceDimensionUomList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteServiceDimensionUomList
                  }
                  disabled={isDisabledFields}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="2">
                <FormLabel>Length</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={isDisabledFields}
                  name="length"
                  onChange={this.onChange}
                  value={uomData.length}
                  decimalScale={2}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Width</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={isDisabledFields}
                  name="width"
                  onChange={this.onChange}
                  value={uomData.width}
                  decimalScale={2}
                />
              </Col>
              <Col sm="2">
                <FormLabel>Height</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={isDisabledFields}
                  name="height"
                  onChange={this.onChange}
                  value={uomData.height}
                  decimalScale={2}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Pallet Dimension Details</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Pallet Dimension UOM</FormLabel>
              </Col>
              <Col sm="4">
                <InputTextbox
                  onChange={this.props.onPalletDimensionUomChange}
                  name="palletDimensionUomCode"
                  placeholder="palletDimensionUOMCode"
                  value={uomData.palletDimensionUomCode}
                  lookupRequired={true}
                  lookupHandler={this.state.palletDimensionUOMLookupHandler}
                  enterKeyEventHandler={
                    this.props.palletDimensionUomEnterKeyEventHandler
                  }
                  autoCompleteListData={
                    this.props.palletDimensionUomPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.props.displayAutoCompletePalletDimensionUomList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompletePalletDimensionUomList
                  }
                  disabled={isDisabledFields}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="2">
                <FormLabel>Pallet Length</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={isDisabledFields}
                  name="palletLength"
                  onChange={this.onChange}
                  value={uomData.palletLength}
                  decimalScale={2}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Pallet Width</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={isDisabledFields}
                  name="palletWidth"
                  onChange={this.onChange}
                  value={uomData.palletWidth}
                  decimalScale={2}
                />
              </Col>
              <Col sm="2">
                <FormLabel>Pallet Height</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={isDisabledFields}
                  name="palletHeight"
                  onChange={this.onChange}
                  value={uomData.palletHeight}
                  decimalScale={2}
                />
              </Col>
            </Row>

            <Row>
              <Col sm="2">
                <FormLabel>Is Stackable</FormLabel>
              </Col>
              <Col sm="4">
                <InputCheckbox
                  disabled={isDisabledFields}
                  name="stackableFlag"
                  onChange={this.onChange}
                  checked={uomData.stackableFlag}
                />
              </Col>
              <Col sm="2">
                <FormLabel>StackableQty</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={this.props.disableStackableQty}
                  name="stackableQuantity"
                  onChange={this.onChange}
                  value={uomData.stackableQuantity}
                  decimalScale={2}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>No of Items Per Pallet</FormLabel>
              </Col>
              <Col sm="4">
                <NumberFormatInputbox
                  disabled={isDisabledFields}
                  name="numberOfItemsPerPallet"
                  onChange={this.onChange}
                  value={uomData.numberOfItemsPerPallet}
                  decimalScale={2}
                />
              </Col>
            </Row>
          </>
        ) : null}
      </div>
    );
    // return (
    //   <div>
    //     <Row>
    //       <Col sm="2">
    //         <FormLabel>CompanyCode</FormLabel>{" "}
    //       </Col>
    //       <Col sm="4">
    //         <InputTextbox
    //           name="companyCode"
    //           onChange={this.onChange}
    //           value={uomData.companyCode}
    //           disabled={true}
    //         />{" "}
    //       </Col>
    //       <Col sm="2">
    //         {is3PL ? (
    //           <FormLabel>Item</FormLabel>
    //         ) : (
    //           <FormLabel>FabricStyle</FormLabel>
    //         )}
    //       </Col>
    //       <Col sm="4">
    //         <InputTextbox
    //           name="fabricStyleCode"
    //           onChange={this.onChange}
    //           value={uomData.fabricStyleCode}
    //           disabled={true}
    //         />{" "}
    //       </Col>
    //     </Row>
    //     {this.props.uomCaption == "Buying UOM" ? (
    //       <Row>
    //         {" "}
    //         <Col sm="4">
    //           <FormLabel>Buying UOM Details</FormLabel>{" "}
    //         </Col>
    //       </Row>
    //     ) : (
    //       <Row>
    //         {" "}
    //         <Col sm="4">
    //           {is3PL ? (
    //             <FormLabel>Service UOM Details</FormLabel>
    //           ) : (
    //             <FormLabel>Selling UOM Details</FormLabel>
    //           )}
    //         </Col>
    //       </Row>
    //     )}
    //     <Row>
    //       <Col sm="2">
    //         <FormLabel>UOMCode</FormLabel>{" "}
    //       </Col>

    //       <Col sm="4">
    //         <InputTextbox
    //           onChange={this.onPopupUomCodeChange}
    //           ref={this.uomsRef}
    //           name="uomCode"
    //           placeholder="uomCode"
    //           value={uomData.uomCode}
    //           lookupRequired={true}
    //           lookupHandler={this.state.uomsLookupHandler}
    //           enterKeyEventHandler={this.uomPopupEnterKeyEvent}
    //           autoCompleteListData={
    //             this.props.uomPopupPageListForAutoCompleteList
    //           }
    //           enableAutoCompleteTextBox={true}
    //           displayAutoCompleteList={this.displayAutoCompleteUomPopupList}
    //           showAutoCompleteList={this.props.showAutoCompleteUOMPopupList}
    //           disabled={this.props.isDisableUomFields}
    //           isMandatory={true}
    //         ></InputTextbox>
    //       </Col>

    //       <Col sm="2">
    //         <FormLabel>Inventory UOM</FormLabel>{" "}
    //       </Col>

    //       <Col sm="4">
    //         <InputTextbox
    //           name="fabricStyleInventoryUOMCode"
    //           onChange={this.onChange}
    //           value={uomData.fabricStyleInventoryUOMCode}
    //           disabled={true}
    //         />{" "}
    //       </Col>
    //     </Row>
    //     <Row>
    //       <Col sm="2">
    //         <FormLabel>Conv Rate</FormLabel>
    //       </Col>
    //       <Col sm="4">
    //         <NumberFormatInputbox
    //           name="conversionRate"
    //           onChange={this.onChange}
    //           value={uomData.conversionRate}
    //           disabled={isDisabledFields}
    //           isMandatory={true}
    //           decimalScale={2}
    //         />
    //       </Col>
    //       {is3PL ? (
    //         <>
    //           <Col sm="2">
    //             <FormLabel>Price</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               name="wholeSalePrice"
    //               onChange={this.onChange}
    //               value={uomData.wholeSalePrice}
    //               disabled={isDisabledFields}
    //               isMandatory={true}
    //               decimalScale={2}
    //             />
    //           </Col>{" "}
    //         </>
    //       ) : null}
    //     </Row>
    //     {this.props.uomCaption == "Buying UOM" ? (
    //       <Row>
    //         <Col sm="2">
    //           <FormLabel>Cost</FormLabel>
    //         </Col>

    //         <Col sm="4">
    //           <NumberFormatInputbox
    //             name="cost"
    //             onChange={this.onChange}
    //             value={uomData.cost}
    //             disabled={isDisabledFields}
    //             isMandatory={true}
    //             decimalScale={2}
    //           />{" "}
    //         </Col>
    //       </Row>
    //     ) : (
    //       <Row>
    //         {is3PL ? (
    //           <>
    //             <Col sm="2">
    //               <FormLabel>Is Stackable</FormLabel>
    //             </Col>
    //             <Col sm="4">
    //               <InputCheckbox
    //                 disabled={isDisabledFields}
    //                 name="stackableFlag"
    //                 onChange={this.onChange}
    //                 checked={uomData.stackableFlag}
    //               />
    //             </Col>
    //             <Col sm="2">
    //               <FormLabel>StackableQty</FormLabel>
    //             </Col>
    //             <Col sm="4">
    //               <NumberFormatInputbox
    //                 disabled={this.props.disableStackableQty}
    //                 name="stackableQuantity"
    //                 onChange={this.onChange}
    //                 value={uomData.stackableQuantity}
    //                 decimalScale={2}
    //               />
    //             </Col>
    //           </>
    //         ) : (
    //           <>
    //             <Col sm="2">
    //               <FormLabel>WholeSale Price</FormLabel>
    //             </Col>
    //             <Col sm="4">
    //               <NumberFormatInputbox
    //                 name="wholeSalePrice"
    //                 onChange={this.onChange}
    //                 value={uomData.wholeSalePrice}
    //                 disabled={isDisabledFields}
    //                 isMandatory={true}
    //                 decimalScale={2}
    //               />
    //             </Col>
    //             <Col sm="2">
    //               <FormLabel>RetailPrice</FormLabel>
    //             </Col>
    //             <Col sm="4">
    //               <NumberFormatInputbox
    //                 name="retailPrice"
    //                 onChange={this.onChange}
    //                 value={uomData.retailPrice}
    //                 disabled={isDisabledFields}
    //                 isMandatory={true}
    //                 decimalScale={2}
    //               />
    //             </Col>
    //           </>
    //         )}
    //       </Row>
    //     )}
    //     {is3PL ? (
    //       <>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>Weight Details</FormLabel>
    //           </Col>
    //         </Row>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>Weight UOM</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             {/* <InputTextbox disabled={true} name="weightUomCode"
    //                 onChange={this.onChange}
    //                 value={uomData.weightUomCode}/> */}
    //             <InputTextbox
    //               onChange={this.props.onServiceWeightUomChange}
    //               name="weightUomCode"
    //               placeholder="weightUOMCode"
    //               value={uomData.weightUomCode}
    //               lookupRequired={true}
    //               lookupHandler={this.state.serviceWeightUOMLookupHandler}
    //               enterKeyEventHandler={
    //                 this.props.serviceWeightUomEnterKeyEventHandler
    //               }
    //               autoCompleteListData={
    //                 this.props.serviceWeightUomPageListForAutoCompleteList
    //               }
    //               enableAutoCompleteTextBox={true}
    //               displayAutoCompleteList={
    //                 this.props.displayAutoCompleteServiceWeightUomList
    //               }
    //               showAutoCompleteList={
    //                 this.props.showAutoCompleteServiceWeightUomList
    //               }
    //               disabled={isDisabledFields}
    //               isMandatory={true}
    //             ></InputTextbox>
    //           </Col>
    //           <Col sm="2">
    //             <FormLabel>Weight</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               disabled={isDisabledFields}
    //               name="weight"
    //               onChange={this.onChange}
    //               value={uomData.weight}
    //               decimalScale={2}
    //             />
    //           </Col>
    //         </Row>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>Dimension Details</FormLabel>
    //           </Col>
    //         </Row>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>Dimension UOM</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             {/* <InputTextbox
    //               disabled={true}
    //               name="dimensionUomCode"
    //               onChange={this.onChange}
    //               value={uomData.dimensionUomCode}
    //             /> */}
    //             <InputTextbox
    //               onChange={this.props.onServiceDimensionUomChange}
    //               name="dimensionUomCode"
    //               placeholder="dimensionUOMCode"
    //               value={uomData.dimensionUomCode}
    //               lookupRequired={true}
    //               lookupHandler={this.state.dimensionUOMLookupHandler}
    //               enterKeyEventHandler={
    //                 this.props.serviceDimensionUomEnterKeyEventHandler
    //               }
    //               autoCompleteListData={
    //                 this.props.serviceDimensionUomPageListForAutoCompleteList
    //               }
    //               enableAutoCompleteTextBox={true}
    //               displayAutoCompleteList={
    //                 this.props.displayAutoCompleteServiceDimensionUomList
    //               }
    //               showAutoCompleteList={
    //                 this.props.showAutoCompleteServiceDimensionUomList
    //               }
    //               disabled={isDisabledFields}
    //               isMandatory={true}
    //             ></InputTextbox>
    //           </Col>
    //           <Col sm="2">
    //             <FormLabel>Length</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               disabled={isDisabledFields}
    //               name="length"
    //               onChange={this.onChange}
    //               value={uomData.length}
    //               decimalScale={2}
    //             />
    //           </Col>
    //         </Row>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>Width</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               disabled={isDisabledFields}
    //               name="width"
    //               onChange={this.onChange}
    //               value={uomData.width}
    //               decimalScale={2}
    //             />
    //           </Col>
    //           <Col sm="2">
    //             <FormLabel>Height</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               disabled={isDisabledFields}
    //               name="height"
    //               onChange={this.onChange}
    //               value={uomData.height}
    //               decimalScale={2}
    //             />
    //           </Col>
    //         </Row>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>Pallet Dimension Details</FormLabel>
    //           </Col>
    //         </Row>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>Pallet Dimension UOM</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <InputTextbox
    //               onChange={this.props.onPalletDimensionUomChange}
    //               name="palletDimensionUomCode"
    //               placeholder="palletDimensionUOMCode"
    //               value={uomData.palletDimensionUomCode}
    //               lookupRequired={true}
    //               lookupHandler={this.state.palletDimensionUOMLookupHandler}
    //               enterKeyEventHandler={
    //                 this.props.palletDimensionUomEnterKeyEventHandler
    //               }
    //               autoCompleteListData={
    //                 this.props.palletDimensionUomPageListForAutoCompleteList
    //               }
    //               enableAutoCompleteTextBox={true}
    //               displayAutoCompleteList={
    //                 this.props.displayAutoCompletePalletDimensionUomList
    //               }
    //               showAutoCompleteList={
    //                 this.props.showAutoCompletePalletDimensionUomList
    //               }
    //               disabled={isDisabledFields}
    //               isMandatory={true}
    //             ></InputTextbox>
    //           </Col>
    //           <Col sm="2">
    //             <FormLabel>Pallet Length</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               disabled={isDisabledFields}
    //               name="palletLength"
    //               onChange={this.onChange}
    //               value={uomData.palletLength}
    //               decimalScale={2}
    //             />
    //           </Col>
    //         </Row>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>Pallet Width</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               disabled={isDisabledFields}
    //               name="palletWidth"
    //               onChange={this.onChange}
    //               value={uomData.palletWidth}
    //               decimalScale={2}
    //             />
    //           </Col>
    //           <Col sm="2">
    //             <FormLabel>Pallet Height</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               disabled={isDisabledFields}
    //               name="palletHeight"
    //               onChange={this.onChange}
    //               value={uomData.palletHeight}
    //               decimalScale={2}
    //             />
    //           </Col>
    //         </Row>
    //         <Row>
    //           <Col sm="2">
    //             <FormLabel>No of Items Per Pallet</FormLabel>
    //           </Col>
    //           <Col sm="4">
    //             <NumberFormatInputbox
    //               disabled={isDisabledFields}
    //               name="numberOfItemsPerPallet"
    //               onChange={this.onChange}
    //               value={uomData.numberOfItemsPerPallet}
    //               decimalScale={2}
    //             />
    //           </Col>
    //         </Row>
    //       </>
    //     ) : null}
    //   </div>
    // );
  }
}

export function ImagePopup(props) {
  const [file, setFile] = useState(null);
  const [fileWeb, setFileWeb] = useState(null);
  const [fileFront, setFileFront] = useState(null);
  const [fileBack, setFileBack] = useState(null);
  const [isShowAlert, setIsShowAlert] = useState(true);
  const [alertType, setAlertType] = useState("");
  const [alertMsgList, setAlertMsgList] = useState([]);

  const [previewMainUrl, setPreviewMainUrl] = useState(props.mainImageUrl);
  const [previewWebUrl, setPreviewWebUrl] = useState(props.webImageUrl);
  const [previewFrontUrl, setPreviewFrontUrl] = useState(props.frontImageUrl);
  const [previewBackUrl, setPreviewBackUrl] = useState(props.backImageUrl);

  const handleChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      setFile(e.target.files[0]);
      setPreviewMainUrl(URL.createObjectURL(e.target.files[0]));
    } else {
      props.showToast("image size is greater", 2);
    }
  };
  const handleWebChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      setFileWeb(e.target.files[0]);
      setPreviewWebUrl(URL.createObjectURL(e.target.files[0]));
    } else {
      props.showToast("image size is greater", 2);
    }
  };
  const handleFrontChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      setFileFront(e.target.files[0]);
      setPreviewFrontUrl(URL.createObjectURL(e.target.files[0]));
    } else {
      props.showToast("image size is greater", 2);
    }
  };
  const handleBackChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      setFileBack(e.target.files[0]);
      setPreviewBackUrl(URL.createObjectURL(e.target.files[0]));
    } else {
      props.showToast("image size is greater", 2);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (file != null) {
      props.setMainUrl(URL.createObjectURL(file));
      props.setMainImg(file);
      props.uploadImage(file, "Main");
      props.showToast("Main image uploaded sucessfully", 1);
    }
  };
  const handleWebSubmit = async (e) => {
    e.preventDefault();
    if (fileWeb != null) {
      props.setWebUrl(URL.createObjectURL(fileWeb));
      props.setWebImg(fileWeb);
      props.uploadImage(fileWeb, "Web");
      props.showToast("Web image uploaded sucessfully", 1);
    }
  };
  const handleFrontSubmit = async (e) => {
    e.preventDefault();
    if (fileFront != null) {
      props.setFrontUrl(URL.createObjectURL(fileFront));
      props.setFrontImg(fileFront);
      props.uploadImage(fileFront, "Front");
      props.showToast("Front image uploaded sucessfully", 1);
    }
  };
  const handleBackSubmit = async (e) => {
    e.preventDefault();
    if (fileBack != null) {
      props.setBackUrl(URL.createObjectURL(fileBack));
      props.setBackImg(fileBack);
      props.uploadImage(fileBack, "Back");
      props.showToast("Back image uploaded sucessfully", 1);
    }
  };
  const fileInputRef = useRef();
  const fileInputWebRef = useRef();
  const fileInputFrontRef = useRef();
  const fileInputBackRef = useRef();
  const deleteFabricImage = (e, imagePart) => {
    if (e.detail == 1) {
      if (imagePart == "Main") {
        setFile(null);
        setPreviewMainUrl("");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else if (imagePart == "Web") {
        setFileWeb(null);
        setPreviewWebUrl("");
        if (fileInputWebRef.current) {
          fileInputWebRef.current.value = "";
        }
      } else if (imagePart == "Front") {
        setFileFront(null);
        setPreviewFrontUrl("");
        if (fileInputFrontRef.current) {
          fileInputFrontRef.current.value = "";
        }
      } else if (imagePart == "Back") {
        setFileBack(null);
        setPreviewBackUrl("");
        if (fileInputBackRef.current) {
          fileInputBackRef.current.value = "";
        }
      }

      props.deleteFabricImage(imagePart);
      props.showToast("Image Deleted sucessfully", 1);
    }
  };

  const hideAlertCallBack = (msgType, isDisplayed) => {
    setIsShowAlert(false);
  };
  return (
    <div className="img-pop">
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              {/* {previewMainUrl && ( */}
              <img
                className="img_div"
                src={previewMainUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="mainImg" className="d-flex justify-content-around ">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    ref={fileInputRef}
                    className="img-input"
                    id="mainImg"
                    accept="image/*"
                    onChange={handleChange}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {!isEmptyString(previewMainUrl) && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteFabricImage(e, "Main")}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="div_Equal_no_overflow">
          <form onSubmit={handleWebSubmit}>
            <div className="d-flex justify-content-around ">
              {/* {previewWebUrl && ( */}
              <img
                className="img_div"
                src={previewWebUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="webImg" className="d-flex justify-content-around ">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    ref={fileInputWebRef}
                    className="img-input"
                    id="webImg"
                    accept="image/*"
                    onChange={handleWebChange}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {previewWebUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteFabricImage(e, "Web")}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <form onSubmit={handleFrontSubmit}>
            <div className="d-flex justify-content-around ">
              {/* {previewFrontUrl && ( */}
              <img
                className="img_div"
                src={previewFrontUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label
                  for="frontImg"
                  className="d-flex justify-content-around "
                >
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    ref={fileInputFrontRef}
                    className="img-input"
                    id="frontImg"
                    accept="image/*"
                    onChange={handleFrontChange}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {previewFrontUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteFabricImage(e, "Front")}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="div_Equal_no_overflow">
          <form onSubmit={handleBackSubmit}>
            <div className="d-flex justify-content-around ">
              {/* {previewBackUrl && ( */}
              <img
                className="img_div"
                src={previewBackUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="backImg" className="d-flex justify-content-around ">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    ref={fileInputBackRef}
                    className="img-input"
                    id="backImg"
                    accept="image/*"
                    onChange={handleBackChange}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {previewBackUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteFabricImage(e, "Back")}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
function ColorPopup(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.colorImgUrl);
  const fabricStyle = props.fabricStyleData;
  const colorData = props.colorData;
  colorData.companyCode = fabricStyle.companyCode;
  colorData.fabricStyleCode = fabricStyle.code;
  let colorCustomerTypePrices = [];
  if (colorData.customerTypePrices != null) {
    colorData.customerTypePrices.map((line) => {
      colorCustomerTypePrices.push(line);
    });
  }

  useEffect(() => {
    setPreviewUrl(props.colorImgUrl);
  }, [props.colorImgUrl]);

  const isDisabledFields = props.isDisabledFields;
  const textAreaStyle = {
    // maxHeight: "100px",
    height: "10em",
    width: "60em",
    resize: "none",
    padding: "9px",
    boxSizing: "border-box",
    fontSize: "15px",
  };

  const handleChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      setFile(e.target.files[0]);
      props.setClrFile(e.target.files[0]);
      setPreviewUrl(URL.createObjectURL(e.target.files[0]));
    } else {
      props.showToast("image size is greater", 2);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (file != null) {
      props.setClrUrl(URL.createObjectURL(file));
      props.setClrFile(file);
      props.uploadClrImage(file, "Main");
      props.showToast("Clr image uploaded sucessfully", 1, 1);
    }
  };
  const deleteClrImage = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewUrl("");
      props.deleteClrImage();
      props.showToast("Image Deleted sucessfully", 1);
    }
  };
  const is3PL = props.is3PL;
  return (
    <div className="header_div">
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>Company</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorName"
              value={colorData.companyCode}
              disabled={true}
            />{" "}
          </Col>

          <Col sm="1">
            {is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              value={colorData.fabricStyleCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {/* <FormLabel>Active</FormLabel> */}
            <FormLabel>ColorStatus</FormLabel>
          </Col>
          <Col sm="2">
            {/* <InputCheckbox
              name="isActive"
              type="checkbox"
              checked={colorData.isActive}
              onChange={props.onColorChange}
              disabled={isDisabledFields}
            /> */}
            <InputTextbox
              onChange={props.onColorStatusChange}
              name="status"
              placeholder="status"
              value={colorData.status}
              lookupRequired={true}
              lookupHandler={props.fabricStatusLookupHandler}
              enterKeyEventHandler={props.fabricColorStatusEnterKeyEventHandler}
              autoCompleteListData={
                props.fabricColorStatusPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                props.displayAutoCompletefabricColorStatusList
              }
              showAutoCompleteList={props.showAutoCompleteColorStausList}
              // disabled={disablePurchaseOrderFormFields}
              // isMandatory={true}

              //    <InputCheckbox
              //   name="isActive"
              //   type="checkbox"
              //   checked={colorData.isActive}
              //   onChange={props.onColorChange}
              //   disabled={isDisabledFields}
              // />
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>CreatedDate</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="createdDate"
              value={colorData.createdDate}
              disabled={true}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Color</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              onChange={props.onPopupColorCodeChange}
              name="fabricStyleColorCode"
              placeholder="fabricStyleColorCode"
              value={colorData.fabricStyleColorCode}
              lookupRequired={true}
              lookupHandler={props.colorLookupHandler}
              enterKeyEventHandler={props.colorPopupEnterKeyEvent}
              autoCompleteListData={props.colorPopupPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={props.displayAutoCompleteColorPopupList}
              showAutoCompleteList={props.showAutoCompleteColorPopupList}
              disabled={isDisabledFields}
              isMandatory={true}
            ></InputTextbox>
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleColorName"
              onChange={props.onColorChange}
              value={colorData.fabricStyleColorName}
              disabled={true}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>NRF#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="nrfCode"
              onChange={props.onColorChange}
              value={colorData.nrfCode}
              disabled={isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>

          <Col sm="1">
            <FormLabel>C.R Number</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="copyrightNumber"
              onChange={props.onColorChange}
              value={colorData.copyrightNumber}
              disabled={isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col>
            <textarea
              style={textAreaStyle}
              className="form-control"
              type="text"
              name="notesCommunication"
              placeholder="Notes"
              value={colorData.notesCommunication}
              disabled={isDisabledFields}
              onChange={props.onColorChange}
            />
          </Col>
        </Row>
      </div>
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <Table id="fabrics_tables">
            <thead>
              <tr>
                <th>CustomerType</th>
                <th>price</th>
                <th>SamplePrice</th>
              </tr>
            </thead>
            <tbody>
              {colorCustomerTypePrices.map((line, i) => (
                <tr key={i}>
                  <td>{line.customerTypeCode}</td>
                  <td>{line.price}</td>
                  <td>{line.samplePrice}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="div_Equal_no_overflow">
          <div className="d-flex justify-content-around ">
            <img
              className="img_div"
              src={previewUrl}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImage;
              }}
              width={275}
              height={275}
              mode="fit"
            />
            {/* <ColorImage url={props}/> */}
          </div>
          <div className="d-flex justify-content-around">
            <div>
              <label for="mainImg" className="d-flex justify-content-around">
                <div className="img_label">
                  Attach Image
                  <span className="img_icon">
                    <CameraIcon />
                  </span>
                </div>
                <input
                  type="file"
                  className="img-input"
                  id="mainImg"
                  accept="image/*"
                  onChange={handleChange}
                  disabled={isDisabledFields}
                />
              </label>
            </div>
            {!isEmptyString(previewUrl) && !isEmpty(file) && (
              <div className="d-flex justify-content-around align-middle">
                <div className="align-middle">
                  <Button
                    id="fabric_Add_Button"
                    disabled={isDisabledFields}
                    onClick={(e) => handleSubmit(e)}
                  >
                    Upload
                  </Button>
                </div>
                {/* <div className="align-middle">
                  <Button
                    id="fabric_Add_Button"
                    onClick={(e) => deleteClrImage(e, "Main")}
                    disabled={isDisabledFields}
                  >
                    <DeleteIcon />
                  </Button>
                </div> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

class MultiColorPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    //
  }
  componentDidMount() {
    //
  }
  selectColor = (e, color) => {
    if (e.detail == 1) this.props.selectColor(color);
  };
  unSelectColor = (e, color) => {
    if (e.detail == 1) this.props.unSelectColor(color);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  render() {
    let selectedMultipleColorList = this.props.temp_selectedMultipleColorList;
    let colorList = this.props.multipleColorList;
    let colorData = this.props.colorData;
    let fabricStyleData = this.props.fabricStyleData;
    const is3PL = this.props.is3PL;
    return (
      <div className="header_div">
        <div>
          <Row>
            <Col sm="1">
              <FormLabel>Company</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="companyCode"
                value={fabricStyleData.companyCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                value={fabricStyleData.code}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="fabricStyleCode"
                value={fabricStyleData.description}
                disabled={true}
              />{" "}
            </Col>
          </Row>
          <div className="multi-clr-div">
            <div className="multi-clr-tble">
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th></th>
                    <th>ColorCode</th>
                    <th>ColorDesc</th>
                  </tr>
                </thead>
                <tbody>
                  {colorList.map((color, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          variant="secondry"
                          onClick={(e) => this.selectColor(e, color)}
                        >
                          <AddIcon />
                        </Button>
                      </td>
                      <td>{color.code}</td>
                      <td>{color.description}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="multi-clr-tble">
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th></th>
                    <th>ColorCode</th>
                    <th>ColorDesc</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedMultipleColorList.map((color, index) => (
                    <tr key={index}>
                      {color.isFetched == false ? (
                        <td>
                          <Button
                            variant="secondry"
                            onClick={(e) => this.unSelectColor(e, color)}
                          >
                            <CancelIcon />
                          </Button>
                        </td>
                      ) : (
                        <td></td>
                      )}
                      <td>{color.fabricStyleColorCode}</td>
                      <td>{color.fabricStyleColorName}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class OnHandQuantityPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isOpenOnHandDetailPopup: this.props.isOpenOnHandDetailPopup,
      fabricStyleData: this.props.fabricStyleData,
      onHandQtyCaption: this.props.onHandQtyCaption,
      batchInventoryDataBean: this.props.batchInventoryDataBean,
    };
  }
  componentDidMount() {
    let prp_fabricStyleData = this.props.fabricStyleData;
    let isOpenOnHandDetailPopup = this.props.isOpenOnHandDetailPopup;
    let onHandQtyCaption = this.props.onHandQtyCaption;
    this.setState({
      isOpenOnHandDetailPopup: isOpenOnHandDetailPopup,
      onHandQtyCaption: onHandQtyCaption,
    });
  }
  closeOnHandDetailPopup = () => {
    this.props.closeOnHandDetailPopup();
  };
  render() {
    let isOpenOnHandDetailPopup = this.state.isOpenOnHandDetailPopup;
    let fabricStyleData = this.state.fabricStyleData;
    let isDisbleAddorUpdateButton = false;
    let batchInventoryDataBean = this.props.batchInventoryDataBean;
    if (
      batchInventoryDataBean.fabricStyleName == null ||
      batchInventoryDataBean.fabricStyleName == ""
    ) {
      batchInventoryDataBean.fabricStyleName = fabricStyleData.description;
    }
    let onHandQtyCaption = this.props.onHandQtyCaption;
    let isDisabledFields = this.props.isDisableOnorderQtyFields;
    let invDetailLines = [];
    if (batchInventoryDataBean != null) {
      if (batchInventoryDataBean.inventoryDataDetails != null) {
        batchInventoryDataBean.inventoryDataDetails.map((line) => {
          invDetailLines.push(line);
        });
      }
    } else {
      batchInventoryDataBean = new SkuBatchInventoryDataBean();
    }
    const is3PL = this.props.is3PL;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel>Company</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="companyCode"
                value={fabricStyleData.companyCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                onChange={this.onChange}
                value={batchInventoryDataBean.fabricStyleCode}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="description"
                onChange={this.onChange}
                value={batchInventoryDataBean.fabricStyleName}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Color</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleColorCode"
                onChange={this.onChange}
                value={batchInventoryDataBean.fabricStyleColorCode}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>UOM</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="uomCode"
                onChange={this.onChange}
                value={batchInventoryDataBean.uomCode}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>SkuNumber</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="skuNumber"
                onChange={this.onChange}
                value={batchInventoryDataBean.skuNumber}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>OnHandQty</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="totalOnHandQuantity"
                // type="cost"
                placeholder="Enter totalOnHandQuantity"
                onChange={this.onChange}
                value={batchInventoryDataBean.totalOnHandQuantity}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>No.Of.Rolls</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="totalNumberOfRolls"
                placeholder="Enter totalNumberOfRolls"
                onChange={this.onChange}
                value={batchInventoryDataBean.totalNumberOfRolls}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
        </div>
        <div className="div_Custom">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>{this.props.is3PL ? "Inventory#" : "RollSKU#"}</th>
                <th>Loc#</th>
                <th>VendorLot</th>
                <th>Roll</th>
                <th>OnHandQty</th>
                <th>P.O#</th>
                <th>P.R#</th>
                <th>RecdQty</th>
              </tr>
            </thead>
            <tbody>
              {invDetailLines.map((line, i) => (
                <tr key={i} data-item={line}>
                  <td>{line.rollSkuNumber}</td>
                  <td>{line.locationCode}</td>
                  <td>{line.vendorBatchNumber}</td>
                  <td>{line.rollNumber}</td>
                  <td>{line.onHandQuantity}</td>
                  <td>{line.purchaseOrderNumber}</td>
                  <td>{line.purchaseOrderReceiptNumber}</td>
                  <td>{line.totalReceivedQuantity}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}
class TargetDetail extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      miscReasons: this.props.miscReasons,
      vendor_List: this.props.vendor_List,
      eComShopifyData: this.props.eComShopifyData,
      fabricStyleSKUData: this.props.fabricStyleSKUData,
      isShowEcomColorPopup: this.props.isShowEcomColorPopup,
      isShowBodyPopup: this.props.isShowBodyPopup,
      editedMiscCostLineList: this.props.editedMiscCostLineList,
      fabricStyleMiscCostLineData: this.props.fabricStyleMiscCostLineData,
      targetWebSiteDetail: this.props.targetWebSiteDetail,
      eComSkuData: this.props.eComSkuData,
    };
  }
  onSkuChange = (e) => {
    this.props.onSkuChange(e);
  };
  addorUpdateSkuDetails = (e) => {
    if (e.detail == 1) {
      this.props.addorUpdateSkuDetails();
      this.closeAlertModalCallBackLvl1(false);
    }
  };
  clearSkuData = () => {
    this.props.clearSkuData();
  };
  colorButtonClick = (e, val) => {
    if (e.detail <= 1) this.props.colorButtonClick(val);
  };
  bodyClick = (e) => {
    if (e.detail == 1) this.props.bodyClick();
  };
  onTargetDetailChange = (e) => {
    this.props.onTargetDetailChange(e);
  };
  onBodyDataChange = (e) => {
    this.props.onBodyDataChange(e);
  };
  onBodyBulletinDataChange = (e) => {
    this.props.onBodyBulletinDataChange(e);
  };
  onBodyTopDataChange = (e) => {
    this.props.onBodyTopDataChange(e);
  };
  onBodyBottomDataChange = (e) => {
    this.props.onBodyBottomDataChange(e);
  };
  deleteLine = (rowData) => {
    this.props.deleteLine(rowData);
  };
  deleteTopLine = (rowData) => {
    this.props.deleteTopLine(rowData);
  };
  deleteBottomLine = (rowData) => {
    this.props.deleteBottomLine(rowData);
  };
  clearLines = () => {
    this.props.clearLines();
  };
  clearTopDescriptionLines = () => {
    this.props.clearTopDescriptionLines();
  };
  clearBottomDescriptionLines = () => {
    this.props.clearBottomDescriptionLines();
  };
  addBodyTopDescriptionLines = () => {
    this.props.addBodyTopDescriptionLines();
  };
  addBodyBottomDescriptionLines = () => {
    this.props.addBodyBottomDescriptionLines();
  };
  addBodyBulletinLines = () => {
    this.props.addBodyBulletinLines();
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeAlertModalCallBack(isShowPopup);
  };
  readBulletLines = (rowData) => {
    this.props.readBulletLines(rowData);
  };
  readTopLines = (rowData) => {
    this.props.readTopLines(rowData);
  };
  readBottomLines = (rowData) => {
    this.props.readBottomLines(rowData);
  };
  convertTextToHtml = (e) => {
    if (e.detail == 1) {
      this.props.convertTextToHtml();
      this.closeAlertModalCallBackLvl1(false);
    }
  };
  closeAlertModalCallBackLvl1 = (isShowPopup) => {
    this.props.closeAlertModalCallBackLvl1(isShowPopup);
    this.props.clearBodyList();
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let targetWebSiteDetail = this.props.targetWebSiteDetail;
    let eComShopifyData = this.props.temp_eComShopifyData;
    eComShopifyData.code = fabricStyleData.code;
    eComShopifyData.description = fabricStyleData.description;
    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "4em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let colors = this.props.fabricStyleData.colors;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <div>
          <div>
            <Row>
              <Col className="align-items-left" sm="2">
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle</FormLabel>
                )}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="code"
                  readOnly={false}
                  onChange={this.onChange}
                  value={eComShopifyData.code}
                  disabled={true}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="2">
                {is3PL ? (
                  <FormLabel>Item Name</FormLabel>
                ) : (
                  <FormLabel>FabricStyle Name</FormLabel>
                )}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="description"
                  readOnly={false}
                  onChange={this.onChange}
                  value={eComShopifyData.description}
                  disabled={true}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="2">
                {" "}
                <FormLabel>Website</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="webSiteCode"
                  readOnly={false}
                  onChange={this.onTargetDetailChange}
                  value={eComShopifyData.webSiteCode}
                  disabled={true}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="2">
                {" "}
                <FormLabel>Vendor</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="vendor"
                  readOnly={false}
                  onChange={this.onTargetDetailChange}
                  value={eComShopifyData.vendor}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="2">
                {" "}
                <FormLabel>Variant Taxable</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="variantTaxable"
                  readOnly={false}
                  onChange={this.onTargetDetailChange}
                  value={eComShopifyData.variantTaxable}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="2">
                {" "}
                <FormLabel>Variant TaxCode</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="variantTaxCode"
                  readOnly={false}
                  onChange={this.onTargetDetailChange}
                  value={eComShopifyData.variantTaxCode}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="2">
                {" "}
                <FormLabel>Type</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="standardProductType"
                  readOnly={false}
                  onChange={this.onTargetDetailChange}
                  value={eComShopifyData.standardProductType}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="2">
                {" "}
                <FormLabel>Web Sales</FormLabel>{" "}
              </Col>
              <Col>
                <InputCheckbox
                  name="webSalesFlag"
                  type="checkbox"
                  checked={eComShopifyData.webSalesFlag}
                  onChange={this.onTargetDetailChange}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
            {!is3PL ? (
              <Row>
                <Col className="align-items-left" sm="2">
                  {" "}
                  <FormLabel>Collection</FormLabel>{" "}
                </Col>

                <Col sm="2">
                  <InputTextbox
                    name="collectionName"
                    onChange={this.onTargetDetailChange}
                    value={eComShopifyData.collectionName}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="2">
                  {" "}
                  <FormLabel>Shipping Weight</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    name="shippingWeight"
                    onChange={this.onTargetDetailChange}
                    value={eComShopifyData.shippingWeight}
                    disabled={isDisabledFields}
                    decimalScale={2}
                  />{" "}
                </Col>
              </Row>
            ) : null}
            <div className="div_80">
              <Row>
                <Col sm="2">
                  {" "}
                  <FormLabel>Handle</FormLabel>
                </Col>
                <Col sm="10">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="handle"
                    type="text"
                    placeholder="Handle"
                    onChange={this.onTargetDetailChange}
                    value={eComShopifyData.handle}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  {" "}
                  <FormLabel>Title</FormLabel>
                </Col>
                <Col sm="10">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="title"
                    type="text"
                    placeholder="Title"
                    onChange={this.onTargetDetailChange}
                    value={eComShopifyData.title}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  {" "}
                  <FormLabel
                    onClick={(e) => this.bodyClick(e)}
                    className="ecomShopifyBody"
                  >
                    Body
                  </FormLabel>
                </Col>
                <Col sm="10">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="body"
                    type="text"
                    placeholder="Body"
                    onChange={this.onTargetDetailChange}
                    value={eComShopifyData.body}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  {" "}
                  <FormLabel>SEO Title</FormLabel>
                </Col>
                <Col sm="10">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="sEOTitle"
                    type="text"
                    placeholder="SEO Title"
                    onChange={this.onTargetDetailChange}
                    value={eComShopifyData.sEOTitle}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  {" "}
                  <FormLabel>SEO Description</FormLabel>
                </Col>
                <Col sm="10">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="sEODescription"
                    type="text"
                    placeholder="SEO Description"
                    onChange={this.onTargetDetailChange}
                    value={eComShopifyData.sEODescription}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  {" "}
                  <FormLabel>Tags</FormLabel>
                </Col>
                <Col sm="10">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="customProductTypeTags"
                    type="text"
                    placeholder="Tags"
                    onChange={this.onTargetDetailChange}
                    value={eComShopifyData.customProductTypeTags}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
            </div>

            <div className="div_20">
              <Table id="fabrics_tables">
                <tbody>
                  {colors.map((line, i) => (
                    <tr key={i} data-item={line}>
                      <td>
                        <Button
                          id="fabric_Add_Button"
                          className="enterFocus"
                          onClick={(e) =>
                            this.colorButtonClick(e, line.fabricStyleColorCode)
                          }
                          disabled={isDisabledFields}
                        >
                          {line.fabricStyleColorCode}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.props.isShowBodyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"Body Details"}
          closeOnDocumentClick={false}
          lockScroll={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.convertTextToHtml(e)}
                disabled={isDisabledFields}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <BodyDetail
              {...this.state}
              is3PL={this.props.is3PL}
              fabricStyleData={this.state.fabricStyleData}
              closeOnHandDetailPopup={this.closeOnHandDetailPopup}
              eComShopifyData={this.props.eComShopifyData}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              shopifyBodyLineData={this.props.shopifyBodyLineData}
              shopifyBodyTopDescriptionData={
                this.props.shopifyBodyTopDescriptionData
              }
              shopifyBodyBottomDescriptionData={
                this.props.shopifyBodyBottomDescriptionData
              }
              shopifyBodyData={this.props.shopifyBodyData}
              onBodyBulletinDataChange={this.onBodyBulletinDataChange}
              onBodyTopDataChange={this.onBodyTopDataChange}
              onBodyBottomDataChange={this.onBodyBottomDataChange}
              onBodyDataChange={this.onBodyDataChange}
              convertTextToHtml={this.convertTextToHtml}
              deleteLine={this.deleteLine}
              deleteTopLine={this.deleteTopLine}
              deleteBottomLine={this.deleteBottomLine}
              clearLines={this.clearLines}
              clearTopDescriptionLines={this.clearTopDescriptionLines}
              clearBottomDescriptionLines={this.clearBottomDescriptionLines}
              readBulletLines={this.readBulletLines}
              readTopLines={this.readTopLines}
              readBottomLines={this.readBottomLines}
              addBodyLines={this.addBodyBulletinLines}
              addBodyTopDescriptionLines={this.addBodyTopDescriptionLines}
              addBodyBottomDescriptionLines={this.addBodyBottomDescriptionLines}
              websiteCode={this.props.websiteCode}
              fabricStyleSKUData={this.props.fabricStyleSKUData}
              shopifyBodyTopList={this.props.shopifyBodyTopList}
              shopifyBodyBulletList={this.props.shopifyBodyBulletList}
              shopifyBodyBottomList={this.props.shopifyBodyBottomList}
              isDisabledFields={this.props.isDisabledFields}
            />
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.props.isShowEcomColorPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"SHOPIFY SKU DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.addorUpdateSkuDetails(e)}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <ColorPopupForm
              is3PL={this.props.is3PL}
              eComSkuData={this.props.eComSkuData}
              onSkuChange={this.onSkuChange}
              isDisabledFields={this.props.isDisabledFields}
              moduleForPopup={this.props.moduleForPopup}
              selectedCode={this.props.selectedCode}
              targetWebSiteDetail={this.props.targetWebSiteDetail}
              editedMiscCostLineList={this.props.editedMiscCostLineList}
            />
          }
        />
      </div>
    );
  }
}
class BodyDetail extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      miscReasons: this.props.miscReasons,
      vendor_List: this.props.vendor_List,
      eComShopifyData: this.props.eComShopifyData,
      shopifyBodyData: this.props.shopifyBodyData,
      shopifyBodyLineData: this.props.shopifyBodyLineData,
      websiteCode: this.props.websiteCode,
      fabricStyleSKUData: this.props.fabricStyleSKUData,
      fabricStyleData: this.props.fabricStyleData,
      editedMiscCostLineList: this.props.editedMiscCostLineList,
      fabricStyleMiscCostLineData: this.props.fabricStyleMiscCostLineData,
      targetWebSiteDetail: this.props.targetWebSiteDetail,
    };
  }
  componentDidMount() {
    //
  }

  onBodyBulletinDataChange = (e) => {
    this.props.onBodyBulletinDataChange(e);
  };
  onBodyBottomDataChange = (e) => {
    this.props.onBodyBottomDataChange(e);
  };
  onBodyTopDataChange = (e) => {
    this.props.onBodyTopDataChange(e);
  };
  onBodyDataChange = (e) => {
    this.props.onBodyDataChange(e);
  };
  deleteLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteLine(rowData);
  };
  deleteTopLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteTopLine(rowData);
  };
  deleteBottomLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteBottomLine(rowData);
  };
  readBulletLines = (e, rowData) => {
    if (e.detail == 1) this.props.readBulletLines(rowData);
  };
  readTopLines = (e, rowData) => {
    if (e.detail == 1) this.props.readTopLines(rowData);
  };
  readBottomLines = (e, rowData) => {
    if (e.detail == 1) this.props.readBottomLines(rowData);
  };
  clearLines = (e) => {
    if (e.detail <= 1) this.props.clearLines();
  };
  clearTopDescriptionLines = (e) => {
    if (e.detail <= 1) this.props.clearTopDescriptionLines();
  };
  clearBottomDescriptionLines = (e) => {
    if (e.detail <= 1) this.props.clearBottomDescriptionLines();
  };
  addBodyLines = (e) => {
    if (e.detail <= 1) this.props.addBodyLines();
  };
  addBodyTopDescriptionLines = (e) => {
    if (e.detail <= 1) this.props.addBodyTopDescriptionLines();
  };
  addBodyBottomDescriptionLines = (e) => {
    if (e.detail <= 1) this.props.addBodyBottomDescriptionLines();
  };
  convertTextToHtml = () => {
    this.props.convertTextToHtml();
  };

  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let isDisabledFields = this.props.isDisabledFields;
    let shopifyBodyData = this.props.shopifyBodyData;
    let shopifyBodyLineData = this.props.shopifyBodyLineData;
    let shopifyBodyTopDescriptionData =
      this.props.shopifyBodyTopDescriptionData;
    let shopifyBodyBottomDescriptionData =
      this.props.shopifyBodyBottomDescriptionData;
    let eComShopifyData = this.props.eComShopifyData;
    eComShopifyData.code = fabricStyleData.code;
    eComShopifyData.description = fabricStyleData.description;
    let topDescriptionDatas = [];
    let bulletinLineDatas = [];
    let bottomDescriptionLineDatas = [];
    if (this.props.shopifyBodyData != null) {
      if (!isEmptyArray(this.props.shopifyBodyTopList)) {
        topDescriptionDatas = this.props.shopifyBodyTopList;
      } else {
        topDescriptionDatas =
          this.props.shopifyBodyData.topDescriptionLineDatas;
      }
      if (!isEmptyArray(this.props.shopifyBodyBulletList)) {
        bulletinLineDatas = this.props.shopifyBodyBulletList;
      } else {
        bulletinLineDatas = this.props.shopifyBodyData.bulletinLineDatas;
      }

      if (!isEmptyArray(this.props.shopifyBodyBottomList)) {
        bottomDescriptionLineDatas = this.props.shopifyBodyBottomList;
      } else {
        bottomDescriptionLineDatas =
          this.props.shopifyBodyData.bottomDescriptionLineDatas;
      }
    }
    const textAreaStyle = {
      maxHeight: "15px",
      minHeight: "2em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    const is3PL = this.props.is3PL;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                onChange={this.onChange}
                value={eComShopifyData.code}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="2">
              {is3PL ? (
                <FormLabel>Item Name</FormLabel>
              ) : (
                <FormLabel>FabricStyle Name</FormLabel>
              )}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="description"
                readOnly={true}
                onChange={this.onChange}
                value={eComShopifyData.description}
                disabled={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="metaDescription"
                type="text"
                onChange={this.onBodyDataChange}
                value={shopifyBodyData.metaDescription}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>
          <div class="div_Equal">
            <div>
              <FormLabel>Top Description</FormLabel>

              <div className="table_mini">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th>Desc</th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {topDescriptionDatas.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) => this.readTopLines(e, ln)}
                          >
                            {ln.description}
                          </Button>
                        </td>
                        <td>
                          <Button
                            id="fabric_Add_Button"
                            className="hyperLinkText"
                            onClick={(e) => this.deleteTopLine(e, ln)}
                            disabled={isDisabledFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="description"
                type="text"
                onChange={this.onBodyTopDataChange}
                value={shopifyBodyTopDescriptionData.description}
                disabled={isDisabledFields}
              />
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.addBodyTopDescriptionLines(e)}
                disabled={isDisabledFields}
              >
                Add/Update
              </Button>
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.clearTopDescriptionLines(e)}
                disabled={isDisabledFields}
              >
                Clear
              </Button>
            </div>
            <div>
              <FormLabel>Bullet Points</FormLabel>
              <div className="table_mini">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th>Desc</th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {bulletinLineDatas.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) => this.readBulletLines(e, ln)}
                          >
                            {ln.description}
                          </Button>
                        </td>

                        <td>
                          <Button
                            id="fabric_Add_Button"
                            className="hyperLinkText"
                            onClick={(e) => this.deleteLine(e, ln)}
                            disabled={isDisabledFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="description"
                type="text"
                onChange={this.onBodyBulletinDataChange}
                value={shopifyBodyLineData.description}
                disabled={isDisabledFields}
              />
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.addBodyLines(e)}
                disabled={isDisabledFields}
              >
                Add/Update
              </Button>
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.clearLines(e)}
                disabled={isDisabledFields}
              >
                Clear
              </Button>
            </div>
          </div>
          <div class="div_Equal">
            <div>
              <FormLabel>Bottom Description</FormLabel>
              <div className="table_mini">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th>Desc</th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {bottomDescriptionLineDatas.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) => this.readBottomLines(e, ln)}
                          >
                            {ln.description}
                          </Button>
                        </td>
                        <td>
                          <Button
                            id="fabric_Add_Button"
                            className="hyperLinkText"
                            onClick={(e) => this.deleteBottomLine(e, ln)}
                            disabled={isDisabledFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="description"
                type="text"
                onChange={this.onBodyBottomDataChange}
                value={shopifyBodyBottomDescriptionData.description}
                disabled={isDisabledFields}
              />
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.addBodyBottomDescriptionLines(e)}
                disabled={isDisabledFields}
              >
                Add/Update
              </Button>
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.clearBottomDescriptionLines(e)}
                disabled={isDisabledFields}
              >
                Clear
              </Button>
            </div>
            <div>
              <Row>
                <Col>
                  <FormLabel>Header Description</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col>
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="headerDescription"
                    type="text"
                    onChange={this.onBodyDataChange}
                    value={shopifyBodyData.headerDescription}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class ColorPopupForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      eComShopifyData: this.props.eComShopifyData,
      miscReasons: this.props.miscReasons,
      vendor_List: this.props.vendor_List,
      moduleForPopup: this.props.moduleForPopup,
      selectedCode: this.props.selectedCode,
      targetWebSiteDetail: this.props.targetWebSiteDetail,
      editedMiscCostLineList: this.props.editedMiscCostLineList,
    };
  }
  onSkuChange = (e) => {
    this.props.onSkuChange(e);
  };
  render() {
    let eComSkuData = this.props.eComSkuData;
    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "4em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <div className="sales_line_pop">
          <Row>
            <Col sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                onChange={this.onSkuChange}
                value={eComSkuData.code}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Desc</FormLabel>{" "}
            </Col>
            <Col sm="4">
              <InputTextbox
                name="description"
                onChange={this.onSkuChange}
                value={eComSkuData.description}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Color</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="colorCode"
                onChange={this.onSkuChange}
                value={eComSkuData.colorCode}
                disabled={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Website</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="webSiteCode"
                onChange={this.onSkuChange}
                value={eComSkuData.webSiteCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Sku</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="skuNumber"
                onChange={this.onSkuChange}
                value={eComSkuData.skuNumber}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Variant Sku</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="variantSKU"
                onChange={this.onSkuChange}
                value={eComSkuData.variantSKU}
                disabled={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>option1Name</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="option1Name"
                onChange={this.onSkuChange}
                value={eComSkuData.option1Name}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Option1Value</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="option1Value"
                onChange={this.onSkuChange}
                value={eComSkuData.option1Value}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Variant Price</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="variantPrice"
                onChange={this.onSkuChange}
                value={eComSkuData.variantPrice}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Variant Grams</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="variantGrams"
                onChange={this.onSkuChange}
                value={eComSkuData.variantGrams}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Variant Bar Code</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="variantBarcode"
                onChange={this.onSkuChange}
                value={eComSkuData.variantBarcode}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Web Sales</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputCheckbox
                name="webSalesFlag"
                type="checkbox"
                checked={eComSkuData.webSalesFlag}
                onChange={this.onSkuChange}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="2">
              <FormLabel>Image Alt Text</FormLabel>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="imageAltText"
                type="text"
                onChange={this.onSkuChange}
                value={eComSkuData.imageAltText}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
class FabricStyleEcomDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      showHide: this.props.showHide,
      fabricStyleData: this.props.fabricStyleData,
      editedMiscCostLineList: this.props.editedMiscCostLineList,
      miscReasons: this.props.miscReasons,
      vendor_List: this.props.vendor_List,
      eComShopifyData: this.props.eComShopifyData,
      isShowTargetWebPopup: this.props.isShowTargetWebPopup,
      isShowEcomColorPopup: this.props.isShowEcomColorPopup,
      isShowBodyPopup: this.props.isShowBodyPopup,
    };
  }

  continueButtonClick = () => {
    this.props.continueButtonClick();
  };
  targetContinueButtonClick = (e) => {
    if (e.detail == 1) this.props.targetContinueButtonClick();
  };
  bodyClick = () => {
    this.props.bodyClick();
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeAlertModalCallBack(isShowPopup);
    this.props.clearData();
  };
  targetDetailButtonClick = (e, element) => {
    if (e.detail <= 1) this.props.targetDetailButtonClick(element);
  };
  colorButtonClick = (val) => {
    this.props.colorButtonClick(val);
  };
  onSkuChange = (e) => {
    this.props.onSkuChange(e);
  };
  addorUpdateSkuDetails = () => {
    this.props.addorUpdateSkuDetails();
  };
  clearSkuData = () => {
    this.props.clearSkuData();
  };
  closeAlertModalCallBackLvl1 = (isShowPopup) => {
    this.props.closeAlertModalCallBackLvl1(isShowPopup);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let targetWebSiteDetail = this.props.targetWebSiteDetail;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <div className="header_div">
          <Row>
            <Col className="align-items-left" sm="1">
              {is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                onChange={this.onChange}
                value={fabricStyleData.code}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              {" "}
              <FormLabel>Company Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                onChange={this.onChange}
                value={fabricStyleData.companyCode}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel className="label_head">Ecom Details</FormLabel>
            </Col>
          </Row>
          <Row className="button-flex">
            {targetWebSiteDetail.map(
              (element) =>
                element.webExportTypCode === "SHOPIFY" && (
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    size="sm1"
                    // bssize="large"
                    onClick={(e) => this.targetDetailButtonClick(e, element)}
                  >
                    {element.code + "(" + element.webExportTypCode + ")"}
                  </Button>
                ),
            )}
          </Row>
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.props.isShowTargetWebPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={this.props.targetDetail + " Details"}
          closeOnDocumentClick={false}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.targetContinueButtonClick(e)}
                disabled={isDisabledFields}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <TargetDetail
              {...this.state}
              is3PL={this.props.is3PL}
              isShowPopupAlert={this.props.isShowPopupAlert}
              isShowAlert={this.props.isShowAlert}
              isShowPopupAlertLvl1={this.props.isShowPopupAlertLvl1}
              isShowEcomColorPopup={this.props.isShowEcomColorPopup}
              fabricStyleData={this.props.fabricStyleData}
              eComShopifyData={this.props.eComShopifyData}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              continueButtonClick={this.continueButtonClick}
              onChange={this.onChange}
              websiteCode={this.props.websiteCode}
              fabricStyleColorData={this.props.fabricStyleColorData}
              fabricStyleSKUData={this.props.fabricStyleSKUData}
              onTargetDetailChange={this.props.onTargetDetailChange}
              temp_eComShopifyData={this.props.temp_eComShopifyData}
              deleteLine={this.props.deleteLine}
              deleteTopLine={this.props.deleteTopLine}
              deleteBottomLine={this.props.deleteBottomLine}
              clearLines={this.props.clearLines}
              clearTopDescriptionLines={this.props.clearTopDescriptionLines}
              clearBottomDescriptionLines={
                this.props.clearBottomDescriptionLines
              }
              onBodyDataChange={this.props.onBodyDataChange}
              onBodyBulletinDataChange={this.props.onBodyBulletinDataChange}
              onBodyTopDataChange={this.props.onBodyTopDataChange}
              onBodyBottomDataChange={this.props.onBodyBottomDataChange}
              addBodyTopDescriptionLines={this.props.addBodyTopDescriptionLines}
              addBodyBottomDescriptionLines={
                this.props.addBodyBottomDescriptionLines
              }
              addBodyBulletinLines={this.props.addBodyBulletinLines}
              readBulletLines={this.props.readBulletLines}
              readTopLines={this.props.readTopLines}
              readBottomLines={this.props.readBottomLines}
              convertTextToHtml={this.props.convertTextToHtml}
              shopifyBodyBulletList={this.props.shopifyBodyBulletList}
              shopifyBodyBottomList={this.props.shopifyBodyBottomList}
              shopifyBodyTopList={this.props.shopifyBodyTopList}
              shopifyBodyData={this.props.shopifyBodyData}
              shopifyBodyBottomDescriptionData={
                this.props.shopifyBodyBottomDescriptionData
              }
              shopifyBodyTopDescriptionData={
                this.props.shopifyBodyTopDescriptionData
              }
              shopifyBodyLineData={this.props.shopifyBodyLineData}
              isShowBodyPopup={this.props.isShowBodyPopup}
              bodyClick={this.bodyClick}
              clearBodyList={this.props.clearBodyList}
              isDisabledFields={this.props.isDisabledFields}
              moduleForPopup={this.props.moduleForPopup}
              selectedCode={this.props.selectedCode}
              targetWebSiteDetail={this.props.targetWebSiteDetail}
              editedMiscCostLineList={this.props.editedMiscCostLineList}
              alertMessage={this.props.alertMessage}
              alertType={this.props.alertType}
              fabricStyleMiscCostLineData={
                this.props.fabricStyleMiscCostLineData
              }
              eComSkuData={this.props.eComSkuData}
              colorButtonClick={this.colorButtonClick}
              onSkuChange={this.onSkuChange}
              addorUpdateSkuDetails={this.addorUpdateSkuDetails}
              clearSkuData={this.clearSkuData}
              closeAlertModalCallBackLvl1={this.closeAlertModalCallBackLvl1}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
        />
      </div>
    );
  }
}

class FabricStyleLogisticDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {
    this.initLookupHandlers();
    this.setDefaultValueForLogestic();
  }
  componentDidUpdate() {
    //
  }
  initLookupHandlers = () => {
    let uomLookupHandler = new GenericAttributeLookupHandler(
      this.props.uoms,
      "UOM",
    );
    this.setState({ uomLookupHandler: uomLookupHandler });
    let caseUOMLookupHandler = new GenericAttributeLookupHandler(
      this.props.lengthUOMs,
      "CaseUOM",
    );
    this.setState({ caseUOMLookupHandler: caseUOMLookupHandler });
    let weightUOMLookupHandler = new GenericAttributeLookupHandler(
      this.props.weightUOMs,
      "weightUOM",
    );
    this.setState({ weightUOMLookupHandler: weightUOMLookupHandler });
    let palletUomHandler = new GenericAttributeLookupHandler(
      this.props.lengthUOMs,
      "PalletUOM",
    );
    this.setState({ palletUomHandler: palletUomHandler });
  };
  setDefaultValueForLogestic = () => {
    this.props.setDefaultValueForLogestic();
  };
  logisticOnChange = (e) => {
    this.props.logisticOnChange(e);
  };
  uomOnChange = (e) => {
    this.props.uomOnChange(e);
  };
  logisticUomEnterKeyEvent = (e) => {
    this.props.logisticUomEnterKeyEvent(e);
  };
  displayLogisticUomAutoCompleteList = (list) => {
    this.props.displayLogisticUomAutoCompleteList(list);
  };
  logisticWeightUomOnChange = (e) => {
    this.props.logisticWeightUomOnChange(e);
  };
  logisticWeightUomEnterKeyEvent = (e) => {
    this.props.logisticWeightUomEnterKeyEvent(e);
  };
  displayLogisticWeightUomAutoCompleteList = (list) => {
    this.props.displayLogisticWeightUomAutoCompleteList(list);
  };

  logisticCaseUomOnChange = (e) => {
    this.props.logisticCaseUomOnChange(e);
  };
  logisticCaseUomEnterKeyEvent = (e) => {
    this.props.logisticCaseUomEnterKeyEvent(e);
  };
  displayLogisticCaseUomAutoCompleteList = (list) => {
    this.props.displayLogisticCaseUomAutoCompleteList(list);
  };

  logisticPalletUomOnChange = (e) => {
    this.props.logisticPalletUomOnChange(e);
  };
  logisticPalletUomEnterKeyEvent = (e) => {
    this.props.logisticPalletUomEnterKeyEvent(e);
  };
  displayLogisticPalletUomAutoCompleteList = (list) => {
    this.props.displayLogisticPalletUomAutoCompleteList(list);
  };

  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let fabricLogisticPackageInfosDetails =
      this.props.fabricLogisticPackageInfosDetails;
    const textAreaStyle = {
      height: "5em",
      width: "15em",
      resize: "none",
      padding: "3px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div className="header_div">
        <Row>
          <Col sm="1">
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="companyCode"
              type="text"
              onChange={this.logisticOnChange}
              value={fabricStyleData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          {/* <Col sm="1">
            <FormLabel>LogisticPackageInfo</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              type="text"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.code}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col> */}
          <Col sm="1">
            <FormLabel>Item</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              onChange={this.logisticOnChange}
              value={fabricStyleData.code}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Inventory UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="uomCode"
              type="text"
              onChange={this.uomOnChange}
              value={fabricLogisticPackageInfosDetails.uomCode}
              disabled={true}
            />
            {/* <InputTextbox
              onChange={this.uomOnChange}
              placeholder="uomCode"
              name="uomCode"
              value={fabricLogisticPackageInfosDetails.uomCode}
              lookupRequired={true}
              lookupHandler={this.state.uomLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.logisticUomEnterKeyEvent}
              autoCompleteListData={
                this.props.logisticUomPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayLogisticUomAutoCompleteList}
              showAutoCompleteList={
                this.props.isShowAutoCompleteLogisticUomList
              }
            /> */}
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputCheckbox
              name="isActive"
              onChange={this.logisticOnChange}
              checked={fabricLogisticPackageInfosDetails.isActive}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Case Details</FormLabel>
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Weight UOM</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {/* <InputTextbox
              name="weightUomCode"
              type="text"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.weightUomCode}
              disabled={this.props.isDisabledFields}
            />{" "} */}
            <InputTextbox
              onChange={this.logisticWeightUomOnChange}
              placeholder="weightUomCode"
              name="weightUomCode"
              value={fabricLogisticPackageInfosDetails.weightUomCode}
              lookupRequired={true}
              lookupHandler={this.state.weightUOMLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.logisticWeightUomEnterKeyEvent}
              autoCompleteListData={
                this.props.logisticWeightUomPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.displayLogisticWeightUomAutoCompleteList
              }
              showAutoCompleteList={
                this.props.isShowAutoCompleteLogisticWeightUomList
              }
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>CaseWeight</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="grossWeightOfUom"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.grossWeightOfUom}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>NetWeight</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="netWeightOfUom"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.netWeightOfUom}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Case UOM#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {/* <InputTextbox
              name="caseUomCode"
              type="text"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.caseUomCode}
              disabled={this.props.isDisabledFields}
            />{" "} */}
            <InputTextbox
              onChange={this.logisticCaseUomOnChange}
              placeholder="caseUomCode"
              name="caseUomCode"
              value={fabricLogisticPackageInfosDetails.caseUomCode}
              lookupRequired={true}
              lookupHandler={this.state.caseUOMLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.logisticCaseUomEnterKeyEvent}
              autoCompleteListData={
                this.props.logisticCaseUomPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.displayLogisticCaseUomAutoCompleteList
              }
              showAutoCompleteList={
                this.props.isShowAutoCompleteLogisticCaseUomList
              }
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Case Length</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="caseLength"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.caseLength}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Case Width</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="caseWidth"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.caseWidth}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Case Height</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="caseHeight"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.caseHeight}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Case/Pallet</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="casePack"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.casePack}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Pallet Details</FormLabel>
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Pallet UOM#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {/* <InputTextbox
              name="palletUomCode"
              type="text"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.palletUomCode}
              disabled={this.props.isDisabledFields}
            />{" "} */}

            <InputTextbox
              onChange={this.logisticPalletUomOnChange}
              placeholder="palletUomCode"
              name="palletUomCode"
              value={fabricLogisticPackageInfosDetails.palletUomCode}
              lookupRequired={true}
              lookupHandler={this.state.palletUomHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.logisticPalletUomEnterKeyEvent}
              autoCompleteListData={
                this.props.logisticPalletUomPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.displayLogisticPalletUomAutoCompleteList
              }
              showAutoCompleteList={
                this.props.isShowAutoCompleteLogisticPalletUomList
              }
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Pallet Length</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="palletLength"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.palletLength}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Pallet width</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="palletWidth"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.palletWidth}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Pallet Height</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="palletHeight"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.palletHeight}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          {/* </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Pallet Tie</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="palletTie"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.palletTie}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Pallet High</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="palletHigh"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.palletHigh}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col> */}
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Pallet Weight</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="palletWeight"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.palletWeight}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>StackableQty</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="stackableQuantity"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.stackableQuantity}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
              decimalScale={2}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Misc Details</FormLabel>
          </Col>
        </Row>
        <Row>
          <div className="column-single-entry">
            <Row>
              <Col sm="">
                <FormLabel>Nmfc#</FormLabel>{" "}
              </Col>
              <Col sm="">
                <InputTextbox
                  name="nmfcCode"
                  type="text"
                  onChange={this.logisticOnChange}
                  value={fabricLogisticPackageInfosDetails.nmfcCode}
                  disabled={this.props.isDisabledFields}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="">
                <FormLabel>LotCodeFormat</FormLabel>{" "}
              </Col>
              <Col sm="">
                <InputTextbox
                  name="lotCodeFormat"
                  type="text"
                  onChange={this.logisticOnChange}
                  value={fabricLogisticPackageInfosDetails.lotCodeFormat}
                  disabled={this.props.isDisabledFields}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="">
                <FormLabel>LtlFreightClass</FormLabel>{" "}
              </Col>
              <Col sm="">
                <InputTextbox
                  name="ltlFreightClass"
                  onChange={this.logisticOnChange}
                  value={fabricLogisticPackageInfosDetails.ltlFreightClass}
                  disabled={this.props.isDisabledFields}
                />{" "}
              </Col>
            </Row>
          </div>
          <div className="column-single-entry">
            <Row>
              <FormLabel>Hardz Desc</FormLabel>{" "}
            </Row>
            <Row>
              <textarea
                // style={textAreaStyle}
                className="logistic-txt-area"
                name="harzadousDescription"
                type="text"
                onChange={this.logisticOnChange}
                value={fabricLogisticPackageInfosDetails.harzadousDescription}
                disabled={this.props.isDisabledFields}
              />{" "}
            </Row>
          </div>
          <div className="column-single-entry">
            <Row>
              <FormLabel>Misc Desc</FormLabel>{" "}
            </Row>
            <Row>
              <textarea
                // style={textAreaStyle}
                className="logistic-txt-area"
                name="miscDescription"
                type="text"
                onChange={this.logisticOnChange}
                value={fabricLogisticPackageInfosDetails.miscDescription}
                disabled={this.props.isDisabledFields}
              />{" "}
            </Row>
          </div>
          {/* <Col sm="1">
            <FormLabel>OrderedQuantity</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="orderedQuantity"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.orderedQuantity}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>BalanceQuantity</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="balanceQuantity"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.balanceQuantity}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col> */}
          {/* <Col sm="1">
            <FormLabel>StackableQuantity</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="stackableQuantity"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.stackableQuantity}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>ReceivedDate</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="receivedDate"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.receivedDate}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>ShippedDate</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="shipedDate"
              onChange={this.logisticOnChange}
              value={fabricLogisticPackageInfosDetails.shipedDate}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>LotCodeRequired</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputCheckbox
              name="lotCodeRequiredFlag"
              onChange={this.logisticOnChange}
              checked={fabricLogisticPackageInfosDetails.lotCodeRequiredFlag}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>ItemAvailable</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputCheckbox
              name="itemAvailableFlag"
              onChange={this.logisticOnChange}
              checked={fabricLogisticPackageInfosDetails.itemAvailableFlag}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Stackable</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputCheckbox
              name="stackableFlag"
              onChange={this.logisticOnChange}
              checked={fabricLogisticPackageInfosDetails.stackableFlag}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputCheckbox
              name="isActive"
              onChange={this.logisticOnChange}
              checked={fabricLogisticPackageInfosDetails.isActive}
              disabled={this.props.isDisabledFields}
            />{" "}
          </Col> */}
        </Row>
        <Row></Row>
      </div>
    );
  }
}

class FabricStyleInOutStatisticsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {}

  containerReceivedQtyClick = (e, val, rowData) => {
    //
    this.props.containerReceivedQtyClick(1, rowData);
  };
  containerShippedQtyClick = (e, val, rowData) => {
    //
    this.props.containerShippedQtyClick(1, rowData);
  };

  projectReceivedQtyClick = (e, val, rowData) => {
    //
    this.props.projectReceivedQtyClick(2, rowData);
  };
  projectShippedQtyClick = (e, val, rowData) => {
    //
    this.props.projectShippedQtyClick(2, rowData);
  };

  containerColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedDate", "receivedDate", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Received", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.containerReceivedQtyClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Shipped", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.containerShippedQtyClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Difference", "differnceQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    return columns;
  };
  projectColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Project#", "projectNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedDate", "receivedDate", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Received", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.projectReceivedQtyClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Shipped", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.projectShippedQtyClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Difference", "differnceQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    return columns;
  };
  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let containerDatas = [];
    if (!isEmptyArray(this.props.containerDatas)) {
      containerDatas = this.props.containerDatas;
    }
    let projectDatas = [];
    if (!isEmptyArray(this.props.projectDatas)) {
      projectDatas = this.props.projectDatas;
    }
    let statisticsCriteria = this.props.statisticsCriteria;
    return (
      <div>
        <div>
          <Row>
            {" "}
            <Col className="align-items-left" sm="1">
              <FormLabel>Item</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                value={fabricStyleData.code}
              />{" "}
            </Col>{" "}
            <Col sm="3">
              <InputTextbox
                name="description"
                readOnly={true}
                value={fabricStyleData.description}
              />{" "}
            </Col>
            <Col sm={2}>
              <FormLabel>Options</FormLabel>
            </Col>
            <Col sm={2}>
              <FormControl
                as="select"
                custom
                onChange={this.props.inOutStatisticsOnChange}
                name="mode"
                value={statisticsCriteria.mode}
              >
                <option value={0}>Container#</option>
                <option value={1}>Project#</option>
              </FormControl>
            </Col>
            <Col sm="2">
              <Button
                size="sm"
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.props.statisticExecuteHandler(e)}
              >
                Execute
              </Button>
            </Col>
          </Row>
        </div>
        {statisticsCriteria.mode == 0 ? (
          <>
            <div>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Container#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="containerNumber"
                    value={statisticsCriteria.containerNumber}
                    onChange={this.props.inOutStatisticsOnChange}
                  />{" "}
                </Col>{" "}
                <Col sm="1">
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.props.filterStatisticsCriteria(e, 0)}
                  >
                    Filter
                  </Button>
                </Col>
                <Col sm="1">
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.props.resetStatisticsCriteria(e, 0)}
                  >
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>

            <div className="div_default">
              <CustomTable
                data={containerDatas}
                columns={this.containerColumns()}
                label={"Container Data List"}
              />
            </div>
          </>
        ) : (
          <>
            <div>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Project#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="projectNumber"
                    value={statisticsCriteria.projectNumber}
                    onChange={this.props.inOutStatisticsOnChange}
                  />{" "}
                </Col>{" "}
                <Col sm="1">
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.props.filterStatisticsCriteria(e, 1)}
                  >
                    Filter
                  </Button>
                </Col>
                <Col sm="1">
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.props.resetStatisticsCriteria(e, 1)}
                  >
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
            <div className="div_default">
              <CustomTable
                data={projectDatas}
                columns={this.projectColumns()}
                label={"Project Data List"}
              />
            </div>
          </>
        )}
      </div>
    );
  }
}
class FabricStyleLotBasedInventoryInOutForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {}

  lotReceivedQtyClick = (e, val, rowData) => {
    //
    this.props.lotReceivedQtyClick(rowData);
  };
  lotShippedQtyClick = (e, val, rowData) => {
    //
    this.props.lotShippedQtyClick(rowData);
  };

  lotColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle#", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("lot#", "lotNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedDate", "receivedDate", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Received", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.lotReceivedQtyClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Shipped", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.lotShippedQtyClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Difference", "differnceQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    return columns;
  };

  render() {
    let fabricStyleData = this.props.fabricStyleData;
    let lotNumberDatas = [];
    if (!isEmptyArray(this.props.lotNumberDatas)) {
      lotNumberDatas = this.props.lotNumberDatas;
    }
    let statisticsCriteria = this.props.statisticsCriteria;
    return (
      <div>
        <div>
          <Row>
            {" "}
            <Col className="align-items-left" sm="1">
              <FormLabel>Item</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                readOnly={true}
                value={fabricStyleData.code}
              />{" "}
            </Col>{" "}
            <Col sm="3">
              <InputTextbox
                name="description"
                readOnly={true}
                value={fabricStyleData.description}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>LotNumber</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lotNumber"
                value={statisticsCriteria.lotNumber}
                onChange={this.props.inOutStatisticsOnChange}
              />{" "}
            </Col>{" "}
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.props.statisticExecuteHandler(e)}
              >
                Execute
              </Button>
            </Col>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.props.resetStatisticsCriteria(e)}
              >
                Reset
              </Button>
            </Col>
          </Row>
          <div className="div_default">
            <CustomTable
              data={lotNumberDatas}
              columns={this.lotColumns()}
              label={"LotNumber Data List"}
            />
          </div>
        </div>
      </div>
    );
  }
}

class HoldingFabricDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
      criteria: new HoldingFabricInventoryDetailBean(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: null,
      customerLookupHandler: null,
      fabricStyleColorList: [],
      showAutoCompleteCustomerSalesColorList: false,
      colorSummaryForAutoCompleteList: new Array(),
      inquiryDataList: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      moduleForPopup: [],
      isShowInvoiceModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      isShowPickTicketModule: false,
      isShowSalesOrderMaintenanceModule: false,

      isShowAutoCompletePoList: false,
      poPageListForAutoCompleteList: new Array(),
      purchaseorderLookupHandler: null,

      purchaseReceiptLookupHandler: null,
      showAutoCompletepurchaseReceiptList: false,
      purchaseReceiptPageListForAutoCompleteList: new Array(),

      isShowHoldingEntryPopup: false,

      isShowHoldingAlert: false,

      holdedDataList: [],

      fabricStyleColorList: [],
      colorLookupHandler: null,
      isDisableHoldingFields: false,

      // isShowPurchaseReceiptLookup: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadColors();
    this.loadPage();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let colors = [];
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    // this.setState({ fabricLookupHandler: fabricLookupHandler });

    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "PurchaseOrder",
      "",
      "R",
    );

    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode",
    );

    let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
      this.companyCode,
      "Purchase Receipt",
      "",
      "",
      "A",
    );

    this.setState({
      customerLookupHandler: customerLookupHandler,
      purchaseorderLookupHandler: purchaseOrderLookupHandler,
      fabricLookupHandler: fabricLookupHandler,
      purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
    });
    // let colorLookupHandler = new GenericAttributeLookupHandler(
    //   this.state.colors,
    //   "fabricStyleColorCode"
    // );
    // this.setState({ colorLookupHandler: colorLookupHandler });
    // let vendorLookupHandler = new VendorLookupHandler(
    //   this.companyCode,
    //   "Vendor"
    // );
    // this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  loadPage = () => {
    let criteria = new HoldingInventoryFabricStyleSearchCriteria();
    let fabricStyleData = this.state.fabricStyleData;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.description = fabricStyleData.description;
    let listRequest = new RestHoldingFabricStyleListRequest();
    listRequest.searchCriteria = criteria;
    let pageInput = new PageListBean();
    listRequest.pageInput = pageInput;

    FabricStyleService.getHoldingFabricInventoryDetailPageList(
      listRequest,
      this.holdLinePageListResponse,
      this.errorCallBack,
    );
  };

  holdLinePageListResponse = (response) => {
    let holdedDataList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.holdingInventoryFabricStylePageList)
    ) {
      holdedDataList =
        response.data.holdingInventoryFabricStylePageList
          .holdingInventoryDetails;
    }

    this.setState({
      holdedDataList: holdedDataList,
    });
  };
  loadColors = () => {
    let fabricStyleColorList = this.state.fabricStyleData.colors;
    let simpleAutoCompleteList = new Array();
    fabricStyleColorList.map((colorCodeDatas) => {
      let simpleItemBean = {
        code: colorCodeDatas.fabricStyleColorCode,
        description: colorCodeDatas.fabricStyleColorName,
      };
      simpleAutoCompleteList.push(simpleItemBean);
    });
    this.setState({ fabricStyleColorList: simpleAutoCompleteList });
    this.state.fabricStyleColorList = simpleAutoCompleteList;
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.fabricStyleColorList,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };

  //
  onCustomerSalesColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteCustomerSalesColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompleteCustomerSalesColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteCustomerSalesColorList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerSalesColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;

          this.state.showAutoCompleteCustomerSalesColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerSalesColorList;
          this.setState({
            showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorCustomerSalesEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorCustomerSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
    });
  };

  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;

      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack,
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };

  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  handleHyperLinkClick = (e, val, rowData) => {
    if (val !== "" && val !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={val}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewsalesOrderModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderMaintenanceModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowPickTicketModule: isOpen,
      isShowSalesOrderMaintenanceModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code, rowData) => {
    this.props.viewInvoiceModule(e, code, rowData);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  purchaseOrderOnChange = (e) => {
    let PurchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePoList = true;
    let tempData = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompletePoList;
    if (isEmpty(PurchaseOrderNumber)) {
      this.state.isShowAutoCompletePoList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePoList;
      let tempData = this.state.criteria;
      // tempData.PurchaseOrderNumber = "";
      // tempData.vendorInvoiceCode = "";
      // tempData.purchaseOrderDate = "";
      // tempData.purchaseOrderStopDate = "";
      tempData.purchaseOrderReceiptNumber = "";
      // tempData.purchaseOrderReceiptApprovalNumber = "";
      let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
        this.companyCode,
        "Purchase Receipt",
        "",
        "",
        "A",
        //this.state.vendorInvoiceData.vendorCode
      );
      this.setState({
        purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
        purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
      });

      let suggestion = [];
      this.setState({
        isShowAutoCompletePoList: showAutoCompleteList,
        criteria: tempData,
        poPageListForAutoCompleteList: suggestion,
        isShowPurchaseReceiptLookup: false,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      PurchaseOrderNumber !== ""
    ) {
      this.readPOBySearchString(e.target.value);
      //   this.readPurchaseOrder(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      criteria: tempData,
    });
  };
  poEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PurchaseOrder",
    });
    this.readPurchaseOrder(e.target.value);
    this.state.isShowAutoCompletePoList = false;
    let showAutoCompleteList = this.state.isShowAutoCompletePoList;
    this.setState({
      poPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoList: showAutoCompleteList,
    });
  };
  readPOBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    // searchCriteria.vendorCode = this.state.vendorInvoiceData.vendorCode;
    searchCriteria.orderStatus = "R";
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.errorCallBack,
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (purchaseorderData.length > 0 && purchaseorderData != null) {
      purchaseorderData.map((po) => {
        let simpleItemBean = {
          code: po.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      poPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };

  displayPoAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompletePoList: showAutoCompleteList });
  };

  readPurchaseOrder = (purchaseOrderCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
      PurchaseOrderService.readPurchaseOrder(
        readrestInput,
        this.readPurchaseOrderResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readPurchaseOrderResponse = (response) => {
    let poBean = response.data.purchaseOrder;
    if (poBean != null) {
      let criteria = this.state.criteria;
      // purchaseOrderData.companyCode = this.companyCode;
      criteria.purchaseOrderNumber = poBean.code;
      // purchaseOrderData.purchaseOrderDate = poBean.orderStartDate;
      // purchaseOrderData.purchaseOrderStopDate = poBean.orderStopDate;
      // purchaseOrderData.vendorInvoiceCode = this.state.vendorInvoiceData.code;
      this.setState(
        {
          criteria: criteria,
          // isShowPurchaseReceiptLookup: true,
        },
        () => {
          this.purchaseReceiptLookup(poBean.code);
          // this.getMultiPurchaseReceiptApproval();
        },
      );
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  purchaseReceiptLookup = (purchaseOrderNumber) => {
    let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
      this.companyCode,
      "Purchase Receipt",
      purchaseOrderNumber,
      "",
      "A",
      //this.state.vendorInvoiceData.vendorCode
    );
    this.setState({
      purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
      // purchaseReceiptLookupHandlerMulti:purchaseReceiptLookupHandler
    });
  };

  onPurchaseReceiptChange = (e) => {
    let purchaseOrderReceiptNumber = e.target.value;
    this.state.showAutoCompletepurchaseReceiptList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
    if (isEmpty(purchaseOrderReceiptNumber)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
      let criteria = this.state.criteria;
      criteria.purchaseOrderReceiptNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompletepurchaseReceiptList: showAutoCompleteList,
        criteria: criteria,
        purchaseReceiptPageListForAutoCompleteList: suggestion,
        isShowPurchaseReceiptApproveLookup: false,
      });
    } else if (
      e.target.name == "purchaseOrderReceiptNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderReceiptNumber !== ""
    ) {
      this.readpurchaseReceiptBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readpurchaseReceiptBySearchString(searchString) {
    let tempCriteria = this.state.criteria;
    let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
    receiptCriteria.companyCode = this.companyCode;
    receiptCriteria.purchaseOrderReceiptNumberStartsWith = searchString;
    receiptCriteria.purchaseOrderNumber = tempCriteria.purchaseOrderNumber;
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = receiptCriteria;
    if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
      PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
        requestInput,
        this.loadByPurchaseOrderReceiptResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  loadByPurchaseOrderReceiptResponse = (response) => {
    let receiptList =
      response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
    let simpleAutoCompleteList = new Array();
    if (receiptList.length > 0 && receiptList != null) {
      receiptList.map((receipt) => {
        let simpleItemBean = {
          code: receipt.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      purchaseReceiptPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readBypurchaseReceiptResponseError = (error) => {
    ShowError("Error : ", error);
  };
  displayAutoCompletepurchaseReceiptList = (
    showAutoCompletepurchaseReceiptList,
  ) => {
    this.setState({
      showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
    });
  };

  purchaseReceiptEnterKeyEventHandler = (e) => {
    this.readPoReceipt(e.target.value);
    this.state.showAutoCompletepurchaseReceiptList = false;
    let showAutoCompletepurchaseReceiptList =
      this.state.showAutoCompletepurchaseReceiptList;
    this.setState({
      poPageListForAutoCompleteList: new Array(),
      showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
    });
  };

  readPoReceipt = (poReceiptCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = poReceiptCode;
    // input.isLoadChildren = true;
    PurchaseOrderReceiptService.readPurchaseOrderReceipt(
      input,
      this.editPoReceiptResponse,
      this.errorCallBack,
    );
  };
  editPoReceiptResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.purchaseOrderReceipt != null) {
      let purchaseOrderReceipt = response.data.purchaseOrderReceipt;
      if (!isEmpty(purchaseOrderReceipt)) {
        //  criteria.vendorName = vendorData.description;
        criteria.purchaseOrderReceiptNumber = purchaseOrderReceipt.code;
        this.setState({
          criteria: criteria,
          isShowPurchaseReceiptApproveLookup: true,
        });
        // this.purchaseReceiptApprovalLookup(purchaseOrderReceipt.code);
        // this.getMultiPurchaseReceiptApproval();
      }
    }
  };

  viewHoldingDetails = (e, val, row) => {

    if (e.detail === 1) {
      let data = { ...row };
      let criteria = new HoldingFabricInventoryDetailBean();
      criteria.companyCode = data.companyCode;
      criteria.fabricStyleCode = data.fabricStyleCode;
      criteria.fabricStyleName = data.fabricStyleName;
      criteria.fabricStyleColorCode = data.fabricStyleColorCode;
      criteria.customerCode = data.customerCode;
      criteria.customerName = data.customerName;

      criteria.purchaseOrderNumber = data.purchaseOrderNumber;
      criteria.purchaseOrderReceiptNumber = data.purchaseOrderReceiptNumber;

      criteria.holdingDate = data.holdingDate;
      criteria.expirationDate = data.expirationDate;
      criteria.holdingNumber = data.holdingNumber;
      // let currentDate = toFormattedDate_v1(new Date());
      this.setState({
        isShowHoldingEntryPopup: true,
        criteria: criteria,
        isDisableHoldingFields: true,
      });
    }
  };

  headerLinesHoldingColumn = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Holding Number", "holdingNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewHoldingDetails, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      //.setClickDetails(true, false, this.viewApprovedDetails, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      //.setClickDetails(true, false, this.viewApprovedDetails, null),
    );
    // columns.push(
    //   new ColumnDefinition()
    //       .setDetails("Holding Number", "code", true)
    //       .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    //     //.setClickDetails(true, false, this.viewApprovedDetails, null),
    //   );

    columns.push(
      new ColumnDefinition()
        .setDetails("Holding Date", "holdingDate", true, false, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Expiry Date", "expirationDate", true, false, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("PR#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PO ReceiptNumber", "purchaseOrderReceiptNumber", true, true)
    //     .setStyleDetails("Right", "", "", "wt-4 ", "wt-4 ")
    // );
    return columns;
  };

  hideAlertCallBackHolding = (msgType, isDisplayed) => {
    this.setState({ isShowHoldingAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  closeAlertHoldingModalCallBack = (isOpen) => {
    this.setState({
      isShowHoldingEntryPopup: isOpen,

      moduleForPopup: [],
      isDisableHoldingFields: false,
    });
    this.hideAlertCallBackHolding();
  };

  addNewHolding = (e) => {
    let criteria = new HoldingFabricInventoryDetailBean();
    let fabricStyleData = this.state.fabricStyleData;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
    let currentDate = toFormattedDate_v1(new Date());
    criteria.holdingDate = currentDate;

    this.setState({
      isShowHoldingEntryPopup: true,
      criteria: criteria,
      isDisableHoldingFields: false,
    });
  };

  approvalHoldingLinesColumn = () => {
    const columns = new Array();
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("", "isApplied", false)
    //     .setInputDetails(
    //       false,
    //       false,
    //       true,
    //       null,
    //       this.onSelectedApprovalLines,
    //       null,
    //     )
    //     .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("LineNumber", "receiptLineNumber", true)
        .setStyleDetails("left", "", "", "wt-2 ", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQuantity", "quantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "amount", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    return columns;
  };
  validateHoldingData = (criteria) => {
    let isValidHoldingData = false;
    let holdedDataList = [...this.state.holdedDataList];

    let err_list = [];
    let errorMessage = "";
    if (criteria == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(criteria.customerCode)) {
        let errMsg = "CustomerCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (
        isEmptyString(criteria.purchaseOrderNumber) &&
        isEmptyString(criteria.purchaseOrderReceiptNumber)
      ) {
        let errMsg =
          "PurchaseOrderNumber Or PurchaseOrderReceiptNumber Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      //          if (isEmptyString(criteria.holdingDate)) {
      //   let errMsg = "HoldingDate Required";
      //   errorMessage = errorMessage + errMsg;
      //   err_list.push(errMsg);
      // }

      if (isEmptyString(criteria.expirationDate)) {
        let errMsg = "ExpirationDate Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }

      if (!isEmptyArray(holdedDataList)) {
        // let errMsg = "ExpirationDate Required";
        // errorMessage = errorMessage + errMsg;
        // err_list.push(errMsg);
        const findedData = holdedDataList.find(
          (item) =>
            item.fabricStyleColorCode === criteria.fabricStyleColorCode &&
            item.purchaseOrderNumber === criteria.purchaseOrderNumber &&
            item.purchaseOrderReceiptNumber ===
              criteria.purchaseOrderReceiptNumber,
        );

        if (findedData) {
          let errMsg = `Already  holding ${findedData.holdingNumber} existed !`;
          errorMessage += errMsg;
          err_list.push(errMsg);
        }
      }
    }
    if (err_list.length > 0) {
      isValidHoldingData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowHoldingAlert: true,
      });
    } else {
      isValidHoldingData = true;
      this.setState({ isShowHoldingAlert: false });
    }
    return isValidHoldingData;
  };
  createHoldingRolls = (e) => {
    if (e.detail === 1) {
      let criteria = { ...this.state.criteria };
      let isValidData = false;
      isValidData = this.validateHoldingData(criteria);
      if (isValidData) {
        FabricStyleService.createHoldingFabricInventoryDetail(
          criteria,
          this.createdHoldResponse,
          this.errorCallBack,
        );
      }
    }
  };
  createdHoldResponse = (response) => {
    let success = this.handleResponse(response.data);
    if (success === true) {
      this.closeAlertHoldingModalCallBack(false);
      this.loadPage();
    } else {

    }
    // this.setState({
    //   isLoading: false,
    // });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowHoldingAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  // getRollInFo = ()=>{

  // }
  render() {
    let criteria = this.state.criteria;
    let fabricStyleData = this.state.fabricStyleData;

    let holdingSkuSummaryList = [];

    let holdedDataList = this.state.holdedDataList;
    let isDisableHoldingFields = this.state.isDisableHoldingFields;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <Row>
          {" "}
          <Col className="align-items-left" sm="1">
            <FormLabel>Item</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              readOnly={true}
              value={fabricStyleData.code}
            />{" "}
          </Col>{" "}
          <Col sm="3">
            <InputTextbox
              name="description"
              readOnly={true}
              value={fabricStyleData.description}
            />{" "}
          </Col>
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              onClick={(e) => this.addNewHolding(e)}
            >
              Add Holding{" "}
            </Button>
          </Col>
        </Row>

        <div>
          <CustomTable
            data={holdedDataList}
            columns={this.headerLinesHoldingColumn()}
            label={"Holded List"}
          />
        </div>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowHoldingEntryPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertHoldingModalCallBack}
          title={"Hodling"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowHoldingAlert}
              hideAlertCallBack={this.hideAlertCallBackHolding}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.createHoldingRolls(e)}
                disabled={isDisableHoldingFields}
              >
                Create
              </Button>
            </div>
          }
          content={
            <diV>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Holding </FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="holdingNumber"
                    readOnly={true}
                      className="summary_input"
                    value={
                      criteria.holdingNumber > 0
                        ? criteria.holdingNumber
                        : "New"
                    }
                    isMandatory={true}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Item</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="code"
                    readOnly={true}
                    value={fabricStyleData.code}
                    isMandatory={true}
                  />{" "}
                </Col>{" "}
                <Col sm="4">
                  <InputTextbox
                    name="description"
                    readOnly={true}
                    value={fabricStyleData.description}
                    isMandatory={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.onCustomerCodeChange}
                    disabled={isDisableHoldingFields}
                    name="customerCode"
                    placeholder="Customer"
                    value={criteria.customerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.customerLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                    autoCompleteListData={
                      this.state.customerPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteList}
                    showAutoCompleteList={
                      this.state.showAutoCompleteCustomerList
                    }
                    isMandatory={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel className="header_labels">
                    Purcahse Order#
                  </FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.purchaseOrderOnChange}
                    name="purchaseOrderNumber"
                    ref={this.purchaseRef}
                    value={criteria.purchaseOrderNumber}
                    // lookupRequired={this.state.isShowPOLookup}
                    lookupRequired={true}
                    lookupHandler={this.state.purchaseorderLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.poEnterKeyEventHandler}
                    autoCompleteListData={
                      this.state.poPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayPoAutoCompleteList}
                    showAutoCompleteList={this.state.isShowAutoCompletePoList}
                    disabled={isDisableHoldingFields}
                    isMandatory={true}
                  />
                </Col>

                <Col className="so-align-items-left" sm="1">
                  <FormLabel className="header_labels">
                    PO Receipt#
                  </FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.onPurchaseReceiptChange}
                    //  ref={this.receiptCodeRef}
                    name="purchaseOrderReceiptNumber"
                    placeholder="purchaseOrderReceiptNumber"
                    value={criteria.purchaseOrderReceiptNumber}
                    // lookupRequired={this.state.isShowPurchaseReceiptLookup}
                    lookupRequired={true}
                    lookupHandler={this.state.purchaseReceiptLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={
                      this.purchaseReceiptEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.state.purchaseReceiptPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompletepurchaseReceiptList
                    }
                    showAutoCompleteList={
                      this.state.showAutoCompletepurchaseReceiptList
                    }
                    isMandatory={true}
                    disabled={isDisableHoldingFields}
                    // isMandatory={true}
                  ></InputTextbox>
                </Col>

                {/* <Col sm="1">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.getRollInFo(e)}
                  >
                    Rolls
                  </Button>
                </Col> */}
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Color</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    // ref={this.colorCodeRef}
                    name="fabricStyleColorCode"
                    onChange={this.onCustomerSalesColorCodeChange}
                    value={criteria.fabricStyleColorCode}
                    lookupRequired={true}
                    lookupHandler={this.state.colorLookupHandler}
                    enterKeyEventHandler={this.colorCustomerSalesEnterKeyEvent}
                    autoCompleteListData={
                      this.state.colorSummaryForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteColorCustomerSalesList
                    }
                    showAutoCompleteList={
                      this.state.showAutoCompleteCustomerSalesColorList
                    }
                    disabled={isDisableHoldingFields}
                    isMandatory={true}
                  />{" "}
                </Col>{" "}
                <Col sm="1">
                  {" "}
                  <FormLabel>HoldDate</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <DatePickerComponent_adv
                    name="holdingDate"
                    value={criteria.holdingDate}
                    onChange={this.onChange}
                    isMandatory={true}
                    disabled={true}
                    // isModifyView={isModify}
                    // isMandatory={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>expiration Date</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <DatePickerComponent_adv
                    name="expirationDate"
                    value={criteria.expirationDate}
                    onChange={this.onChange}
                    isMandatory={true}
                    disabled={isDisableHoldingFields}
                    // isModifyView={isModify}
                    // isMandatory={true}
                  />
                </Col>
              </Row>

              {/* <Row>
                <Col sm="1">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.selectAllHoldingList(e)}
                  >
                    SelectAll
                  </Button>
                </Col>

                <Col sm="1">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.unSelectAllHoldingList(e)}
                  >
                    UnSelectAll
                  </Button>
                </Col>
              </Row>

              <div className="mt-3">
                <CustomTable
                  data={holdingSkuSummaryList}
                  columns={this.approvalHoldingLinesColumn()}
                  label={"Holding Lines "}
                />
              </div> */}
            </diV>
          }
        />
      </div>
    );
  }
}


class FabricInventoryAndSoAndPoForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      fabricStyleData: this.props.fabricStyleData,
      criteria: new AllFabricATSInquiryCriteriaBean(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: null,
      customerLookupHandler: null,
      fabricStyleColorList: [],
      showAutoCompleteCustomerSalesColorList: false,
      colorSummaryForAutoCompleteList: new Array(),
      inquiryDataList: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      moduleForPopup: [],
      isShowInvoiceModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      isShowPickTicketModule: false,
      isShowSalesOrderMaintenanceModule: false,

      isShowAutoCompletePoList: false,
      poPageListForAutoCompleteList: new Array(),
      purchaseorderLookupHandler: null,

      purchaseReceiptLookupHandler: null,
      showAutoCompletepurchaseReceiptList: false,
      purchaseReceiptPageListForAutoCompleteList: new Array(),

      isShowHoldingEntryPopup: false,

      isShowHoldingAlert: false,

      InventoryAndSoAndPo: [],

      fabricStyleColorList: [],
      colorLookupHandler: null,
      isDisableHoldingFields: false,
      fabricListData:[],
      holdedDataList:[],
      ColorData:[],
      skuInventoryColorList:[],
      inquiryDataLists:[],
      inquiryDataListVendor:[],
     isShowColorPopup: false,
     isShowSalesOrderMaintenanceModule:false,
     isShowPurchaseModule: false,
      isShowInvoiceModule: false,
      isShowPurchaseReceiptModule: false,


      // isShowPurchaseReceiptLookup: false,
    };
  }

  componentDidMount() {
 
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadColors();
    // this.loadPage();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let colors = [];
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    // this.setState({ fabricLookupHandler: fabricLookupHandler });

    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "PurchaseOrder",
      "",
      "R",
    );

    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode",
    );

    let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
      this.companyCode,
      "Purchase Receipt",
      "",
      "",
      "A",
    );

    this.setState({
      customerLookupHandler: customerLookupHandler,
      purchaseorderLookupHandler: purchaseOrderLookupHandler,
      fabricLookupHandler: fabricLookupHandler,
      purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
    });
    // let colorLookupHandler = new GenericAttributeLookupHandler(
    //   this.state.colors,
    //   "fabricStyleColorCode"
    // );
    // this.setState({ colorLookupHandler: colorLookupHandler });
    // let vendorLookupHandler = new VendorLookupHandler(
    //   this.companyCode,
    //   "Vendor"
    // );
    // this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  loadFabricInventoryAndSoAndPo = () => {
    


    // let criteria = this.state.criteria;
    // let fabricStyleData = this.state.fabricStyleData;
    // criteria.companyCode = this.companyCode;
    // criteria.fabricStyleCode = fabricStyleData.code;
    // criteria.description = fabricStyleData.description;


    // this.setState({
    //   fabricData :criteria
    // })
    // let listRequest = new RestHoldingFabricStyleListRequest();
    // listRequest.searchCriteria = criteria;
    // let pageInput = new PageListBean();
    // listRequest.pageInput = pageInput;
 
   let criteria = this.state.criteria;
    ReportService.getFabricInventoryAndSalesAndPurchaseActivity(
      criteria,
      this.FabricInventoryAndSoAndPoPageListResponse,
      this.errorCallBack,
    );
  };

  FabricInventoryAndSoAndPoPageListResponse = (response) => {
  
    
    let InventoryAndSoAndPo = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.inquiryResult)
    ) {
      InventoryAndSoAndPo =
        response.data.
inquiryResult.atsInfos;
    }

    this.setState({
      InventoryAndSoAndPo: InventoryAndSoAndPo,
    });
  };
  loadColors = () => {
    let fabricStyleColorList = this.state.fabricStyleData.colors;
    let simpleAutoCompleteList = new Array();
    fabricStyleColorList.map((colorCodeDatas) => {
      let simpleItemBean = {
        code: colorCodeDatas.fabricStyleColorCode,
        description: colorCodeDatas.fabricStyleColorName,
      };
      simpleAutoCompleteList.push(simpleItemBean);
    });
    this.setState({ fabricStyleColorList: simpleAutoCompleteList });
    this.state.fabricStyleColorList = simpleAutoCompleteList;
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.fabricStyleColorList,
      "Color",
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
  };


 

  //
  onCustomerSalesColorCodeChange = (e) => {
   
    
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteCustomerSalesColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompleteCustomerSalesColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteCustomerSalesColorList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerSalesColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
        criteria: color_Data,
        colorSummaryForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readLotBasedColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.fabricStyleColorList;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;

          this.state.showAutoCompleteCustomerSalesColorList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerSalesColorList;
          this.setState({
            showAutoCompleteCustomerSalesColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readLotBasedColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.fabricStyleColorList;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorSummaryForAutoCompleteList: filteredSuggestions,
    });
  }
  colorCustomerSalesEnterKeyEvent = (e) => {
   
    
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.fabricStyleColorList;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      this.setState({
        criteria: temp_fabricStyledata,
        colorSummaryForAutoCompleteList: new Array(),
        fabricListData:temp_fabricStyledata,
      });
    }
  };
  displayAutoCompleteColorCustomerSalesList = (
    showAutoCompleteColorPopupList,
  ) => {
    this.setState({
      showAutoCompleteCustomerSalesColorList: showAutoCompleteColorPopupList,
    });
  };

 
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  // handleHyperLinkClick = (e, val, rowData) => {
  //   if (val !== "" && val !== undefined) {
  //     this.setState({
  //       isShowPickTicketModule: true,
  //       moduleForPopup: (
  //         <PopupPickTicketModule
  //           pickTicketCode={val}
  //           onModuleExit={this.onPopupModalExit}
  //         />
  //       ),
  //     });
  //   }
  // };
  // viewsalesOrderModule = (e, code) => {
  //   if (e.detail === 1) {
  //     if (code !== "" && code !== undefined) {
  //       this.setState({
  //         isShowSalesOrderMaintenanceModule: true,
  //         moduleForPopup: (
  //           <PopupSalesModule
  //             code={code}
  //             onModuleExit={this.onPopupModalExit}
  //           />
  //         ),
  //       });
  //     }
  //   }
  // };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowPickTicketModule: isOpen,
      isShowSalesOrderMaintenanceModule: isOpen,
       isShowPurchaseReceiptModule: isOpen, 
      isShowPurchaseModule: isOpen,  
   
      moduleForPopup: [],
    });
  };
  // viewInvoiceModule = (e, code, rowData) => {
  //   this.props.viewInvoiceModule(e, code, rowData);
  // };
  // onPopupModalExit = () => {
  //   this.closeModalCallBack(false);
  // };

  // purchaseOrderOnChange = (e) => {
  //   let PurchaseOrderNumber = e.target.value;
  //   this.state.isShowAutoCompletePoList = true;
  //   let tempData = this.state.criteria;
  //   let showAutoCompleteList = this.state.isShowAutoCompletePoList;
  //   if (isEmpty(PurchaseOrderNumber)) {
  //     this.state.isShowAutoCompletePoList = false;
  //     let showAutoCompleteList = this.state.isShowAutoCompletePoList;
  //     let tempData = this.state.criteria;
  //     // tempData.PurchaseOrderNumber = "";
  //     // tempData.vendorInvoiceCode = "";
  //     // tempData.purchaseOrderDate = "";
  //     // tempData.purchaseOrderStopDate = "";
  //     tempData.purchaseOrderReceiptNumber = "";
  //     // tempData.purchaseOrderReceiptApprovalNumber = "";
  //     let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
  //       this.companyCode,
  //       "Purchase Receipt",
  //       "",
  //       "",
  //       "A",
  //       //this.state.vendorInvoiceData.vendorCode
  //     );
  //     this.setState({
  //       purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
  //       purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
  //     });

  //     let suggestion = [];
  //     this.setState({
  //       isShowAutoCompletePoList: showAutoCompleteList,
  //       criteria: tempData,
  //       poPageListForAutoCompleteList: suggestion,
  //       isShowPurchaseReceiptLookup: false,
  //     });
  //   } else if (
  //     e.target.name == "purchaseOrderNumber" &&
  //     showAutoCompleteList === true &&
  //     PurchaseOrderNumber !== ""
  //   ) {
  //     this.readPOBySearchString(e.target.value);
  //     //   this.readPurchaseOrder(e.target.value);
  //   }
  //   tempData[e.target.name] = e.target.value.toUpperCase();
  //   this.setState({
  //     criteria: tempData,
  //   });
  // };
  // poEnterKeyEventHandler = (e) => {
  //   this.setState({
  //     isShowProgressBarPopup: true,
  //     progressLoadingText: "Reading PurchaseOrder",
  //   });
  //   this.readPurchaseOrder(e.target.value);
  //   this.state.isShowAutoCompletePoList = false;
  //   let showAutoCompleteList = this.state.isShowAutoCompletePoList;
  //   this.setState({
  //     poPageListForAutoCompleteList: new Array(),
  //     isShowAutoCompletePoList: showAutoCompleteList,
  //   });
  // };
  // readPOBySearchString(searchString) {
  //   let searchCriteria = new PurchaseOrderSearchCriteria();
  //   searchCriteria.companyCode = this.companyCode;
  //   searchCriteria.purchaseOrderNumberStartsWith = searchString;
  //   searchCriteria.purchaseOrderNumberContains = searchString;
  //   // searchCriteria.vendorCode = this.state.vendorInvoiceData.vendorCode;
  //   searchCriteria.orderStatus = "R";
  //   let cust_pageList = new PageListBean();
  //   cust_pageList.pageSize = 100;
  //   let cust_requestInput = new RestPurchaseOrderListRequest();
  //   cust_requestInput.pageInput = cust_pageList;
  //   cust_requestInput.searchCriteria = searchCriteria;
  //   PurchaseOrderService.getPurchaseOrderPageList(
  //     cust_requestInput,
  //     this.readPurchaseOrderBySearchStringResponse,
  //     this.errorCallBack,
  //   );
  // }
  // readPurchaseOrderBySearchStringResponse = (response) => {
  //   let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
  //   let simpleAutoCompleteList = new Array();
  //   if (purchaseorderData.length > 0 && purchaseorderData != null) {
  //     purchaseorderData.map((po) => {
  //       let simpleItemBean = {
  //         code: po.code,
  //         description: "",
  //       };
  //       simpleAutoCompleteList.push(simpleItemBean);
  //     });
  //   }
  //   this.setState({
  //     poPageListForAutoCompleteList: simpleAutoCompleteList,
  //   });
  // };

  // displayPoAutoCompleteList = (showAutoCompleteList) => {
  //   this.setState({ isShowAutoCompletePoList: showAutoCompleteList });
  // };

  // readPurchaseOrder = (purchaseOrderCode) => {
  //   let readrestInput = new RestReadRequest();
  //   readrestInput.companyCode = this.companyCode;
  //   readrestInput.code = purchaseOrderCode;
  //   if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
  //     PurchaseOrderService.readPurchaseOrder(
  //       readrestInput,
  //       this.readPurchaseOrderResponse,
  //       this.errorCallBack,
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);

  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // readPurchaseOrderResponse = (response) => {
  //   let poBean = response.data.purchaseOrder;
  //   if (poBean != null) {
  //     let criteria = this.state.criteria;
  //     // purchaseOrderData.companyCode = this.companyCode;
  //     criteria.purchaseOrderNumber = poBean.code;
  //     // purchaseOrderData.purchaseOrderDate = poBean.orderStartDate;
  //     // purchaseOrderData.purchaseOrderStopDate = poBean.orderStopDate;
  //     // purchaseOrderData.vendorInvoiceCode = this.state.vendorInvoiceData.code;
  //     this.setState(
  //       {
  //         criteria: criteria,
  //         // isShowPurchaseReceiptLookup: true,
  //       },
  //       () => {
  //         this.purchaseReceiptLookup(poBean.code);
  //         // this.getMultiPurchaseReceiptApproval();
  //       },
  //     );
  //   }
  //   this.setState({
  //     isShowProgressBarPopup: false,
  //     progressLoadingText: "",
  //   });
  // };

  // purchaseReceiptLookup = (purchaseOrderNumber) => {
  //   let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
  //     this.companyCode,
  //     "Purchase Receipt",
  //     purchaseOrderNumber,
  //     "",
  //     "A",
  //     //this.state.vendorInvoiceData.vendorCode
  //   );
  //   this.setState({
  //     purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
  //     // purchaseReceiptLookupHandlerMulti:purchaseReceiptLookupHandler
  //   });
  // };

  // onPurchaseReceiptChange = (e) => {
  //   let purchaseOrderReceiptNumber = e.target.value;
  //   this.state.showAutoCompletepurchaseReceiptList = true;
  //   let tempCriteria = this.state.criteria;
  //   let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
  //   if (isEmpty(purchaseOrderReceiptNumber)) {
  //     this.state.showAutoCompleteList = false;
  //     let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
  //     let criteria = this.state.criteria;
  //     criteria.purchaseOrderReceiptNumber = "";
  //     let suggestion = [];
  //     this.setState({
  //       showAutoCompletepurchaseReceiptList: showAutoCompleteList,
  //       criteria: criteria,
  //       purchaseReceiptPageListForAutoCompleteList: suggestion,
  //       isShowPurchaseReceiptApproveLookup: false,
  //     });
  //   } else if (
  //     e.target.name == "purchaseOrderReceiptNumber" &&
  //     showAutoCompleteList === true &&
  //     purchaseOrderReceiptNumber !== ""
  //   ) {
  //     this.readpurchaseReceiptBySearchString(e.target.value);
  //   }
  //   tempCriteria[e.target.name] = e.target.value;
  //   this.setState({ criteria: tempCriteria });
  // };
  // readpurchaseReceiptBySearchString(searchString) {
  //   let tempCriteria = this.state.criteria;
  //   let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
  //   receiptCriteria.companyCode = this.companyCode;
  //   receiptCriteria.purchaseOrderReceiptNumberStartsWith = searchString;
  //   receiptCriteria.purchaseOrderNumber = tempCriteria.purchaseOrderNumber;
  //   let requestInput = new RestPurchaseOrderReceiptListRequest();
  //   requestInput.pageInput = new RestPageListBean();
  //   requestInput.searchCriteria = receiptCriteria;
  //   if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
  //     PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
  //       requestInput,
  //       this.loadByPurchaseOrderReceiptResponse,
  //       this.errorCallBack,
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);

  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // }
  // loadByPurchaseOrderReceiptResponse = (response) => {
  //   let receiptList =
  //     response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
  //   let simpleAutoCompleteList = new Array();
  //   if (receiptList.length > 0 && receiptList != null) {
  //     receiptList.map((receipt) => {
  //       let simpleItemBean = {
  //         code: receipt.code,
  //         description: "",
  //       };
  //       simpleAutoCompleteList.push(simpleItemBean);
  //     });
  //   }
  //   this.setState({
  //     purchaseReceiptPageListForAutoCompleteList: simpleAutoCompleteList,
  //   });
  // };
  // readBypurchaseReceiptResponseError = (error) => {
  //   ShowError("Error : ", error);
  // };
  // displayAutoCompletepurchaseReceiptList = (
  //   showAutoCompletepurchaseReceiptList,
  // ) => {
  //   this.setState({
  //     showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
  //   });
  // };

  // purchaseReceiptEnterKeyEventHandler = (e) => {
  //   this.readPoReceipt(e.target.value);
  //   this.state.showAutoCompletepurchaseReceiptList = false;
  //   let showAutoCompletepurchaseReceiptList =
  //     this.state.showAutoCompletepurchaseReceiptList;
  //   this.setState({
  //     poPageListForAutoCompleteList: new Array(),
  //     showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
  //   });
  // };

  // readPoReceipt = (poReceiptCode) => {
  //   let input = new RestReadRequest();
  //   input.companyCode = this.companyCode;
  //   input.code = poReceiptCode;
  //   // input.isLoadChildren = true;
  //   PurchaseOrderReceiptService.readPurchaseOrderReceipt(
  //     input,
  //     this.editPoReceiptResponse,
  //     this.errorCallBack,
  //   );
  // };
  // editPoReceiptResponse = (response) => {
  //   let criteria = this.state.criteria;
  //   if (response.data != null && response.data.purchaseOrderReceipt != null) {
  //     let purchaseOrderReceipt = response.data.purchaseOrderReceipt;
  //     if (!isEmpty(purchaseOrderReceipt)) {
  //       //  criteria.vendorName = vendorData.description;
  //       criteria.purchaseOrderReceiptNumber = purchaseOrderReceipt.code;
  //       this.setState({
  //         criteria: criteria,
  //         isShowPurchaseReceiptApproveLookup: true,
  //       });
  //       // this.purchaseReceiptApprovalLookup(purchaseOrderReceipt.code);
  //       // this.getMultiPurchaseReceiptApproval();
  //     }
  //   }
  // };

  // viewHoldingDetails = (e, val, row) => {

  //   if (e.detail === 1) {
  //     let data = { ...row };
  //     let criteria = new HoldingFabricInventoryDetailBean();
  //     criteria.companyCode = data.companyCode;
  //     criteria.fabricStyleCode = data.fabricStyleCode;
  //     criteria.fabricStyleName = data.fabricStyleName;
  //     criteria.fabricStyleColorCode = data.fabricStyleColorCode;
  //     criteria.customerCode = data.customerCode;
  //     criteria.customerName = data.customerName;

  //     criteria.purchaseOrderNumber = data.purchaseOrderNumber;
  //     criteria.purchaseOrderReceiptNumber = data.purchaseOrderReceiptNumber;

  //     criteria.holdingDate = data.holdingDate;
  //     criteria.expirationDate = data.expirationDate;
  //     criteria.holdingNumber = data.holdingNumber;
  //     // let currentDate = toFormattedDate_v1(new Date());
  //     this.setState({
  //       isShowHoldingEntryPopup: true,
  //       criteria: criteria,
  //       isDisableHoldingFields: true,
  //     });
  //   }
  // };

  headerLinesFetchingColumn = () => {
    const columns = new Array();

     columns.push(
      new ColumnDefinition()
          .setDetails("Color","fabricStyleColorCode", true)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.onColorClick, null),
      );

    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQuantity", "onHandQuantity", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
       
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("customerOnOrderQty", "customerOnOrderQuantity", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      //.setClickDetails(true, false, this.viewApprovedDetails, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("vendorOnOrderQty", "vendorOnOrderQuantity", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      //.setClickDetails(true, false, this.viewApprovedDetails, null),
    );
     columns.push(
      new ColumnDefinition()
        .setDetails("Sku#", "skuNumber", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
   
    columns.push(
      new ColumnDefinition()
        .setDetails("ATS", "atsYardage", true,)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("NumberOfRolls", "numberOfRolls", true,)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Risk", "riskValue", true)
        .setGraphDetails(true, this.riskvalueHandler)
        .setStyleDetails("center", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Image", "fabricStyleImagePath", true)
        .setStyleDetails("center", "", "", "wt-4 ", "wt-4 ")
       .setImageDetails(true,this.getLotImage)
    );

   
 columns.push(
      new ColumnDefinition()
        .setDetails("ColorImage", "fabricStyleColorImagePath", true)
        .setStyleDetails("center", "", "", "wt-4 ", "wt-4 ")
        .setImageDetails(true,this.getLotColorImage)
    );

    


    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PO ReceiptNumber", "purchaseOrderReceiptNumber", true, true)
    //     .setStyleDetails("Right", "", "", "wt-4 ", "wt-4 ")
    // );
    return columns;
  };
   riskvalueHandler = (column, row, risk) => {
    if (risk === 1) {
      return "bg-yellow rish-value";
    } else if (risk === 2) {
      return "bg-pink rish-value";
    } else if (risk === 3) {
      return "bg-red rish-value";
    } else if (risk === 0) {
      return "bg-green rish-value";
    } else {
      return "bg-green rish-value";
    }
  };
onColorClick=(e,val,rowData)=>{


       let tempCriteria = new FabricStyleInventoryForLotBasedSearchCriteria();
         
          let criteria = new SalesAndPurchaseInquiryCriteriaBean();
          let newCriteria = new SalesAndPurchaseInquiryCriteriaBean();
          tempCriteria.companyCode = this.companyCode;
          tempCriteria.fabricStyleCode = rowData.fabricStyleCode;
          tempCriteria.colorCode = rowData.fabricStyleColorCode;
      
          // tempCriteria.isSummary = true;
      
      
      
          // tempCriteria_v1.companyCode = this.companyCode;
          // tempCriteria_v1.fabricStyleCode = rowData.fabricStyleCode;
          // tempCriteria_v1.colorCode = rowData.fabricStyleColorCode;
      
      
      
          if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
            this.setState({
              isShowProgressBarPopup: true,
              progressLoadingText: this.props.is3PL
                ? "read Item Lot Inventory(Summary)"
                : "read Fabric Lot Inventory (Summary)",
            });
            
      
            InventoryService.getFabricStyleInventoryForLotBased(
              tempCriteria,
              this.loadFabricInventoryLotcolorPageResponse,
              this.loadFabricInventoryLotPageError
            );
      
      
            // InventoryService.getFabricStyleInventoryForLotBased(
            //   tempCriteria_v1,
            //   this.loadFabricInventoryLotcolorsPageResponse,
            //   this.loadFabricInventoryLotPageError
            // );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
      
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
      
      
          criteria.companyCode = this.companyCode;
          criteria.fabricStyleCode = rowData.fabricStyleCode;
          criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
          criteria.fabricStyleName = rowData.fabricStyleColorName;
          criteria.resultType = 0;
      
      
          newCriteria.companyCode = this.companyCode;
          newCriteria.fabricStyleCode = rowData.fabricStyleCode;
          newCriteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
          newCriteria.fabricStyleName = rowData.fabricStyleColorName;
          newCriteria.resultType = 1;
      
          ReportService.inquireSalesAndPurchaseDetailsForFabricStyle(
            criteria,
            this.loadSalesAndPurchasePageResponse,
            this.errorCallBack
          );
      
          ReportService.inquireSalesAndPurchaseDetailsForFabricStyle(
            newCriteria,
            this.loadSalesOrderAndPurchasePageResponse,
            this.errorCallBack
          );
      
      
          this.setState({
            ColorData: rowData
          })
  

}
loadFabricInventoryLotPageError = (error) => {
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
    ShowError("loadFabricInventoryLotPageError :" + error);
    this.setFocus();
  };

    loadSalesOrderAndPurchasePageResponse = (response) => {
    

         this.showErrorMessage(response.data);
          if (response.data != null && response.data.resultBean != null) {
            let customerSalesDataList = [];
            let inquiryDataList = response.data.resultBean;
            if (!isEmptyArray(response.data.resultBean.infos)) {
              customerSalesDataList = response.data.resultBean.infos;
              // this.setState({
              //   isShowPDFButton: true,
              //   isShowExcelButton: true,
              // });
            }
            this.setState({
      
              inquiryDataListVendor: customerSalesDataList,
      
            });
            //  this.disable();
          }
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
      
      
    }

    loadFabricInventoryLotcolorPageResponse = (response) => {


    let inquiryList = response.data.result;
    if (inquiryList != null) {
      let skuInventoryList = [];
      if (response.data.result.skuInventoryDataDetails != null) {
        skuInventoryList = response.data.result.skuInventoryDataDetails;
        this.setState({
          skuInventoryColorList: skuInventoryList,
          inventoryDataList: [],
        });
      }
      this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
    }

    this.setState({
      isShowColorPopup: true,
    })

  }
   loadSalesAndPurchasePageResponse = (response) => {
     
      this.showErrorMessage(response.data);
      if (response.data != null && response.data.resultBean != null) {
        let customerSalesDataList = [];
        let inquiryDataList = response.data.resultBean;
        if (!isEmptyArray(response.data.resultBean.infos)) {
          customerSalesDataList = response.data.resultBean.infos;
          // this.setState({
          //   isShowPDFButton: true,
          //   isShowExcelButton: true,
          // });
        }
        this.setState({
  
          inquiryDataLists: customerSalesDataList,
  
        });
        //  this.disable();
      }
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
  
    }

  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };
  getLotImage = (val) =>{
  
   
       let url = this.getImageURL();
 url =   url + val.fabricStyleImagePath;    
 
  
    return url;
  ;
    

  }
  getLotColorImage = (val)=>{
    
       let url = this.getImageURL();
 url =   url + val.fabricStyleColorImagePath;    
   
    return url;

  }

  hideAlertCallBackHolding = (msgType, isDisplayed) => {
    this.setState({ isShowHoldingAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  closeAlertHoldingModalCallBack = (isOpen) => {
    this.setState({
      isShowHoldingEntryPopup: isOpen,

      moduleForPopup: [],
      isDisableHoldingFields: false,
    });
    this.hideAlertCallBackHolding();
  };

  addNewFetch = (e) => {

    
    let criteria = new HoldingFabricInventoryDetailBean();
    let fabricStyleData = this.state.fabricStyleData;
     let fabricListData = this.state.fabricListData;
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricStyleData.code;
    criteria.fabricStyleName = fabricStyleData.description;
     criteria.fabricStyleColorCode = fabricListData.fabricStyleColorCode;
    let currentDate = toFormattedDate_v1(new Date());
    criteria.holdingDate = currentDate;

    this.setState({
      // isShowHoldingEntryPopup: true,
      criteria: criteria,
      isDisableHoldingFields: false,
    },()=>{
      this.loadFabricInventoryAndSoAndPo()
    });
  };

 


  inquiryColorColumns = () => {
      const columns = new Array();
      columns.push(
        new ColumnDefinition()
          .setDetails("Color", "fabricStyleColorCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Location", "locationCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Lot", "lotNumber", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("TotalOnHandQty", "totalOnHandQuantity", true, true)
          .setStyleDetails("right", "", "", "wt-2", "wt-2")
        //  .setClickDetails(true, false, this.onHandQuantityClick, null)
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Width", "widthCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
      );
      if (this.props.is3PL) {
        columns.push(
          new ColumnDefinition()
            .setDetails("No Of Pallets", "numberOfPallets", true, true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
      }
      if (!this.props.is3PL) {
        columns.push(
          new ColumnDefinition()
            .setDetails("No.Of.Rolls", "numberOfRolls", true, true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
      }
      if (this.props.is3PL) {
        columns.push(
          new ColumnDefinition()
            .setDetails("Total Area", "totalArea", true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
      }
      columns.push(
        new ColumnDefinition()
          .setDetails(this.props.is3PL ? "LO" : "PO", "purchaseOrderNumber", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails(
            this.props.is3PL ? "LR" : "PR",
            "purchaseOrderReceiptNumber",
            true
          )
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
      );
      return columns;
    };

      inquiryInvoiceColumns = () => {
        const columns = new Array();
        columns.push(
          new ColumnDefinition()
            .setDetails("Customer", "customerCode", true)
    
            .setStyleDetails("left", "5", "", "wt-4", "wt-4")
    
          //.setClickDetails(true, false, this.viewFabricModule, null)
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("CustomerName", "customerName", true)
            .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );
        // columns.push(
        //   new ColumnDefinition()
        //     .setDetails("FabricStyle", "fabricStyleCode", true)
        //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
        // );
        // columns.push(
        //   new ColumnDefinition()
        //     .setDetails("FabricStyleName", "fabricStyleName", true)
        //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
        // );
        columns.push(
          new ColumnDefinition()
            .setDetails("Color", "colorCode", true)
            .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("SO#", "salesOrderNumber", true)
            .setStyleDetails("left", "", "", "wt-2", "wt-2")
            .setClickDetails(true, false, this.viewsalesOrderModule, null)
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("PT", "pickTicketNumber", true)
            .setStyleDetails("left", "", "", "wt-2", "wt-2")
            .setClickDetails(true, false, this.handleHyperLinkClick, null)
        );
    
        columns.push(
          new ColumnDefinition()
            .setDetails("Invoice", "invoiceNumber", true)
            .setStyleDetails("left", "", "", "wt-2", "wt-2")
           .setClickDetails(true, false, this.viewInvoiceModule, null)
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("InvoiceDate", "invoiceDate", true)
            .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("UOM", "uomCode", true)
            .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );
    
        columns.push(
          new ColumnDefinition()
            .setDetails("Quantity", "quantity", true, true)
            .setStyleDetails("right", "", "", "wt-2", "wt-2")
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Price", "price", true, true)
            .setStyleDetails("right", "", "", "wt-2", "wt-2")
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Extension", "extension", true, true)
            .setStyleDetails("right", "", "", "wt-2", "wt-2")
        );
    
        return columns;
      };
        inquiryPurchaseColumns = () => {
          const columns = new Array();
          columns.push(
            new ColumnDefinition()
              .setDetails("Vendor", "vendorCode", true)
      
              .setStyleDetails("left", "4", "", "wt-4", "wt-4")
      
            // .setClickDetails(true, false, this.viewFabricModule, null)
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("VendorName", "vendorName", true)
              .setStyleDetails("left", "3", "", "wt-2", "wt-2")
          );
          // columns.push(
          //   new ColumnDefinition()
          //     .setDetails("FabricStyle", "fabricStyleCode", true)
          //     .setStyleDetails("left", "3", "", "wt-2", "wt-2")
          // );
          // columns.push(
          //   new ColumnDefinition()
          //     .setDetails("FabricStyleName", "fabricStyleName", true)
          //     .setStyleDetails("left", "3", "", "wt-2", "wt-2")
          // );
          columns.push(
            new ColumnDefinition()
              .setDetails("Color", "colorCode", true)
              .setStyleDetails("left", "2", "", "wt-2", "wt-2")
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("PoDate", "purchaseOrderDate", true, false.true)
              .setStyleDetails("left", "", "", "wt-2", "wt-2")
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("PO", "purchaseOrderNumber", true)
              .setStyleDetails("left", "", "", "wt-2", "wt-2")
              .setClickDetails(true, false, this.viewPurchaseModule, null)
          );
          // columns.push(
          //   new ColumnDefinition()
          //     .setDetails("PRDate", "purchaseOrderReceiptNumber", true)
          //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
          // );
          columns.push(
            new ColumnDefinition()
              .setDetails("PR", "purchaseOrderReceiptNumber", true)
              .setStyleDetails("left", "", "", "wt-2", "wt-2")
              .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("ReceiptDate", "receiptDate", true)
              .setStyleDetails("left", "", "", "wt-2", "wt-2")
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("UOM", "uomCode", true)
              .setStyleDetails("left", "", "", "wt-2", "wt-2")
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("ordQuantity", "orderQuantity", true, true)
              .setStyleDetails("right", "", "", "wt-2", "wt-2")
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("Price", "price", true, true)
              .setStyleDetails("right", "", "", "wt-2", "wt-2")
          );
      
          columns.push(
            new ColumnDefinition()
              .setDetails("Extension", "extension", true, true)
              .setStyleDetails("right", "", "", "wt-2", "wt-2")
          );
      
          columns.push(
            new ColumnDefinition()
              .setDetails("RecdQuantity", "receivedQuantity", true, true)
              .setStyleDetails("right", "", "", "wt-2", "wt-2")
          );
      
          return columns;
        };
  // validateHoldingData = (criteria) => {
  //   let isValidHoldingData = false;
  //   let holdedDataList = [...this.state.holdedDataList];

  //   let err_list = [];
  //   let errorMessage = "";
  //   if (criteria == null) {
  //     let errMsg = "Enter All Fields ";
  //     errorMessage = errorMessage + errMsg;
  //     err_list.push(errMsg);
  //   } else {
  //     if (isEmptyString(criteria.customerCode)) {
  //       let errMsg = "CustomerCode is Required";
  //       errorMessage = errorMessage + errMsg;
  //       err_list.push(errMsg);
  //     }
  //     if (
  //       isEmptyString(criteria.purchaseOrderNumber) &&
  //       isEmptyString(criteria.purchaseOrderReceiptNumber)
  //     ) {
  //       let errMsg =
  //         "PurchaseOrderNumber Or PurchaseOrderReceiptNumber Required";
  //       errorMessage = errorMessage + errMsg;
  //       err_list.push(errMsg);
  //     }
  //     //          if (isEmptyString(criteria.holdingDate)) {
  //     //   let errMsg = "HoldingDate Required";
  //     //   errorMessage = errorMessage + errMsg;
  //     //   err_list.push(errMsg);
  //     // }

  //     if (isEmptyString(criteria.expirationDate)) {
  //       let errMsg = "ExpirationDate Required";
  //       errorMessage = errorMessage + errMsg;
  //       err_list.push(errMsg);
  //     }

  //     if (!isEmptyArray(holdedDataList)) {
  //       // let errMsg = "ExpirationDate Required";
  //       // errorMessage = errorMessage + errMsg;
  //       // err_list.push(errMsg);
  //       const findedData = holdedDataList.find(
  //         (item) =>
  //           item.fabricStyleColorCode === criteria.fabricStyleColorCode &&
  //           item.purchaseOrderNumber === criteria.purchaseOrderNumber &&
  //           item.purchaseOrderReceiptNumber ===
  //             criteria.purchaseOrderReceiptNumber,
  //       );

  //       if (findedData) {
  //         let errMsg = `Already  holding ${findedData.holdingNumber} existed !`;
  //         errorMessage += errMsg;
  //         err_list.push(errMsg);
  //       }
  //     }
  //   }
  //   if (err_list.length > 0) {
  //     isValidHoldingData = false;
  //     this.setState({
  //       alertMessage: err_list,
  //       alertType: "danger",
  //       isShowHoldingAlert: true,
  //     });
  //   } else {
  //     isValidHoldingData = true;
  //     this.setState({ isShowHoldingAlert: false });
  //   }
  //   return isValidHoldingData;
  // };
  createHoldingRolls = (e) => {
    if (e.detail === 1) {
      let criteria = { ...this.state.criteria };
      let isValidData = false;
      isValidData = this.validateHoldingData(criteria);
      if (isValidData) {
        FabricStyleService.createHoldingFabricInventoryDetail(
          criteria,
          this.createdHoldResponse,
          this.errorCallBack,
        );
      }
    }
  };
  createdHoldResponse = (response) => {
    let success = this.handleResponse(response.data);
    if (success === true) {
      this.closeAlertHoldingModalCallBack(false);
      this.loadPage();
    } else {

    }
    // this.setState({
    //   isLoading: false,
    // });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowHoldingAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  // getRollInFo = ()=>{

  // }

   onfabricColorKeyDown = (e) => {
    this.props.onfabricColorKeyDown()
  };
  onfabricColorBlur = (e) => {
    this.props.onfabricColorBlur()
  };
   onFabricColourCodeChange = (e) => {
  
    
    this.props.onFabricColourCodeChange(e)
  }; 
fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler()
  }; 
// displayAutoCompleteColourList = (e) => {
//     this.props.displayAutoCompleteColourList()
//   }; 


 closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
     
      isShowColorPopup: isShowPopup,
    });
    
  };

    viewsalesOrderModule = (e, code,rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderMaintenanceModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
    
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
   

    
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
    handleHyperLinkClick = (e, val, rowData) => {

    if (val !== "" && val !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={val}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
    viewPurchaseModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
    viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  }
    onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
   viewInvoiceModule = (e, code, rowData) => {
    this.props.viewInvoiceModule(e, code, rowData);
  };
  
  render() {
    let criteria = this.state.criteria;
    
    
    let fabricStyleData = this.state.fabricStyleData;


    let holdingSkuSummaryList = [];

    let InventoryAndSoAndPo = this.state.InventoryAndSoAndPo;
    let isDisableHoldingFields = this.state.isDisableHoldingFields;
     let is3PL = this.props.is3PL;
     let fabricListData = this.state.fabricListData;
    

     let ColorData= this.state.ColorData;
     let skuInventoryColorList = this.state.skuInventoryColorList;
     let inquiryDataLists =this.state.inquiryDataLists;
     let inquiryDataListVendor =this.state.inquiryDataListVendor;
     
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <Row>
          {" "}
          <Col className="align-items-left" sm="1">
           {is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              readOnly={true}
              value={fabricStyleData.code}
            />{" "}
          </Col>{" "}
          <Col sm="3">
            <InputTextbox
              name="description"
              readOnly={true}
              value={fabricStyleData.description}
            />{" "}
          </Col>
          <Col sm="1">
                  {" "}
                  <FormLabel>Color</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    // ref={this.colorCodeRef}
                    name="fabricStyleColorCode"
                    onChange={this.onCustomerSalesColorCodeChange}
                    value={criteria.fabricStyleColorCode}
                    lookupRequired={true}
                    lookupHandler={this.state.colorLookupHandler}
                    enterKeyEventHandler={this.colorCustomerSalesEnterKeyEvent}
                    autoCompleteListData={
                      this.state.colorSummaryForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteColorCustomerSalesList
                    }
                    showAutoCompleteList={
                      this.state.showAutoCompleteCustomerSalesColorList
                    }
                    disabled={isDisableHoldingFields}
                    isMandatory={true}
                  />{" "}
                </Col>{" "}
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
               className="enterFocus"
              onClick={(e) => this.addNewFetch(e)}
            >
              Fetch{" "}
            </Button>
          </Col>
        </Row>

        <div>
          <CustomTable
            data={InventoryAndSoAndPo}
            columns={this.headerLinesFetchingColumn()}
            label={"Fabric Inventory And Sales And Purchase List"}
          />



        </div>
        <div>
           <Table id="fabrics_tables_v1">
                    <thead>
                      <tr>
                    
                        <th>Img</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                       {InventoryAndSoAndPo.map((clr, index) => (
                       <td>{clr.fabricStyleImagePath}</td>

                       ))}
                    </tbody>
                    </Table>
</div>

<MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          isShowPopup={this.state.isShowPickTicketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesOrderMaintenanceModule}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

<MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowColorPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Color"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.generateOnHandQtyPdf(e)}
          //     >
          //       PDF
          //     </Button>
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.generateOnHandQtyExcel(e)}
          //     >
          //       Excel
          //     </Button>
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.onHandQtySummaryOnClick(e)}
          //     >
          //       Summary
          //     </Button>

          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.onHandQtyLotSummaryOnClick(e)}
          //     >
          //       Lot Summary
          //     </Button>
          //   </div>
          // }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={ColorData.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={ColorData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={ColorData.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>UOM</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={ColorData.uomCode}
                    name={"uomCode"}
                    disabled={true}
                  />
                </Col>
              </Row>
              {/* <Row>
                <Col sm="1">
                  <FormLabel>OnHandQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={ColorData.totalOnHandQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalOnHandQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row> */}

              <div className="mt-3">
                <CustomTable
                  data={skuInventoryColorList}
                  columns={this.inquiryColorColumns()}
                  label={"Lot Summary Inventory Data List"}
                 enableVritualizer={true}

                />
              </div>
             
              <div className="mt-3">
                <CustomTable
                  data={inquiryDataLists}
                  columns={this.inquiryInvoiceColumns()}
                  // isEnableSpan={true}
                  label={"Customer Sales Data List"}
                   enableVritualizer={true}

                />
              </div>

             <div className="mt-3">
                <CustomTable
                  data={inquiryDataListVendor}
                  columns={this.inquiryPurchaseColumns()}
                  // isEnableSpan={true}
                  label={"Purchase Data List"}
                  enableVritualizer={true}
                />
              </div>

            </div>
          } />
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowHoldingEntryPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertHoldingModalCallBack}
          title={"Hodling"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowHoldingAlert}
              hideAlertCallBack={this.hideAlertCallBackHolding}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.createHoldingRolls(e)}
                disabled={isDisableHoldingFields}
              >
                Create
              </Button>
            </div>
          }
          content={
            <diV>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Holding </FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="holdingNumber"
                    readOnly={true}
                      className="summary_input"
                    value={
                      criteria.holdingNumber > 0
                        ? criteria.holdingNumber
                        : "New"
                    }
                    isMandatory={true}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Item</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="code"
                    readOnly={true}
                    value={fabricStyleData.code}
                    isMandatory={true}
                  />{" "}
                </Col>{" "}
                <Col sm="4">
                  <InputTextbox
                    name="description"
                    readOnly={true}
                    value={fabricStyleData.description}
                    isMandatory={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.onCustomerCodeChange}
                    disabled={isDisableHoldingFields}
                    name="customerCode"
                    placeholder="Customer"
                    value={criteria.customerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.customerLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                    autoCompleteListData={
                      this.state.customerPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteList}
                    showAutoCompleteList={
                      this.state.showAutoCompleteCustomerList
                    }
                    isMandatory={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel className="header_labels">
                    Purcahse Order#
                  </FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.purchaseOrderOnChange}
                    name="purchaseOrderNumber"
                    ref={this.purchaseRef}
                    value={criteria.purchaseOrderNumber}
                    // lookupRequired={this.state.isShowPOLookup}
                    lookupRequired={true}
                    lookupHandler={this.state.purchaseorderLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.poEnterKeyEventHandler}
                    autoCompleteListData={
                      this.state.poPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayPoAutoCompleteList}
                    showAutoCompleteList={this.state.isShowAutoCompletePoList}
                    disabled={isDisableHoldingFields}
                    isMandatory={true}
                  />
                </Col>

                <Col className="so-align-items-left" sm="1">
                  <FormLabel className="header_labels">
                    PO Receipt#
                  </FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.onPurchaseReceiptChange}
                    //  ref={this.receiptCodeRef}
                    name="purchaseOrderReceiptNumber"
                    placeholder="purchaseOrderReceiptNumber"
                    value={criteria.purchaseOrderReceiptNumber}
                    // lookupRequired={this.state.isShowPurchaseReceiptLookup}
                    lookupRequired={true}
                    lookupHandler={this.state.purchaseReceiptLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={
                      this.purchaseReceiptEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.state.purchaseReceiptPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompletepurchaseReceiptList
                    }
                    showAutoCompleteList={
                      this.state.showAutoCompletepurchaseReceiptList
                    }
                    isMandatory={true}
                    disabled={isDisableHoldingFields}
                    // isMandatory={true}
                  ></InputTextbox>
                </Col>

               
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Color</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    // ref={this.colorCodeRef}
                    name="fabricStyleColorCode"
                    onChange={this.onCustomerSalesColorCodeChange}
                    value={criteria.fabricStyleColorCode}
                    lookupRequired={true}
                    lookupHandler={this.state.colorLookupHandler}
                    enterKeyEventHandler={this.colorCustomerSalesEnterKeyEvent}
                    autoCompleteListData={
                      this.state.colorSummaryForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteColorCustomerSalesList
                    }
                    showAutoCompleteList={
                      this.state.showAutoCompleteCustomerSalesColorList
                    }
                    disabled={isDisableHoldingFields}
                    isMandatory={true}
                  />{" "}
                </Col>{" "}
                <Col sm="1">
                  {" "}
                  <FormLabel>HoldDate</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <DatePickerComponent_adv
                    name="holdingDate"
                    value={criteria.holdingDate}
                    onChange={this.onChange}
                    isMandatory={true}
                    disabled={true}
                    // isModifyView={isModify}
                    // isMandatory={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>expiration Date</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <DatePickerComponent_adv
                    name="expirationDate"
                    value={criteria.expirationDate}
                    onChange={this.onChange}
                    isMandatory={true}
                    disabled={isDisableHoldingFields}
                    // isModifyView={isModify}
                    // isMandatory={true}
                  />
                </Col>
              </Row>

              
            </diV>
          }
        /> */}
      </div>
    );
  }
}
export function ItemImages(props) {
  const openItemImage = () => {
    props.openItemImage();
  };

  const content = (url) => {
    return (
      <img
        src={url}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        // width={800}
        // height={600}
        // mode="fit"
      />
    );
  };
  return (
    <div>
      <CustomImage
        // data-tip={props.mainImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={props.mainImageUrl}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
        // onClick={openItemImage}
      />{" "}
      <CustomImage
        // data-tip={props.webImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={props.webImageUrl}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      <CustomImage
        // data-tip={props.frontImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={props.frontImageUrl}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      <CustomImage
        // data-tip={props.backImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={props.backImageUrl}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      {/* <ReactTooltip
        id="global"
        // aria-haspopup="true"
        className="cstm-img-tool-tip"
        // globalEventOff="click"
        getContent={(dataTip) => content(dataTip)}
        // place='bottom'
      ></ReactTooltip> */}
    </div>
  );
}

export function MutilpleDocuments(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewDocs] = useState(props.preview_Docs);
  const [documents, setDocuments] = useState([...props.documents]);
  const [tempIndex, setIndex] = useState(null);
  const documentData = props.fabricStyleData.fabricStyleDocuments;
  const [isDocumentUpload, setIsDocumentUpload] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;

  const docHandler = (e) => {
    e.preventDefault();
    let tempDocs = e.target.files;
    let doc_list = [];
    let previewList = [];
    if (!isEmptyArray(documents)) {
      doc_list = [...documents];
    }
    if (!isEmptyArray(previewUrl)) {
      previewList = [...previewUrl];
    }
    for (let index = 0; index < tempDocs.length; index++) {
      let docUrl = "";
      doc_list.push(tempDocs[index]);
      docUrl = URL.createObjectURL(tempDocs[index]);
      previewList.push(docUrl);
    }
    setDocuments(doc_list);
    setPreviewDocs(previewList);
    setIsDocumentUpload(true);
  };

  useEffect(() => {
    setDocuments(documents);
  }, [documents]);

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    props.uploadMutiDouments(documents);
    props.uploadMutiDoumentsUrl(previewUrl);
    props.showToast("Uploaded Sucessfully", 1);
    setIsDocumentUpload(false);
  };
  const deleteDocs = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewDocs("");
      props.showToast("deleted sucessfully", 1);
      setDocuments(props.documents);
      setIsDocumentUpload(false);
    }
  };

  const documentColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Document", "documentName", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
      // .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Document Name", "documentName", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setClickDetails(false, true, deleteDocuments, <DeleteIcon />),
    );

    return columns;
  };
  const deleteDocuments = (e, value, rowData) => {
    let documentDataList = documents;
    let fileUrl = previewUrl;
    documentDataList.map((list, index) => {
      if (list.documentName === rowData.documentName) {
        // list.deleted = true;
        // list.isDeleted = true;
        fileUrl.splice(index, 1);
      }
    });
    setPreviewDocs(fileUrl);
    props.uploadMutiDoumentsUrl(fileUrl);
    props.deleteMultiDocument(rowData);
  };
  const editDocument = (e, name, tempIndex) => {
    let docUrl = previewUrl;
    let tempUrl = "";
    if (!isEmptyArray(docUrl)) {
      for (let index = 0; index < docUrl.length; index++) {
        if (index === tempIndex) {
          tempUrl = docUrl[index];
        }
      }
      window.open(tempUrl);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        <div className="div_60_no_overflow">
          <div className="div_Equal_no_overflow">
            <form onSubmit={handleDocumentSubmit}>
              <div className="d-flex justify-content-around ">
                <div>
                  <label for="imgTag" className="d-flex justify-content-around">
                    <div className="img_label">
                      Attach Documents
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>

                    <input
                      type="file"
                      className="img-input"
                      id="imgTag"
                      multiple
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                      onChange={docHandler}
                      disabled={isShowDocLabel}
                    />
                  </label>
                </div>
                {isDocumentUpload && (
                  <div className="d-flex justify-content-around align-middle">
                    <div className="align-middle">
                      <button
                        id="fabric_Add_Button"
                        type="submit"
                        disabled={isShowDocLabel}
                      >
                        Upload
                      </button>
                    </div>
                    <div className="align-middle">
                      <Button
                        id="fabric_Add_Button"
                        onClick={(e) => deleteDocs(e)}
                        disabled={isShowDocLabel}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="div_Custom_3">
        <Table id="fabrics_tables_default">
          <thead>
            <tr>
              <th
              // onClick={(e) =>
              //   props.handleSortingStageDocumentChange(e, "documentName")
              // }
              >
                Document
                {/* {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )} */}
              </th>
              <th
              // onClick={(e) =>
              //   props.handleSortingStageDocumentChange(e, "documentName")
              // }
              >
                Document Name
                {/* {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )} */}
              </th>
              <th>Delete</th>
            </tr>
          </thead>
          {documentData != null ? (
            <tbody>
              {documentData.map(
                (ln, index) =>
                  ln.isDeleted != true && (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            editDocument(e, ln.documentName, index)
                          }
                        >
                          {ln.documentName}
                        </Button>
                      </td>
                      <td>{ln.documentName}</td>
                      <td className="text-right">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            deleteDocuments(e, ln.documentCode, ln)
                          }
                          disabled={isShowDocLabel}
                        >
                          {<DeleteIcon />}
                        </Button>
                      </td>
                    </tr>
                  ),
              )}
            </tbody>
          ) : null}
        </Table>
      </div>
      {/* <div className="mt-3">
        <CustomTable
          data={documentData}
          columns={documentColumns()}
          label={"Inquiry Data List"}
        />
      </div> */}
    </div>
  );
}
// function FabricStyleMaintenanceModule(props) {
//   // const value = React.useContext(AppContext);
//   return (
//     <div id="moduleContainer" class="module_container">
//       <div id="app_container"></div>
//       <FabricStyleList {...props} name="" /> <br />
//     </div>
//   );
// }


class FabricStyleMaintenanceModule extends React.Component {
  constructor(props) {
    super(props);
    this.moduleRef = React.createRef();
  }
  render() {
    return (
      <div id="moduleContainer" className="module_container">
        <div className="App">
          <FabricStyleList {...this.props} name="" ref={this.moduleRef} />{" "}
          <br />
        </div>
      </div>
    );
  }
}

export default FabricStyleMaintenanceModule;
